
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5906"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5906"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
"use strict";

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
"use strict";
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $0b2e6adb871a3b94$var$Mg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Ng = null, $0b2e6adb871a3b94$var$Og = null, $0b2e6adb871a3b94$var$Pg = null;
function $0b2e6adb871a3b94$var$Qg() {
    $0b2e6adb871a3b94$var$Pg = $0b2e6adb871a3b94$var$Og = $0b2e6adb871a3b94$var$Ng = null;
}
function $0b2e6adb871a3b94$var$Rg(a) {
    var b = $0b2e6adb871a3b94$var$Mg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Mg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$Tg(a, b) {
    $0b2e6adb871a3b94$var$Ng = a;
    $0b2e6adb871a3b94$var$Pg = $0b2e6adb871a3b94$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$Ug = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$Vg(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Og) {
            if (null === $0b2e6adb871a3b94$var$Ng) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Og = a;
            $0b2e6adb871a3b94$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Og = $0b2e6adb871a3b94$var$Og.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$Wg = null;
function $0b2e6adb871a3b94$var$Xg(a) {
    null === $0b2e6adb871a3b94$var$Wg ? $0b2e6adb871a3b94$var$Wg = [
        a
    ] : $0b2e6adb871a3b94$var$Wg.push(a);
}
function $0b2e6adb871a3b94$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$Zg(a, d);
}
function $0b2e6adb871a3b94$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$$g = !1;
function $0b2e6adb871a3b94$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$Zg(a, c);
}
function $0b2e6adb871a3b94$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$jh = (new $acw62.Component).refs;
function $0b2e6adb871a3b94$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$L(), e = $0b2e6adb871a3b94$var$lh(a), f = $0b2e6adb871a3b94$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$dh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, e, d), $0b2e6adb871a3b94$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$L(), e = $0b2e6adb871a3b94$var$lh(a), f = $0b2e6adb871a3b94$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$dh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, e, d), $0b2e6adb871a3b94$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$L(), d = $0b2e6adb871a3b94$var$lh(a), e = $0b2e6adb871a3b94$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$dh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, d, c), $0b2e6adb871a3b94$var$eh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$ph(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$Vg(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$nh.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $0b2e6adb871a3b94$var$jh;
    $0b2e6adb871a3b94$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$Vg(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$nh.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $0b2e6adb871a3b94$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$sh(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$sh(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$zh(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Ah(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Bh = $0b2e6adb871a3b94$var$vh(!0), $0b2e6adb871a3b94$var$Ch = $0b2e6adb871a3b94$var$vh(!1), $0b2e6adb871a3b94$var$Dh = {}, $0b2e6adb871a3b94$var$Eh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh), $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh), $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh);
function $0b2e6adb871a3b94$var$Hh(a) {
    if (a === $0b2e6adb871a3b94$var$Dh) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$Ih(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Gh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Fh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, $0b2e6adb871a3b94$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, b);
}
function $0b2e6adb871a3b94$var$Jh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Fh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Gh);
}
function $0b2e6adb871a3b94$var$Kh(a) {
    $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
    var b = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Fh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, c));
}
function $0b2e6adb871a3b94$var$Lh(a) {
    $0b2e6adb871a3b94$var$Fh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Fh));
}
var $0b2e6adb871a3b94$var$M = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nh = [];
function $0b2e6adb871a3b94$var$Oh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Nh.length; a++)$0b2e6adb871a3b94$var$Nh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Nh.length = 0;
}
var $0b2e6adb871a3b94$var$Ph = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Qh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Rh = 0, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$P = null, $0b2e6adb871a3b94$var$Sh = !1, $0b2e6adb871a3b94$var$Th = !1, $0b2e6adb871a3b94$var$Uh = 0, $0b2e6adb871a3b94$var$Vh = 0;
function $0b2e6adb871a3b94$var$Q() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Xh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Rh = f;
    $0b2e6adb871a3b94$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Ph.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Yh : $0b2e6adb871a3b94$var$Zh;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Th) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Th = !1;
            $0b2e6adb871a3b94$var$Uh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$$h;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Th);
    }
    $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$ai;
    b = null !== $0b2e6adb871a3b94$var$O && null !== $0b2e6adb871a3b94$var$O.next;
    $0b2e6adb871a3b94$var$Rh = 0;
    $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
    $0b2e6adb871a3b94$var$Sh = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$bi() {
    var a = 0 !== $0b2e6adb871a3b94$var$Uh;
    $0b2e6adb871a3b94$var$Uh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState = $0b2e6adb871a3b94$var$P = a : $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$P.next = a;
    return $0b2e6adb871a3b94$var$P;
}
function $0b2e6adb871a3b94$var$di() {
    if (null === $0b2e6adb871a3b94$var$O) {
        var a = $0b2e6adb871a3b94$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$O.next;
    var b = null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState : $0b2e6adb871a3b94$var$P.next;
    if (null !== b) $0b2e6adb871a3b94$var$P = b, $0b2e6adb871a3b94$var$O = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$O = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$O.memoizedState,
            baseState: $0b2e6adb871a3b94$var$O.baseState,
            baseQueue: $0b2e6adb871a3b94$var$O.baseQueue,
            queue: $0b2e6adb871a3b94$var$O.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState = $0b2e6adb871a3b94$var$P = a : $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$P.next = a;
    }
    return $0b2e6adb871a3b94$var$P;
}
function $0b2e6adb871a3b94$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$di(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$N.lanes |= m;
                $0b2e6adb871a3b94$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$N.lanes |= f, $0b2e6adb871a3b94$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$gi(a) {
    var b = $0b2e6adb871a3b94$var$di(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$hi() {}
function $0b2e6adb871a3b94$var$ii(a, b) {
    var c = $0b2e6adb871a3b94$var$N, d = $0b2e6adb871a3b94$var$di(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$Ug = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$ji($0b2e6adb871a3b94$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$P && $0b2e6adb871a3b94$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$li(9, $0b2e6adb871a3b94$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$R) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Rh & 30) || $0b2e6adb871a3b94$var$ni(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$oi(b) && $0b2e6adb871a3b94$var$pi(a);
}
function $0b2e6adb871a3b94$var$ki(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$oi(b) && $0b2e6adb871a3b94$var$pi(a);
    });
}
function $0b2e6adb871a3b94$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$pi(a) {
    var b = $0b2e6adb871a3b94$var$Zg(a, 1);
    null !== b && $0b2e6adb871a3b94$var$mh(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$qi(a) {
    var b = $0b2e6adb871a3b94$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ri.bind(null, $0b2e6adb871a3b94$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$si() {
    return $0b2e6adb871a3b94$var$di().memoizedState;
}
function $0b2e6adb871a3b94$var$ti(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$ci();
    $0b2e6adb871a3b94$var$N.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$ui(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$O) {
        var g = $0b2e6adb871a3b94$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Wh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$li(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$N.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$li(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    return $0b2e6adb871a3b94$var$ti(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$ji(a, b) {
    return $0b2e6adb871a3b94$var$ui(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$wi(a, b) {
    return $0b2e6adb871a3b94$var$ui(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$xi(a, b) {
    return $0b2e6adb871a3b94$var$ui(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$ui(4, 4, $0b2e6adb871a3b94$var$yi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$Ai() {}
function $0b2e6adb871a3b94$var$Bi(a, b) {
    var c = $0b2e6adb871a3b94$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$Ci(a, b) {
    var c = $0b2e6adb871a3b94$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$Di(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Rh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$Ug = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$N.lanes |= c, $0b2e6adb871a3b94$var$hh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$Ei(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Qh.transition;
    $0b2e6adb871a3b94$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Qh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$Fi() {
    return $0b2e6adb871a3b94$var$di().memoizedState;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$Hi(a)) $0b2e6adb871a3b94$var$Ii(b, c);
    else if (c = $0b2e6adb871a3b94$var$Yg(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$L();
        $0b2e6adb871a3b94$var$mh(c, a, d, e);
        $0b2e6adb871a3b94$var$Ji(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ri(a, b, c) {
    var d = $0b2e6adb871a3b94$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$Hi(a)) $0b2e6adb871a3b94$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$Yg(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$L(), $0b2e6adb871a3b94$var$mh(c, a, d, e), $0b2e6adb871a3b94$var$Ji(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$Hi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$N || null !== b && b === $0b2e6adb871a3b94$var$N;
}
function $0b2e6adb871a3b94$var$Ii(a, b) {
    $0b2e6adb871a3b94$var$Th = $0b2e6adb871a3b94$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$ai = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Q,
    useContext: $0b2e6adb871a3b94$var$Q,
    useEffect: $0b2e6adb871a3b94$var$Q,
    useImperativeHandle: $0b2e6adb871a3b94$var$Q,
    useInsertionEffect: $0b2e6adb871a3b94$var$Q,
    useLayoutEffect: $0b2e6adb871a3b94$var$Q,
    useMemo: $0b2e6adb871a3b94$var$Q,
    useReducer: $0b2e6adb871a3b94$var$Q,
    useRef: $0b2e6adb871a3b94$var$Q,
    useState: $0b2e6adb871a3b94$var$Q,
    useDebugValue: $0b2e6adb871a3b94$var$Q,
    useDeferredValue: $0b2e6adb871a3b94$var$Q,
    useTransition: $0b2e6adb871a3b94$var$Q,
    useMutableSource: $0b2e6adb871a3b94$var$Q,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Q,
    useId: $0b2e6adb871a3b94$var$Q,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Yh = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ti(4194308, 4, $0b2e6adb871a3b94$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$Gi.bind(null, $0b2e6adb871a3b94$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$qi,
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$qi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$Ei.bind(null, a[1]);
        $0b2e6adb871a3b94$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$N, e = $0b2e6adb871a3b94$var$ci();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$R) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Rh & 30) || $0b2e6adb871a3b94$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$vi($0b2e6adb871a3b94$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$li(9, $0b2e6adb871a3b94$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$ci(), b = $0b2e6adb871a3b94$var$R.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Zh = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Bi,
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$ji,
    useImperativeHandle: $0b2e6adb871a3b94$var$zi,
    useInsertionEffect: $0b2e6adb871a3b94$var$wi,
    useLayoutEffect: $0b2e6adb871a3b94$var$xi,
    useMemo: $0b2e6adb871a3b94$var$Ci,
    useReducer: $0b2e6adb871a3b94$var$fi,
    useRef: $0b2e6adb871a3b94$var$si,
    useState: function() {
        return $0b2e6adb871a3b94$var$fi($0b2e6adb871a3b94$var$ei);
    },
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$di();
        return $0b2e6adb871a3b94$var$Di(b, $0b2e6adb871a3b94$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$fi($0b2e6adb871a3b94$var$ei)[0], b = $0b2e6adb871a3b94$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$hi,
    useSyncExternalStore: $0b2e6adb871a3b94$var$ii,
    useId: $0b2e6adb871a3b94$var$Fi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$$h = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Bi,
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$ji,
    useImperativeHandle: $0b2e6adb871a3b94$var$zi,
    useInsertionEffect: $0b2e6adb871a3b94$var$wi,
    useLayoutEffect: $0b2e6adb871a3b94$var$xi,
    useMemo: $0b2e6adb871a3b94$var$Ci,
    useReducer: $0b2e6adb871a3b94$var$gi,
    useRef: $0b2e6adb871a3b94$var$si,
    useState: function() {
        return $0b2e6adb871a3b94$var$gi($0b2e6adb871a3b94$var$ei);
    },
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$di();
        return null === $0b2e6adb871a3b94$var$O ? b.memoizedState = a : $0b2e6adb871a3b94$var$Di(b, $0b2e6adb871a3b94$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$gi($0b2e6adb871a3b94$var$ei)[0], b = $0b2e6adb871a3b94$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$hi,
    useSyncExternalStore: $0b2e6adb871a3b94$var$ii,
    useId: $0b2e6adb871a3b94$var$Fi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Oi(a, b, c) {
    c = $0b2e6adb871a3b94$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Pi || ($0b2e6adb871a3b94$var$Pi = !0, $0b2e6adb871a3b94$var$Qi = d);
        $0b2e6adb871a3b94$var$Mi(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Ri(a, b, c) {
    c = $0b2e6adb871a3b94$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Mi(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Si ? $0b2e6adb871a3b94$var$Si = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$ch(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Xi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$Ug = !1;
function $0b2e6adb871a3b94$var$Yi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Ch(b, null, c, d) : $0b2e6adb871a3b94$var$Bh(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$Tg(b, e);
    d = $0b2e6adb871a3b94$var$Xh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$bi();
    if (null !== a && !$0b2e6adb871a3b94$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$$i(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Yi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$cj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$Ug = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$$i(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$dj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj);
            $0b2e6adb871a3b94$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= d;
    $0b2e6adb871a3b94$var$Yi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$dj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$Tg(b, e);
    c = $0b2e6adb871a3b94$var$Xh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$bi();
    if (null !== a && !$0b2e6adb871a3b94$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$$i(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Yi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$Tg(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$jj(a, b), $0b2e6adb871a3b94$var$ph(b, c, d), $0b2e6adb871a3b94$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$Vg(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$qh(b, g, d, l);
        $0b2e6adb871a3b94$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$$g ? ("function" === typeof m && ($0b2e6adb871a3b94$var$kh(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$$g || $0b2e6adb871a3b94$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$Vg(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$qh(b, g, d, k);
        $0b2e6adb871a3b94$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$$g ? ("function" === typeof y && ($0b2e6adb871a3b94$var$kh(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$$g || $0b2e6adb871a3b94$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$kj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$kj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$$i(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Bh(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Bh(b, null, h, f)) : $0b2e6adb871a3b94$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$Ih(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$mj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Yi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$pj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$qj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$oj(c), b.memoizedState = $0b2e6adb871a3b94$var$nj, a) : $0b2e6adb871a3b94$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$wh(h, f) : (f = $0b2e6adb871a3b94$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$rj(a, b) {
    b = $0b2e6adb871a3b94$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$tj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Bh(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Li(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$oj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Li(f, d, void 0);
        return $0b2e6adb871a3b94$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$Ug || h) {
        d = $0b2e6adb871a3b94$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$Zg(a, e), $0b2e6adb871a3b94$var$mh(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$uj();
        d = $0b2e6adb871a3b94$var$Li(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$Sg(a.return, b, c);
}
function $0b2e6adb871a3b94$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Yi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$wj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$lj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Kh(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$pj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1);
                a = $0b2e6adb871a3b94$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$ej(a, b, c);
    }
    return $0b2e6adb871a3b94$var$$i(a, b, c);
}
var $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj, $0b2e6adb871a3b94$var$Dj;
$0b2e6adb871a3b94$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Bj = function() {};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Ej(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$Jh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Gj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Bj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Lh(b);
            var e = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
                $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Gj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$M.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$Jh(), $0b2e6adb871a3b94$var$Bj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$Rg(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Ej(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Hj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$M.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$gj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Jj(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$Jh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Lh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M), null;
        case 4:
            return $0b2e6adb871a3b94$var$Jh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Kj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Oj = !1;
function $0b2e6adb871a3b94$var$Pj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Oj;
    $0b2e6adb871a3b94$var$Oj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Xj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Xj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Yj = !1;
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$ak(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$ak(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Mj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Yj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Yj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Yj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Yj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Yj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Yj = !0;
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Nj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Zj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Zj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Lj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Yj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Yj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$ak(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$ek(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Qj(3, a, a.return), $0b2e6adb871a3b94$var$Rj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Qj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Mj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$gk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$dk(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 4 && $0b2e6adb871a3b94$var$bk(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$dk(b, a), $0b2e6adb871a3b94$var$fk(a);
    }
}
function $0b2e6adb871a3b94$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Vj(a);
                    $0b2e6adb871a3b94$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Vj(a);
                    $0b2e6adb871a3b94$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$jk(a, b, c);
}
function $0b2e6adb871a3b94$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Kj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Kj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$kk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$kk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$jk(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Kj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$lk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$lk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Sj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$hk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Sj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Sj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$mk = Math.ceil, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$pk = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$gj = 0, $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$qk = null, $0b2e6adb871a3b94$var$hh = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = 0, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$gk = 0, $0b2e6adb871a3b94$var$Hj = Infinity, $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Pi = !1, $0b2e6adb871a3b94$var$Qi = null, $0b2e6adb871a3b94$var$Si = null, $0b2e6adb871a3b94$var$wk = !1, $0b2e6adb871a3b94$var$xk = null, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = null, $0b2e6adb871a3b94$var$Bk = -1, $0b2e6adb871a3b94$var$Ck = 0;
function $0b2e6adb871a3b94$var$L() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Bk ? $0b2e6adb871a3b94$var$Bk : $0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Ck && ($0b2e6adb871a3b94$var$Ck = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Ck;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$mh(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$zk) throw $0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$R) a === $0b2e6adb871a3b94$var$R && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$rk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Ek(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Ek(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$R ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Fk.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Fk.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Gk(c, $0b2e6adb871a3b94$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Hk(a, b) {
    $0b2e6adb871a3b94$var$Bk = -1;
    $0b2e6adb871a3b94$var$Ck = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Ik() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$R ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Jk(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Kk();
        if ($0b2e6adb871a3b94$var$R !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Lk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Mk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Nk(a, h);
        }
        $0b2e6adb871a3b94$var$Qg();
        $0b2e6adb871a3b94$var$nk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Ok(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, d), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Pk(e) && (b = $0b2e6adb871a3b94$var$Jk(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Ok(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, d), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$gk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Qk.bind(null, a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Qk.bind(null, a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Hk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Ok(a, b) {
    var c = $0b2e6adb871a3b94$var$tk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Lk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Jk(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$uk = c, null !== b && $0b2e6adb871a3b94$var$Gj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Gj(a) {
    null === $0b2e6adb871a3b94$var$uk ? $0b2e6adb871a3b94$var$uk = a : $0b2e6adb871a3b94$var$uk.push.apply($0b2e6adb871a3b94$var$uk, a);
}
function $0b2e6adb871a3b94$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    b &= ~$0b2e6adb871a3b94$var$sk;
    b &= ~$0b2e6adb871a3b94$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Fk(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Ik();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Ok(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, b), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Rk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Sk(a) {
    null !== $0b2e6adb871a3b94$var$xk && 0 === $0b2e6adb871a3b94$var$xk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Ik();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$pk.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$pk.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$pk.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Ij() {
    $0b2e6adb871a3b94$var$gj = $0b2e6adb871a3b94$var$fj.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$fj);
}
function $0b2e6adb871a3b94$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$Jh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Oh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Lh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$Jh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
                break;
            case 10:
                $0b2e6adb871a3b94$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Ij();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$R = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$wh(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$gj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$qk = null;
    $0b2e6adb871a3b94$var$sk = $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$hh = 0;
    $0b2e6adb871a3b94$var$uk = $0b2e6adb871a3b94$var$tk = null;
    if (null !== $0b2e6adb871a3b94$var$Wg) {
        for(b = 0; b < $0b2e6adb871a3b94$var$Wg.length; b++)if (c = $0b2e6adb871a3b94$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$Wg = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$Qg();
            $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$ai;
            if ($0b2e6adb871a3b94$var$Sh) {
                for(var d = $0b2e6adb871a3b94$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Sh = !1;
            }
            $0b2e6adb871a3b94$var$Rh = 0;
            $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            $0b2e6adb871a3b94$var$Th = !1;
            $0b2e6adb871a3b94$var$Uh = 0;
            $0b2e6adb871a3b94$var$ok.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$qk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Ti(f, l, b);
                            $0b2e6adb871a3b94$var$uj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Wi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ki(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = [
                    f
                ] : $0b2e6adb871a3b94$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Oi(f, k, b);
                            $0b2e6adb871a3b94$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Si || !$0b2e6adb871a3b94$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Ri(f, h, b);
                                $0b2e6adb871a3b94$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Tk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Kk() {
    var a = $0b2e6adb871a3b94$var$nk.current;
    $0b2e6adb871a3b94$var$nk.current = $0b2e6adb871a3b94$var$ai;
    return null === a ? $0b2e6adb871a3b94$var$ai : a;
}
function $0b2e6adb871a3b94$var$uj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$R || 0 === ($0b2e6adb871a3b94$var$hh & 268435455) && 0 === ($0b2e6adb871a3b94$var$rk & 268435455) || $0b2e6adb871a3b94$var$Dk($0b2e6adb871a3b94$var$R, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Jk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Kk();
    if ($0b2e6adb871a3b94$var$R !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Lk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Uk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Nk(a, e);
    }
    $0b2e6adb871a3b94$var$Qg();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$nk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$R = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Uk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Vk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Mk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Vk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Vk(a) {
    var b = $0b2e6adb871a3b94$var$Wk(a.alternate, a, $0b2e6adb871a3b94$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Tk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$ok.current = null;
}
function $0b2e6adb871a3b94$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Fj(c, b, $0b2e6adb871a3b94$var$gj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Qk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$pk.transition;
    try {
        $0b2e6adb871a3b94$var$pk.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Xk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$pk.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Ik();
    while (null !== $0b2e6adb871a3b94$var$xk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$R && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$wk || ($0b2e6adb871a3b94$var$wk = !0, $0b2e6adb871a3b94$var$Gk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$pk.transition;
        $0b2e6adb871a3b94$var$pk.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$ok.current = null;
        $0b2e6adb871a3b94$var$Pj(a, c);
        $0b2e6adb871a3b94$var$ek(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$ik(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$pk.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$wk && ($0b2e6adb871a3b94$var$wk = !1, $0b2e6adb871a3b94$var$xk = a, $0b2e6adb871a3b94$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Si = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Pi) throw $0b2e6adb871a3b94$var$Pi = !1, a = $0b2e6adb871a3b94$var$Qi, $0b2e6adb871a3b94$var$Qi = null, a;
    0 !== ($0b2e6adb871a3b94$var$yk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$zk++ : ($0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = a) : $0b2e6adb871a3b94$var$zk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Ik() {
    if (null !== $0b2e6adb871a3b94$var$xk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$yk), b = $0b2e6adb871a3b94$var$pk.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$pk.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$xk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$xk;
                $0b2e6adb871a3b94$var$xk = null;
                $0b2e6adb871a3b94$var$yk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Tj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Rj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$pk.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Yk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ki(c, b);
    b = $0b2e6adb871a3b94$var$Oi(a, b, 1);
    a = $0b2e6adb871a3b94$var$dh(a, b, 1);
    b = $0b2e6adb871a3b94$var$L();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Ek(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Si || !$0b2e6adb871a3b94$var$Si.has(d))) {
                a = $0b2e6adb871a3b94$var$Ki(c, a);
                a = $0b2e6adb871a3b94$var$Ri(b, a, 1);
                b = $0b2e6adb871a3b94$var$dh(b, a, 1);
                a = $0b2e6adb871a3b94$var$L();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$R === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$gk ? $0b2e6adb871a3b94$var$Lk(a, 0) : $0b2e6adb871a3b94$var$sk |= c);
    $0b2e6adb871a3b94$var$Ek(a, b);
}
function $0b2e6adb871a3b94$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$L();
    a = $0b2e6adb871a3b94$var$Zg(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Ek(a, c));
}
function $0b2e6adb871a3b94$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Zk(a, c);
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Zk(a, c);
}
var $0b2e6adb871a3b94$var$Wk;
$0b2e6adb871a3b94$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$Ug = !1, $0b2e6adb871a3b94$var$zj(a, b, c);
            $0b2e6adb871a3b94$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$Ug = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$jj(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$Tg(b, c);
            e = $0b2e6adb871a3b94$var$Xh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$ah(b), e.updater = $0b2e6adb871a3b94$var$nh, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$rh(b, d, a, c), b = $0b2e6adb871a3b94$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$$k(d);
                a = $0b2e6adb871a3b94$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$aj(null, b, d, $0b2e6adb871a3b94$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$lj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$bh(a, b);
                $0b2e6adb871a3b94$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$mj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$$i(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Kh(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$hj(a, b), $0b2e6adb871a3b94$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$pj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Bh(b, null, d, c) : $0b2e6adb871a3b94$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$Zi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$Tg(b, c), e = $0b2e6adb871a3b94$var$Vg(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Lg(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Lg(d.type, e), $0b2e6adb871a3b94$var$aj(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$jj(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$Tg(b, c), $0b2e6adb871a3b94$var$ph(b, d, e), $0b2e6adb871a3b94$var$rh(b, d, e, c), $0b2e6adb871a3b94$var$kj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$yj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$ej(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Gk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$al(a, b, c, d);
}
function $0b2e6adb871a3b94$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$$k(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Ah(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Ah(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$qj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$xh(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$zh(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$ah(f);
    return a;
}
function $0b2e6adb871a3b94$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$el(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$el(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$L();
    e = $0b2e6adb871a3b94$var$lh(c);
    f = $0b2e6adb871a3b94$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$dh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Ek(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$gl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$L(), g = $0b2e6adb871a3b94$var$lh(e);
    c = $0b2e6adb871a3b94$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$dh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$mh(a, e, g, f), $0b2e6adb871a3b94$var$eh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$jl(a, b) {
    $0b2e6adb871a3b94$var$il(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$il(a, b);
}
function $0b2e6adb871a3b94$var$kl() {
    return null;
}
var $0b2e6adb871a3b94$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$nl.prototype.render = $0b2e6adb871a3b94$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$gl(a, b, null, null);
};
$0b2e6adb871a3b94$var$nl.prototype.unmount = $0b2e6adb871a3b94$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Sk(function() {
            $0b2e6adb871a3b94$var$gl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$ql() {}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$hl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$fl(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$ql);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$hl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$cl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$ql);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Sk(function() {
        $0b2e6adb871a3b94$var$gl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$hl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$gl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$rl(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$hl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Ek(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Sk(function() {
                var b = $0b2e6adb871a3b94$var$Zg(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$L();
                    $0b2e6adb871a3b94$var$mh(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$jl(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$L();
            $0b2e6adb871a3b94$var$mh(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$jl(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$lh(a), c = $0b2e6adb871a3b94$var$Zg(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$L();
            $0b2e6adb871a3b94$var$mh(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$jl(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Rk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Sk;
var $0b2e6adb871a3b94$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Rk
    ]
}, $0b2e6adb871a3b94$var$ul = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$vl = {
    bundleType: $0b2e6adb871a3b94$var$ul.bundleType,
    version: $0b2e6adb871a3b94$var$ul.version,
    rendererPackageName: $0b2e6adb871a3b94$var$ul.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$ul.findFiberByHostInstance || $0b2e6adb871a3b94$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$wl.isDisabled && $0b2e6adb871a3b94$var$wl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$wl.inject($0b2e6adb871a3b94$var$vl), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$wl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$tl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$dl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Sk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$pl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$sl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$nl(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$pl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$sl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$pl(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Sk(function() {
        $0b2e6adb871a3b94$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Rk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$pl(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$sl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("fO90s", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
"use strict";
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});



parcelRegister("30Ie1", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $2313ad640c2ad62d$export$306c0aa65ff9ec16, (v) => $2313ad640c2ad62d$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2313ad640c2ad62d$export$306c0aa65ff9ec16;
"use strict";

var $acw62 = parcelRequire("acw62");
function $2313ad640c2ad62d$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $2313ad640c2ad62d$var$k = "function" === typeof Object.is ? Object.is : $2313ad640c2ad62d$var$h, $2313ad640c2ad62d$var$l = $acw62.useState, $2313ad640c2ad62d$var$m = $acw62.useEffect, $2313ad640c2ad62d$var$n = $acw62.useLayoutEffect, $2313ad640c2ad62d$var$p = $acw62.useDebugValue;
function $2313ad640c2ad62d$var$q(a, b) {
    var d = b(), f = $2313ad640c2ad62d$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $2313ad640c2ad62d$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $2313ad640c2ad62d$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $2313ad640c2ad62d$var$m(function() {
        $2313ad640c2ad62d$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $2313ad640c2ad62d$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $2313ad640c2ad62d$var$p(d);
    return d;
}
function $2313ad640c2ad62d$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$2313ad640c2ad62d$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $2313ad640c2ad62d$var$t(a, b) {
    return b();
}
var $2313ad640c2ad62d$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $2313ad640c2ad62d$var$t : $2313ad640c2ad62d$var$q;
$2313ad640c2ad62d$export$306c0aa65ff9ec16 = void 0 !== $acw62.useSyncExternalStore ? $acw62.useSyncExternalStore : $2313ad640c2ad62d$var$u;

});

parcelRegister("6VZtt", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $50c7c0793ca9e0ff$export$bf730a2d8bf68b42, (v) => $50c7c0793ca9e0ff$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $50c7c0793ca9e0ff$export$bf730a2d8bf68b42;
"use strict";

var $acw62 = parcelRequire("acw62");

var $hfliI = parcelRequire("hfliI");
function $50c7c0793ca9e0ff$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $50c7c0793ca9e0ff$var$q = "function" === typeof Object.is ? Object.is : $50c7c0793ca9e0ff$var$p, $50c7c0793ca9e0ff$var$r = $hfliI.useSyncExternalStore, $50c7c0793ca9e0ff$var$t = $acw62.useRef, $50c7c0793ca9e0ff$var$u = $acw62.useEffect, $50c7c0793ca9e0ff$var$v = $acw62.useMemo, $50c7c0793ca9e0ff$var$w = $acw62.useDebugValue;
$50c7c0793ca9e0ff$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $50c7c0793ca9e0ff$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $50c7c0793ca9e0ff$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($50c7c0793ca9e0ff$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $50c7c0793ca9e0ff$var$r(a, c[0], c[1]);
    $50c7c0793ca9e0ff$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $50c7c0793ca9e0ff$var$w(d);
    return d;
};

});
parcelRegister("hfliI", function(module, exports) {
"use strict";

module.exports = (parcelRequire("30Ie1"));

});


parcelRegister("9cCWX", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $6b3372b60d35b33f$export$2b8d127b894957b9, (v) => $6b3372b60d35b33f$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $6b3372b60d35b33f$export$cea3a54a6425200c, (v) => $6b3372b60d35b33f$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $6b3372b60d35b33f$export$a7c73072b1a182ae, (v) => $6b3372b60d35b33f$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $6b3372b60d35b33f$export$9f27bc3417b4524d, (v) => $6b3372b60d35b33f$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $6b3372b60d35b33f$export$db77ccec0bb4ccac, (v) => $6b3372b60d35b33f$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $6b3372b60d35b33f$export$8392c0c9d3dcbd35, (v) => $6b3372b60d35b33f$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $6b3372b60d35b33f$export$ffb0004e005737fa, (v) => $6b3372b60d35b33f$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $6b3372b60d35b33f$export$b624eff549462981, (v) => $6b3372b60d35b33f$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $6b3372b60d35b33f$export$7897aa7841a5380c, (v) => $6b3372b60d35b33f$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $6b3372b60d35b33f$export$602eac185826482c, (v) => $6b3372b60d35b33f$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $6b3372b60d35b33f$export$e2c29f18771995cb, (v) => $6b3372b60d35b33f$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $6b3372b60d35b33f$export$5f8d39834fd61797, (v) => $6b3372b60d35b33f$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $6b3372b60d35b33f$export$74bf444e3cd11ea5, (v) => $6b3372b60d35b33f$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $6b3372b60d35b33f$export$92387174baf9b227, (v) => $6b3372b60d35b33f$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $6b3372b60d35b33f$export$ec112efeb987d9c6, (v) => $6b3372b60d35b33f$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $6b3372b60d35b33f$export$b706b080d889d2c9, (v) => $6b3372b60d35b33f$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $6b3372b60d35b33f$export$5be5a87408f70ddc, (v) => $6b3372b60d35b33f$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $6b3372b60d35b33f$export$45a5e7f76e0caa8d, (v) => $6b3372b60d35b33f$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $6b3372b60d35b33f$export$455c2e768291efa6, (v) => $6b3372b60d35b33f$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $6b3372b60d35b33f$export$9522e17588c12572, (v) => $6b3372b60d35b33f$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $6b3372b60d35b33f$export$2110ac352bb060b9, (v) => $6b3372b60d35b33f$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $6b3372b60d35b33f$export$56885ab8b9c456ab, (v) => $6b3372b60d35b33f$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $6b3372b60d35b33f$export$d927fcb6adf8f9de, (v) => $6b3372b60d35b33f$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $6b3372b60d35b33f$export$b82d16f27459e05a, (v) => $6b3372b60d35b33f$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $6b3372b60d35b33f$export$522c17b4f5e123e8, (v) => $6b3372b60d35b33f$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $6b3372b60d35b33f$export$1aabd8a0274ecfd6, (v) => $6b3372b60d35b33f$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $6b3372b60d35b33f$export$9b621391a187a31a, (v) => $6b3372b60d35b33f$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $6b3372b60d35b33f$export$f5bbd400c2f4426f, (v) => $6b3372b60d35b33f$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6b3372b60d35b33f$export$2b8d127b894957b9;
var $6b3372b60d35b33f$export$cea3a54a6425200c;
var $6b3372b60d35b33f$export$a7c73072b1a182ae;
var $6b3372b60d35b33f$export$9f27bc3417b4524d;
var $6b3372b60d35b33f$export$db77ccec0bb4ccac;
var $6b3372b60d35b33f$export$8392c0c9d3dcbd35;
var $6b3372b60d35b33f$export$ffb0004e005737fa;
var $6b3372b60d35b33f$export$b624eff549462981;
var $6b3372b60d35b33f$export$7897aa7841a5380c;
var $6b3372b60d35b33f$export$602eac185826482c;
var $6b3372b60d35b33f$export$e2c29f18771995cb;
var $6b3372b60d35b33f$export$5f8d39834fd61797;
var $6b3372b60d35b33f$export$74bf444e3cd11ea5;
var $6b3372b60d35b33f$export$92387174baf9b227;
var $6b3372b60d35b33f$export$ec112efeb987d9c6;
var $6b3372b60d35b33f$export$b706b080d889d2c9;
var $6b3372b60d35b33f$export$5be5a87408f70ddc;
var $6b3372b60d35b33f$export$45a5e7f76e0caa8d;
var $6b3372b60d35b33f$export$455c2e768291efa6;
var $6b3372b60d35b33f$export$9522e17588c12572;
var $6b3372b60d35b33f$export$2110ac352bb060b9;
var $6b3372b60d35b33f$export$56885ab8b9c456ab;
var $6b3372b60d35b33f$export$d927fcb6adf8f9de;
var $6b3372b60d35b33f$export$b82d16f27459e05a;
var $6b3372b60d35b33f$export$522c17b4f5e123e8;
var $6b3372b60d35b33f$export$1aabd8a0274ecfd6;
var $6b3372b60d35b33f$export$9b621391a187a31a;
var $6b3372b60d35b33f$export$f5bbd400c2f4426f;
"use strict";
var $6b3372b60d35b33f$var$b = "function" === typeof Symbol && Symbol.for, $6b3372b60d35b33f$var$c = $6b3372b60d35b33f$var$b ? Symbol.for("react.element") : 60103, $6b3372b60d35b33f$var$d = $6b3372b60d35b33f$var$b ? Symbol.for("react.portal") : 60106, $6b3372b60d35b33f$var$e = $6b3372b60d35b33f$var$b ? Symbol.for("react.fragment") : 60107, $6b3372b60d35b33f$var$f = $6b3372b60d35b33f$var$b ? Symbol.for("react.strict_mode") : 60108, $6b3372b60d35b33f$var$g = $6b3372b60d35b33f$var$b ? Symbol.for("react.profiler") : 60114, $6b3372b60d35b33f$var$h = $6b3372b60d35b33f$var$b ? Symbol.for("react.provider") : 60109, $6b3372b60d35b33f$var$k = $6b3372b60d35b33f$var$b ? Symbol.for("react.context") : 60110, $6b3372b60d35b33f$var$l = $6b3372b60d35b33f$var$b ? Symbol.for("react.async_mode") : 60111, $6b3372b60d35b33f$var$m = $6b3372b60d35b33f$var$b ? Symbol.for("react.concurrent_mode") : 60111, $6b3372b60d35b33f$var$n = $6b3372b60d35b33f$var$b ? Symbol.for("react.forward_ref") : 60112, $6b3372b60d35b33f$var$p = $6b3372b60d35b33f$var$b ? Symbol.for("react.suspense") : 60113, $6b3372b60d35b33f$var$q = $6b3372b60d35b33f$var$b ? Symbol.for("react.suspense_list") : 60120, $6b3372b60d35b33f$var$r = $6b3372b60d35b33f$var$b ? Symbol.for("react.memo") : 60115, $6b3372b60d35b33f$var$t = $6b3372b60d35b33f$var$b ? Symbol.for("react.lazy") : 60116, $6b3372b60d35b33f$var$v = $6b3372b60d35b33f$var$b ? Symbol.for("react.block") : 60121, $6b3372b60d35b33f$var$w = $6b3372b60d35b33f$var$b ? Symbol.for("react.fundamental") : 60117, $6b3372b60d35b33f$var$x = $6b3372b60d35b33f$var$b ? Symbol.for("react.responder") : 60118, $6b3372b60d35b33f$var$y = $6b3372b60d35b33f$var$b ? Symbol.for("react.scope") : 60119;
function $6b3372b60d35b33f$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $6b3372b60d35b33f$var$c:
                switch(a = a.type, a){
                    case $6b3372b60d35b33f$var$l:
                    case $6b3372b60d35b33f$var$m:
                    case $6b3372b60d35b33f$var$e:
                    case $6b3372b60d35b33f$var$g:
                    case $6b3372b60d35b33f$var$f:
                    case $6b3372b60d35b33f$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $6b3372b60d35b33f$var$k:
                            case $6b3372b60d35b33f$var$n:
                            case $6b3372b60d35b33f$var$t:
                            case $6b3372b60d35b33f$var$r:
                            case $6b3372b60d35b33f$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $6b3372b60d35b33f$var$d:
                return u;
        }
    }
}
function $6b3372b60d35b33f$var$A(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$m;
}
$6b3372b60d35b33f$export$2b8d127b894957b9 = $6b3372b60d35b33f$var$l;
$6b3372b60d35b33f$export$cea3a54a6425200c = $6b3372b60d35b33f$var$m;
$6b3372b60d35b33f$export$a7c73072b1a182ae = $6b3372b60d35b33f$var$k;
$6b3372b60d35b33f$export$9f27bc3417b4524d = $6b3372b60d35b33f$var$h;
$6b3372b60d35b33f$export$db77ccec0bb4ccac = $6b3372b60d35b33f$var$c;
$6b3372b60d35b33f$export$8392c0c9d3dcbd35 = $6b3372b60d35b33f$var$n;
$6b3372b60d35b33f$export$ffb0004e005737fa = $6b3372b60d35b33f$var$e;
$6b3372b60d35b33f$export$b624eff549462981 = $6b3372b60d35b33f$var$t;
$6b3372b60d35b33f$export$7897aa7841a5380c = $6b3372b60d35b33f$var$r;
$6b3372b60d35b33f$export$602eac185826482c = $6b3372b60d35b33f$var$d;
$6b3372b60d35b33f$export$e2c29f18771995cb = $6b3372b60d35b33f$var$g;
$6b3372b60d35b33f$export$5f8d39834fd61797 = $6b3372b60d35b33f$var$f;
$6b3372b60d35b33f$export$74bf444e3cd11ea5 = $6b3372b60d35b33f$var$p;
$6b3372b60d35b33f$export$92387174baf9b227 = function(a) {
    return $6b3372b60d35b33f$var$A(a) || $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$l;
};
$6b3372b60d35b33f$export$ec112efeb987d9c6 = $6b3372b60d35b33f$var$A;
$6b3372b60d35b33f$export$b706b080d889d2c9 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$k;
};
$6b3372b60d35b33f$export$5be5a87408f70ddc = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$h;
};
$6b3372b60d35b33f$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $6b3372b60d35b33f$var$c;
};
$6b3372b60d35b33f$export$455c2e768291efa6 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$n;
};
$6b3372b60d35b33f$export$9522e17588c12572 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$e;
};
$6b3372b60d35b33f$export$2110ac352bb060b9 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$t;
};
$6b3372b60d35b33f$export$56885ab8b9c456ab = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$r;
};
$6b3372b60d35b33f$export$d927fcb6adf8f9de = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$d;
};
$6b3372b60d35b33f$export$b82d16f27459e05a = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$g;
};
$6b3372b60d35b33f$export$522c17b4f5e123e8 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$f;
};
$6b3372b60d35b33f$export$1aabd8a0274ecfd6 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$p;
};
$6b3372b60d35b33f$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $6b3372b60d35b33f$var$e || a === $6b3372b60d35b33f$var$m || a === $6b3372b60d35b33f$var$g || a === $6b3372b60d35b33f$var$f || a === $6b3372b60d35b33f$var$p || a === $6b3372b60d35b33f$var$q || "object" === typeof a && null !== a && (a.$$typeof === $6b3372b60d35b33f$var$t || a.$$typeof === $6b3372b60d35b33f$var$r || a.$$typeof === $6b3372b60d35b33f$var$h || a.$$typeof === $6b3372b60d35b33f$var$k || a.$$typeof === $6b3372b60d35b33f$var$n || a.$$typeof === $6b3372b60d35b33f$var$w || a.$$typeof === $6b3372b60d35b33f$var$x || a.$$typeof === $6b3372b60d35b33f$var$y || a.$$typeof === $6b3372b60d35b33f$var$v);
};
$6b3372b60d35b33f$export$f5bbd400c2f4426f = $6b3372b60d35b33f$var$z;

});

parcelRegister("cgj07", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $8ed5b7d8837dad8a$export$a7c73072b1a182ae, (v) => $8ed5b7d8837dad8a$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $8ed5b7d8837dad8a$export$9f27bc3417b4524d, (v) => $8ed5b7d8837dad8a$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $8ed5b7d8837dad8a$export$db77ccec0bb4ccac, (v) => $8ed5b7d8837dad8a$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $8ed5b7d8837dad8a$export$8392c0c9d3dcbd35, (v) => $8ed5b7d8837dad8a$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $8ed5b7d8837dad8a$export$ffb0004e005737fa, (v) => $8ed5b7d8837dad8a$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $8ed5b7d8837dad8a$export$b624eff549462981, (v) => $8ed5b7d8837dad8a$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $8ed5b7d8837dad8a$export$7897aa7841a5380c, (v) => $8ed5b7d8837dad8a$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $8ed5b7d8837dad8a$export$602eac185826482c, (v) => $8ed5b7d8837dad8a$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $8ed5b7d8837dad8a$export$e2c29f18771995cb, (v) => $8ed5b7d8837dad8a$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $8ed5b7d8837dad8a$export$5f8d39834fd61797, (v) => $8ed5b7d8837dad8a$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $8ed5b7d8837dad8a$export$74bf444e3cd11ea5, (v) => $8ed5b7d8837dad8a$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $8ed5b7d8837dad8a$export$998bcd577473dd93, (v) => $8ed5b7d8837dad8a$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $8ed5b7d8837dad8a$export$92387174baf9b227, (v) => $8ed5b7d8837dad8a$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $8ed5b7d8837dad8a$export$ec112efeb987d9c6, (v) => $8ed5b7d8837dad8a$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $8ed5b7d8837dad8a$export$b706b080d889d2c9, (v) => $8ed5b7d8837dad8a$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $8ed5b7d8837dad8a$export$5be5a87408f70ddc, (v) => $8ed5b7d8837dad8a$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $8ed5b7d8837dad8a$export$45a5e7f76e0caa8d, (v) => $8ed5b7d8837dad8a$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $8ed5b7d8837dad8a$export$455c2e768291efa6, (v) => $8ed5b7d8837dad8a$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $8ed5b7d8837dad8a$export$9522e17588c12572, (v) => $8ed5b7d8837dad8a$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $8ed5b7d8837dad8a$export$2110ac352bb060b9, (v) => $8ed5b7d8837dad8a$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $8ed5b7d8837dad8a$export$56885ab8b9c456ab, (v) => $8ed5b7d8837dad8a$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $8ed5b7d8837dad8a$export$d927fcb6adf8f9de, (v) => $8ed5b7d8837dad8a$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $8ed5b7d8837dad8a$export$b82d16f27459e05a, (v) => $8ed5b7d8837dad8a$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $8ed5b7d8837dad8a$export$522c17b4f5e123e8, (v) => $8ed5b7d8837dad8a$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $8ed5b7d8837dad8a$export$1aabd8a0274ecfd6, (v) => $8ed5b7d8837dad8a$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $8ed5b7d8837dad8a$export$3d6c20d97e46b957, (v) => $8ed5b7d8837dad8a$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $8ed5b7d8837dad8a$export$9b621391a187a31a, (v) => $8ed5b7d8837dad8a$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $8ed5b7d8837dad8a$export$f5bbd400c2f4426f, (v) => $8ed5b7d8837dad8a$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8ed5b7d8837dad8a$export$a7c73072b1a182ae;
var $8ed5b7d8837dad8a$export$9f27bc3417b4524d;
var $8ed5b7d8837dad8a$export$db77ccec0bb4ccac;
var $8ed5b7d8837dad8a$export$8392c0c9d3dcbd35;
var $8ed5b7d8837dad8a$export$ffb0004e005737fa;
var $8ed5b7d8837dad8a$export$b624eff549462981;
var $8ed5b7d8837dad8a$export$7897aa7841a5380c;
var $8ed5b7d8837dad8a$export$602eac185826482c;
var $8ed5b7d8837dad8a$export$e2c29f18771995cb;
var $8ed5b7d8837dad8a$export$5f8d39834fd61797;
var $8ed5b7d8837dad8a$export$74bf444e3cd11ea5;
var $8ed5b7d8837dad8a$export$998bcd577473dd93;
var $8ed5b7d8837dad8a$export$92387174baf9b227;
var $8ed5b7d8837dad8a$export$ec112efeb987d9c6;
var $8ed5b7d8837dad8a$export$b706b080d889d2c9;
var $8ed5b7d8837dad8a$export$5be5a87408f70ddc;
var $8ed5b7d8837dad8a$export$45a5e7f76e0caa8d;
var $8ed5b7d8837dad8a$export$455c2e768291efa6;
var $8ed5b7d8837dad8a$export$9522e17588c12572;
var $8ed5b7d8837dad8a$export$2110ac352bb060b9;
var $8ed5b7d8837dad8a$export$56885ab8b9c456ab;
var $8ed5b7d8837dad8a$export$d927fcb6adf8f9de;
var $8ed5b7d8837dad8a$export$b82d16f27459e05a;
var $8ed5b7d8837dad8a$export$522c17b4f5e123e8;
var $8ed5b7d8837dad8a$export$1aabd8a0274ecfd6;
var $8ed5b7d8837dad8a$export$3d6c20d97e46b957;
var $8ed5b7d8837dad8a$export$9b621391a187a31a;
var $8ed5b7d8837dad8a$export$f5bbd400c2f4426f;
"use strict";
var $8ed5b7d8837dad8a$var$b = Symbol.for("react.element"), $8ed5b7d8837dad8a$var$c = Symbol.for("react.portal"), $8ed5b7d8837dad8a$var$d = Symbol.for("react.fragment"), $8ed5b7d8837dad8a$var$e = Symbol.for("react.strict_mode"), $8ed5b7d8837dad8a$var$f = Symbol.for("react.profiler"), $8ed5b7d8837dad8a$var$g = Symbol.for("react.provider"), $8ed5b7d8837dad8a$var$h = Symbol.for("react.context"), $8ed5b7d8837dad8a$var$k = Symbol.for("react.server_context"), $8ed5b7d8837dad8a$var$l = Symbol.for("react.forward_ref"), $8ed5b7d8837dad8a$var$m = Symbol.for("react.suspense"), $8ed5b7d8837dad8a$var$n = Symbol.for("react.suspense_list"), $8ed5b7d8837dad8a$var$p = Symbol.for("react.memo"), $8ed5b7d8837dad8a$var$q = Symbol.for("react.lazy"), $8ed5b7d8837dad8a$var$t = Symbol.for("react.offscreen"), $8ed5b7d8837dad8a$var$u;
$8ed5b7d8837dad8a$var$u = Symbol.for("react.module.reference");
function $8ed5b7d8837dad8a$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $8ed5b7d8837dad8a$var$b:
                switch(a = a.type, a){
                    case $8ed5b7d8837dad8a$var$d:
                    case $8ed5b7d8837dad8a$var$f:
                    case $8ed5b7d8837dad8a$var$e:
                    case $8ed5b7d8837dad8a$var$m:
                    case $8ed5b7d8837dad8a$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $8ed5b7d8837dad8a$var$k:
                            case $8ed5b7d8837dad8a$var$h:
                            case $8ed5b7d8837dad8a$var$l:
                            case $8ed5b7d8837dad8a$var$q:
                            case $8ed5b7d8837dad8a$var$p:
                            case $8ed5b7d8837dad8a$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $8ed5b7d8837dad8a$var$c:
                return r;
        }
    }
}
$8ed5b7d8837dad8a$export$a7c73072b1a182ae = $8ed5b7d8837dad8a$var$h;
$8ed5b7d8837dad8a$export$9f27bc3417b4524d = $8ed5b7d8837dad8a$var$g;
$8ed5b7d8837dad8a$export$db77ccec0bb4ccac = $8ed5b7d8837dad8a$var$b;
$8ed5b7d8837dad8a$export$8392c0c9d3dcbd35 = $8ed5b7d8837dad8a$var$l;
$8ed5b7d8837dad8a$export$ffb0004e005737fa = $8ed5b7d8837dad8a$var$d;
$8ed5b7d8837dad8a$export$b624eff549462981 = $8ed5b7d8837dad8a$var$q;
$8ed5b7d8837dad8a$export$7897aa7841a5380c = $8ed5b7d8837dad8a$var$p;
$8ed5b7d8837dad8a$export$602eac185826482c = $8ed5b7d8837dad8a$var$c;
$8ed5b7d8837dad8a$export$e2c29f18771995cb = $8ed5b7d8837dad8a$var$f;
$8ed5b7d8837dad8a$export$5f8d39834fd61797 = $8ed5b7d8837dad8a$var$e;
$8ed5b7d8837dad8a$export$74bf444e3cd11ea5 = $8ed5b7d8837dad8a$var$m;
$8ed5b7d8837dad8a$export$998bcd577473dd93 = $8ed5b7d8837dad8a$var$n;
$8ed5b7d8837dad8a$export$92387174baf9b227 = function() {
    return !1;
};
$8ed5b7d8837dad8a$export$ec112efeb987d9c6 = function() {
    return !1;
};
$8ed5b7d8837dad8a$export$b706b080d889d2c9 = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$h;
};
$8ed5b7d8837dad8a$export$5be5a87408f70ddc = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$g;
};
$8ed5b7d8837dad8a$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $8ed5b7d8837dad8a$var$b;
};
$8ed5b7d8837dad8a$export$455c2e768291efa6 = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$l;
};
$8ed5b7d8837dad8a$export$9522e17588c12572 = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$d;
};
$8ed5b7d8837dad8a$export$2110ac352bb060b9 = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$q;
};
$8ed5b7d8837dad8a$export$56885ab8b9c456ab = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$p;
};
$8ed5b7d8837dad8a$export$d927fcb6adf8f9de = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$c;
};
$8ed5b7d8837dad8a$export$b82d16f27459e05a = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$f;
};
$8ed5b7d8837dad8a$export$522c17b4f5e123e8 = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$e;
};
$8ed5b7d8837dad8a$export$1aabd8a0274ecfd6 = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$m;
};
$8ed5b7d8837dad8a$export$3d6c20d97e46b957 = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$n;
};
$8ed5b7d8837dad8a$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $8ed5b7d8837dad8a$var$d || a === $8ed5b7d8837dad8a$var$f || a === $8ed5b7d8837dad8a$var$e || a === $8ed5b7d8837dad8a$var$m || a === $8ed5b7d8837dad8a$var$n || a === $8ed5b7d8837dad8a$var$t || "object" === typeof a && null !== a && (a.$$typeof === $8ed5b7d8837dad8a$var$q || a.$$typeof === $8ed5b7d8837dad8a$var$p || a.$$typeof === $8ed5b7d8837dad8a$var$g || a.$$typeof === $8ed5b7d8837dad8a$var$h || a.$$typeof === $8ed5b7d8837dad8a$var$l || a.$$typeof === $8ed5b7d8837dad8a$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$8ed5b7d8837dad8a$export$f5bbd400c2f4426f = $8ed5b7d8837dad8a$var$v;

});

parcelRegister("i4CZ2", function(module, exports) {

$parcel$export(module.exports, "isDraft", () => r);
$parcel$export(module.exports, "isDraftable", () => t);
$parcel$export(module.exports, "immerable", () => L);
$parcel$export(module.exports, "original", () => e);
$parcel$export(module.exports, "freeze", () => d);
$parcel$export(module.exports, "nothing", () => H);
$parcel$export(module.exports, "current", () => R);
$parcel$export(module.exports, "enableES5", () => F);
$parcel$export(module.exports, "enablePatches", () => T);
$parcel$export(module.exports, "enableMapSet", () => C);
$parcel$export(module.exports, "enableAllPlugins", () => J);
$parcel$export(module.exports, "castDraft", () => K);
$parcel$export(module.exports, "castImmutable", () => $);
$parcel$export(module.exports, "Immer", () => un);
$parcel$export(module.exports, "produce", () => fn);
$parcel$export(module.exports, "produceWithPatches", () => cn);
$parcel$export(module.exports, "setAutoFreeze", () => sn);
$parcel$export(module.exports, "setUseProxies", () => vn);
$parcel$export(module.exports, "applyPatches", () => pn);
$parcel$export(module.exports, "createDraft", () => ln);
$parcel$export(module.exports, "finishDraft", () => dn);
$parcel$export(module.exports, "default", () => $d286d705bbfd559a$export$2e2bcd8739ae039);
function n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(n) {
    return !!n && !!n[Q];
}
function t(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
    }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
}
function e(t) {
    return r(t) || n(23, t), t[Q].t;
}
function i(n, r, t) {
    void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function o(n) {
    var r = n[Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, r) {
    return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function a(n, r) {
    return 2 === o(n) ? n.get(r) : n[r];
}
function f(n, r, t) {
    var e = o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = rn(n);
    delete r[Q];
    for(var t = nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function d(n, e) {
    return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
        return d(r, !0);
    }, !0)), n;
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b(r) {
    var t = tn[r];
    return t || n(18, r), t;
}
function m(n, r) {
    tn[n] || (tn[n] = r);
}
function _() {
    return U;
}
function j(n, r) {
    r && (b("Patches"), n.u = [], n.s = [], n.v = r);
}
function g(n) {
    O(n), n.p.forEach(S), n.p = null;
}
function O(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var r = n[Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.O || b("ES5").S(e, r, o), o ? (i[Q].P && (g(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), g(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
}
function M(n, r, t) {
    if (y(r)) return r;
    var e = r[Q];
    if (!e) return i(r, function(i, o) {
        return A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function(r, i) {
            return A(n, e, o, r, i, t, a);
        }), x(n, o, !1), t && n.u && b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s, v) {
    if (r(c)) {
        var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
        if (f(o, a, p), !r(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if (t(c) && !y(c)) {
        if (!e.h.D && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
}
function z(n, r) {
    var t = n[Q];
    return (t ? p(t) : n)[r];
}
function I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function k(n) {
    n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
    n.o || (n.o = l(n.t));
}
function N(n, r, t) {
    var e = s(r) ? b("MapSet").F(r, t) : v(r) ? b("MapSet").T(r, t) : n.O ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : _(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = en;
        t && (i = [
            e
        ], o = on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : b("ES5").J(r, t);
    return (t ? t.A : _()).p.push(e), e;
}
function R(e) {
    return r(e) || n(22, e), function n(r) {
        if (!t(r)) return r;
        var e, u = r[Q], c = o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
            u.I = !0, e = D(r, c), u.I = !1;
        } else e = D(r, c);
        return i(e, function(r, t) {
            u && a(u.t, r) === t || f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
function F() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[Q];
                return en.get(r, n);
            },
            set: function(r) {
                var t = this[Q];
                en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && k(t);
                    break;
                case 4:
                    o(t) && k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== Q) {
                var a = r[o];
                if (void 0 === a && !u(r, o)) return !0;
                var f = t[o], s = f && f[Q];
                if (s ? s.t !== a : !c(f, a)) return !0;
            }
        }
        var v = !!r[Q];
        return e.length !== nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var s = {};
    m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = rn(r);
                delete o[Q];
                for(var u = nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(i, Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.R, c = t.i;
                        if (4 === c) i(o, function(r) {
                            r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
                        }), i(e, function(n) {
                            void 0 !== o[n] || u(o, n) || (f[n] = !1, k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && (k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function T() {
    function e(n) {
        if (!t(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if (v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return u(n, L) && (r[L] = n[L]), r;
    }
    function f(n) {
        return r(n) ? e(n) : n;
    }
    var c = "add";
    m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = o(f), p = i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                }
                var l = o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        n(17, u);
                }
            }), r;
        },
        N: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        i(n.R, function(n, i) {
                            var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.R, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === H ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function C() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if (t(r)) {
                var e = N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[Q] = {
                i: 2,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), o.has = function(n) {
            return p(this[Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[Q];
            return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), e(r), k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (e(n), k(n), n.R = new Map, i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            p(this[Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[Q];
            u(r);
            var i = p(r).get(n);
            if (r.I || !t(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = N(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return p(this[Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[Q] = {
                i: 3,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), t.has = function(n) {
            var r = this[Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[Q];
            return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (o(n), k(n), n.o.clear());
        }, t.values = function() {
            var n = this[Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    m("MapSet", {
        F: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function J() {
    F(), C(), T();
}
function K(n) {
    return n;
}
function $(n) {
    return n;
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, tn = {}, en = {
    get: function(n, r) {
        if (r === Q) return n;
        var e = p(n);
        if (!u(e, r)) return function(n, r, t) {
            var e, i = I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function(n, r, t) {
        var e = I(p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = z(p(n), r), o = null == i ? void 0 : i[Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
            E(n), k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        n(12);
    }
}, on = {};
i(en, function(n, r) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), on.deleteProperty = function(r, t) {
    return on.set.call(this, r, t, void 0);
}, on.set = function(r, t, e) {
    return en.set.call(this, r[0], t, e, r[0]);
};
var un = function() {
    function e(r) {
        var e = this;
        this.O = B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                var c = w(e), s = N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? g(c) : O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return j(c, o), P(n, c);
                }, function(n) {
                    throw g(c), n;
                }) : (j(c, o), P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
                    var p = [], l = [];
                    b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        t(e) || n(8), r(e) && (e = R(e));
        var i = w(this), o = N(this, e, void 0);
        return o[Q].C = !0, O(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[Q];
        var i = e.A;
        return j(i, t), P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !B && n(20), this.O = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = b("Patches").$;
        return r(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
var $d286d705bbfd559a$export$2e2bcd8739ae039 = fn;

});

parcelRegister("7YFi7", function(module, exports) {

$parcel$export(module.exports, "Formik", () => Formik);
$parcel$export(module.exports, "Field", () => Field);
$parcel$export(module.exports, "Form", () => Form);

var $cCVp3 = parcelRequire("cCVp3");

var $3rtvu = parcelRequire("3rtvu");

var $acw62 = parcelRequire("acw62");

var $ai2Pb = parcelRequire("ai2Pb");

var $9RYKL = parcelRequire("9RYKL");

var $hNIl0 = parcelRequire("hNIl0");

var $58lCa = parcelRequire("58lCa");

var $9ORqK = parcelRequire("9ORqK");

var $chB0Q = parcelRequire("chB0Q");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
var FormikContext = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
FormikContext.displayName = "FormikContext";
var FormikProvider = FormikContext.Provider;
var FormikConsumer = FormikContext.Consumer;
function useFormikContext() {
    var formik = (0, $acw62.useContext)(FormikContext);
    !!!formik && (0, $9RYKL.default)(false);
    return formik;
}
/** @private is the value an empty array? */ var isEmptyArray = function isEmptyArray(value) {
    return Array.isArray(value) && value.length === 0;
};
/** @private is the given object a Function? */ var isFunction = function isFunction(obj) {
    return typeof obj === "function";
};
/** @private is the given object an Object? */ var isObject = function isObject(obj) {
    return obj !== null && typeof obj === "object";
};
/** @private is the given object an integer? */ var isInteger = function isInteger(obj) {
    return String(Math.floor(Number(obj))) === obj;
};
/** @private is the given object a string? */ var isString = function isString(obj) {
    return Object.prototype.toString.call(obj) === "[object String]";
};
/** @private is the given object a NaN? */ // eslint-disable-next-line no-self-compare
var isNaN$1 = function isNaN1(obj) {
    return obj !== obj;
};
/** @private Does a React component have exactly 0 children? */ var isEmptyChildren = function isEmptyChildren(children) {
    return (0, $acw62.Children).count(children) === 0;
};
/** @private is the given object/value a promise? */ var isPromise = function isPromise(value) {
    return isObject(value) && isFunction(value.then);
};
/** @private is the given object/value a type of synthetic event? */ var isInputEvent = function isInputEvent(value) {
    return value && isObject(value) && isObject(value.target);
};
/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?Document} doc Defaults to current document.
 * @return {Element | null}
 * @see https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/dom/getActiveElement.js
 */ function getActiveElement(doc) {
    doc = doc || (typeof document !== "undefined" ? document : undefined);
    if (typeof doc === "undefined") return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
/**
 * Deeply get a value from an object via its path.
 */ function getIn(obj, key, def, p) {
    if (p === void 0) p = 0;
    var path = (0, $58lCa.default)(key);
    while(obj && p < path.length)obj = obj[path[p++]];
     // check if path is not in the end
    if (p !== path.length && !obj) return def;
    return obj === undefined ? def : obj;
}
/**
 * Deeply set a value from in object via it's path. If the value at `path`
 * has changed, return a shallow copy of obj with `value` set at `path`.
 * If `value` has not changed, return the original `obj`.
 *
 * Existing objects / arrays along `path` are also shallow copied. Sibling
 * objects along path retain the same internal js reference. Since new
 * objects / arrays are only created along `path`, we can test if anything
 * changed in a nested structure by comparing the object's reference in
 * the old and new object, similar to how russian doll cache invalidation
 * works.
 *
 * In earlier versions of this function, which used cloneDeep, there were
 * issues whereby settings a nested value would mutate the parent
 * instead of creating a new object. `clone` avoids that bug making a
 * shallow copy of the objects along the update path
 * so no object is mutated in place.
 *
 * Before changing this function, please read through the following
 * discussions.
 *
 * @see https://github.com/developit/linkstate
 * @see https://github.com/jaredpalmer/formik/pull/123
 */ function setIn(obj, path, value) {
    var res = (0, $hNIl0.default)(obj); // this keeps inheritance when obj is a class
    var resVal = res;
    var i = 0;
    var pathArray = (0, $58lCa.default)(path);
    for(; i < pathArray.length - 1; i++){
        var currentPath = pathArray[i];
        var currentObj = getIn(obj, pathArray.slice(0, i + 1));
        if (currentObj && (isObject(currentObj) || Array.isArray(currentObj))) resVal = resVal[currentPath] = (0, $hNIl0.default)(currentObj);
        else {
            var nextPath = pathArray[i + 1];
            resVal = resVal[currentPath] = isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {};
        }
    } // Return original object if new value is the same as current
    if ((i === 0 ? obj : resVal)[pathArray[i]] === value) return obj;
    if (value === undefined) delete resVal[pathArray[i]];
    else resVal[pathArray[i]] = value;
     // If the path array has a single element, the loop did not run.
    // Deleting on `resVal` had no effect in this scenario, so we delete on the result instead.
    if (i === 0 && value === undefined) delete res[pathArray[i]];
    return res;
}
/**
 * Recursively a set the same value for all keys and arrays nested object, cloning
 * @param object
 * @param value
 * @param visited
 * @param response
 */ function setNestedObjectValues(object, value, visited, response) {
    if (visited === void 0) visited = new WeakMap();
    if (response === void 0) response = {};
    for(var _i = 0, _Object$keys = Object.keys(object); _i < _Object$keys.length; _i++){
        var k = _Object$keys[_i];
        var val = object[k];
        if (isObject(val)) {
            if (!visited.get(val)) {
                visited.set(val, true); // In order to keep array values consistent for both dot path  and
                // bracket syntax, we need to check if this is an array so that
                // this will output  { friends: [true] } and not { friends: { "0": true } }
                response[k] = Array.isArray(val) ? [] : {};
                setNestedObjectValues(val, value, visited, response[k]);
            }
        } else response[k] = value;
    }
    return response;
}
function formikReducer(state, msg) {
    switch(msg.type){
        case "SET_VALUES":
            return _extends({}, state, {
                values: msg.payload
            });
        case "SET_TOUCHED":
            return _extends({}, state, {
                touched: msg.payload
            });
        case "SET_ERRORS":
            if ((0, (/*@__PURE__*/$parcel$interopDefault($ai2Pb)))(state.errors, msg.payload)) return state;
            return _extends({}, state, {
                errors: msg.payload
            });
        case "SET_STATUS":
            return _extends({}, state, {
                status: msg.payload
            });
        case "SET_ISSUBMITTING":
            return _extends({}, state, {
                isSubmitting: msg.payload
            });
        case "SET_ISVALIDATING":
            return _extends({}, state, {
                isValidating: msg.payload
            });
        case "SET_FIELD_VALUE":
            return _extends({}, state, {
                values: setIn(state.values, msg.payload.field, msg.payload.value)
            });
        case "SET_FIELD_TOUCHED":
            return _extends({}, state, {
                touched: setIn(state.touched, msg.payload.field, msg.payload.value)
            });
        case "SET_FIELD_ERROR":
            return _extends({}, state, {
                errors: setIn(state.errors, msg.payload.field, msg.payload.value)
            });
        case "RESET_FORM":
            return _extends({}, state, msg.payload);
        case "SET_FORMIK_STATE":
            return msg.payload(state);
        case "SUBMIT_ATTEMPT":
            return _extends({}, state, {
                touched: setNestedObjectValues(state.values, true),
                isSubmitting: true,
                submitCount: state.submitCount + 1
            });
        case "SUBMIT_FAILURE":
            return _extends({}, state, {
                isSubmitting: false
            });
        case "SUBMIT_SUCCESS":
            return _extends({}, state, {
                isSubmitting: false
            });
        default:
            return state;
    }
} // Initial empty states // objects
var emptyErrors = {};
var emptyTouched = {};
function useFormik(_ref) {
    var _ref$validateOnChange = _ref.validateOnChange, validateOnChange = _ref$validateOnChange === void 0 ? true : _ref$validateOnChange, _ref$validateOnBlur = _ref.validateOnBlur, validateOnBlur = _ref$validateOnBlur === void 0 ? true : _ref$validateOnBlur, _ref$validateOnMount = _ref.validateOnMount, validateOnMount = _ref$validateOnMount === void 0 ? false : _ref$validateOnMount, isInitialValid = _ref.isInitialValid, _ref$enableReinitiali = _ref.enableReinitialize, enableReinitialize = _ref$enableReinitiali === void 0 ? false : _ref$enableReinitiali, onSubmit = _ref.onSubmit, rest = _objectWithoutPropertiesLoose(_ref, [
        "validateOnChange",
        "validateOnBlur",
        "validateOnMount",
        "isInitialValid",
        "enableReinitialize",
        "onSubmit"
    ]);
    var props = _extends({
        validateOnChange: validateOnChange,
        validateOnBlur: validateOnBlur,
        validateOnMount: validateOnMount,
        onSubmit: onSubmit
    }, rest);
    var initialValues = (0, $acw62.useRef)(props.initialValues);
    var initialErrors = (0, $acw62.useRef)(props.initialErrors || emptyErrors);
    var initialTouched = (0, $acw62.useRef)(props.initialTouched || emptyTouched);
    var initialStatus = (0, $acw62.useRef)(props.initialStatus);
    var isMounted = (0, $acw62.useRef)(false);
    var fieldRegistry = (0, $acw62.useRef)({});
    (0, $acw62.useEffect)(function() {
        isMounted.current = true;
        return function() {
            isMounted.current = false;
        };
    }, []);
    var _React$useState = (0, $acw62.useState)(0), setIteration = _React$useState[1];
    var stateRef = (0, $acw62.useRef)({
        values: props.initialValues,
        errors: props.initialErrors || emptyErrors,
        touched: props.initialTouched || emptyTouched,
        status: props.initialStatus,
        isSubmitting: false,
        isValidating: false,
        submitCount: 0
    });
    var state = stateRef.current;
    var dispatch = (0, $acw62.useCallback)(function(action) {
        var prev = stateRef.current;
        stateRef.current = formikReducer(prev, action); // force rerender
        if (prev !== stateRef.current) setIteration(function(x) {
            return x + 1;
        });
    }, []);
    var runValidateHandler = (0, $acw62.useCallback)(function(values, field) {
        return new Promise(function(resolve, reject) {
            var maybePromisedErrors = props.validate(values, field);
            if (maybePromisedErrors == null) // use loose null check here on purpose
            resolve(emptyErrors);
            else if (isPromise(maybePromisedErrors)) maybePromisedErrors.then(function(errors) {
                resolve(errors || emptyErrors);
            }, function(actualException) {
                reject(actualException);
            });
            else resolve(maybePromisedErrors);
        });
    }, [
        props.validate
    ]);
    /**
   * Run validation against a Yup schema and optionally run a function if successful
   */ var runValidationSchema = (0, $acw62.useCallback)(function(values, field) {
        var validationSchema = props.validationSchema;
        var schema = isFunction(validationSchema) ? validationSchema(field) : validationSchema;
        var promise = field && schema.validateAt ? schema.validateAt(field, values) : validateYupSchema(values, schema);
        return new Promise(function(resolve, reject) {
            promise.then(function() {
                resolve(emptyErrors);
            }, function(err) {
                // Yup will throw a validation error if validation fails. We catch those and
                // resolve them into Formik errors. We can sniff if something is a Yup error
                // by checking error.name.
                // @see https://github.com/jquense/yup#validationerrorerrors-string--arraystring-value-any-path-string
                if (err.name === "ValidationError") resolve(yupToFormErrors(err));
                else reject(err);
            });
        });
    }, [
        props.validationSchema
    ]);
    var runSingleFieldLevelValidation = (0, $acw62.useCallback)(function(field, value) {
        return new Promise(function(resolve) {
            return resolve(fieldRegistry.current[field].validate(value));
        });
    }, []);
    var runFieldLevelValidations = (0, $acw62.useCallback)(function(values) {
        var fieldKeysWithValidation = Object.keys(fieldRegistry.current).filter(function(f) {
            return isFunction(fieldRegistry.current[f].validate);
        }); // Construct an array with all of the field validation functions
        var fieldValidations = fieldKeysWithValidation.length > 0 ? fieldKeysWithValidation.map(function(f) {
            return runSingleFieldLevelValidation(f, getIn(values, f));
        }) : [
            Promise.resolve("DO_NOT_DELETE_YOU_WILL_BE_FIRED")
        ]; // use special case ;)
        return Promise.all(fieldValidations).then(function(fieldErrorsList) {
            return fieldErrorsList.reduce(function(prev, curr, index) {
                if (curr === "DO_NOT_DELETE_YOU_WILL_BE_FIRED") return prev;
                if (curr) prev = setIn(prev, fieldKeysWithValidation[index], curr);
                return prev;
            }, {});
        });
    }, [
        runSingleFieldLevelValidation
    ]); // Run all validations and return the result
    var runAllValidations = (0, $acw62.useCallback)(function(values) {
        return Promise.all([
            runFieldLevelValidations(values),
            props.validationSchema ? runValidationSchema(values) : {},
            props.validate ? runValidateHandler(values) : {}
        ]).then(function(_ref2) {
            var fieldErrors = _ref2[0], schemaErrors = _ref2[1], validateErrors = _ref2[2];
            var combinedErrors = (0, $cCVp3.default).all([
                fieldErrors,
                schemaErrors,
                validateErrors
            ], {
                arrayMerge: arrayMerge
            });
            return combinedErrors;
        });
    }, [
        props.validate,
        props.validationSchema,
        runFieldLevelValidations,
        runValidateHandler,
        runValidationSchema
    ]); // Run all validations methods and update state accordingly
    var validateFormWithHighPriority = useEventCallback(function(values) {
        if (values === void 0) values = state.values;
        dispatch({
            type: "SET_ISVALIDATING",
            payload: true
        });
        return runAllValidations(values).then(function(combinedErrors) {
            if (!!isMounted.current) {
                dispatch({
                    type: "SET_ISVALIDATING",
                    payload: false
                });
                dispatch({
                    type: "SET_ERRORS",
                    payload: combinedErrors
                });
            }
            return combinedErrors;
        });
    });
    (0, $acw62.useEffect)(function() {
        if (validateOnMount && isMounted.current === true && (0, (/*@__PURE__*/$parcel$interopDefault($ai2Pb)))(initialValues.current, props.initialValues)) validateFormWithHighPriority(initialValues.current);
    }, [
        validateOnMount,
        validateFormWithHighPriority
    ]);
    var resetForm = (0, $acw62.useCallback)(function(nextState) {
        var values = nextState && nextState.values ? nextState.values : initialValues.current;
        var errors = nextState && nextState.errors ? nextState.errors : initialErrors.current ? initialErrors.current : props.initialErrors || {};
        var touched = nextState && nextState.touched ? nextState.touched : initialTouched.current ? initialTouched.current : props.initialTouched || {};
        var status = nextState && nextState.status ? nextState.status : initialStatus.current ? initialStatus.current : props.initialStatus;
        initialValues.current = values;
        initialErrors.current = errors;
        initialTouched.current = touched;
        initialStatus.current = status;
        var dispatchFn = function dispatchFn() {
            dispatch({
                type: "RESET_FORM",
                payload: {
                    isSubmitting: !!nextState && !!nextState.isSubmitting,
                    errors: errors,
                    touched: touched,
                    status: status,
                    values: values,
                    isValidating: !!nextState && !!nextState.isValidating,
                    submitCount: !!nextState && !!nextState.submitCount && typeof nextState.submitCount === "number" ? nextState.submitCount : 0
                }
            });
        };
        if (props.onReset) {
            var maybePromisedOnReset = props.onReset(state.values, imperativeMethods);
            if (isPromise(maybePromisedOnReset)) maybePromisedOnReset.then(dispatchFn);
            else dispatchFn();
        } else dispatchFn();
    }, [
        props.initialErrors,
        props.initialStatus,
        props.initialTouched,
        props.onReset
    ]);
    (0, $acw62.useEffect)(function() {
        if (isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($ai2Pb)))(initialValues.current, props.initialValues)) {
            if (enableReinitialize) {
                initialValues.current = props.initialValues;
                resetForm();
                if (validateOnMount) validateFormWithHighPriority(initialValues.current);
            }
        }
    }, [
        enableReinitialize,
        props.initialValues,
        resetForm,
        validateOnMount,
        validateFormWithHighPriority
    ]);
    (0, $acw62.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($ai2Pb)))(initialErrors.current, props.initialErrors)) {
            initialErrors.current = props.initialErrors || emptyErrors;
            dispatch({
                type: "SET_ERRORS",
                payload: props.initialErrors || emptyErrors
            });
        }
    }, [
        enableReinitialize,
        props.initialErrors
    ]);
    (0, $acw62.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($ai2Pb)))(initialTouched.current, props.initialTouched)) {
            initialTouched.current = props.initialTouched || emptyTouched;
            dispatch({
                type: "SET_TOUCHED",
                payload: props.initialTouched || emptyTouched
            });
        }
    }, [
        enableReinitialize,
        props.initialTouched
    ]);
    (0, $acw62.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($ai2Pb)))(initialStatus.current, props.initialStatus)) {
            initialStatus.current = props.initialStatus;
            dispatch({
                type: "SET_STATUS",
                payload: props.initialStatus
            });
        }
    }, [
        enableReinitialize,
        props.initialStatus,
        props.initialTouched
    ]);
    var validateField = useEventCallback(function(name) {
        // This will efficiently validate a single field by avoiding state
        // changes if the validation function is synchronous. It's different from
        // what is called when using validateForm.
        if (fieldRegistry.current[name] && isFunction(fieldRegistry.current[name].validate)) {
            var value = getIn(state.values, name);
            var maybePromise = fieldRegistry.current[name].validate(value);
            if (isPromise(maybePromise)) {
                // Only flip isValidating if the function is async.
                dispatch({
                    type: "SET_ISVALIDATING",
                    payload: true
                });
                return maybePromise.then(function(x) {
                    return x;
                }).then(function(error) {
                    dispatch({
                        type: "SET_FIELD_ERROR",
                        payload: {
                            field: name,
                            value: error
                        }
                    });
                    dispatch({
                        type: "SET_ISVALIDATING",
                        payload: false
                    });
                });
            } else {
                dispatch({
                    type: "SET_FIELD_ERROR",
                    payload: {
                        field: name,
                        value: maybePromise
                    }
                });
                return Promise.resolve(maybePromise);
            }
        } else if (props.validationSchema) {
            dispatch({
                type: "SET_ISVALIDATING",
                payload: true
            });
            return runValidationSchema(state.values, name).then(function(x) {
                return x;
            }).then(function(error) {
                dispatch({
                    type: "SET_FIELD_ERROR",
                    payload: {
                        field: name,
                        value: getIn(error, name)
                    }
                });
                dispatch({
                    type: "SET_ISVALIDATING",
                    payload: false
                });
            });
        }
        return Promise.resolve();
    });
    var registerField = (0, $acw62.useCallback)(function(name, _ref3) {
        var validate = _ref3.validate;
        fieldRegistry.current[name] = {
            validate: validate
        };
    }, []);
    var unregisterField = (0, $acw62.useCallback)(function(name) {
        delete fieldRegistry.current[name];
    }, []);
    var setTouched = useEventCallback(function(touched, shouldValidate) {
        dispatch({
            type: "SET_TOUCHED",
            payload: touched
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var setErrors = (0, $acw62.useCallback)(function(errors) {
        dispatch({
            type: "SET_ERRORS",
            payload: errors
        });
    }, []);
    var setValues = useEventCallback(function(values, shouldValidate) {
        var resolvedValues = isFunction(values) ? values(state.values) : values;
        dispatch({
            type: "SET_VALUES",
            payload: resolvedValues
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(resolvedValues) : Promise.resolve();
    });
    var setFieldError = (0, $acw62.useCallback)(function(field, value) {
        dispatch({
            type: "SET_FIELD_ERROR",
            payload: {
                field: field,
                value: value
            }
        });
    }, []);
    var setFieldValue = useEventCallback(function(field, value, shouldValidate) {
        dispatch({
            type: "SET_FIELD_VALUE",
            payload: {
                field: field,
                value: value
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(setIn(state.values, field, value)) : Promise.resolve();
    });
    var executeChange = (0, $acw62.useCallback)(function(eventOrTextValue, maybePath) {
        // By default, assume that the first argument is a string. This allows us to use
        // handleChange with React Native and React Native Web's onChangeText prop which
        // provides just the value of the input.
        var field = maybePath;
        var val = eventOrTextValue;
        var parsed; // If the first argument is not a string though, it has to be a synthetic React Event (or a fake one),
        // so we handle like we would a normal HTML change event.
        if (!isString(eventOrTextValue)) {
            // If we can, persist the event
            // @see https://reactjs.org/docs/events.html#event-pooling
            if (eventOrTextValue.persist) eventOrTextValue.persist();
            var target = eventOrTextValue.target ? eventOrTextValue.target : eventOrTextValue.currentTarget;
            var type = target.type, name = target.name, id = target.id, value = target.value, checked = target.checked, outerHTML = target.outerHTML, options = target.options, multiple = target.multiple;
            field = maybePath ? maybePath : name ? name : id;
            val = /number|range/.test(type) ? (parsed = parseFloat(value), isNaN(parsed) ? "" : parsed) : /checkbox/.test(type) // checkboxes
             ? getValueForCheckbox(getIn(state.values, field), checked, value) : options && multiple // <select multiple>
             ? getSelectedValues(options) : value;
        }
        if (field) // Set form fields by name
        setFieldValue(field, val);
    }, [
        setFieldValue,
        state.values
    ]);
    var handleChange = useEventCallback(function(eventOrPath) {
        if (isString(eventOrPath)) return function(event) {
            return executeChange(event, eventOrPath);
        };
        else executeChange(eventOrPath);
    });
    var setFieldTouched = useEventCallback(function(field, touched, shouldValidate) {
        if (touched === void 0) touched = true;
        dispatch({
            type: "SET_FIELD_TOUCHED",
            payload: {
                field: field,
                value: touched
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var executeBlur = (0, $acw62.useCallback)(function(e, path) {
        if (e.persist) e.persist();
        var _e$target = e.target, name = _e$target.name, id = _e$target.id, outerHTML = _e$target.outerHTML;
        var field = path ? path : name ? name : id;
        setFieldTouched(field, true);
    }, [
        setFieldTouched
    ]);
    var handleBlur = useEventCallback(function(eventOrString) {
        if (isString(eventOrString)) return function(event) {
            return executeBlur(event, eventOrString);
        };
        else executeBlur(eventOrString);
    });
    var setFormikState = (0, $acw62.useCallback)(function(stateOrCb) {
        if (isFunction(stateOrCb)) dispatch({
            type: "SET_FORMIK_STATE",
            payload: stateOrCb
        });
        else dispatch({
            type: "SET_FORMIK_STATE",
            payload: function payload() {
                return stateOrCb;
            }
        });
    }, []);
    var setStatus = (0, $acw62.useCallback)(function(status) {
        dispatch({
            type: "SET_STATUS",
            payload: status
        });
    }, []);
    var setSubmitting = (0, $acw62.useCallback)(function(isSubmitting) {
        dispatch({
            type: "SET_ISSUBMITTING",
            payload: isSubmitting
        });
    }, []);
    var submitForm = useEventCallback(function() {
        dispatch({
            type: "SUBMIT_ATTEMPT"
        });
        return validateFormWithHighPriority().then(function(combinedErrors) {
            // In case an error was thrown and passed to the resolved Promise,
            // `combinedErrors` can be an instance of an Error. We need to check
            // that and abort the submit.
            // If we don't do that, calling `Object.keys(new Error())` yields an
            // empty array, which causes the validation to pass and the form
            // to be submitted.
            var isInstanceOfError = combinedErrors instanceof Error;
            var isActuallyValid = !isInstanceOfError && Object.keys(combinedErrors).length === 0;
            if (isActuallyValid) {
                // Proceed with submit...
                //
                // To respect sync submit fns, we can't simply wrap executeSubmit in a promise and
                // _always_ dispatch SUBMIT_SUCCESS because isSubmitting would then always be false.
                // This would be fine in simple cases, but make it impossible to disable submit
                // buttons where people use callbacks or promises as side effects (which is basically
                // all of v1 Formik code). Instead, recall that we are inside of a promise chain already,
                //  so we can try/catch executeSubmit(), if it returns undefined, then just bail.
                // If there are errors, throw em. Otherwise, wrap executeSubmit in a promise and handle
                // cleanup of isSubmitting on behalf of the consumer.
                var promiseOrUndefined;
                try {
                    promiseOrUndefined = executeSubmit(); // Bail if it's sync, consumer is responsible for cleaning up
                    // via setSubmitting(false)
                    if (promiseOrUndefined === undefined) return;
                } catch (error) {
                    throw error;
                }
                return Promise.resolve(promiseOrUndefined).then(function(result) {
                    if (!!isMounted.current) dispatch({
                        type: "SUBMIT_SUCCESS"
                    });
                    return result;
                })["catch"](function(_errors) {
                    if (!!isMounted.current) {
                        dispatch({
                            type: "SUBMIT_FAILURE"
                        }); // This is a legit error rejected by the onSubmit fn
                        // so we don't want to break the promise chain
                        throw _errors;
                    }
                });
            } else if (!!isMounted.current) {
                // ^^^ Make sure Formik is still mounted before updating state
                dispatch({
                    type: "SUBMIT_FAILURE"
                }); // throw combinedErrors;
                if (isInstanceOfError) throw combinedErrors;
            }
            return;
        });
    });
    var handleSubmit = useEventCallback(function(e) {
        if (e && e.preventDefault && isFunction(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && isFunction(e.stopPropagation)) e.stopPropagation();
         // Warn if form submission is triggered by a <button> without a
        var activeElement;
        submitForm()["catch"](function(reason) {
            console.warn("Warning: An unhandled error was caught from submitForm()", reason);
        });
    });
    var imperativeMethods = {
        resetForm: resetForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        setErrors: setErrors,
        setFieldError: setFieldError,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        setFormikState: setFormikState,
        submitForm: submitForm
    };
    var executeSubmit = useEventCallback(function() {
        return onSubmit(state.values, imperativeMethods);
    });
    var handleReset = useEventCallback(function(e) {
        if (e && e.preventDefault && isFunction(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && isFunction(e.stopPropagation)) e.stopPropagation();
        resetForm();
    });
    var getFieldMeta = (0, $acw62.useCallback)(function(name) {
        return {
            value: getIn(state.values, name),
            error: getIn(state.errors, name),
            touched: !!getIn(state.touched, name),
            initialValue: getIn(initialValues.current, name),
            initialTouched: !!getIn(initialTouched.current, name),
            initialError: getIn(initialErrors.current, name)
        };
    }, [
        state.errors,
        state.touched,
        state.values
    ]);
    var getFieldHelpers = (0, $acw62.useCallback)(function(name) {
        return {
            setValue: function setValue(value, shouldValidate) {
                return setFieldValue(name, value, shouldValidate);
            },
            setTouched: function setTouched(value, shouldValidate) {
                return setFieldTouched(name, value, shouldValidate);
            },
            setError: function setError(value) {
                return setFieldError(name, value);
            }
        };
    }, [
        setFieldValue,
        setFieldTouched,
        setFieldError
    ]);
    var getFieldProps = (0, $acw62.useCallback)(function(nameOrOptions) {
        var isAnObject = isObject(nameOrOptions);
        var name = isAnObject ? nameOrOptions.name : nameOrOptions;
        var valueState = getIn(state.values, name);
        var field = {
            name: name,
            value: valueState,
            onChange: handleChange,
            onBlur: handleBlur
        };
        if (isAnObject) {
            var type = nameOrOptions.type, valueProp = nameOrOptions.value, is = nameOrOptions.as, multiple = nameOrOptions.multiple;
            if (type === "checkbox") {
                if (valueProp === undefined) field.checked = !!valueState;
                else {
                    field.checked = !!(Array.isArray(valueState) && ~valueState.indexOf(valueProp));
                    field.value = valueProp;
                }
            } else if (type === "radio") {
                field.checked = valueState === valueProp;
                field.value = valueProp;
            } else if (is === "select" && multiple) {
                field.value = field.value || [];
                field.multiple = true;
            }
        }
        return field;
    }, [
        handleBlur,
        handleChange,
        state.values
    ]);
    var dirty = (0, $acw62.useMemo)(function() {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($ai2Pb)))(initialValues.current, state.values);
    }, [
        initialValues.current,
        state.values
    ]);
    var isValid = (0, $acw62.useMemo)(function() {
        return typeof isInitialValid !== "undefined" ? dirty ? state.errors && Object.keys(state.errors).length === 0 : isInitialValid !== false && isFunction(isInitialValid) ? isInitialValid(props) : isInitialValid : state.errors && Object.keys(state.errors).length === 0;
    }, [
        isInitialValid,
        dirty,
        state.errors,
        props
    ]);
    var ctx = _extends({}, state, {
        initialValues: initialValues.current,
        initialErrors: initialErrors.current,
        initialTouched: initialTouched.current,
        initialStatus: initialStatus.current,
        handleBlur: handleBlur,
        handleChange: handleChange,
        handleReset: handleReset,
        handleSubmit: handleSubmit,
        resetForm: resetForm,
        setErrors: setErrors,
        setFormikState: setFormikState,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setFieldError: setFieldError,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        submitForm: submitForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        isValid: isValid,
        dirty: dirty,
        unregisterField: unregisterField,
        registerField: registerField,
        getFieldProps: getFieldProps,
        getFieldMeta: getFieldMeta,
        getFieldHelpers: getFieldHelpers,
        validateOnBlur: validateOnBlur,
        validateOnChange: validateOnChange,
        validateOnMount: validateOnMount
    });
    return ctx;
}
function Formik(props) {
    var formikbag = useFormik(props);
    var component = props.component, children = props.children, render = props.render, innerRef = props.innerRef; // This allows folks to pass a ref to <Formik />
    (0, $acw62.useImperativeHandle)(innerRef, function() {
        return formikbag;
    });
    return (0, $acw62.createElement)(FormikProvider, {
        value: formikbag
    }, component ? (0, $acw62.createElement)(component, formikbag) : render ? render(formikbag) : children // children come last, always called
     ? isFunction(children) ? children(formikbag) : !isEmptyChildren(children) ? (0, $acw62.Children).only(children) : null : null);
}
function warnAboutMissingIdentifier(_ref4) {
    var htmlContent = _ref4.htmlContent, documentationAnchorLink = _ref4.documentationAnchorLink, handlerName = _ref4.handlerName;
    console.warn("Warning: Formik called `" + handlerName + "`, but you forgot to pass an `id` or `name` attribute to your input:\n    " + htmlContent + "\n    Formik cannot determine which value to update. For more info see https://formik.org/docs/api/formik#" + documentationAnchorLink + "\n  ");
}
/**
 * Transform Yup ValidationError to a more usable object
 */ function yupToFormErrors(yupError) {
    var errors = {};
    if (yupError.inner) {
        if (yupError.inner.length === 0) return setIn(errors, yupError.path, yupError.message);
        for(var _iterator = yupError.inner, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
            var _ref5;
            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref5 = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref5 = _i.value;
            }
            var err = _ref5;
            if (!getIn(errors, err.path)) errors = setIn(errors, err.path, err.message);
        }
    }
    return errors;
}
/**
 * Validate a yup schema.
 */ function validateYupSchema(values, schema, sync, context) {
    if (sync === void 0) sync = false;
    var normalizedValues = prepareDataForValidation(values);
    return schema[sync ? "validateSync" : "validate"](normalizedValues, {
        abortEarly: false,
        context: context || normalizedValues
    });
}
/**
 * Recursively prepare values.
 */ function prepareDataForValidation(values) {
    var data = Array.isArray(values) ? [] : {};
    for(var k in values)if (Object.prototype.hasOwnProperty.call(values, k)) {
        var key = String(k);
        if (Array.isArray(values[key]) === true) data[key] = values[key].map(function(value) {
            if (Array.isArray(value) === true || (0, $3rtvu.default)(value)) return prepareDataForValidation(value);
            else return value !== "" ? value : undefined;
        });
        else if ((0, $3rtvu.default)(values[key])) data[key] = prepareDataForValidation(values[key]);
        else data[key] = values[key] !== "" ? values[key] : undefined;
    }
    return data;
}
/**
 * deepmerge array merging algorithm
 * https://github.com/KyleAMathews/deepmerge#combine-array
 */ function arrayMerge(target, source, options) {
    var destination = target.slice();
    source.forEach(function merge(e, i) {
        if (typeof destination[i] === "undefined") {
            var cloneRequested = options.clone !== false;
            var shouldClone = cloneRequested && options.isMergeableObject(e);
            destination[i] = shouldClone ? (0, $cCVp3.default)(Array.isArray(e) ? [] : {}, e, options) : e;
        } else if (options.isMergeableObject(e)) destination[i] = (0, $cCVp3.default)(target[i], e, options);
        else if (target.indexOf(e) === -1) destination.push(e);
    });
    return destination;
}
/** Return multi select values based on an array of options */ function getSelectedValues(options) {
    return Array.from(options).filter(function(el) {
        return el.selected;
    }).map(function(el) {
        return el.value;
    });
}
/** Return the next value for a checkbox */ function getValueForCheckbox(currentValue, checked, valueProp) {
    // If the current value was a boolean, return a boolean
    if (typeof currentValue === "boolean") return Boolean(checked);
     // If the currentValue was not a boolean we want to return an array
    var currentArrayOfValues = [];
    var isValueInArray = false;
    var index = -1;
    if (!Array.isArray(currentValue)) {
        // eslint-disable-next-line eqeqeq
        if (!valueProp || valueProp == "true" || valueProp == "false") return Boolean(checked);
    } else {
        // If the current value is already an array, use it
        currentArrayOfValues = currentValue;
        index = currentValue.indexOf(valueProp);
        isValueInArray = index >= 0;
    } // If the checkbox was checked and the value is not already present in the aray we want to add the new value to the array of values
    if (checked && valueProp && !isValueInArray) return currentArrayOfValues.concat(valueProp);
     // If the checkbox was unchecked and the value is not in the array, simply return the already existing array of values
    if (!isValueInArray) return currentArrayOfValues;
     // If the checkbox was unchecked and the value is in the array, remove the value and return the array
    return currentArrayOfValues.slice(0, index).concat(currentArrayOfValues.slice(index + 1));
} // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
// @see https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
var useIsomorphicLayoutEffect = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined" ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
function useEventCallback(fn) {
    var ref = (0, $acw62.useRef)(fn); // we copy a ref to the callback scoped to the current state/props on each render
    useIsomorphicLayoutEffect(function() {
        ref.current = fn;
    });
    return (0, $acw62.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current.apply(void 0, args);
    }, []);
}
function useField(propsOrFieldName) {
    var formik = useFormikContext();
    var getFieldProps = formik.getFieldProps, getFieldMeta = formik.getFieldMeta, getFieldHelpers = formik.getFieldHelpers, registerField = formik.registerField, unregisterField = formik.unregisterField;
    var isAnObject = isObject(propsOrFieldName); // Normalize propsOrFieldName to FieldHookConfig<Val>
    var props = isAnObject ? propsOrFieldName : {
        name: propsOrFieldName
    };
    var fieldName = props.name, validateFn = props.validate;
    (0, $acw62.useEffect)(function() {
        if (fieldName) registerField(fieldName, {
            validate: validateFn
        });
        return function() {
            if (fieldName) unregisterField(fieldName);
        };
    }, [
        registerField,
        unregisterField,
        fieldName,
        validateFn
    ]);
    !fieldName && (0, $9RYKL.default)(false);
    var fieldHelpers = (0, $acw62.useMemo)(function() {
        return getFieldHelpers(fieldName);
    }, [
        getFieldHelpers,
        fieldName
    ]);
    return [
        getFieldProps(props),
        getFieldMeta(fieldName),
        fieldHelpers
    ];
}
function Field(_ref) {
    var validate = _ref.validate, name = _ref.name, render = _ref.render, children = _ref.children, is = _ref.as, component = _ref.component, className = _ref.className, props = _objectWithoutPropertiesLoose(_ref, [
        "validate",
        "name",
        "render",
        "children",
        "as",
        "component",
        "className"
    ]);
    var _useFormikContext = useFormikContext(), formik = _objectWithoutPropertiesLoose(_useFormikContext, [
        "validate",
        "validationSchema"
    ]);
    var registerField = formik.registerField, unregisterField = formik.unregisterField;
    (0, $acw62.useEffect)(function() {
        registerField(name, {
            validate: validate
        });
        return function() {
            unregisterField(name);
        };
    }, [
        registerField,
        unregisterField,
        name,
        validate
    ]);
    var field = formik.getFieldProps(_extends({
        name: name
    }, props));
    var meta = formik.getFieldMeta(name);
    var legacyBag = {
        field: field,
        form: formik
    };
    if (render) return render(_extends({}, legacyBag, {
        meta: meta
    }));
    if (isFunction(children)) return children(_extends({}, legacyBag, {
        meta: meta
    }));
    if (component) {
        // This behavior is backwards compat with earlier Formik 0.9 to 1.x
        if (typeof component === "string") {
            var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, $acw62.createElement)(component, _extends({
                ref: innerRef
            }, field, rest, {
                className: className
            }), children);
        } // We don't pass `meta` for backwards compat
        return (0, $acw62.createElement)(component, _extends({
            field: field,
            form: formik
        }, props, {
            className: className
        }), children);
    } // default to input here so we can check for both `as` and `children` above
    var asElement = is || "input";
    if (typeof asElement === "string") {
        var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
            "innerRef"
        ]);
        return (0, $acw62.createElement)(asElement, _extends({
            ref: _innerRef
        }, field, _rest, {
            className: className
        }), children);
    }
    return (0, $acw62.createElement)(asElement, _extends({}, field, props, {
        className: className
    }), children);
}
var Form = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
    // iOS needs an "action" attribute for nice input: https://stackoverflow.com/a/39485162/406725
    // We default the action to "#" in case the preventDefault fails (just updates the URL hash)
    var action = props.action, rest = _objectWithoutPropertiesLoose(props, [
        "action"
    ]);
    var _action = action != null ? action : "#";
    var _useFormikContext = useFormikContext(), handleReset = _useFormikContext.handleReset, handleSubmit = _useFormikContext.handleSubmit;
    return (0, $acw62.createElement)("form", _extends({
        onSubmit: handleSubmit,
        ref: ref,
        onReset: handleReset,
        action: _action
    }, rest));
});
Form.displayName = "Form";
/**
 * A public higher-order component to access the imperative API
 */ function withFormik(_ref) {
    var _ref$mapPropsToValues = _ref.mapPropsToValues, mapPropsToValues = _ref$mapPropsToValues === void 0 ? function(vanillaProps) {
        var val = {};
        for(var k in vanillaProps)if (vanillaProps.hasOwnProperty(k) && typeof vanillaProps[k] !== "function") // @todo TypeScript fix
        val[k] = vanillaProps[k];
        return val;
    } : _ref$mapPropsToValues, config = _objectWithoutPropertiesLoose(_ref, [
        "mapPropsToValues"
    ]);
    return function createFormik(Component$1) {
        var componentDisplayName = Component$1.displayName || Component$1.name || Component$1.constructor && Component$1.constructor.name || "Component";
        /**
     * We need to use closures here for to provide the wrapped component's props to
     * the respective withFormik config methods.
     */ var C = /*#__PURE__*/ function(_React$Component) {
            _inheritsLoose(C, _React$Component);
            function C() {
                var _this;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                _this = _React$Component.call.apply(_React$Component, [
                    this
                ].concat(args)) || this;
                _this.validate = function(values) {
                    return config.validate(values, _this.props);
                };
                _this.validationSchema = function() {
                    return isFunction(config.validationSchema) ? config.validationSchema(_this.props) : config.validationSchema;
                };
                _this.handleSubmit = function(values, actions) {
                    return config.handleSubmit(values, _extends({}, actions, {
                        props: _this.props
                    }));
                };
                _this.renderFormComponent = function(formikProps) {
                    return (0, $acw62.createElement)(Component$1, _extends({}, _this.props, formikProps));
                };
                return _this;
            }
            var _proto = C.prototype;
            _proto.render = function render() {
                var _this$props = this.props, props = _objectWithoutPropertiesLoose(_this$props, [
                    "children"
                ]);
                return (0, $acw62.createElement)(Formik, _extends({}, props, config, {
                    validate: config.validate && this.validate,
                    validationSchema: config.validationSchema && this.validationSchema,
                    initialValues: mapPropsToValues(this.props),
                    initialStatus: config.mapPropsToStatus && config.mapPropsToStatus(this.props),
                    initialErrors: config.mapPropsToErrors && config.mapPropsToErrors(this.props),
                    initialTouched: config.mapPropsToTouched && config.mapPropsToTouched(this.props),
                    onSubmit: this.handleSubmit,
                    children: this.renderFormComponent
                }));
            };
            return C;
        }((0, $acw62.Component));
        C.displayName = "WithFormik(" + componentDisplayName + ")";
        return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(C, Component$1 // cast type to ComponentClass (even if SFC)
        );
    };
}
/**
 * Connect any component to Formik context, and inject as a prop called `formik`;
 * @param Comp React Component
 */ function connect(Comp) {
    var C = function C(props) {
        return (0, $acw62.createElement)(FormikConsumer, null, function(formik) {
            !!!formik && (0, $9RYKL.default)(false);
            return (0, $acw62.createElement)(Comp, _extends({}, props, {
                formik: formik
            }));
        });
    };
    var componentDisplayName = Comp.displayName || Comp.name || Comp.constructor && Comp.constructor.name || "Component"; // Assign Comp to C.WrappedComponent so we can access the inner component in tests
    // For example, <Field.WrappedComponent /> gets us <FieldInner/>
    C.WrappedComponent = Comp;
    C.displayName = "FormikConnect(" + componentDisplayName + ")";
    return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(C, Comp // cast type to ComponentClass (even if SFC)
    );
}
/**
 * Some array helpers!
 */ var move = function move(array, from, to) {
    var copy = copyArrayLike(array);
    var value = copy[from];
    copy.splice(from, 1);
    copy.splice(to, 0, value);
    return copy;
};
var swap = function swap(arrayLike, indexA, indexB) {
    var copy = copyArrayLike(arrayLike);
    var a = copy[indexA];
    copy[indexA] = copy[indexB];
    copy[indexB] = a;
    return copy;
};
var insert = function insert(arrayLike, index, value) {
    var copy = copyArrayLike(arrayLike);
    copy.splice(index, 0, value);
    return copy;
};
var replace = function replace(arrayLike, index, value) {
    var copy = copyArrayLike(arrayLike);
    copy[index] = value;
    return copy;
};
var copyArrayLike = function copyArrayLike(arrayLike) {
    if (!arrayLike) return [];
    else if (Array.isArray(arrayLike)) return [].concat(arrayLike);
    else {
        var maxIndex = Object.keys(arrayLike).map(function(key) {
            return parseInt(key);
        }).reduce(function(max, el) {
            return el > max ? el : max;
        }, 0);
        return Array.from(_extends({}, arrayLike, {
            length: maxIndex + 1
        }));
    }
};
var createAlterationHandler = function createAlterationHandler(alteration, defaultFunction) {
    var fn = typeof alteration === "function" ? alteration : defaultFunction;
    return function(data) {
        if (Array.isArray(data) || isObject(data)) {
            var clone = copyArrayLike(data);
            return fn(clone);
        } // This can be assumed to be a primitive, which
        // is a case for top level validation errors
        return data;
    };
};
var FieldArrayInner = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(FieldArrayInner, _React$Component);
    function FieldArrayInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this; // We need TypeScript generics on these, so we'll bind them in the constructor
        // @todo Fix TS 3.2.1
        _this.updateArrayField = function(fn, alterTouched, alterErrors) {
            var _this$props = _this.props, name = _this$props.name, setFormikState = _this$props.formik.setFormikState;
            setFormikState(function(prevState) {
                var updateErrors = createAlterationHandler(alterErrors, fn);
                var updateTouched = createAlterationHandler(alterTouched, fn); // values fn should be executed before updateErrors and updateTouched,
                // otherwise it causes an error with unshift.
                var values = setIn(prevState.values, name, fn(getIn(prevState.values, name)));
                var fieldError = alterErrors ? updateErrors(getIn(prevState.errors, name)) : undefined;
                var fieldTouched = alterTouched ? updateTouched(getIn(prevState.touched, name)) : undefined;
                if (isEmptyArray(fieldError)) fieldError = undefined;
                if (isEmptyArray(fieldTouched)) fieldTouched = undefined;
                return _extends({}, prevState, {
                    values: values,
                    errors: alterErrors ? setIn(prevState.errors, name, fieldError) : prevState.errors,
                    touched: alterTouched ? setIn(prevState.touched, name, fieldTouched) : prevState.touched
                });
            });
        };
        _this.push = function(value) {
            return _this.updateArrayField(function(arrayLike) {
                return [].concat(copyArrayLike(arrayLike), [
                    (0, $chB0Q.default)(value)
                ]);
            }, false, false);
        };
        _this.handlePush = function(value) {
            return function() {
                return _this.push(value);
            };
        };
        _this.swap = function(indexA, indexB) {
            return _this.updateArrayField(function(array) {
                return swap(array, indexA, indexB);
            }, true, true);
        };
        _this.handleSwap = function(indexA, indexB) {
            return function() {
                return _this.swap(indexA, indexB);
            };
        };
        _this.move = function(from, to) {
            return _this.updateArrayField(function(array) {
                return move(array, from, to);
            }, true, true);
        };
        _this.handleMove = function(from, to) {
            return function() {
                return _this.move(from, to);
            };
        };
        _this.insert = function(index, value) {
            return _this.updateArrayField(function(array) {
                return insert(array, index, value);
            }, function(array) {
                return insert(array, index, null);
            }, function(array) {
                return insert(array, index, null);
            });
        };
        _this.handleInsert = function(index, value) {
            return function() {
                return _this.insert(index, value);
            };
        };
        _this.replace = function(index, value) {
            return _this.updateArrayField(function(array) {
                return replace(array, index, value);
            }, false, false);
        };
        _this.handleReplace = function(index, value) {
            return function() {
                return _this.replace(index, value);
            };
        };
        _this.unshift = function(value) {
            var length = -1;
            _this.updateArrayField(function(array) {
                var arr = array ? [
                    value
                ].concat(array) : [
                    value
                ];
                length = arr.length;
                return arr;
            }, function(array) {
                return array ? [
                    null
                ].concat(array) : [
                    null
                ];
            }, function(array) {
                return array ? [
                    null
                ].concat(array) : [
                    null
                ];
            });
            return length;
        };
        _this.handleUnshift = function(value) {
            return function() {
                return _this.unshift(value);
            };
        };
        _this.handleRemove = function(index) {
            return function() {
                return _this.remove(index);
            };
        };
        _this.handlePop = function() {
            return function() {
                return _this.pop();
            };
        };
        _this.remove = _this.remove.bind(_assertThisInitialized(_this));
        _this.pop = _this.pop.bind(_assertThisInitialized(_this));
        return _this;
    }
    var _proto = FieldArrayInner.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.validateOnChange && this.props.formik.validateOnChange && !(0, (/*@__PURE__*/$parcel$interopDefault($ai2Pb)))(getIn(prevProps.formik.values, prevProps.name), getIn(this.props.formik.values, this.props.name))) this.props.formik.validateForm(this.props.formik.values);
    };
    _proto.remove = function remove(index) {
        // We need to make sure we also remove relevant pieces of `touched` and `errors`
        var result;
        this.updateArrayField(function(array) {
            var copy = array ? copyArrayLike(array) : [];
            if (!result) result = copy[index];
            if (isFunction(copy.splice)) copy.splice(index, 1);
             // if the array only includes undefined values we have to return an empty array
            return isFunction(copy.every) ? copy.every(function(v) {
                return v === undefined;
            }) ? [] : copy : copy;
        }, true, true);
        return result;
    };
    _proto.pop = function pop() {
        // Remove relevant pieces of `touched` and `errors` too!
        var result;
        this.updateArrayField(function(array) {
            var tmp = array.slice();
            if (!result) result = tmp && tmp.pop && tmp.pop();
            return tmp;
        }, true, true);
        return result;
    };
    _proto.render = function render() {
        var arrayHelpers = {
            push: this.push,
            pop: this.pop,
            swap: this.swap,
            move: this.move,
            insert: this.insert,
            replace: this.replace,
            unshift: this.unshift,
            remove: this.remove,
            handlePush: this.handlePush,
            handlePop: this.handlePop,
            handleSwap: this.handleSwap,
            handleMove: this.handleMove,
            handleInsert: this.handleInsert,
            handleReplace: this.handleReplace,
            handleUnshift: this.handleUnshift,
            handleRemove: this.handleRemove
        };
        var _this$props2 = this.props, component = _this$props2.component, render = _this$props2.render, children = _this$props2.children, name = _this$props2.name, _this$props2$formik = _this$props2.formik, restOfFormik = _objectWithoutPropertiesLoose(_this$props2$formik, [
            "validate",
            "validationSchema"
        ]);
        var props = _extends({}, arrayHelpers, {
            form: restOfFormik,
            name: name
        });
        return component ? (0, $acw62.createElement)(component, props) : render ? render(props) : children // children come last, always called
         ? typeof children === "function" ? children(props) : !isEmptyChildren(children) ? (0, $acw62.Children).only(children) : null : null;
    };
    return FieldArrayInner;
}((0, $acw62.Component));
FieldArrayInner.defaultProps = {
    validateOnChange: true
};
var FieldArray = /*#__PURE__*/ connect(FieldArrayInner);
var ErrorMessageImpl = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(ErrorMessageImpl, _React$Component);
    function ErrorMessageImpl() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = ErrorMessageImpl.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (getIn(this.props.formik.errors, this.props.name) !== getIn(props.formik.errors, this.props.name) || getIn(this.props.formik.touched, this.props.name) !== getIn(props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length) return true;
        else return false;
    };
    _proto.render = function render() {
        var _this$props = this.props, component = _this$props.component, formik = _this$props.formik, render = _this$props.render, children = _this$props.children, name = _this$props.name, rest = _objectWithoutPropertiesLoose(_this$props, [
            "component",
            "formik",
            "render",
            "children",
            "name"
        ]);
        var touch = getIn(formik.touched, name);
        var error = getIn(formik.errors, name);
        return !!touch && !!error ? render ? isFunction(render) ? render(error) : null : children ? isFunction(children) ? children(error) : null : component ? (0, $acw62.createElement)(component, rest, error) : error : null;
    };
    return ErrorMessageImpl;
}((0, $acw62.Component));
var ErrorMessage = /*#__PURE__*/ connect(ErrorMessageImpl);
/**
 * Custom Field component for quickly hooking into Formik
 * context and wiring up forms.
 */ var FastFieldInner = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(FastFieldInner, _React$Component);
    function FastFieldInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        var render = props.render, children = props.children, component = props.component, is = props.as, name = props.name;
        !!render && (0, $9RYKL.default)(false);
        !!(component && render) && (0, $9RYKL.default)(false);
        !!(is && children && isFunction(children)) && (0, $9RYKL.default)(false);
        !!(component && children && isFunction(children)) && (0, $9RYKL.default)(false);
        !!(render && children && !isEmptyChildren(children)) && (0, $9RYKL.default)(false);
        return _this;
    }
    var _proto = FastFieldInner.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (this.props.shouldUpdate) return this.props.shouldUpdate(props, this.props);
        else if (props.name !== this.props.name || getIn(props.formik.values, this.props.name) !== getIn(this.props.formik.values, this.props.name) || getIn(props.formik.errors, this.props.name) !== getIn(this.props.formik.errors, this.props.name) || getIn(props.formik.touched, this.props.name) !== getIn(this.props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length || props.formik.isSubmitting !== this.props.formik.isSubmitting) return true;
        else return false;
    };
    _proto.componentDidMount = function componentDidMount() {
        // Register the Field with the parent Formik. Parent will cycle through
        // registered Field's validate fns right prior to submit
        this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.name !== prevProps.name) {
            this.props.formik.unregisterField(prevProps.name);
            this.props.formik.registerField(this.props.name, {
                validate: this.props.validate
            });
        }
        if (this.props.validate !== prevProps.validate) this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.props.formik.unregisterField(this.props.name);
    };
    _proto.render = function render() {
        var _this$props = this.props, name = _this$props.name, render = _this$props.render, is = _this$props.as, children = _this$props.children, component = _this$props.component, formik = _this$props.formik, props = _objectWithoutPropertiesLoose(_this$props, [
            "validate",
            "name",
            "render",
            "as",
            "children",
            "component",
            "shouldUpdate",
            "formik"
        ]);
        var restOfFormik = _objectWithoutPropertiesLoose(formik, [
            "validate",
            "validationSchema"
        ]);
        var field = formik.getFieldProps(_extends({
            name: name
        }, props));
        var meta = {
            value: getIn(formik.values, name),
            error: getIn(formik.errors, name),
            touched: !!getIn(formik.touched, name),
            initialValue: getIn(formik.initialValues, name),
            initialTouched: !!getIn(formik.initialTouched, name),
            initialError: getIn(formik.initialErrors, name)
        };
        var bag = {
            field: field,
            meta: meta,
            form: restOfFormik
        };
        if (render) return render(bag);
        if (isFunction(children)) return children(bag);
        if (component) {
            // This behavior is backwards compat with earlier Formik 0.9 to 1.x
            if (typeof component === "string") {
                var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                    "innerRef"
                ]);
                return (0, $acw62.createElement)(component, _extends({
                    ref: innerRef
                }, field, rest), children);
            } // We don't pass `meta` for backwards compat
            return (0, $acw62.createElement)(component, _extends({
                field: field,
                form: formik
            }, props), children);
        } // default to input here so we can check for both `as` and `children` above
        var asElement = is || "input";
        if (typeof asElement === "string") {
            var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, $acw62.createElement)(asElement, _extends({
                ref: _innerRef
            }, field, _rest), children);
        }
        return (0, $acw62.createElement)(asElement, _extends({}, field, props), children);
    };
    return FastFieldInner;
}((0, $acw62.Component));
var FastField = /*#__PURE__*/ connect(FastFieldInner);

});
parcelRegister("cCVp3", function(module, exports) {

$parcel$export(module.exports, "default", () => $93158fb633685272$export$2e2bcd8739ae039);
var $93158fb633685272$var$isMergeableObject = function isMergeableObject(value) {
    return $93158fb633685272$var$isNonNullObject(value) && !$93158fb633685272$var$isSpecial(value);
};
function $93158fb633685272$var$isNonNullObject(value) {
    return !!value && typeof value === "object";
}
function $93158fb633685272$var$isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === "[object RegExp]" || stringValue === "[object Date]" || $93158fb633685272$var$isReactElement(value);
}
// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var $93158fb633685272$var$canUseSymbol = typeof Symbol === "function" && Symbol.for;
var $93158fb633685272$var$REACT_ELEMENT_TYPE = $93158fb633685272$var$canUseSymbol ? Symbol.for("react.element") : 0xeac7;
function $93158fb633685272$var$isReactElement(value) {
    return value.$$typeof === $93158fb633685272$var$REACT_ELEMENT_TYPE;
}
function $93158fb633685272$var$emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
}
function $93158fb633685272$var$cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? $93158fb633685272$var$deepmerge($93158fb633685272$var$emptyTarget(value), value, options) : value;
}
function $93158fb633685272$var$defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element) {
        return $93158fb633685272$var$cloneUnlessOtherwiseSpecified(element, options);
    });
}
function $93158fb633685272$var$mergeObject(target, source, options) {
    var destination = {};
    if (options.isMergeableObject(target)) Object.keys(target).forEach(function(key) {
        destination[key] = $93158fb633685272$var$cloneUnlessOtherwiseSpecified(target[key], options);
    });
    Object.keys(source).forEach(function(key) {
        if (!options.isMergeableObject(source[key]) || !target[key]) destination[key] = $93158fb633685272$var$cloneUnlessOtherwiseSpecified(source[key], options);
        else destination[key] = $93158fb633685272$var$deepmerge(target[key], source[key], options);
    });
    return destination;
}
function $93158fb633685272$var$deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || $93158fb633685272$var$defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || $93158fb633685272$var$isMergeableObject;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) return $93158fb633685272$var$cloneUnlessOtherwiseSpecified(source, options);
    else if (sourceIsArray) return options.arrayMerge(target, source, options);
    else return $93158fb633685272$var$mergeObject(target, source, options);
}
$93158fb633685272$var$deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) throw new Error("first argument should be an array");
    return array.reduce(function(prev, next) {
        return $93158fb633685272$var$deepmerge(prev, next, options);
    }, {});
};
var $93158fb633685272$var$deepmerge_1 = $93158fb633685272$var$deepmerge;
var $93158fb633685272$export$2e2bcd8739ae039 = $93158fb633685272$var$deepmerge_1;

});

parcelRegister("3rtvu", function(module, exports) {

$parcel$export(module.exports, "default", () => $281ac82f5f5844b1$export$2e2bcd8739ae039);

var $hArsG = parcelRequire("hArsG");

var $bzIQZ = parcelRequire("bzIQZ");

var $f2iog = parcelRequire("f2iog");
/** `Object#toString` result references. */ var $281ac82f5f5844b1$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $281ac82f5f5844b1$var$funcProto = Function.prototype, $281ac82f5f5844b1$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $281ac82f5f5844b1$var$funcToString = $281ac82f5f5844b1$var$funcProto.toString;
/** Used to check objects for own properties. */ var $281ac82f5f5844b1$var$hasOwnProperty = $281ac82f5f5844b1$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $281ac82f5f5844b1$var$objectCtorString = $281ac82f5f5844b1$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $281ac82f5f5844b1$var$isPlainObject(value) {
    if (!(0, $f2iog.default)(value) || (0, $hArsG.default)(value) != $281ac82f5f5844b1$var$objectTag) return false;
    var proto = (0, $bzIQZ.default)(value);
    if (proto === null) return true;
    var Ctor = $281ac82f5f5844b1$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $281ac82f5f5844b1$var$funcToString.call(Ctor) == $281ac82f5f5844b1$var$objectCtorString;
}
var $281ac82f5f5844b1$export$2e2bcd8739ae039 = $281ac82f5f5844b1$var$isPlainObject;

});
parcelRegister("hArsG", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccdb19c7f0a62300$export$2e2bcd8739ae039);

var $kRxPv = parcelRequire("kRxPv");

var $7IZ3R = parcelRequire("7IZ3R");

var $cIkDx = parcelRequire("cIkDx");
/** `Object#toString` result references. */ var $ccdb19c7f0a62300$var$nullTag = "[object Null]", $ccdb19c7f0a62300$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $ccdb19c7f0a62300$var$symToStringTag = (0, $kRxPv.default) ? (0, $kRxPv.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $ccdb19c7f0a62300$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $ccdb19c7f0a62300$var$undefinedTag : $ccdb19c7f0a62300$var$nullTag;
    return $ccdb19c7f0a62300$var$symToStringTag && $ccdb19c7f0a62300$var$symToStringTag in Object(value) ? (0, $7IZ3R.default)(value) : (0, $cIkDx.default)(value);
}
var $ccdb19c7f0a62300$export$2e2bcd8739ae039 = $ccdb19c7f0a62300$var$baseGetTag;

});
parcelRegister("kRxPv", function(module, exports) {

$parcel$export(module.exports, "default", () => $f302ffc9a48734c4$export$2e2bcd8739ae039);

var $2mpFt = parcelRequire("2mpFt");
/** Built-in value references. */ var $f302ffc9a48734c4$var$Symbol = (0, $2mpFt.default).Symbol;
var $f302ffc9a48734c4$export$2e2bcd8739ae039 = $f302ffc9a48734c4$var$Symbol;

});
parcelRegister("2mpFt", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b818bf49f333098$export$2e2bcd8739ae039);

var $4kWvg = parcelRequire("4kWvg");
/** Detect free variable `self`. */ var $1b818bf49f333098$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $1b818bf49f333098$var$root = (0, $4kWvg.default) || $1b818bf49f333098$var$freeSelf || Function("return this")();
var $1b818bf49f333098$export$2e2bcd8739ae039 = $1b818bf49f333098$var$root;

});
parcelRegister("4kWvg", function(module, exports) {

$parcel$export(module.exports, "default", () => $32866938ab70cc57$export$2e2bcd8739ae039);
/** Detect free variable `global` from Node.js. */ var $32866938ab70cc57$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $32866938ab70cc57$export$2e2bcd8739ae039 = $32866938ab70cc57$var$freeGlobal;

});



parcelRegister("7IZ3R", function(module, exports) {

$parcel$export(module.exports, "default", () => $59fc01f5e412f819$export$2e2bcd8739ae039);

var $kRxPv = parcelRequire("kRxPv");
/** Used for built-in method references. */ var $59fc01f5e412f819$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $59fc01f5e412f819$var$hasOwnProperty = $59fc01f5e412f819$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $59fc01f5e412f819$var$nativeObjectToString = $59fc01f5e412f819$var$objectProto.toString;
/** Built-in value references. */ var $59fc01f5e412f819$var$symToStringTag = (0, $kRxPv.default) ? (0, $kRxPv.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $59fc01f5e412f819$var$getRawTag(value) {
    var isOwn = $59fc01f5e412f819$var$hasOwnProperty.call(value, $59fc01f5e412f819$var$symToStringTag), tag = value[$59fc01f5e412f819$var$symToStringTag];
    try {
        value[$59fc01f5e412f819$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $59fc01f5e412f819$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$59fc01f5e412f819$var$symToStringTag] = tag;
        else delete value[$59fc01f5e412f819$var$symToStringTag];
    }
    return result;
}
var $59fc01f5e412f819$export$2e2bcd8739ae039 = $59fc01f5e412f819$var$getRawTag;

});

parcelRegister("cIkDx", function(module, exports) {

$parcel$export(module.exports, "default", () => $94199a1861e07064$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $94199a1861e07064$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $94199a1861e07064$var$nativeObjectToString = $94199a1861e07064$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $94199a1861e07064$var$objectToString(value) {
    return $94199a1861e07064$var$nativeObjectToString.call(value);
}
var $94199a1861e07064$export$2e2bcd8739ae039 = $94199a1861e07064$var$objectToString;

});


parcelRegister("bzIQZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $86d5c19d81d423c4$export$2e2bcd8739ae039);

var $7N1cZ = parcelRequire("7N1cZ");
/** Built-in value references. */ var $86d5c19d81d423c4$var$getPrototype = (0, $7N1cZ.default)(Object.getPrototypeOf, Object);
var $86d5c19d81d423c4$export$2e2bcd8739ae039 = $86d5c19d81d423c4$var$getPrototype;

});
parcelRegister("7N1cZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5abe0bf7e062106b$export$2e2bcd8739ae039);
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $5abe0bf7e062106b$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $5abe0bf7e062106b$export$2e2bcd8739ae039 = $5abe0bf7e062106b$var$overArg;

});


parcelRegister("f2iog", function(module, exports) {

$parcel$export(module.exports, "default", () => $af254ed7460d123e$export$2e2bcd8739ae039);
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $af254ed7460d123e$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
var $af254ed7460d123e$export$2e2bcd8739ae039 = $af254ed7460d123e$var$isObjectLike;

});


parcelRegister("ai2Pb", function(module, exports) {
"use strict";
var $77ddc6be16b1d7de$var$isArray = Array.isArray;
var $77ddc6be16b1d7de$var$keyList = Object.keys;
var $77ddc6be16b1d7de$var$hasProp = Object.prototype.hasOwnProperty;
var $77ddc6be16b1d7de$var$hasElementType = typeof Element !== "undefined";
function $77ddc6be16b1d7de$var$equal(a, b) {
    // fast-deep-equal index.js 2.0.1
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        var arrA = $77ddc6be16b1d7de$var$isArray(a), arrB = $77ddc6be16b1d7de$var$isArray(b), i, length, key;
        if (arrA && arrB) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$77ddc6be16b1d7de$var$equal(a[i], b[i])) return false;
            return true;
        }
        if (arrA != arrB) return false;
        var dateA = a instanceof Date, dateB = b instanceof Date;
        if (dateA != dateB) return false;
        if (dateA && dateB) return a.getTime() == b.getTime();
        var regexpA = a instanceof RegExp, regexpB = b instanceof RegExp;
        if (regexpA != regexpB) return false;
        if (regexpA && regexpB) return a.toString() == b.toString();
        var keys = $77ddc6be16b1d7de$var$keyList(a);
        length = keys.length;
        if (length !== $77ddc6be16b1d7de$var$keyList(b).length) return false;
        for(i = length; i-- !== 0;)if (!$77ddc6be16b1d7de$var$hasProp.call(b, keys[i])) return false;
        // end fast-deep-equal
        // start react-fast-compare
        // custom handling for DOM elements
        if ($77ddc6be16b1d7de$var$hasElementType && a instanceof Element && b instanceof Element) return a === b;
        // custom handling for React
        for(i = length; i-- !== 0;){
            key = keys[i];
            if (key === "_owner" && a.$$typeof) continue;
            else {
                // all other properties should be traversed as usual
                if (!$77ddc6be16b1d7de$var$equal(a[key], b[key])) return false;
            }
        }
        // end react-fast-compare
        // fast-deep-equal index.js 2.0.1
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function exportedEqual(a, b) {
    try {
        return $77ddc6be16b1d7de$var$equal(a, b);
    } catch (error) {
        if (error.message && error.message.match(/stack|recursion/i) || error.number === -2146828260) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("Warning: react-fast-compare does not handle circular references.", error.name, error.message);
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});

parcelRegister("9RYKL", function(module, exports) {

$parcel$export(module.exports, "default", () => $72f8309e8b4c5d38$export$2e2bcd8739ae039);
var $72f8309e8b4c5d38$var$isProduction = true;
function $72f8309e8b4c5d38$var$warning(condition, message) {
    if (!$72f8309e8b4c5d38$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== "undefined") console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $72f8309e8b4c5d38$export$2e2bcd8739ae039 = $72f8309e8b4c5d38$var$warning;

});

parcelRegister("hNIl0", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf5967d89366f433$export$2e2bcd8739ae039);

var $gbpSA = parcelRequire("gbpSA");
/** Used to compose bitmasks for cloning. */ var $cf5967d89366f433$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function $cf5967d89366f433$var$clone(value) {
    return (0, $gbpSA.default)(value, $cf5967d89366f433$var$CLONE_SYMBOLS_FLAG);
}
var $cf5967d89366f433$export$2e2bcd8739ae039 = $cf5967d89366f433$var$clone;

});
parcelRegister("gbpSA", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc81bf84e8d65dab$export$2e2bcd8739ae039);

var $9WjpT = parcelRequire("9WjpT");

var $iDECW = parcelRequire("iDECW");

var $a6l6i = parcelRequire("a6l6i");

var $7FIi5 = parcelRequire("7FIi5");

var $3vFgL = parcelRequire("3vFgL");

var $gqoYg = parcelRequire("gqoYg");

var $jXStN = parcelRequire("jXStN");

var $8gRDv = parcelRequire("8gRDv");

var $7AKhX = parcelRequire("7AKhX");

var $oK0lo = parcelRequire("oK0lo");

var $7bulh = parcelRequire("7bulh");

var $4wkSQ = parcelRequire("4wkSQ");

var $9HyGp = parcelRequire("9HyGp");

var $iBTyS = parcelRequire("iBTyS");

var $7lgl7 = parcelRequire("7lgl7");

var $hf0C9 = parcelRequire("hf0C9");

var $f3ZL4 = parcelRequire("f3ZL4");

var $5HFwJ = parcelRequire("5HFwJ");

var $iYDsF = parcelRequire("iYDsF");

var $4X3Cn = parcelRequire("4X3Cn");

var $8krEv = parcelRequire("8krEv");

var $ceNjR = parcelRequire("ceNjR");
/** Used to compose bitmasks for cloning. */ var $bc81bf84e8d65dab$var$CLONE_DEEP_FLAG = 1, $bc81bf84e8d65dab$var$CLONE_FLAT_FLAG = 2, $bc81bf84e8d65dab$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $bc81bf84e8d65dab$var$argsTag = "[object Arguments]", $bc81bf84e8d65dab$var$arrayTag = "[object Array]", $bc81bf84e8d65dab$var$boolTag = "[object Boolean]", $bc81bf84e8d65dab$var$dateTag = "[object Date]", $bc81bf84e8d65dab$var$errorTag = "[object Error]", $bc81bf84e8d65dab$var$funcTag = "[object Function]", $bc81bf84e8d65dab$var$genTag = "[object GeneratorFunction]", $bc81bf84e8d65dab$var$mapTag = "[object Map]", $bc81bf84e8d65dab$var$numberTag = "[object Number]", $bc81bf84e8d65dab$var$objectTag = "[object Object]", $bc81bf84e8d65dab$var$regexpTag = "[object RegExp]", $bc81bf84e8d65dab$var$setTag = "[object Set]", $bc81bf84e8d65dab$var$stringTag = "[object String]", $bc81bf84e8d65dab$var$symbolTag = "[object Symbol]", $bc81bf84e8d65dab$var$weakMapTag = "[object WeakMap]";
var $bc81bf84e8d65dab$var$arrayBufferTag = "[object ArrayBuffer]", $bc81bf84e8d65dab$var$dataViewTag = "[object DataView]", $bc81bf84e8d65dab$var$float32Tag = "[object Float32Array]", $bc81bf84e8d65dab$var$float64Tag = "[object Float64Array]", $bc81bf84e8d65dab$var$int8Tag = "[object Int8Array]", $bc81bf84e8d65dab$var$int16Tag = "[object Int16Array]", $bc81bf84e8d65dab$var$int32Tag = "[object Int32Array]", $bc81bf84e8d65dab$var$uint8Tag = "[object Uint8Array]", $bc81bf84e8d65dab$var$uint8ClampedTag = "[object Uint8ClampedArray]", $bc81bf84e8d65dab$var$uint16Tag = "[object Uint16Array]", $bc81bf84e8d65dab$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $bc81bf84e8d65dab$var$cloneableTags = {};
$bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$argsTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$arrayTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$arrayBufferTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$dataViewTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$boolTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$dateTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$float32Tag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$float64Tag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$int8Tag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$int16Tag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$int32Tag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$mapTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$numberTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$objectTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$regexpTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$setTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$stringTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$symbolTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$uint8Tag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$uint8ClampedTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$uint16Tag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$uint32Tag] = true;
$bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$errorTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$funcTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $bc81bf84e8d65dab$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $bc81bf84e8d65dab$var$CLONE_DEEP_FLAG, isFlat = bitmask & $bc81bf84e8d65dab$var$CLONE_FLAT_FLAG, isFull = bitmask & $bc81bf84e8d65dab$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!(0, $iYDsF.default)(value)) return value;
    var isArr = (0, $hf0C9.default)(value);
    if (isArr) {
        result = (0, $9HyGp.default)(value);
        if (!isDeep) return (0, $jXStN.default)(value, result);
    } else {
        var tag = (0, $4wkSQ.default)(value), isFunc = tag == $bc81bf84e8d65dab$var$funcTag || tag == $bc81bf84e8d65dab$var$genTag;
        if ((0, $f3ZL4.default)(value)) return (0, $gqoYg.default)(value, isDeep);
        if (tag == $bc81bf84e8d65dab$var$objectTag || tag == $bc81bf84e8d65dab$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : (0, $7lgl7.default)(value);
            if (!isDeep) return isFlat ? (0, $7AKhX.default)(value, (0, $3vFgL.default)(result, value)) : (0, $8gRDv.default)(value, (0, $7FIi5.default)(result, value));
        } else {
            if (!$bc81bf84e8d65dab$var$cloneableTags[tag]) return object ? value : {};
            result = (0, $iBTyS.default)(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new (0, $9WjpT.default));
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ((0, $4X3Cn.default)(value)) value.forEach(function(subValue) {
        result.add($bc81bf84e8d65dab$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ((0, $5HFwJ.default)(value)) value.forEach(function(subValue, key) {
        result.set(key, $bc81bf84e8d65dab$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? (0, $7bulh.default) : (0, $oK0lo.default) : isFlat ? (0, $ceNjR.default) : (0, $8krEv.default);
    var props = isArr ? undefined : keysFunc(value);
    (0, $iDECW.default)(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        (0, $a6l6i.default)(result, key, $bc81bf84e8d65dab$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
var $bc81bf84e8d65dab$export$2e2bcd8739ae039 = $bc81bf84e8d65dab$var$baseClone;

});
parcelRegister("9WjpT", function(module, exports) {

$parcel$export(module.exports, "default", () => $73c8979051c99f66$export$2e2bcd8739ae039);

var $kVnfZ = parcelRequire("kVnfZ");

var $czhOX = parcelRequire("czhOX");

var $5QEPI = parcelRequire("5QEPI");

var $lwDUG = parcelRequire("lwDUG");

var $b5lTf = parcelRequire("b5lTf");

var $i8OSr = parcelRequire("i8OSr");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $73c8979051c99f66$var$Stack(entries) {
    var data = this.__data__ = new (0, $kVnfZ.default)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$73c8979051c99f66$var$Stack.prototype.clear = (0, $czhOX.default);
$73c8979051c99f66$var$Stack.prototype["delete"] = (0, $5QEPI.default);
$73c8979051c99f66$var$Stack.prototype.get = (0, $lwDUG.default);
$73c8979051c99f66$var$Stack.prototype.has = (0, $b5lTf.default);
$73c8979051c99f66$var$Stack.prototype.set = (0, $i8OSr.default);
var $73c8979051c99f66$export$2e2bcd8739ae039 = $73c8979051c99f66$var$Stack;

});
parcelRegister("kVnfZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3bb2bde4f3d2e10$export$2e2bcd8739ae039);

var $htx5f = parcelRequire("htx5f");

var $dEGYX = parcelRequire("dEGYX");

var $eiOY8 = parcelRequire("eiOY8");

var $5yv8I = parcelRequire("5yv8I");

var $67Adw = parcelRequire("67Adw");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $f3bb2bde4f3d2e10$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$f3bb2bde4f3d2e10$var$ListCache.prototype.clear = (0, $htx5f.default);
$f3bb2bde4f3d2e10$var$ListCache.prototype["delete"] = (0, $dEGYX.default);
$f3bb2bde4f3d2e10$var$ListCache.prototype.get = (0, $eiOY8.default);
$f3bb2bde4f3d2e10$var$ListCache.prototype.has = (0, $5yv8I.default);
$f3bb2bde4f3d2e10$var$ListCache.prototype.set = (0, $67Adw.default);
var $f3bb2bde4f3d2e10$export$2e2bcd8739ae039 = $f3bb2bde4f3d2e10$var$ListCache;

});
parcelRegister("htx5f", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb8ececfecd0309c$export$2e2bcd8739ae039);
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $cb8ececfecd0309c$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $cb8ececfecd0309c$export$2e2bcd8739ae039 = $cb8ececfecd0309c$var$listCacheClear;

});

parcelRegister("dEGYX", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f105a2cb198cf75$export$2e2bcd8739ae039);

var $eWSnX = parcelRequire("eWSnX");
/** Used for built-in method references. */ var $9f105a2cb198cf75$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $9f105a2cb198cf75$var$splice = $9f105a2cb198cf75$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $9f105a2cb198cf75$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $eWSnX.default)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $9f105a2cb198cf75$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $9f105a2cb198cf75$export$2e2bcd8739ae039 = $9f105a2cb198cf75$var$listCacheDelete;

});
parcelRegister("eWSnX", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae20ab4a6778d088$export$2e2bcd8739ae039);

var $lvgV1 = parcelRequire("lvgV1");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $ae20ab4a6778d088$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $lvgV1.default)(array[length][0], key)) return length;
    }
    return -1;
}
var $ae20ab4a6778d088$export$2e2bcd8739ae039 = $ae20ab4a6778d088$var$assocIndexOf;

});
parcelRegister("lvgV1", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa799df2e830873c$export$2e2bcd8739ae039);
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $fa799df2e830873c$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $fa799df2e830873c$export$2e2bcd8739ae039 = $fa799df2e830873c$var$eq;

});



parcelRegister("eiOY8", function(module, exports) {

$parcel$export(module.exports, "default", () => $a69a48810b4d495b$export$2e2bcd8739ae039);

var $eWSnX = parcelRequire("eWSnX");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $a69a48810b4d495b$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $eWSnX.default)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $a69a48810b4d495b$export$2e2bcd8739ae039 = $a69a48810b4d495b$var$listCacheGet;

});

parcelRegister("5yv8I", function(module, exports) {

$parcel$export(module.exports, "default", () => $40b84863e34edf18$export$2e2bcd8739ae039);

var $eWSnX = parcelRequire("eWSnX");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $40b84863e34edf18$var$listCacheHas(key) {
    return (0, $eWSnX.default)(this.__data__, key) > -1;
}
var $40b84863e34edf18$export$2e2bcd8739ae039 = $40b84863e34edf18$var$listCacheHas;

});

parcelRegister("67Adw", function(module, exports) {

$parcel$export(module.exports, "default", () => $474f7d7f66ed40d6$export$2e2bcd8739ae039);

var $eWSnX = parcelRequire("eWSnX");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $474f7d7f66ed40d6$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $eWSnX.default)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $474f7d7f66ed40d6$export$2e2bcd8739ae039 = $474f7d7f66ed40d6$var$listCacheSet;

});


parcelRegister("czhOX", function(module, exports) {

$parcel$export(module.exports, "default", () => $926693c1c5aa1b3b$export$2e2bcd8739ae039);

var $kVnfZ = parcelRequire("kVnfZ");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $926693c1c5aa1b3b$var$stackClear() {
    this.__data__ = new (0, $kVnfZ.default);
    this.size = 0;
}
var $926693c1c5aa1b3b$export$2e2bcd8739ae039 = $926693c1c5aa1b3b$var$stackClear;

});

parcelRegister("5QEPI", function(module, exports) {

$parcel$export(module.exports, "default", () => $44217bb0c3913906$export$2e2bcd8739ae039);
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $44217bb0c3913906$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
var $44217bb0c3913906$export$2e2bcd8739ae039 = $44217bb0c3913906$var$stackDelete;

});

parcelRegister("lwDUG", function(module, exports) {

$parcel$export(module.exports, "default", () => $fabb8c13d7ec2da0$export$2e2bcd8739ae039);
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $fabb8c13d7ec2da0$var$stackGet(key) {
    return this.__data__.get(key);
}
var $fabb8c13d7ec2da0$export$2e2bcd8739ae039 = $fabb8c13d7ec2da0$var$stackGet;

});

parcelRegister("b5lTf", function(module, exports) {

$parcel$export(module.exports, "default", () => $8121243fb2037ab0$export$2e2bcd8739ae039);
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $8121243fb2037ab0$var$stackHas(key) {
    return this.__data__.has(key);
}
var $8121243fb2037ab0$export$2e2bcd8739ae039 = $8121243fb2037ab0$var$stackHas;

});

parcelRegister("i8OSr", function(module, exports) {

$parcel$export(module.exports, "default", () => $d350707940985b27$export$2e2bcd8739ae039);

var $kVnfZ = parcelRequire("kVnfZ");

var $fs3H6 = parcelRequire("fs3H6");

var $7n3PR = parcelRequire("7n3PR");
/** Used as the size to enable large array optimizations. */ var $d350707940985b27$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $d350707940985b27$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, $kVnfZ.default)) {
        var pairs = data.__data__;
        if (!(0, $fs3H6.default) || pairs.length < $d350707940985b27$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, $7n3PR.default)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
var $d350707940985b27$export$2e2bcd8739ae039 = $d350707940985b27$var$stackSet;

});
parcelRegister("fs3H6", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3fc56271887eaf3$export$2e2bcd8739ae039);

var $jLT9P = parcelRequire("jLT9P");

var $2mpFt = parcelRequire("2mpFt");
/* Built-in method references that are verified to be native. */ var $b3fc56271887eaf3$var$Map = (0, $jLT9P.default)((0, $2mpFt.default), "Map");
var $b3fc56271887eaf3$export$2e2bcd8739ae039 = $b3fc56271887eaf3$var$Map;

});
parcelRegister("jLT9P", function(module, exports) {

$parcel$export(module.exports, "default", () => $e64d313d457435ee$export$2e2bcd8739ae039);

var $hJ8AQ = parcelRequire("hJ8AQ");

var $b0QTV = parcelRequire("b0QTV");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $e64d313d457435ee$var$getNative(object, key) {
    var value = (0, $b0QTV.default)(object, key);
    return (0, $hJ8AQ.default)(value) ? value : undefined;
}
var $e64d313d457435ee$export$2e2bcd8739ae039 = $e64d313d457435ee$var$getNative;

});
parcelRegister("hJ8AQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce7d4e19db8c5f74$export$2e2bcd8739ae039);

var $4VY3C = parcelRequire("4VY3C");

var $fMWvx = parcelRequire("fMWvx");

var $iYDsF = parcelRequire("iYDsF");

var $5bfPQ = parcelRequire("5bfPQ");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $ce7d4e19db8c5f74$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $ce7d4e19db8c5f74$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $ce7d4e19db8c5f74$var$funcProto = Function.prototype, $ce7d4e19db8c5f74$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $ce7d4e19db8c5f74$var$funcToString = $ce7d4e19db8c5f74$var$funcProto.toString;
/** Used to check objects for own properties. */ var $ce7d4e19db8c5f74$var$hasOwnProperty = $ce7d4e19db8c5f74$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $ce7d4e19db8c5f74$var$reIsNative = RegExp("^" + $ce7d4e19db8c5f74$var$funcToString.call($ce7d4e19db8c5f74$var$hasOwnProperty).replace($ce7d4e19db8c5f74$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $ce7d4e19db8c5f74$var$baseIsNative(value) {
    if (!(0, $iYDsF.default)(value) || (0, $fMWvx.default)(value)) return false;
    var pattern = (0, $4VY3C.default)(value) ? $ce7d4e19db8c5f74$var$reIsNative : $ce7d4e19db8c5f74$var$reIsHostCtor;
    return pattern.test((0, $5bfPQ.default)(value));
}
var $ce7d4e19db8c5f74$export$2e2bcd8739ae039 = $ce7d4e19db8c5f74$var$baseIsNative;

});
parcelRegister("4VY3C", function(module, exports) {

$parcel$export(module.exports, "default", () => $397b12740d7995ef$export$2e2bcd8739ae039);

var $hArsG = parcelRequire("hArsG");

var $iYDsF = parcelRequire("iYDsF");
/** `Object#toString` result references. */ var $397b12740d7995ef$var$asyncTag = "[object AsyncFunction]", $397b12740d7995ef$var$funcTag = "[object Function]", $397b12740d7995ef$var$genTag = "[object GeneratorFunction]", $397b12740d7995ef$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $397b12740d7995ef$var$isFunction(value) {
    if (!(0, $iYDsF.default)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $hArsG.default)(value);
    return tag == $397b12740d7995ef$var$funcTag || tag == $397b12740d7995ef$var$genTag || tag == $397b12740d7995ef$var$asyncTag || tag == $397b12740d7995ef$var$proxyTag;
}
var $397b12740d7995ef$export$2e2bcd8739ae039 = $397b12740d7995ef$var$isFunction;

});
parcelRegister("iYDsF", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd0c70c8150db920$export$2e2bcd8739ae039);
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $dd0c70c8150db920$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
var $dd0c70c8150db920$export$2e2bcd8739ae039 = $dd0c70c8150db920$var$isObject;

});


parcelRegister("fMWvx", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7e8b9239f02cfcb$export$2e2bcd8739ae039);

var $gsGrt = parcelRequire("gsGrt");
/** Used to detect methods masquerading as native. */ var $b7e8b9239f02cfcb$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $gsGrt.default) && (0, $gsGrt.default).keys && (0, $gsGrt.default).keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $b7e8b9239f02cfcb$var$isMasked(func) {
    return !!$b7e8b9239f02cfcb$var$maskSrcKey && $b7e8b9239f02cfcb$var$maskSrcKey in func;
}
var $b7e8b9239f02cfcb$export$2e2bcd8739ae039 = $b7e8b9239f02cfcb$var$isMasked;

});
parcelRegister("gsGrt", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfc02efb2c4f5b86$export$2e2bcd8739ae039);

var $2mpFt = parcelRequire("2mpFt");
/** Used to detect overreaching core-js shims. */ var $bfc02efb2c4f5b86$var$coreJsData = (0, $2mpFt.default)["__core-js_shared__"];
var $bfc02efb2c4f5b86$export$2e2bcd8739ae039 = $bfc02efb2c4f5b86$var$coreJsData;

});


parcelRegister("5bfPQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c5a435f91273845$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $3c5a435f91273845$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $3c5a435f91273845$var$funcToString = $3c5a435f91273845$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $3c5a435f91273845$var$toSource(func) {
    if (func != null) {
        try {
            return $3c5a435f91273845$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
var $3c5a435f91273845$export$2e2bcd8739ae039 = $3c5a435f91273845$var$toSource;

});


parcelRegister("b0QTV", function(module, exports) {

$parcel$export(module.exports, "default", () => $8048bad1174acf1d$export$2e2bcd8739ae039);
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $8048bad1174acf1d$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $8048bad1174acf1d$export$2e2bcd8739ae039 = $8048bad1174acf1d$var$getValue;

});



parcelRegister("7n3PR", function(module, exports) {

$parcel$export(module.exports, "default", () => $55dda8022ba8f51a$export$2e2bcd8739ae039);

var $bAMUC = parcelRequire("bAMUC");

var $56mPM = parcelRequire("56mPM");

var $428kg = parcelRequire("428kg");

var $jYsb1 = parcelRequire("jYsb1");

var $5XP4x = parcelRequire("5XP4x");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $55dda8022ba8f51a$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$55dda8022ba8f51a$var$MapCache.prototype.clear = (0, $bAMUC.default);
$55dda8022ba8f51a$var$MapCache.prototype["delete"] = (0, $56mPM.default);
$55dda8022ba8f51a$var$MapCache.prototype.get = (0, $428kg.default);
$55dda8022ba8f51a$var$MapCache.prototype.has = (0, $jYsb1.default);
$55dda8022ba8f51a$var$MapCache.prototype.set = (0, $5XP4x.default);
var $55dda8022ba8f51a$export$2e2bcd8739ae039 = $55dda8022ba8f51a$var$MapCache;

});
parcelRegister("bAMUC", function(module, exports) {

$parcel$export(module.exports, "default", () => $8708ff73733b2f97$export$2e2bcd8739ae039);

var $lSo3Y = parcelRequire("lSo3Y");

var $kVnfZ = parcelRequire("kVnfZ");

var $fs3H6 = parcelRequire("fs3H6");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $8708ff73733b2f97$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new (0, $lSo3Y.default),
        "map": new ((0, $fs3H6.default) || (0, $kVnfZ.default)),
        "string": new (0, $lSo3Y.default)
    };
}
var $8708ff73733b2f97$export$2e2bcd8739ae039 = $8708ff73733b2f97$var$mapCacheClear;

});
parcelRegister("lSo3Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $fed14e894961a2f6$export$2e2bcd8739ae039);

var $kTYGm = parcelRequire("kTYGm");

var $3NrNW = parcelRequire("3NrNW");

var $lyGZN = parcelRequire("lyGZN");

var $lMA2G = parcelRequire("lMA2G");

var $aKknX = parcelRequire("aKknX");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $fed14e894961a2f6$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$fed14e894961a2f6$var$Hash.prototype.clear = (0, $kTYGm.default);
$fed14e894961a2f6$var$Hash.prototype["delete"] = (0, $3NrNW.default);
$fed14e894961a2f6$var$Hash.prototype.get = (0, $lyGZN.default);
$fed14e894961a2f6$var$Hash.prototype.has = (0, $lMA2G.default);
$fed14e894961a2f6$var$Hash.prototype.set = (0, $aKknX.default);
var $fed14e894961a2f6$export$2e2bcd8739ae039 = $fed14e894961a2f6$var$Hash;

});
parcelRegister("kTYGm", function(module, exports) {

$parcel$export(module.exports, "default", () => $f37803ed33a1d3d1$export$2e2bcd8739ae039);

var $cbYyv = parcelRequire("cbYyv");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $f37803ed33a1d3d1$var$hashClear() {
    this.__data__ = (0, $cbYyv.default) ? (0, $cbYyv.default)(null) : {};
    this.size = 0;
}
var $f37803ed33a1d3d1$export$2e2bcd8739ae039 = $f37803ed33a1d3d1$var$hashClear;

});
parcelRegister("cbYyv", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e057c2da47d85b2$export$2e2bcd8739ae039);

var $jLT9P = parcelRequire("jLT9P");
/* Built-in method references that are verified to be native. */ var $8e057c2da47d85b2$var$nativeCreate = (0, $jLT9P.default)(Object, "create");
var $8e057c2da47d85b2$export$2e2bcd8739ae039 = $8e057c2da47d85b2$var$nativeCreate;

});


parcelRegister("3NrNW", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c3b841be68d9967$export$2e2bcd8739ae039);
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $2c3b841be68d9967$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $2c3b841be68d9967$export$2e2bcd8739ae039 = $2c3b841be68d9967$var$hashDelete;

});

parcelRegister("lyGZN", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb1e2001932a20de$export$2e2bcd8739ae039);

var $cbYyv = parcelRequire("cbYyv");
/** Used to stand-in for `undefined` hash values. */ var $fb1e2001932a20de$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $fb1e2001932a20de$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $fb1e2001932a20de$var$hasOwnProperty = $fb1e2001932a20de$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $fb1e2001932a20de$var$hashGet(key) {
    var data = this.__data__;
    if (0, $cbYyv.default) {
        var result = data[key];
        return result === $fb1e2001932a20de$var$HASH_UNDEFINED ? undefined : result;
    }
    return $fb1e2001932a20de$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $fb1e2001932a20de$export$2e2bcd8739ae039 = $fb1e2001932a20de$var$hashGet;

});

parcelRegister("lMA2G", function(module, exports) {

$parcel$export(module.exports, "default", () => $fdba09ea24ad742a$export$2e2bcd8739ae039);

var $cbYyv = parcelRequire("cbYyv");
/** Used for built-in method references. */ var $fdba09ea24ad742a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $fdba09ea24ad742a$var$hasOwnProperty = $fdba09ea24ad742a$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $fdba09ea24ad742a$var$hashHas(key) {
    var data = this.__data__;
    return (0, $cbYyv.default) ? data[key] !== undefined : $fdba09ea24ad742a$var$hasOwnProperty.call(data, key);
}
var $fdba09ea24ad742a$export$2e2bcd8739ae039 = $fdba09ea24ad742a$var$hashHas;

});

parcelRegister("aKknX", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d2e036616ad2fb6$export$2e2bcd8739ae039);

var $cbYyv = parcelRequire("cbYyv");
/** Used to stand-in for `undefined` hash values. */ var $7d2e036616ad2fb6$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $7d2e036616ad2fb6$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $cbYyv.default) && value === undefined ? $7d2e036616ad2fb6$var$HASH_UNDEFINED : value;
    return this;
}
var $7d2e036616ad2fb6$export$2e2bcd8739ae039 = $7d2e036616ad2fb6$var$hashSet;

});



parcelRegister("56mPM", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b6f39a956fe6a39$export$2e2bcd8739ae039);

var $9vBNU = parcelRequire("9vBNU");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $3b6f39a956fe6a39$var$mapCacheDelete(key) {
    var result = (0, $9vBNU.default)(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $3b6f39a956fe6a39$export$2e2bcd8739ae039 = $3b6f39a956fe6a39$var$mapCacheDelete;

});
parcelRegister("9vBNU", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ec4556484e81801$export$2e2bcd8739ae039);

var $4WJzL = parcelRequire("4WJzL");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $6ec4556484e81801$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $4WJzL.default)(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
var $6ec4556484e81801$export$2e2bcd8739ae039 = $6ec4556484e81801$var$getMapData;

});
parcelRegister("4WJzL", function(module, exports) {

$parcel$export(module.exports, "default", () => $399fee9a556f4b4d$export$2e2bcd8739ae039);
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $399fee9a556f4b4d$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
var $399fee9a556f4b4d$export$2e2bcd8739ae039 = $399fee9a556f4b4d$var$isKeyable;

});



parcelRegister("428kg", function(module, exports) {

$parcel$export(module.exports, "default", () => $2efdcea83805e55c$export$2e2bcd8739ae039);

var $9vBNU = parcelRequire("9vBNU");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $2efdcea83805e55c$var$mapCacheGet(key) {
    return (0, $9vBNU.default)(this, key).get(key);
}
var $2efdcea83805e55c$export$2e2bcd8739ae039 = $2efdcea83805e55c$var$mapCacheGet;

});

parcelRegister("jYsb1", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8a97a3ac9920cdd$export$2e2bcd8739ae039);

var $9vBNU = parcelRequire("9vBNU");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e8a97a3ac9920cdd$var$mapCacheHas(key) {
    return (0, $9vBNU.default)(this, key).has(key);
}
var $e8a97a3ac9920cdd$export$2e2bcd8739ae039 = $e8a97a3ac9920cdd$var$mapCacheHas;

});

parcelRegister("5XP4x", function(module, exports) {

$parcel$export(module.exports, "default", () => $457a144fcd79754e$export$2e2bcd8739ae039);

var $9vBNU = parcelRequire("9vBNU");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $457a144fcd79754e$var$mapCacheSet(key, value) {
    var data = (0, $9vBNU.default)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $457a144fcd79754e$export$2e2bcd8739ae039 = $457a144fcd79754e$var$mapCacheSet;

});




parcelRegister("iDECW", function(module, exports) {

$parcel$export(module.exports, "default", () => $d91b623631254979$export$2e2bcd8739ae039);
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $d91b623631254979$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
var $d91b623631254979$export$2e2bcd8739ae039 = $d91b623631254979$var$arrayEach;

});

parcelRegister("a6l6i", function(module, exports) {

$parcel$export(module.exports, "default", () => $75aad50ec93ed496$export$2e2bcd8739ae039);

var $dLTlW = parcelRequire("dLTlW");

var $lvgV1 = parcelRequire("lvgV1");
/** Used for built-in method references. */ var $75aad50ec93ed496$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $75aad50ec93ed496$var$hasOwnProperty = $75aad50ec93ed496$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $75aad50ec93ed496$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($75aad50ec93ed496$var$hasOwnProperty.call(object, key) && (0, $lvgV1.default)(objValue, value)) || value === undefined && !(key in object)) (0, $dLTlW.default)(object, key, value);
}
var $75aad50ec93ed496$export$2e2bcd8739ae039 = $75aad50ec93ed496$var$assignValue;

});
parcelRegister("dLTlW", function(module, exports) {

$parcel$export(module.exports, "default", () => $a06a9a17329ff8a6$export$2e2bcd8739ae039);

var $1RMjB = parcelRequire("1RMjB");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $a06a9a17329ff8a6$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && (0, $1RMjB.default)) (0, $1RMjB.default)(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
var $a06a9a17329ff8a6$export$2e2bcd8739ae039 = $a06a9a17329ff8a6$var$baseAssignValue;

});
parcelRegister("1RMjB", function(module, exports) {

$parcel$export(module.exports, "default", () => $15c038100f8779dc$export$2e2bcd8739ae039);

var $jLT9P = parcelRequire("jLT9P");
var $15c038100f8779dc$var$defineProperty = function() {
    try {
        var func = (0, $jLT9P.default)(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
var $15c038100f8779dc$export$2e2bcd8739ae039 = $15c038100f8779dc$var$defineProperty;

});



parcelRegister("7FIi5", function(module, exports) {

$parcel$export(module.exports, "default", () => $595eb7f7a07807be$export$2e2bcd8739ae039);

var $3Wzdm = parcelRequire("3Wzdm");

var $8krEv = parcelRequire("8krEv");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $595eb7f7a07807be$var$baseAssign(object, source) {
    return object && (0, $3Wzdm.default)(source, (0, $8krEv.default)(source), object);
}
var $595eb7f7a07807be$export$2e2bcd8739ae039 = $595eb7f7a07807be$var$baseAssign;

});
parcelRegister("3Wzdm", function(module, exports) {

$parcel$export(module.exports, "default", () => $2df21abc8bda85fc$export$2e2bcd8739ae039);

var $a6l6i = parcelRequire("a6l6i");

var $dLTlW = parcelRequire("dLTlW");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $2df21abc8bda85fc$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) (0, $dLTlW.default)(object, key, newValue);
        else (0, $a6l6i.default)(object, key, newValue);
    }
    return object;
}
var $2df21abc8bda85fc$export$2e2bcd8739ae039 = $2df21abc8bda85fc$var$copyObject;

});

parcelRegister("8krEv", function(module, exports) {

$parcel$export(module.exports, "default", () => $6105a42c6332ca51$export$2e2bcd8739ae039);

var $OC2DR = parcelRequire("OC2DR");

var $lTyg4 = parcelRequire("lTyg4");

var $lAOUf = parcelRequire("lAOUf");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $6105a42c6332ca51$var$keys(object) {
    return (0, $lAOUf.default)(object) ? (0, $OC2DR.default)(object) : (0, $lTyg4.default)(object);
}
var $6105a42c6332ca51$export$2e2bcd8739ae039 = $6105a42c6332ca51$var$keys;

});
parcelRegister("OC2DR", function(module, exports) {

$parcel$export(module.exports, "default", () => $09822de5e5cf749f$export$2e2bcd8739ae039);

var $3f4I6 = parcelRequire("3f4I6");

var $5VdmZ = parcelRequire("5VdmZ");

var $hf0C9 = parcelRequire("hf0C9");

var $f3ZL4 = parcelRequire("f3ZL4");

var $cBYZY = parcelRequire("cBYZY");

var $cmTeE = parcelRequire("cmTeE");
/** Used for built-in method references. */ var $09822de5e5cf749f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $09822de5e5cf749f$var$hasOwnProperty = $09822de5e5cf749f$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $09822de5e5cf749f$var$arrayLikeKeys(value, inherited) {
    var isArr = (0, $hf0C9.default)(value), isArg = !isArr && (0, $5VdmZ.default)(value), isBuff = !isArr && !isArg && (0, $f3ZL4.default)(value), isType = !isArr && !isArg && !isBuff && (0, $cmTeE.default)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, $3f4I6.default)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $09822de5e5cf749f$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    (0, $cBYZY.default)(key, length)))) result.push(key);
    return result;
}
var $09822de5e5cf749f$export$2e2bcd8739ae039 = $09822de5e5cf749f$var$arrayLikeKeys;

});
parcelRegister("3f4I6", function(module, exports) {

$parcel$export(module.exports, "default", () => $25c66d2c4e8fadd1$export$2e2bcd8739ae039);
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $25c66d2c4e8fadd1$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
var $25c66d2c4e8fadd1$export$2e2bcd8739ae039 = $25c66d2c4e8fadd1$var$baseTimes;

});

parcelRegister("5VdmZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $44fca59879666c41$export$2e2bcd8739ae039);

var $j2nBL = parcelRequire("j2nBL");

var $f2iog = parcelRequire("f2iog");
/** Used for built-in method references. */ var $44fca59879666c41$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $44fca59879666c41$var$hasOwnProperty = $44fca59879666c41$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $44fca59879666c41$var$propertyIsEnumerable = $44fca59879666c41$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $44fca59879666c41$var$isArguments = (0, $j2nBL.default)(function() {
    return arguments;
}()) ? (0, $j2nBL.default) : function(value) {
    return (0, $f2iog.default)(value) && $44fca59879666c41$var$hasOwnProperty.call(value, "callee") && !$44fca59879666c41$var$propertyIsEnumerable.call(value, "callee");
};
var $44fca59879666c41$export$2e2bcd8739ae039 = $44fca59879666c41$var$isArguments;

});
parcelRegister("j2nBL", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddc0844e7eecdb52$export$2e2bcd8739ae039);

var $hArsG = parcelRequire("hArsG");

var $f2iog = parcelRequire("f2iog");
/** `Object#toString` result references. */ var $ddc0844e7eecdb52$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $ddc0844e7eecdb52$var$baseIsArguments(value) {
    return (0, $f2iog.default)(value) && (0, $hArsG.default)(value) == $ddc0844e7eecdb52$var$argsTag;
}
var $ddc0844e7eecdb52$export$2e2bcd8739ae039 = $ddc0844e7eecdb52$var$baseIsArguments;

});


parcelRegister("hf0C9", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8d4506109b88831$export$2e2bcd8739ae039);
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $c8d4506109b88831$var$isArray = Array.isArray;
var $c8d4506109b88831$export$2e2bcd8739ae039 = $c8d4506109b88831$var$isArray;

});

parcelRegister("f3ZL4", function(module, exports) {

$parcel$export(module.exports, "default", () => $af770abdaf769dee$export$2e2bcd8739ae039);

var $2mpFt = parcelRequire("2mpFt");

var $kcGKx = parcelRequire("kcGKx");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $2mpFt.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, $kcGKx.default);
var $af770abdaf769dee$export$2e2bcd8739ae039 = isBuffer;

});
parcelRegister("kcGKx", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb5616d4c933d058$export$2e2bcd8739ae039);
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $eb5616d4c933d058$var$stubFalse() {
    return false;
}
var $eb5616d4c933d058$export$2e2bcd8739ae039 = $eb5616d4c933d058$var$stubFalse;

});


parcelRegister("cBYZY", function(module, exports) {

$parcel$export(module.exports, "default", () => $92e841cef318fb91$export$2e2bcd8739ae039);
/** Used as references for various `Number` constants. */ var $92e841cef318fb91$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $92e841cef318fb91$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $92e841cef318fb91$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $92e841cef318fb91$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $92e841cef318fb91$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $92e841cef318fb91$export$2e2bcd8739ae039 = $92e841cef318fb91$var$isIndex;

});

parcelRegister("cmTeE", function(module, exports) {

$parcel$export(module.exports, "default", () => $901262b1d4441a58$export$2e2bcd8739ae039);

var $eaXgH = parcelRequire("eaXgH");

var $hb0cD = parcelRequire("hb0cD");

var $lFXqE = parcelRequire("lFXqE");
/* Node.js helper references. */ var $901262b1d4441a58$var$nodeIsTypedArray = (0, $lFXqE.default) && (0, $lFXqE.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $901262b1d4441a58$var$isTypedArray = $901262b1d4441a58$var$nodeIsTypedArray ? (0, $hb0cD.default)($901262b1d4441a58$var$nodeIsTypedArray) : (0, $eaXgH.default);
var $901262b1d4441a58$export$2e2bcd8739ae039 = $901262b1d4441a58$var$isTypedArray;

});
parcelRegister("eaXgH", function(module, exports) {

$parcel$export(module.exports, "default", () => $a51ff94e4fd33486$export$2e2bcd8739ae039);

var $hArsG = parcelRequire("hArsG");

var $idNmI = parcelRequire("idNmI");

var $f2iog = parcelRequire("f2iog");
/** `Object#toString` result references. */ var $a51ff94e4fd33486$var$argsTag = "[object Arguments]", $a51ff94e4fd33486$var$arrayTag = "[object Array]", $a51ff94e4fd33486$var$boolTag = "[object Boolean]", $a51ff94e4fd33486$var$dateTag = "[object Date]", $a51ff94e4fd33486$var$errorTag = "[object Error]", $a51ff94e4fd33486$var$funcTag = "[object Function]", $a51ff94e4fd33486$var$mapTag = "[object Map]", $a51ff94e4fd33486$var$numberTag = "[object Number]", $a51ff94e4fd33486$var$objectTag = "[object Object]", $a51ff94e4fd33486$var$regexpTag = "[object RegExp]", $a51ff94e4fd33486$var$setTag = "[object Set]", $a51ff94e4fd33486$var$stringTag = "[object String]", $a51ff94e4fd33486$var$weakMapTag = "[object WeakMap]";
var $a51ff94e4fd33486$var$arrayBufferTag = "[object ArrayBuffer]", $a51ff94e4fd33486$var$dataViewTag = "[object DataView]", $a51ff94e4fd33486$var$float32Tag = "[object Float32Array]", $a51ff94e4fd33486$var$float64Tag = "[object Float64Array]", $a51ff94e4fd33486$var$int8Tag = "[object Int8Array]", $a51ff94e4fd33486$var$int16Tag = "[object Int16Array]", $a51ff94e4fd33486$var$int32Tag = "[object Int32Array]", $a51ff94e4fd33486$var$uint8Tag = "[object Uint8Array]", $a51ff94e4fd33486$var$uint8ClampedTag = "[object Uint8ClampedArray]", $a51ff94e4fd33486$var$uint16Tag = "[object Uint16Array]", $a51ff94e4fd33486$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $a51ff94e4fd33486$var$typedArrayTags = {};
$a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$float32Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$float64Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$int8Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$int16Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$int32Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$uint8Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$uint8ClampedTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$uint16Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$uint32Tag] = true;
$a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$argsTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$arrayTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$arrayBufferTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$boolTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$dataViewTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$dateTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$errorTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$funcTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$mapTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$numberTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$objectTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$regexpTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$setTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$stringTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $a51ff94e4fd33486$var$baseIsTypedArray(value) {
    return (0, $f2iog.default)(value) && (0, $idNmI.default)(value.length) && !!$a51ff94e4fd33486$var$typedArrayTags[(0, $hArsG.default)(value)];
}
var $a51ff94e4fd33486$export$2e2bcd8739ae039 = $a51ff94e4fd33486$var$baseIsTypedArray;

});
parcelRegister("idNmI", function(module, exports) {

$parcel$export(module.exports, "default", () => $d43fbbcf5bc665de$export$2e2bcd8739ae039);
/** Used as references for various `Number` constants. */ var $d43fbbcf5bc665de$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $d43fbbcf5bc665de$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $d43fbbcf5bc665de$var$MAX_SAFE_INTEGER;
}
var $d43fbbcf5bc665de$export$2e2bcd8739ae039 = $d43fbbcf5bc665de$var$isLength;

});


parcelRegister("hb0cD", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8139f05a61e038a$export$2e2bcd8739ae039);
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $c8139f05a61e038a$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
var $c8139f05a61e038a$export$2e2bcd8739ae039 = $c8139f05a61e038a$var$baseUnary;

});

parcelRegister("lFXqE", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc7b86a02b9b077f$export$2e2bcd8739ae039);

var $4kWvg = parcelRequire("4kWvg");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, $4kWvg.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
var $fc7b86a02b9b077f$export$2e2bcd8739ae039 = nodeUtil;

});



parcelRegister("lTyg4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff094f04b4f9f6ca$export$2e2bcd8739ae039);

var $74QAJ = parcelRequire("74QAJ");

var $4lnKf = parcelRequire("4lnKf");
/** Used for built-in method references. */ var $ff094f04b4f9f6ca$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ff094f04b4f9f6ca$var$hasOwnProperty = $ff094f04b4f9f6ca$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $ff094f04b4f9f6ca$var$baseKeys(object) {
    if (!(0, $74QAJ.default)(object)) return (0, $4lnKf.default)(object);
    var result = [];
    for(var key in Object(object))if ($ff094f04b4f9f6ca$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
var $ff094f04b4f9f6ca$export$2e2bcd8739ae039 = $ff094f04b4f9f6ca$var$baseKeys;

});
parcelRegister("74QAJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5271b3ac6403835d$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $5271b3ac6403835d$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $5271b3ac6403835d$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $5271b3ac6403835d$var$objectProto;
    return value === proto;
}
var $5271b3ac6403835d$export$2e2bcd8739ae039 = $5271b3ac6403835d$var$isPrototype;

});

parcelRegister("4lnKf", function(module, exports) {

$parcel$export(module.exports, "default", () => $329b8ad85e05c8eb$export$2e2bcd8739ae039);

var $7N1cZ = parcelRequire("7N1cZ");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $329b8ad85e05c8eb$var$nativeKeys = (0, $7N1cZ.default)(Object.keys, Object);
var $329b8ad85e05c8eb$export$2e2bcd8739ae039 = $329b8ad85e05c8eb$var$nativeKeys;

});


parcelRegister("lAOUf", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb8472aba17743fc$export$2e2bcd8739ae039);

var $4VY3C = parcelRequire("4VY3C");

var $idNmI = parcelRequire("idNmI");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $fb8472aba17743fc$var$isArrayLike(value) {
    return value != null && (0, $idNmI.default)(value.length) && !(0, $4VY3C.default)(value);
}
var $fb8472aba17743fc$export$2e2bcd8739ae039 = $fb8472aba17743fc$var$isArrayLike;

});



parcelRegister("3vFgL", function(module, exports) {

$parcel$export(module.exports, "default", () => $28e447985d6ff998$export$2e2bcd8739ae039);

var $3Wzdm = parcelRequire("3Wzdm");

var $ceNjR = parcelRequire("ceNjR");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $28e447985d6ff998$var$baseAssignIn(object, source) {
    return object && (0, $3Wzdm.default)(source, (0, $ceNjR.default)(source), object);
}
var $28e447985d6ff998$export$2e2bcd8739ae039 = $28e447985d6ff998$var$baseAssignIn;

});
parcelRegister("ceNjR", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e8d0ca4619e1205$export$2e2bcd8739ae039);

var $OC2DR = parcelRequire("OC2DR");

var $28fGX = parcelRequire("28fGX");

var $lAOUf = parcelRequire("lAOUf");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $8e8d0ca4619e1205$var$keysIn(object) {
    return (0, $lAOUf.default)(object) ? (0, $OC2DR.default)(object, true) : (0, $28fGX.default)(object);
}
var $8e8d0ca4619e1205$export$2e2bcd8739ae039 = $8e8d0ca4619e1205$var$keysIn;

});
parcelRegister("28fGX", function(module, exports) {

$parcel$export(module.exports, "default", () => $18d88030c379da98$export$2e2bcd8739ae039);

var $iYDsF = parcelRequire("iYDsF");

var $74QAJ = parcelRequire("74QAJ");

var $ab5U2 = parcelRequire("ab5U2");
/** Used for built-in method references. */ var $18d88030c379da98$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $18d88030c379da98$var$hasOwnProperty = $18d88030c379da98$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $18d88030c379da98$var$baseKeysIn(object) {
    if (!(0, $iYDsF.default)(object)) return (0, $ab5U2.default)(object);
    var isProto = (0, $74QAJ.default)(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !$18d88030c379da98$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
var $18d88030c379da98$export$2e2bcd8739ae039 = $18d88030c379da98$var$baseKeysIn;

});
parcelRegister("ab5U2", function(module, exports) {

$parcel$export(module.exports, "default", () => $768f82a6c66c1e5e$export$2e2bcd8739ae039);
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $768f82a6c66c1e5e$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
var $768f82a6c66c1e5e$export$2e2bcd8739ae039 = $768f82a6c66c1e5e$var$nativeKeysIn;

});




parcelRegister("gqoYg", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf5271c040a1f410$export$2e2bcd8739ae039);

var $2mpFt = parcelRequire("2mpFt");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $2mpFt.default).Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
var $bf5271c040a1f410$export$2e2bcd8739ae039 = cloneBuffer;

});

parcelRegister("jXStN", function(module, exports) {

$parcel$export(module.exports, "default", () => $e88dc98a9c0b5c36$export$2e2bcd8739ae039);
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $e88dc98a9c0b5c36$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
var $e88dc98a9c0b5c36$export$2e2bcd8739ae039 = $e88dc98a9c0b5c36$var$copyArray;

});

parcelRegister("8gRDv", function(module, exports) {

$parcel$export(module.exports, "default", () => $60596c5c5ae95246$export$2e2bcd8739ae039);

var $3Wzdm = parcelRequire("3Wzdm");

var $dKFRe = parcelRequire("dKFRe");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $60596c5c5ae95246$var$copySymbols(source, object) {
    return (0, $3Wzdm.default)(source, (0, $dKFRe.default)(source), object);
}
var $60596c5c5ae95246$export$2e2bcd8739ae039 = $60596c5c5ae95246$var$copySymbols;

});
parcelRegister("dKFRe", function(module, exports) {

$parcel$export(module.exports, "default", () => $02956b8552c88dad$export$2e2bcd8739ae039);

var $bpczR = parcelRequire("bpczR");

var $37AVt = parcelRequire("37AVt");
/** Used for built-in method references. */ var $02956b8552c88dad$var$objectProto = Object.prototype;
/** Built-in value references. */ var $02956b8552c88dad$var$propertyIsEnumerable = $02956b8552c88dad$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $02956b8552c88dad$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $02956b8552c88dad$var$getSymbols = !$02956b8552c88dad$var$nativeGetSymbols ? (0, $37AVt.default) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, $bpczR.default)($02956b8552c88dad$var$nativeGetSymbols(object), function(symbol) {
        return $02956b8552c88dad$var$propertyIsEnumerable.call(object, symbol);
    });
};
var $02956b8552c88dad$export$2e2bcd8739ae039 = $02956b8552c88dad$var$getSymbols;

});
parcelRegister("bpczR", function(module, exports) {

$parcel$export(module.exports, "default", () => $84dbc91852227c49$export$2e2bcd8739ae039);
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $84dbc91852227c49$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
var $84dbc91852227c49$export$2e2bcd8739ae039 = $84dbc91852227c49$var$arrayFilter;

});

parcelRegister("37AVt", function(module, exports) {

$parcel$export(module.exports, "default", () => $245eab4238d1191b$export$2e2bcd8739ae039);
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $245eab4238d1191b$var$stubArray() {
    return [];
}
var $245eab4238d1191b$export$2e2bcd8739ae039 = $245eab4238d1191b$var$stubArray;

});



parcelRegister("7AKhX", function(module, exports) {

$parcel$export(module.exports, "default", () => $586fcd2cd99597f5$export$2e2bcd8739ae039);

var $3Wzdm = parcelRequire("3Wzdm");

var $hDzVK = parcelRequire("hDzVK");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $586fcd2cd99597f5$var$copySymbolsIn(source, object) {
    return (0, $3Wzdm.default)(source, (0, $hDzVK.default)(source), object);
}
var $586fcd2cd99597f5$export$2e2bcd8739ae039 = $586fcd2cd99597f5$var$copySymbolsIn;

});
parcelRegister("hDzVK", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd71f33290dd3540$export$2e2bcd8739ae039);

var $6JPqi = parcelRequire("6JPqi");

var $bzIQZ = parcelRequire("bzIQZ");

var $dKFRe = parcelRequire("dKFRe");

var $37AVt = parcelRequire("37AVt");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $cd71f33290dd3540$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $cd71f33290dd3540$var$getSymbolsIn = !$cd71f33290dd3540$var$nativeGetSymbols ? (0, $37AVt.default) : function(object) {
    var result = [];
    while(object){
        (0, $6JPqi.default)(result, (0, $dKFRe.default)(object));
        object = (0, $bzIQZ.default)(object);
    }
    return result;
};
var $cd71f33290dd3540$export$2e2bcd8739ae039 = $cd71f33290dd3540$var$getSymbolsIn;

});
parcelRegister("6JPqi", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e7ed5991d883ad6$export$2e2bcd8739ae039);
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $4e7ed5991d883ad6$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
var $4e7ed5991d883ad6$export$2e2bcd8739ae039 = $4e7ed5991d883ad6$var$arrayPush;

});



parcelRegister("oK0lo", function(module, exports) {

$parcel$export(module.exports, "default", () => $04a5ed8d1a69f13e$export$2e2bcd8739ae039);

var $hNlD0 = parcelRequire("hNlD0");

var $dKFRe = parcelRequire("dKFRe");

var $8krEv = parcelRequire("8krEv");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $04a5ed8d1a69f13e$var$getAllKeys(object) {
    return (0, $hNlD0.default)(object, (0, $8krEv.default), (0, $dKFRe.default));
}
var $04a5ed8d1a69f13e$export$2e2bcd8739ae039 = $04a5ed8d1a69f13e$var$getAllKeys;

});
parcelRegister("hNlD0", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf47ca2fc3f4de6e$export$2e2bcd8739ae039);

var $6JPqi = parcelRequire("6JPqi");

var $hf0C9 = parcelRequire("hf0C9");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $cf47ca2fc3f4de6e$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, $hf0C9.default)(object) ? result : (0, $6JPqi.default)(result, symbolsFunc(object));
}
var $cf47ca2fc3f4de6e$export$2e2bcd8739ae039 = $cf47ca2fc3f4de6e$var$baseGetAllKeys;

});


parcelRegister("7bulh", function(module, exports) {

$parcel$export(module.exports, "default", () => $53b118d05aedad9a$export$2e2bcd8739ae039);

var $hNlD0 = parcelRequire("hNlD0");

var $hDzVK = parcelRequire("hDzVK");

var $ceNjR = parcelRequire("ceNjR");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $53b118d05aedad9a$var$getAllKeysIn(object) {
    return (0, $hNlD0.default)(object, (0, $ceNjR.default), (0, $hDzVK.default));
}
var $53b118d05aedad9a$export$2e2bcd8739ae039 = $53b118d05aedad9a$var$getAllKeysIn;

});

parcelRegister("4wkSQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $34aa59a61c7ccccb$export$2e2bcd8739ae039);

var $dR5x6 = parcelRequire("dR5x6");

var $fs3H6 = parcelRequire("fs3H6");

var $ab1Hq = parcelRequire("ab1Hq");

var $iypSL = parcelRequire("iypSL");

var $1xFLT = parcelRequire("1xFLT");

var $hArsG = parcelRequire("hArsG");

var $5bfPQ = parcelRequire("5bfPQ");
/** `Object#toString` result references. */ var $34aa59a61c7ccccb$var$mapTag = "[object Map]", $34aa59a61c7ccccb$var$objectTag = "[object Object]", $34aa59a61c7ccccb$var$promiseTag = "[object Promise]", $34aa59a61c7ccccb$var$setTag = "[object Set]", $34aa59a61c7ccccb$var$weakMapTag = "[object WeakMap]";
var $34aa59a61c7ccccb$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $34aa59a61c7ccccb$var$dataViewCtorString = (0, $5bfPQ.default)((0, $dR5x6.default)), $34aa59a61c7ccccb$var$mapCtorString = (0, $5bfPQ.default)((0, $fs3H6.default)), $34aa59a61c7ccccb$var$promiseCtorString = (0, $5bfPQ.default)((0, $ab1Hq.default)), $34aa59a61c7ccccb$var$setCtorString = (0, $5bfPQ.default)((0, $iypSL.default)), $34aa59a61c7ccccb$var$weakMapCtorString = (0, $5bfPQ.default)((0, $1xFLT.default));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $34aa59a61c7ccccb$var$getTag = (0, $hArsG.default);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, $dR5x6.default) && $34aa59a61c7ccccb$var$getTag(new (0, $dR5x6.default)(new ArrayBuffer(1))) != $34aa59a61c7ccccb$var$dataViewTag || (0, $fs3H6.default) && $34aa59a61c7ccccb$var$getTag(new (0, $fs3H6.default)) != $34aa59a61c7ccccb$var$mapTag || (0, $ab1Hq.default) && $34aa59a61c7ccccb$var$getTag((0, $ab1Hq.default).resolve()) != $34aa59a61c7ccccb$var$promiseTag || (0, $iypSL.default) && $34aa59a61c7ccccb$var$getTag(new (0, $iypSL.default)) != $34aa59a61c7ccccb$var$setTag || (0, $1xFLT.default) && $34aa59a61c7ccccb$var$getTag(new (0, $1xFLT.default)) != $34aa59a61c7ccccb$var$weakMapTag) $34aa59a61c7ccccb$var$getTag = function(value) {
    var result = (0, $hArsG.default)(value), Ctor = result == $34aa59a61c7ccccb$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, $5bfPQ.default)(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $34aa59a61c7ccccb$var$dataViewCtorString:
            return $34aa59a61c7ccccb$var$dataViewTag;
        case $34aa59a61c7ccccb$var$mapCtorString:
            return $34aa59a61c7ccccb$var$mapTag;
        case $34aa59a61c7ccccb$var$promiseCtorString:
            return $34aa59a61c7ccccb$var$promiseTag;
        case $34aa59a61c7ccccb$var$setCtorString:
            return $34aa59a61c7ccccb$var$setTag;
        case $34aa59a61c7ccccb$var$weakMapCtorString:
            return $34aa59a61c7ccccb$var$weakMapTag;
    }
    return result;
};
var $34aa59a61c7ccccb$export$2e2bcd8739ae039 = $34aa59a61c7ccccb$var$getTag;

});
parcelRegister("dR5x6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1648453896f67d2$export$2e2bcd8739ae039);

var $jLT9P = parcelRequire("jLT9P");

var $2mpFt = parcelRequire("2mpFt");
/* Built-in method references that are verified to be native. */ var $a1648453896f67d2$var$DataView = (0, $jLT9P.default)((0, $2mpFt.default), "DataView");
var $a1648453896f67d2$export$2e2bcd8739ae039 = $a1648453896f67d2$var$DataView;

});

parcelRegister("ab1Hq", function(module, exports) {

$parcel$export(module.exports, "default", () => $768c3ff3ee4df356$export$2e2bcd8739ae039);

var $jLT9P = parcelRequire("jLT9P");

var $2mpFt = parcelRequire("2mpFt");
/* Built-in method references that are verified to be native. */ var $768c3ff3ee4df356$var$Promise = (0, $jLT9P.default)((0, $2mpFt.default), "Promise");
var $768c3ff3ee4df356$export$2e2bcd8739ae039 = $768c3ff3ee4df356$var$Promise;

});

parcelRegister("iypSL", function(module, exports) {

$parcel$export(module.exports, "default", () => $d81f7aa452e6e637$export$2e2bcd8739ae039);

var $jLT9P = parcelRequire("jLT9P");

var $2mpFt = parcelRequire("2mpFt");
/* Built-in method references that are verified to be native. */ var $d81f7aa452e6e637$var$Set = (0, $jLT9P.default)((0, $2mpFt.default), "Set");
var $d81f7aa452e6e637$export$2e2bcd8739ae039 = $d81f7aa452e6e637$var$Set;

});

parcelRegister("1xFLT", function(module, exports) {

$parcel$export(module.exports, "default", () => $11f94673ff7d99d8$export$2e2bcd8739ae039);

var $jLT9P = parcelRequire("jLT9P");

var $2mpFt = parcelRequire("2mpFt");
/* Built-in method references that are verified to be native. */ var $11f94673ff7d99d8$var$WeakMap = (0, $jLT9P.default)((0, $2mpFt.default), "WeakMap");
var $11f94673ff7d99d8$export$2e2bcd8739ae039 = $11f94673ff7d99d8$var$WeakMap;

});


parcelRegister("9HyGp", function(module, exports) {

$parcel$export(module.exports, "default", () => $7103088c29fc4f0b$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $7103088c29fc4f0b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7103088c29fc4f0b$var$hasOwnProperty = $7103088c29fc4f0b$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $7103088c29fc4f0b$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == "string" && $7103088c29fc4f0b$var$hasOwnProperty.call(array, "index")) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
var $7103088c29fc4f0b$export$2e2bcd8739ae039 = $7103088c29fc4f0b$var$initCloneArray;

});

parcelRegister("iBTyS", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8c6c80dd3650253$export$2e2bcd8739ae039);

var $9tz5c = parcelRequire("9tz5c");

var $9sDYA = parcelRequire("9sDYA");

var $g8BP3 = parcelRequire("g8BP3");

var $lcI69 = parcelRequire("lcI69");

var $40E9j = parcelRequire("40E9j");
/** `Object#toString` result references. */ var $d8c6c80dd3650253$var$boolTag = "[object Boolean]", $d8c6c80dd3650253$var$dateTag = "[object Date]", $d8c6c80dd3650253$var$mapTag = "[object Map]", $d8c6c80dd3650253$var$numberTag = "[object Number]", $d8c6c80dd3650253$var$regexpTag = "[object RegExp]", $d8c6c80dd3650253$var$setTag = "[object Set]", $d8c6c80dd3650253$var$stringTag = "[object String]", $d8c6c80dd3650253$var$symbolTag = "[object Symbol]";
var $d8c6c80dd3650253$var$arrayBufferTag = "[object ArrayBuffer]", $d8c6c80dd3650253$var$dataViewTag = "[object DataView]", $d8c6c80dd3650253$var$float32Tag = "[object Float32Array]", $d8c6c80dd3650253$var$float64Tag = "[object Float64Array]", $d8c6c80dd3650253$var$int8Tag = "[object Int8Array]", $d8c6c80dd3650253$var$int16Tag = "[object Int16Array]", $d8c6c80dd3650253$var$int32Tag = "[object Int32Array]", $d8c6c80dd3650253$var$uint8Tag = "[object Uint8Array]", $d8c6c80dd3650253$var$uint8ClampedTag = "[object Uint8ClampedArray]", $d8c6c80dd3650253$var$uint16Tag = "[object Uint16Array]", $d8c6c80dd3650253$var$uint32Tag = "[object Uint32Array]";
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $d8c6c80dd3650253$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $d8c6c80dd3650253$var$arrayBufferTag:
            return (0, $9tz5c.default)(object);
        case $d8c6c80dd3650253$var$boolTag:
        case $d8c6c80dd3650253$var$dateTag:
            return new Ctor(+object);
        case $d8c6c80dd3650253$var$dataViewTag:
            return (0, $9sDYA.default)(object, isDeep);
        case $d8c6c80dd3650253$var$float32Tag:
        case $d8c6c80dd3650253$var$float64Tag:
        case $d8c6c80dd3650253$var$int8Tag:
        case $d8c6c80dd3650253$var$int16Tag:
        case $d8c6c80dd3650253$var$int32Tag:
        case $d8c6c80dd3650253$var$uint8Tag:
        case $d8c6c80dd3650253$var$uint8ClampedTag:
        case $d8c6c80dd3650253$var$uint16Tag:
        case $d8c6c80dd3650253$var$uint32Tag:
            return (0, $40E9j.default)(object, isDeep);
        case $d8c6c80dd3650253$var$mapTag:
            return new Ctor;
        case $d8c6c80dd3650253$var$numberTag:
        case $d8c6c80dd3650253$var$stringTag:
            return new Ctor(object);
        case $d8c6c80dd3650253$var$regexpTag:
            return (0, $g8BP3.default)(object);
        case $d8c6c80dd3650253$var$setTag:
            return new Ctor;
        case $d8c6c80dd3650253$var$symbolTag:
            return (0, $lcI69.default)(object);
    }
}
var $d8c6c80dd3650253$export$2e2bcd8739ae039 = $d8c6c80dd3650253$var$initCloneByTag;

});
parcelRegister("9tz5c", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e620930bc6a5ada$export$2e2bcd8739ae039);

var $dJVnF = parcelRequire("dJVnF");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $6e620930bc6a5ada$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new (0, $dJVnF.default)(result).set(new (0, $dJVnF.default)(arrayBuffer));
    return result;
}
var $6e620930bc6a5ada$export$2e2bcd8739ae039 = $6e620930bc6a5ada$var$cloneArrayBuffer;

});
parcelRegister("dJVnF", function(module, exports) {

$parcel$export(module.exports, "default", () => $a00bfcf041d47533$export$2e2bcd8739ae039);

var $2mpFt = parcelRequire("2mpFt");
/** Built-in value references. */ var $a00bfcf041d47533$var$Uint8Array = (0, $2mpFt.default).Uint8Array;
var $a00bfcf041d47533$export$2e2bcd8739ae039 = $a00bfcf041d47533$var$Uint8Array;

});


parcelRegister("9sDYA", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e35bd0ad6403ada$export$2e2bcd8739ae039);

var $9tz5c = parcelRequire("9tz5c");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $6e35bd0ad6403ada$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? (0, $9tz5c.default)(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
var $6e35bd0ad6403ada$export$2e2bcd8739ae039 = $6e35bd0ad6403ada$var$cloneDataView;

});

parcelRegister("g8BP3", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbfabb74c4bdb037$export$2e2bcd8739ae039);
/** Used to match `RegExp` flags from their coerced string values. */ var $bbfabb74c4bdb037$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $bbfabb74c4bdb037$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $bbfabb74c4bdb037$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
var $bbfabb74c4bdb037$export$2e2bcd8739ae039 = $bbfabb74c4bdb037$var$cloneRegExp;

});

parcelRegister("lcI69", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6fcecf8c6eee3b2$export$2e2bcd8739ae039);

var $kRxPv = parcelRequire("kRxPv");
/** Used to convert symbols to primitives and strings. */ var $f6fcecf8c6eee3b2$var$symbolProto = (0, $kRxPv.default) ? (0, $kRxPv.default).prototype : undefined, $f6fcecf8c6eee3b2$var$symbolValueOf = $f6fcecf8c6eee3b2$var$symbolProto ? $f6fcecf8c6eee3b2$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $f6fcecf8c6eee3b2$var$cloneSymbol(symbol) {
    return $f6fcecf8c6eee3b2$var$symbolValueOf ? Object($f6fcecf8c6eee3b2$var$symbolValueOf.call(symbol)) : {};
}
var $f6fcecf8c6eee3b2$export$2e2bcd8739ae039 = $f6fcecf8c6eee3b2$var$cloneSymbol;

});

parcelRegister("40E9j", function(module, exports) {

$parcel$export(module.exports, "default", () => $2eb64e5339c21018$export$2e2bcd8739ae039);

var $9tz5c = parcelRequire("9tz5c");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $2eb64e5339c21018$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? (0, $9tz5c.default)(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var $2eb64e5339c21018$export$2e2bcd8739ae039 = $2eb64e5339c21018$var$cloneTypedArray;

});


parcelRegister("7lgl7", function(module, exports) {

$parcel$export(module.exports, "default", () => $55872b451e11a8ad$export$2e2bcd8739ae039);

var $kgBRQ = parcelRequire("kgBRQ");

var $bzIQZ = parcelRequire("bzIQZ");

var $74QAJ = parcelRequire("74QAJ");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $55872b451e11a8ad$var$initCloneObject(object) {
    return typeof object.constructor == "function" && !(0, $74QAJ.default)(object) ? (0, $kgBRQ.default)((0, $bzIQZ.default)(object)) : {};
}
var $55872b451e11a8ad$export$2e2bcd8739ae039 = $55872b451e11a8ad$var$initCloneObject;

});
parcelRegister("kgBRQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec12acf7896f0d70$export$2e2bcd8739ae039);

var $iYDsF = parcelRequire("iYDsF");
/** Built-in value references. */ var $ec12acf7896f0d70$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $ec12acf7896f0d70$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!(0, $iYDsF.default)(proto)) return {};
        if ($ec12acf7896f0d70$var$objectCreate) return $ec12acf7896f0d70$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
var $ec12acf7896f0d70$export$2e2bcd8739ae039 = $ec12acf7896f0d70$var$baseCreate;

});


parcelRegister("5HFwJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $42712e4fe0b60e59$export$2e2bcd8739ae039);

var $dp7sl = parcelRequire("dp7sl");

var $hb0cD = parcelRequire("hb0cD");

var $lFXqE = parcelRequire("lFXqE");
/* Node.js helper references. */ var $42712e4fe0b60e59$var$nodeIsMap = (0, $lFXqE.default) && (0, $lFXqE.default).isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $42712e4fe0b60e59$var$isMap = $42712e4fe0b60e59$var$nodeIsMap ? (0, $hb0cD.default)($42712e4fe0b60e59$var$nodeIsMap) : (0, $dp7sl.default);
var $42712e4fe0b60e59$export$2e2bcd8739ae039 = $42712e4fe0b60e59$var$isMap;

});
parcelRegister("dp7sl", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c2364d1ace94eb9$export$2e2bcd8739ae039);

var $4wkSQ = parcelRequire("4wkSQ");

var $f2iog = parcelRequire("f2iog");
/** `Object#toString` result references. */ var $9c2364d1ace94eb9$var$mapTag = "[object Map]";
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $9c2364d1ace94eb9$var$baseIsMap(value) {
    return (0, $f2iog.default)(value) && (0, $4wkSQ.default)(value) == $9c2364d1ace94eb9$var$mapTag;
}
var $9c2364d1ace94eb9$export$2e2bcd8739ae039 = $9c2364d1ace94eb9$var$baseIsMap;

});


parcelRegister("4X3Cn", function(module, exports) {

$parcel$export(module.exports, "default", () => $39af7a8fe30b5013$export$2e2bcd8739ae039);

var $4Mn6B = parcelRequire("4Mn6B");

var $hb0cD = parcelRequire("hb0cD");

var $lFXqE = parcelRequire("lFXqE");
/* Node.js helper references. */ var $39af7a8fe30b5013$var$nodeIsSet = (0, $lFXqE.default) && (0, $lFXqE.default).isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $39af7a8fe30b5013$var$isSet = $39af7a8fe30b5013$var$nodeIsSet ? (0, $hb0cD.default)($39af7a8fe30b5013$var$nodeIsSet) : (0, $4Mn6B.default);
var $39af7a8fe30b5013$export$2e2bcd8739ae039 = $39af7a8fe30b5013$var$isSet;

});
parcelRegister("4Mn6B", function(module, exports) {

$parcel$export(module.exports, "default", () => $37ad91635d9ff11e$export$2e2bcd8739ae039);

var $4wkSQ = parcelRequire("4wkSQ");

var $f2iog = parcelRequire("f2iog");
/** `Object#toString` result references. */ var $37ad91635d9ff11e$var$setTag = "[object Set]";
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $37ad91635d9ff11e$var$baseIsSet(value) {
    return (0, $f2iog.default)(value) && (0, $4wkSQ.default)(value) == $37ad91635d9ff11e$var$setTag;
}
var $37ad91635d9ff11e$export$2e2bcd8739ae039 = $37ad91635d9ff11e$var$baseIsSet;

});




parcelRegister("58lCa", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bce775629368657$export$2e2bcd8739ae039);

var $afgje = parcelRequire("afgje");

var $jXStN = parcelRequire("jXStN");

var $hf0C9 = parcelRequire("hf0C9");

var $1WN0o = parcelRequire("1WN0o");

var $6D9Aa = parcelRequire("6D9Aa");

var $ft2bY = parcelRequire("ft2bY");

var $1fnxW = parcelRequire("1fnxW");
/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */ function $3bce775629368657$var$toPath(value) {
    if ((0, $hf0C9.default)(value)) return (0, $afgje.default)(value, (0, $ft2bY.default));
    return (0, $1WN0o.default)(value) ? [
        value
    ] : (0, $jXStN.default)((0, $6D9Aa.default)((0, $1fnxW.default)(value)));
}
var $3bce775629368657$export$2e2bcd8739ae039 = $3bce775629368657$var$toPath;

});
parcelRegister("afgje", function(module, exports) {

$parcel$export(module.exports, "default", () => $7757f4c9b8d2d7a9$export$2e2bcd8739ae039);
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $7757f4c9b8d2d7a9$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
var $7757f4c9b8d2d7a9$export$2e2bcd8739ae039 = $7757f4c9b8d2d7a9$var$arrayMap;

});

parcelRegister("1WN0o", function(module, exports) {

$parcel$export(module.exports, "default", () => $16b138b0231026b6$export$2e2bcd8739ae039);

var $hArsG = parcelRequire("hArsG");

var $f2iog = parcelRequire("f2iog");
/** `Object#toString` result references. */ var $16b138b0231026b6$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $16b138b0231026b6$var$isSymbol(value) {
    return typeof value == "symbol" || (0, $f2iog.default)(value) && (0, $hArsG.default)(value) == $16b138b0231026b6$var$symbolTag;
}
var $16b138b0231026b6$export$2e2bcd8739ae039 = $16b138b0231026b6$var$isSymbol;

});

parcelRegister("6D9Aa", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d3dd1738f3a2bd9$export$2e2bcd8739ae039);

var $bOE4H = parcelRequire("bOE4H");
/** Used to match property names within property paths. */ var $4d3dd1738f3a2bd9$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $4d3dd1738f3a2bd9$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $4d3dd1738f3a2bd9$var$stringToPath = (0, $bOE4H.default)(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($4d3dd1738f3a2bd9$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($4d3dd1738f3a2bd9$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
var $4d3dd1738f3a2bd9$export$2e2bcd8739ae039 = $4d3dd1738f3a2bd9$var$stringToPath;

});
parcelRegister("bOE4H", function(module, exports) {

$parcel$export(module.exports, "default", () => $89a3733fc9405b69$export$2e2bcd8739ae039);

var $e21Zk = parcelRequire("e21Zk");
/** Used as the maximum memoize cache size. */ var $89a3733fc9405b69$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $89a3733fc9405b69$var$memoizeCapped(func) {
    var result = (0, $e21Zk.default)(func, function(key) {
        if (cache.size === $89a3733fc9405b69$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
var $89a3733fc9405b69$export$2e2bcd8739ae039 = $89a3733fc9405b69$var$memoizeCapped;

});
parcelRegister("e21Zk", function(module, exports) {

$parcel$export(module.exports, "default", () => $a372cb680e5e1128$export$2e2bcd8739ae039);

var $7n3PR = parcelRequire("7n3PR");
/** Error message constants. */ var $a372cb680e5e1128$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $a372cb680e5e1128$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($a372cb680e5e1128$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($a372cb680e5e1128$var$memoize.Cache || (0, $7n3PR.default));
    return memoized;
}
// Expose `MapCache`.
$a372cb680e5e1128$var$memoize.Cache = (0, $7n3PR.default);
var $a372cb680e5e1128$export$2e2bcd8739ae039 = $a372cb680e5e1128$var$memoize;

});



parcelRegister("ft2bY", function(module, exports) {

$parcel$export(module.exports, "default", () => $b42b43c5a84e61a9$export$2e2bcd8739ae039);

var $1WN0o = parcelRequire("1WN0o");
/** Used as references for various `Number` constants. */ var $b42b43c5a84e61a9$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $b42b43c5a84e61a9$var$toKey(value) {
    if (typeof value == "string" || (0, $1WN0o.default)(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$b42b43c5a84e61a9$var$INFINITY ? "-0" : result;
}
var $b42b43c5a84e61a9$export$2e2bcd8739ae039 = $b42b43c5a84e61a9$var$toKey;

});

parcelRegister("1fnxW", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e8974ff738aca49$export$2e2bcd8739ae039);

var $5sJxm = parcelRequire("5sJxm");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $0e8974ff738aca49$var$toString(value) {
    return value == null ? "" : (0, $5sJxm.default)(value);
}
var $0e8974ff738aca49$export$2e2bcd8739ae039 = $0e8974ff738aca49$var$toString;

});
parcelRegister("5sJxm", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fa2e3fba0ff938d$export$2e2bcd8739ae039);

var $kRxPv = parcelRequire("kRxPv");

var $afgje = parcelRequire("afgje");

var $hf0C9 = parcelRequire("hf0C9");

var $1WN0o = parcelRequire("1WN0o");
/** Used as references for various `Number` constants. */ var $3fa2e3fba0ff938d$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $3fa2e3fba0ff938d$var$symbolProto = (0, $kRxPv.default) ? (0, $kRxPv.default).prototype : undefined, $3fa2e3fba0ff938d$var$symbolToString = $3fa2e3fba0ff938d$var$symbolProto ? $3fa2e3fba0ff938d$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $3fa2e3fba0ff938d$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ((0, $hf0C9.default)(value)) // Recursively convert values (susceptible to call stack limits).
    return (0, $afgje.default)(value, $3fa2e3fba0ff938d$var$baseToString) + "";
    if ((0, $1WN0o.default)(value)) return $3fa2e3fba0ff938d$var$symbolToString ? $3fa2e3fba0ff938d$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$3fa2e3fba0ff938d$var$INFINITY ? "-0" : result;
}
var $3fa2e3fba0ff938d$export$2e2bcd8739ae039 = $3fa2e3fba0ff938d$var$baseToString;

});



parcelRegister("9ORqK", function(module, exports) {
"use strict";

var $4jPKB = parcelRequire("4jPKB");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $72623ab6bcb0a33b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $72623ab6bcb0a33b$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $72623ab6bcb0a33b$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$TYPE_STATICS = {};
$72623ab6bcb0a33b$var$TYPE_STATICS[$4jPKB.ForwardRef] = $72623ab6bcb0a33b$var$FORWARD_REF_STATICS;
$72623ab6bcb0a33b$var$TYPE_STATICS[$4jPKB.Memo] = $72623ab6bcb0a33b$var$MEMO_STATICS;
function $72623ab6bcb0a33b$var$getStatics(component) {
    // React v16.11 and below
    if ($4jPKB.isMemo(component)) return $72623ab6bcb0a33b$var$MEMO_STATICS;
     // React v16.12 and above
    return $72623ab6bcb0a33b$var$TYPE_STATICS[component["$$typeof"]] || $72623ab6bcb0a33b$var$REACT_STATICS;
}
var $72623ab6bcb0a33b$var$defineProperty = Object.defineProperty;
var $72623ab6bcb0a33b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $72623ab6bcb0a33b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $72623ab6bcb0a33b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $72623ab6bcb0a33b$var$getPrototypeOf = Object.getPrototypeOf;
var $72623ab6bcb0a33b$var$objectPrototype = Object.prototype;
function $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($72623ab6bcb0a33b$var$objectPrototype) {
            var inheritedComponent = $72623ab6bcb0a33b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $72623ab6bcb0a33b$var$objectPrototype) $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $72623ab6bcb0a33b$var$getOwnPropertyNames(sourceComponent);
        if ($72623ab6bcb0a33b$var$getOwnPropertySymbols) keys = keys.concat($72623ab6bcb0a33b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $72623ab6bcb0a33b$var$getStatics(targetComponent);
        var sourceStatics = $72623ab6bcb0a33b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$72623ab6bcb0a33b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $72623ab6bcb0a33b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $72623ab6bcb0a33b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $72623ab6bcb0a33b$var$hoistNonReactStatics;

});
parcelRegister("4jPKB", function(module, exports) {
"use strict";

module.exports = (parcelRequire("9cCWX"));

});


parcelRegister("chB0Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f13c87c1500733f$export$2e2bcd8739ae039);

var $gbpSA = parcelRequire("gbpSA");
/** Used to compose bitmasks for cloning. */ var $8f13c87c1500733f$var$CLONE_DEEP_FLAG = 1, $8f13c87c1500733f$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $8f13c87c1500733f$var$cloneDeep(value) {
    return (0, $gbpSA.default)(value, $8f13c87c1500733f$var$CLONE_DEEP_FLAG | $8f13c87c1500733f$var$CLONE_SYMBOLS_FLAG);
}
var $8f13c87c1500733f$export$2e2bcd8739ae039 = $8f13c87c1500733f$var$cloneDeep;

});


var $7b02d682eb115277$exports = {};
"use strict";

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));



var $acw62 = parcelRequire("acw62");
var $7e96a608cb33bf79$exports = {};

$parcel$export($7e96a608cb33bf79$exports, "createRoot", () => $7e96a608cb33bf79$export$882461b6382ed46c, (v) => $7e96a608cb33bf79$export$882461b6382ed46c = v);
$parcel$export($7e96a608cb33bf79$exports, "hydrateRoot", () => $7e96a608cb33bf79$export$757ceba2d55c277e, (v) => $7e96a608cb33bf79$export$757ceba2d55c277e = v);
var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
"use strict";
var $11492dca620dcaa5$exports = {};
"use strict";
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));


var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $11492dca620dcaa5$exports.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $11492dca620dcaa5$exports.hydrateRoot;




var $acw62 = parcelRequire("acw62");
/**
 * React Router DOM v6.20.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

/**
 * @remix-run/router v1.13.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $1d34d5c4a288b213$var$_extends() {
    $1d34d5c4a288b213$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1d34d5c4a288b213$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $1d34d5c4a288b213$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($1d34d5c4a288b213$export$e19cd5f9376f8cee || ($1d34d5c4a288b213$export$e19cd5f9376f8cee = {}));
const $1d34d5c4a288b213$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $1d34d5c4a288b213$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $1d34d5c4a288b213$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $1d34d5c4a288b213$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $1d34d5c4a288b213$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $1d34d5c4a288b213$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $1d34d5c4a288b213$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $1d34d5c4a288b213$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $1d34d5c4a288b213$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $1d34d5c4a288b213$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $1d34d5c4a288b213$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $1d34d5c4a288b213$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $1d34d5c4a288b213$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $1d34d5c4a288b213$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($1d34d5c4a288b213$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
        $1d34d5c4a288b213$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $1d34d5c4a288b213$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($1d34d5c4a288b213$var$ResultType || ($1d34d5c4a288b213$var$ResultType = {}));
const $1d34d5c4a288b213$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $1d34d5c4a288b213$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $1d34d5c4a288b213$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $1d34d5c4a288b213$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($1d34d5c4a288b213$var$isIndexRoute(route)) {
            let indexRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $1d34d5c4a288b213$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $1d34d5c4a288b213$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $1d34d5c4a288b213$var$flattenRoutes(routes);
    $1d34d5c4a288b213$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $1d34d5c4a288b213$var$matchRouteBranch(branches[i], // Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $1d34d5c4a288b213$var$safelyDecodeURI(pathname));
    return matches;
}
function $1d34d5c4a288b213$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $1d34d5c4a288b213$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $1d34d5c4a288b213$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $1d34d5c4a288b213$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $1d34d5c4a288b213$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $1d34d5c4a288b213$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $1d34d5c4a288b213$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $1d34d5c4a288b213$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $1d34d5c4a288b213$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $1d34d5c4a288b213$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $1d34d5c4a288b213$var$paramRe = /^:\w+$/;
const $1d34d5c4a288b213$var$dynamicSegmentValue = 3;
const $1d34d5c4a288b213$var$indexRouteValue = 2;
const $1d34d5c4a288b213$var$emptySegmentValue = 1;
const $1d34d5c4a288b213$var$staticSegmentValue = 10;
const $1d34d5c4a288b213$var$splatPenalty = -2;
const $1d34d5c4a288b213$var$isSplat = (s)=>s === "*";
function $1d34d5c4a288b213$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($1d34d5c4a288b213$var$isSplat)) initialScore += $1d34d5c4a288b213$var$splatPenalty;
    if (index) initialScore += $1d34d5c4a288b213$var$indexRouteValue;
    return segments.filter((s)=>!$1d34d5c4a288b213$var$isSplat(s)).reduce((score, segment)=>score + ($1d34d5c4a288b213$var$paramRe.test(segment) ? $1d34d5c4a288b213$var$dynamicSegmentValue : segment === "" ? $1d34d5c4a288b213$var$emptySegmentValue : $1d34d5c4a288b213$var$staticSegmentValue), initialScore);
}
function $1d34d5c4a288b213$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $1d34d5c4a288b213$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $1d34d5c4a288b213$export$a5c6d149b50c1d86($1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $1d34d5c4a288b213$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $1d34d5c4a288b213$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:(\w+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $1d34d5c4a288b213$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $1d34d5c4a288b213$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $1d34d5c4a288b213$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = $1d34d5c4a288b213$var$safelyDecodeURIComponent(value || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $1d34d5c4a288b213$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $1d34d5c4a288b213$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $1d34d5c4a288b213$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $1d34d5c4a288b213$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $1d34d5c4a288b213$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $1d34d5c4a288b213$var$normalizeSearch(search),
        hash: $1d34d5c4a288b213$var$normalizeHash(hash)
    };
}
function $1d34d5c4a288b213$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $1d34d5c4a288b213$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $1d34d5c4a288b213$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $1d34d5c4a288b213$export$a5784978eca585fa(matches) {
    // Use the full pathname for the leaf match so we include splat values for "." links
    return $1d34d5c4a288b213$var$getPathContributingMatches(matches).map((match, idx)=>idx === matches.length - 1 ? match.pathname : match.pathnameBase);
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $1d34d5c4a288b213$export$8ccf933b0513f8d0(toArg);
    else {
        to = $1d34d5c4a288b213$var$_extends({}, toArg);
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $1d34d5c4a288b213$var$getInvalidPathError("?", "pathname", "search", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "pathname", "hash", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else if (isPathRelative) {
        let fromSegments = routePathnames[routePathnames.length - 1].replace(/^\//, "").split("/");
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            // With relative="path", each leading .. segment means "go up one URL segment"
            while(toSegments[0] === ".."){
                toSegments.shift();
                fromSegments.pop();
            }
            to.pathname = toSegments.join("/");
        }
        from = "/" + fromSegments.join("/");
    } else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            // With relative="route" (the default), each leading .. segment means
            // "go up one route" instead of "go up one URL segment".  This is a key
            // difference from how <a href> works and a major reason we call this a
            // "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $1d34d5c4a288b213$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $1d34d5c4a288b213$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $1d34d5c4a288b213$export$42a99a7a4bc0e76a extends Error {
}
class $1d34d5c4a288b213$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $1d34d5c4a288b213$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $1d34d5c4a288b213$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $1d34d5c4a288b213$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $1d34d5c4a288b213$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $1d34d5c4a288b213$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $1d34d5c4a288b213$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $1d34d5c4a288b213$var$unwrapTrackedPromise(value) {
    if (!$1d34d5c4a288b213$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $1d34d5c4a288b213$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $1d34d5c4a288b213$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $1d34d5c4a288b213$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $1d34d5c4a288b213$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $1d34d5c4a288b213$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $1d34d5c4a288b213$var$validMutationMethods = new Set($1d34d5c4a288b213$var$validMutationMethodsArr);
const $1d34d5c4a288b213$var$validRequestMethodsArr = [
    "get",
    ...$1d34d5c4a288b213$var$validMutationMethodsArr
];
const $1d34d5c4a288b213$var$validRequestMethods = new Set($1d34d5c4a288b213$var$validRequestMethodsArr);
const $1d34d5c4a288b213$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $1d34d5c4a288b213$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $1d34d5c4a288b213$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $1d34d5c4a288b213$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_prependBasename: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized = // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    !initialMatches.some((m)=>m.route.lazy) && // And we have to either have no loaders or have been provided hydrationData
    (!initialMatches.some((m)=>m.route.loader) || init.hydrationData != null);
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $1d34d5c4a288b213$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $1d34d5c4a288b213$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$1d34d5c4a288b213$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop, state.location);
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $1d34d5c4a288b213$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $1d34d5c4a288b213$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($1d34d5c4a288b213$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $1d34d5c4a288b213$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $1d34d5c4a288b213$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $1d34d5c4a288b213$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$1d34d5c4a288b213$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, flushSync, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $1d34d5c4a288b213$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        // Call our action and get the result
        let result;
        let actionMatch = $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $1d34d5c4a288b213$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, flushSync, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $1d34d5c4a288b213$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $1d34d5c4a288b213$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $1d34d5c4a288b213$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        if (!isUninterruptedRevalidation) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($1d34d5c4a288b213$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $1d34d5c4a288b213$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(state, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $1d34d5c4a288b213$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, routeId, opts == null ? void 0 : opts.relative);
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResult = await $1d34d5c4a288b213$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
            return;
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(actionResult)) {
            fetchControllers.delete(key);
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our action started, so that
                // should take precedence over this redirect navigation.  We already
                // set isRevalidationRequired so all loaders for the new route should
                // fire unless opted out via shouldRevalidate
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission));
                return startRedirectNavigation(state, actionResult, {
                    fetcherSubmission: submission
                });
            }
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(actionResult)) {
            setFetcherError(key, routeId, actionResult.error);
            return;
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(actionResult)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $1d34d5c4a288b213$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $1d34d5c4a288b213$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(state, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let result = await $1d34d5c4a288b213$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) result = await $1d34d5c4a288b213$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(state, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $1d34d5c4a288b213$var$createLocation(state.location, redirect.location, {
            _isRedirect: true
        });
        $1d34d5c4a288b213$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                const url = init.history.createURL(redirect.location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace : $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $1d34d5c4a288b213$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $1d34d5c4a288b213$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $1d34d5c4a288b213$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$1d34d5c4a288b213$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $1d34d5c4a288b213$var$callLoaderOrAction("loader", $1d34d5c4a288b213$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename);
                else {
                    let error = {
                        type: $1d34d5c4a288b213$var$ResultType.error,
                        error: $1d34d5c4a288b213$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $1d34d5c4a288b213$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $1d34d5c4a288b213$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $1d34d5c4a288b213$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $1d34d5c4a288b213$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $1d34d5c4a288b213$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$1d34d5c4a288b213$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $1d34d5c4a288b213$export$4d0306f8f6a4585b = Symbol("deferred");
function $1d34d5c4a288b213$export$3336b097a6fbc59a(routes, opts) {
    $1d34d5c4a288b213$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp3) {
        let { requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD") {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $1d34d5c4a288b213$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $1d34d5c4a288b213$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$1d34d5c4a288b213$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $1d34d5c4a288b213$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($1d34d5c4a288b213$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $1d34d5c4a288b213$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $1d34d5c4a288b213$var$isResponse(result) ? result : $1d34d5c4a288b213$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($1d34d5c4a288b213$var$isQueryRouteResponse(e)) {
                if (e.type === $1d34d5c4a288b213$var$ResultType.error) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($1d34d5c4a288b213$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        } else {
            result = await $1d34d5c4a288b213$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) {
                let method = isRouteRequest ? "queryRoute" : "query";
                throw new Error(method + "() call aborted: " + request.method + " " + request.url);
            }
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($1d34d5c4a288b213$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $1d34d5c4a288b213$var$_extends({}, context, {
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $1d34d5c4a288b213$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$1d34d5c4a288b213$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) {
            let method = isRouteRequest ? "queryRoute" : "query";
            throw new Error(method + "() call aborted: " + request.method + " " + request.url);
        }
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $1d34d5c4a288b213$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $1d34d5c4a288b213$export$fec11da027c70692(routes, context, error) {
    let newContext = $1d34d5c4a288b213$var$_extends({}, context, {
        statusCode: 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $1d34d5c4a288b213$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $1d34d5c4a288b213$var$normalizeTo(location, matches, basename, prependBasename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $1d34d5c4a288b213$export$cae722b0cc860f13(to ? to : ".", $1d34d5c4a288b213$export$a5784978eca585fa(contextualMatches), $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$1d34d5c4a288b213$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $1d34d5c4a288b213$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $1d34d5c4a288b213$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $1d34d5c4a288b213$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$1d34d5c4a288b213$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$1d34d5c4a288b213$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $1d34d5c4a288b213$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $1d34d5c4a288b213$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $1d34d5c4a288b213$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $1d34d5c4a288b213$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $1d34d5c4a288b213$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $1d34d5c4a288b213$var$getMatchesToLoad(history, state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        if (match.route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (match.route.loader == null) return false;
        // Always call the loader on new route instances and pending defer cancellations
        if ($1d34d5c4a288b213$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $1d34d5c4a288b213$var$shouldRevalidateLoader(match, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $1d34d5c4a288b213$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate if fetcher won't be present in the subsequent render
        if (!matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $1d34d5c4a288b213$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $1d34d5c4a288b213$var$shouldRevalidateLoader(fetcherMatch, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $1d34d5c4a288b213$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $1d34d5c4a288b213$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $1d34d5c4a288b213$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $1d34d5c4a288b213$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $1d34d5c4a288b213$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$1d34d5c4a288b213$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $1d34d5c4a288b213$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let values = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $1d34d5c4a288b213$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError) throw handlerError;
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $1d34d5c4a288b213$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $1d34d5c4a288b213$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $1d34d5c4a288b213$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $1d34d5c4a288b213$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($1d34d5c4a288b213$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($1d34d5c4a288b213$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) location = $1d34d5c4a288b213$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $1d34d5c4a288b213$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) {
            let queryRouteResponse = {
                type: resultType === $1d34d5c4a288b213$var$ResultType.error ? $1d34d5c4a288b213$var$ResultType.error : $1d34d5c4a288b213$var$ResultType.data,
                response: result
            };
            throw queryRouteResponse;
        }
        let data;
        let contentType = result.headers.get("Content-Type");
        // Check between word boundaries instead of startsWith() due to the last
        // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
        if (contentType && /\bapplication\/json\b/.test(contentType)) data = await result.json();
        else data = await result.text();
        if (resultType === $1d34d5c4a288b213$var$ResultType.error) return {
            type: resultType,
            error: new $1d34d5c4a288b213$export$6c6580e81da25755(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $1d34d5c4a288b213$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($1d34d5c4a288b213$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $1d34d5c4a288b213$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $1d34d5c4a288b213$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($1d34d5c4a288b213$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $1d34d5c4a288b213$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $1d34d5c4a288b213$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $1d34d5c4a288b213$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $1d34d5c4a288b213$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $1d34d5c4a288b213$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($1d34d5c4a288b213$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $1d34d5c4a288b213$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $1d34d5c4a288b213$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $1d34d5c4a288b213$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $1d34d5c4a288b213$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $1d34d5c4a288b213$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $1d34d5c4a288b213$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $1d34d5c4a288b213$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $1d34d5c4a288b213$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) : path;
    return $1d34d5c4a288b213$export$fe53371bee54353d($1d34d5c4a288b213$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $1d34d5c4a288b213$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $1d34d5c4a288b213$var$isDeferredResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.deferred;
}
function $1d34d5c4a288b213$var$isErrorResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.error;
}
function $1d34d5c4a288b213$var$isRedirectResult(result) {
    return (result && result.type) === $1d34d5c4a288b213$var$ResultType.redirect;
}
function $1d34d5c4a288b213$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $1d34d5c4a288b213$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $1d34d5c4a288b213$var$isRedirectResponse(result) {
    if (!$1d34d5c4a288b213$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $1d34d5c4a288b213$var$isQueryRouteResponse(obj) {
    return obj && $1d34d5c4a288b213$var$isResponse(obj.response) && (obj.type === $1d34d5c4a288b213$var$ResultType.data || obj.type === $1d34d5c4a288b213$var$ResultType.error);
}
function $1d34d5c4a288b213$var$isValidMethod(method) {
    return $1d34d5c4a288b213$var$validRequestMethods.has(method.toLowerCase());
}
function $1d34d5c4a288b213$var$isMutationMethod(method) {
    return $1d34d5c4a288b213$var$validMutationMethods.has(method.toLowerCase());
}
async function $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($1d34d5c4a288b213$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $1d34d5c4a288b213$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $1d34d5c4a288b213$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $1d34d5c4a288b213$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $1d34d5c4a288b213$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $1d34d5c4a288b213$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $1d34d5c4a288b213$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $1d34d5c4a288b213$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $1d34d5c4a288b213$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $1d34d5c4a288b213$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $1d34d5c4a288b213$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.20.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

function $7939e29d663dd3ed$var$_extends() {
    $7939e29d663dd3ed$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7939e29d663dd3ed$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $7939e29d663dd3ed$export$3add0d5dce533e2e = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$145dfa71566a64dc = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$var$AwaitContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $7939e29d663dd3ed$export$26749e8557646306 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$c7914228fb69b0f5 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$9072aa6dd1f93057 = /*#__PURE__*/ $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $7939e29d663dd3ed$var$RouteErrorContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $7939e29d663dd3ed$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $7939e29d663dd3ed$export$9c954a9d03d32f4a() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $7939e29d663dd3ed$export$45d76561a5302f2b() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $7939e29d663dd3ed$export$1b3f31771c5d07c() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $7939e29d663dd3ed$export$6c330e8992e8a295(pattern) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $7939e29d663dd3ed$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $acw62.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $7939e29d663dd3ed$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7939e29d663dd3ed$var$useNavigateStable() : $7939e29d663dd3ed$var$useNavigateUnstable();
}
function $7939e29d663dd3ed$var$useNavigateUnstable() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches));
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$OutletContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $7939e29d663dd3ed$export$4138103a3ae699cc() {
    return $acw62.useContext($7939e29d663dd3ed$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $7939e29d663dd3ed$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $7939e29d663dd3ed$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches));
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $7939e29d663dd3ed$export$5d3fca4a98652595(routes, locationArg) {
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg, dataRouterState) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: parentMatches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $1d34d5c4a288b213$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $7939e29d663dd3ed$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7939e29d663dd3ed$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7939e29d663dd3ed$var$DefaultErrorComponent() {
    let error = $7939e29d663dd3ed$export$ed527bf60f6e05f2();
    let message = (0, $1d34d5c4a288b213$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $7939e29d663dd3ed$var$defaultErrorElement = /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DefaultErrorComponent, null);
class $7939e29d663dd3ed$var$RenderErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error || state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7939e29d663dd3ed$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7939e29d663dd3ed$var$_renderMatches(matches, parentMatches, dataRouterState) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null;
        // Only data routers handle errors
        let errorElement = null;
        if (dataRouterState) errorElement = match.route.errorElement || $7939e29d663dd3ed$var$defaultErrorElement;
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7939e29d663dd3ed$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($7939e29d663dd3ed$var$DataRouterHook || {});
var $7939e29d663dd3ed$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($7939e29d663dd3ed$var$DataRouterStateHook || {});
function $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $7939e29d663dd3ed$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $7939e29d663dd3ed$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($7939e29d663dd3ed$export$145dfa71566a64dc);
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
function $7939e29d663dd3ed$var$useRouteContext(hookName) {
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $7939e29d663dd3ed$var$useCurrentRouteId(hookName) {
    let route = $7939e29d663dd3ed$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7939e29d663dd3ed$export$5fc8298006ad9e58() {
    return $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7939e29d663dd3ed$export$d0fd4b7106de2769() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7939e29d663dd3ed$export$600dc272ed516c15() {
    let dataRouterContext = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseRevalidator);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRevalidator);
    return $acw62.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7939e29d663dd3ed$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseMatches);
    return $acw62.useMemo(()=>matches.map((m)=>(0, $1d34d5c4a288b213$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7939e29d663dd3ed$export$1448a5050d252c4d() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7939e29d663dd3ed$export$fd5d37484eab868d(routeId) {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7939e29d663dd3ed$export$fdc00f3f26066d5e() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseActionData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7939e29d663dd3ed$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $acw62.useContext($7939e29d663dd3ed$var$RouteErrorContext);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$17f53340677d5831() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7939e29d663dd3ed$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7939e29d663dd3ed$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseBlocker);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $7939e29d663dd3ed$var$_extends({}, currentLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $7939e29d663dd3ed$var$_extends({}, nextLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $acw62.useEffect(()=>{
        let key = String(++$7939e29d663dd3ed$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $1d34d5c4a288b213$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7939e29d663dd3ed$var$useNavigateStable() {
    let { router: router } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseNavigateStable);
    let id = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7939e29d663dd3ed$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$alreadyWarned = {};
function $7939e29d663dd3ed$var$warningOnce(key, cond, message) {
    if (!cond && !$7939e29d663dd3ed$var$alreadyWarned[key]) $7939e29d663dd3ed$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $7939e29d663dd3ed$var$START_TRANSITION = "startTransition";
const $7939e29d663dd3ed$var$startTransitionImpl = $acw62[$7939e29d663dd3ed$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7939e29d663dd3ed$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        if (v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl) $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, state.initialized ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement))), null);
}
function $7939e29d663dd3ed$var$DataRoutes(_ref2) {
    let { routes: routes, state: state } = _ref2;
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, undefined, state);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $7939e29d663dd3ed$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl ? $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $7939e29d663dd3ed$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let navigate = $7939e29d663dd3ed$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, (0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $7939e29d663dd3ed$export$910ae8079b2c2852(props) {
    return $7939e29d663dd3ed$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $7939e29d663dd3ed$export$e7b0ac011bb776c6(_props) {
    (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $7939e29d663dd3ed$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false } = _ref5;
    !!$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $7939e29d663dd3ed$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $7939e29d663dd3ed$export$5d3fca4a98652595($7939e29d663dd3ed$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7939e29d663dd3ed$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$ResolveAwait, null, children));
}
var $7939e29d663dd3ed$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($7939e29d663dd3ed$var$AwaitRenderStatus || {});
const $7939e29d663dd3ed$var$neverSettledPromise = new Promise(()=>{});
class $7939e29d663dd3ed$var$AwaitErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $7939e29d663dd3ed$var$AwaitRenderStatus.error : promise._data !== undefined ? $7939e29d663dd3ed$var$AwaitRenderStatus.success : $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && promise._error instanceof (0, $1d34d5c4a288b213$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $7939e29d663dd3ed$var$neverSettledPromise;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $7939e29d663dd3ed$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $7939e29d663dd3ed$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $7939e29d663dd3ed$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7939e29d663dd3ed$export$e7b0ac011bb776c6) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7939e29d663dd3ed$export$daf73786167a7f72(matches) {
    return $7939e29d663dd3ed$var$_renderMatches(matches);
}
function $7939e29d663dd3ed$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $acw62.createElement(route.Component),
        Component: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $acw62.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $7939e29d663dd3ed$export$f30f7e456d254e83(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7939e29d663dd3ed$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7939e29d663dd3ed$export$52b333d321859367
    }).initialize();
}



function $040dbb9c344a508d$var$_extends() {
    $040dbb9c344a508d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $040dbb9c344a508d$var$_extends.apply(this, arguments);
}
function $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $040dbb9c344a508d$var$defaultMethod = "get";
const $040dbb9c344a508d$var$defaultEncType = "application/x-www-form-urlencoded";
function $040dbb9c344a508d$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $040dbb9c344a508d$var$isButtonElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $040dbb9c344a508d$var$isFormElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $040dbb9c344a508d$var$isInputElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $040dbb9c344a508d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $040dbb9c344a508d$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$040dbb9c344a508d$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $040dbb9c344a508d$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $040dbb9c344a508d$var$_formDataSupportsSubmitter = null;
function $040dbb9c344a508d$var$isFormDataSubmitterSupported() {
    if ($040dbb9c344a508d$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = true;
    }
    return $040dbb9c344a508d$var$_formDataSupportsSubmitter;
}
const $040dbb9c344a508d$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $040dbb9c344a508d$var$getFormEncType(encType) {
    if (encType != null && !$040dbb9c344a508d$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($040dbb9c344a508d$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        formData = new FormData(target);
    } else if ($040dbb9c344a508d$var$isButtonElement(target) || $040dbb9c344a508d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("formenctype")) || $040dbb9c344a508d$var$getFormEncType(form.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$040dbb9c344a508d$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($040dbb9c344a508d$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $040dbb9c344a508d$var$defaultMethod;
        action = null;
        encType = $040dbb9c344a508d$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $040dbb9c344a508d$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $040dbb9c344a508d$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $040dbb9c344a508d$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
function $040dbb9c344a508d$export$1f3f55432a00e06d(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $040dbb9c344a508d$var$_extends({}, state, {
        errors: $040dbb9c344a508d$var$deserializeErrors(state.errors)
    });
    return state;
}
function $040dbb9c344a508d$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $1d34d5c4a288b213$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $040dbb9c344a508d$export$7ad602f0e94e62d1 = /*#__PURE__*/ $acw62.createContext({
    isTransitioning: false
});
const $040dbb9c344a508d$export$148fd98d095596d4 = /*#__PURE__*/ $acw62.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $040dbb9c344a508d$var$START_TRANSITION = "startTransition";
const $040dbb9c344a508d$var$startTransitionImpl = $acw62[$040dbb9c344a508d$var$START_TRANSITION];
const $040dbb9c344a508d$var$FLUSH_SYNC = "flushSync";
const $040dbb9c344a508d$var$flushSyncImpl = $11492dca620dcaa5$exports[$040dbb9c344a508d$var$FLUSH_SYNC];
function $040dbb9c344a508d$var$startTransitionSafe(cb) {
    if ($040dbb9c344a508d$var$startTransitionImpl) $040dbb9c344a508d$var$startTransitionImpl(cb);
    else cb();
}
function $040dbb9c344a508d$var$flushSyncSafe(cb) {
    if ($040dbb9c344a508d$var$flushSyncImpl) $040dbb9c344a508d$var$flushSyncImpl(cb);
    else cb();
}
class $040dbb9c344a508d$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $040dbb9c344a508d$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let fetcherData = $acw62.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $acw62.useCallback((cb)=>{
        if (v7_startTransition) $040dbb9c344a508d$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $acw62.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $040dbb9c344a508d$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $040dbb9c344a508d$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $040dbb9c344a508d$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, state.initialized ? /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement))))), null);
}
function $040dbb9c344a508d$var$DataRoutes(_ref3) {
    let { routes: routes, state: state } = _ref3;
    return (0, $7939e29d663dd3ed$export$5fcee62552a12fbf)(routes, undefined, state);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $040dbb9c344a508d$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $040dbb9c344a508d$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $040dbb9c344a508d$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
const $040dbb9c344a508d$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $040dbb9c344a508d$export$a6c7ac8248d6e38a = /*#__PURE__*/ $acw62.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref7, $040dbb9c344a508d$var$_excluded);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($040dbb9c344a508d$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $7939e29d663dd3ed$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $040dbb9c344a508d$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $acw62.createElement("a", $040dbb9c344a508d$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $040dbb9c344a508d$export$b0d92dbee9b5b60d = /*#__PURE__*/ $acw62.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref8, $040dbb9c344a508d$var$_excluded2);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let routerState = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    let { navigator: navigator } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $040dbb9c344a508d$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a6c7ac8248d6e38a, $040dbb9c344a508d$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $040dbb9c344a508d$export$a7fed597f4b8afd8 = /*#__PURE__*/ $acw62.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $040dbb9c344a508d$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref9, $040dbb9c344a508d$var$_excluded3);
    let submit = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let formAction = $040dbb9c344a508d$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $acw62.createElement("form", $040dbb9c344a508d$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $040dbb9c344a508d$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $040dbb9c344a508d$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $040dbb9c344a508d$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($040dbb9c344a508d$var$DataRouterHook || ($040dbb9c344a508d$var$DataRouterHook = {}));
var $040dbb9c344a508d$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($040dbb9c344a508d$var$DataRouterStateHook || ($040dbb9c344a508d$var$DataRouterStateHook = {}));
// Internal hooks
function $040dbb9c344a508d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $040dbb9c344a508d$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext((0, $7939e29d663dd3ed$export$3add0d5dce533e2e));
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $040dbb9c344a508d$var$useDataRouterState(hookName) {
    let state = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $040dbb9c344a508d$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($040dbb9c344a508d$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $1d34d5c4a288b213$export$fe53371bee54353d)(location) === (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $040dbb9c344a508d$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $acw62.useRef($040dbb9c344a508d$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $040dbb9c344a508d$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $040dbb9c344a508d$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $040dbb9c344a508d$var$fetcherId = 0;
let $040dbb9c344a508d$var$getUniqueFetcherId = ()=>"__" + String(++$040dbb9c344a508d$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $040dbb9c344a508d$export$47c85c6e3a081d3() {
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let currentRouteId = (0, $7939e29d663dd3ed$export$5fc8298006ad9e58)();
    return $acw62.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $040dbb9c344a508d$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $040dbb9c344a508d$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $040dbb9c344a508d$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let routeContext = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    !routeContext && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $040dbb9c344a508d$var$_extends({}, (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $040dbb9c344a508d$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseFetcher);
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $acw62.useContext($040dbb9c344a508d$export$148fd98d095596d4);
    let route = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    let [fetcherKey, setFetcherKey] = $acw62.useState(key || "");
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) setFetcherKey($040dbb9c344a508d$var$getUniqueFetcherId());
    // Registration/cleanup
    $acw62.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $acw62.useCallback((href, opts)=>{
        !routeId && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let submit = $acw62.useCallback((target, opts)=>{
        submitImpl(target, $040dbb9c344a508d$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $acw62.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a7fed597f4b8afd8, $040dbb9c344a508d$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $1d34d5c4a288b213$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>$040dbb9c344a508d$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $040dbb9c344a508d$export$fa996778a3a31087() {
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $040dbb9c344a508d$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $040dbb9c344a508d$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $040dbb9c344a508d$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let matches = (0, $7939e29d663dd3ed$export$2378eb7f5ff86053)();
    let navigation = (0, $7939e29d663dd3ed$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $040dbb9c344a508d$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $040dbb9c344a508d$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($040dbb9c344a508d$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $040dbb9c344a508d$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($040dbb9c344a508d$var$_extends({}, location, {
                    pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($040dbb9c344a508d$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $040dbb9c344a508d$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $7939e29d663dd3ed$export$b273b3273281a049)(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $040dbb9c344a508d$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $acw62.useContext($040dbb9c344a508d$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.useViewTransitionState);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}




var $acw62 = parcelRequire("acw62");
const $c09882a49af06a79$export$38ee920e59704589 = /*#__PURE__*/ (0, $acw62.createContext)({
    userName: "default",
    loginStatus: false,
    noticationMessage: ""
});


// The primary entry point assumes we're working with standard ReactDOM/RN, but
// older versions that do not include `useSyncExternalStore` (React 16.9 - 17.x).
// Because of that, the useSyncExternalStore compat shim is needed.

var $hfliI = parcelRequire("hfliI");
var $6ae5e5baff12bbf7$exports = {};
"use strict";

$6ae5e5baff12bbf7$exports = (parcelRequire("6VZtt"));





// Default to a dummy "batch" implementation that just runs the callback
function $f9089991fdc24c9c$var$defaultNoopBatch(callback) {
    callback();
}
let $f9089991fdc24c9c$var$batch = $f9089991fdc24c9c$var$defaultNoopBatch; // Allow injecting another batching function later
const $f9089991fdc24c9c$export$4b9874722d0da7bc = (newBatch)=>$f9089991fdc24c9c$var$batch = newBatch; // Supply a getter just to skip dealing with ESM bindings
const $f9089991fdc24c9c$export$fc47d4c0ba3bd2c6 = ()=>$f9089991fdc24c9c$var$batch;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $55099852ccad0564$var$ContextKey = Symbol.for(`react-redux-context`);
const $55099852ccad0564$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $55099852ccad0564$var$getContext() {
    var _gT$ContextKey;
    if (!$acw62.createContext) return {};
    const contextMap = (_gT$ContextKey = $55099852ccad0564$var$gT[$55099852ccad0564$var$ContextKey]) != null ? _gT$ContextKey : $55099852ccad0564$var$gT[$55099852ccad0564$var$ContextKey] = new Map();
    let realContext = contextMap.get($acw62.createContext);
    if (!realContext) {
        realContext = $acw62.createContext(null);
        contextMap.set($acw62.createContext, realContext);
    }
    return realContext;
}
const $55099852ccad0564$export$cc80c08dc91f1c00 = /*#__PURE__*/ $55099852ccad0564$var$getContext();
var $55099852ccad0564$export$2e2bcd8739ae039 = $55099852ccad0564$export$cc80c08dc91f1c00;


function $11518dc3bb05d381$export$d4d6226d5fc61558(context = (0, $55099852ccad0564$export$cc80c08dc91f1c00)) {
    return function useReduxContext() {
        const contextValue = (0, $acw62.useContext)(context);
        return contextValue;
    };
}
const $11518dc3bb05d381$export$c1275ca9a6fd3ec5 = /*#__PURE__*/ $11518dc3bb05d381$export$d4d6226d5fc61558();



const $d2699e687deeb28e$export$20656a4825650bd0 = ()=>{
    throw new Error("uSES not initialized!");
};


let $d8fc8d639f906efc$var$useSyncExternalStoreWithSelector = (0, $d2699e687deeb28e$export$20656a4825650bd0);
const $d8fc8d639f906efc$export$e2e6e3f3f3b782e3 = (fn)=>{
    $d8fc8d639f906efc$var$useSyncExternalStoreWithSelector = fn;
};
const $d8fc8d639f906efc$var$refEquality = (a, b)=>a === b;
function $d8fc8d639f906efc$export$2b53f90d2bd1cbfb(context = (0, $55099852ccad0564$export$cc80c08dc91f1c00)) {
    const useReduxContext = context === (0, $55099852ccad0564$export$cc80c08dc91f1c00) ? (0, $11518dc3bb05d381$export$c1275ca9a6fd3ec5) : (0, $11518dc3bb05d381$export$d4d6226d5fc61558)(context);
    return function useSelector(selector, equalityFnOrOptions = {}) {
        const { equalityFn: equalityFn = $d8fc8d639f906efc$var$refEquality, stabilityCheck: stabilityCheck, noopCheck: noopCheck } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const { store: store, subscription: subscription, getServerState: getServerState, stabilityCheck: globalStabilityCheck, noopCheck: globalNoopCheck } = useReduxContext();
        const firstRun = (0, $acw62.useRef)(true);
        const wrappedSelector = (0, $acw62.useCallback)({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector,
            globalStabilityCheck,
            stabilityCheck
        ]);
        const selectedState = $d8fc8d639f906efc$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        (0, $acw62.useDebugValue)(selectedState);
        return selectedState;
    };
}
const $d8fc8d639f906efc$export$2105062e25df4afe = /*#__PURE__*/ $d8fc8d639f906efc$export$2b53f90d2bd1cbfb();


function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(this, arguments);
}


function $133b6e059b2f6d5e$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var $9ORqK = parcelRequire("9ORqK");

var $acw62 = parcelRequire("acw62");
var $8eaf5463f712f9ea$exports = {};
"use strict";

$8eaf5463f712f9ea$exports = (parcelRequire("cgj07"));



/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $58c9380df5fc9ad2$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }


function $98b92028b84cbd13$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) (0, $58c9380df5fc9ad2$export$2e2bcd8739ae039)(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $98b92028b84cbd13$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps) {
    $98b92028b84cbd13$var$verify(mapStateToProps, "mapStateToProps");
    $98b92028b84cbd13$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $98b92028b84cbd13$var$verify(mergeProps, "mergeProps");
}


const $2eb761e6a8ffbe36$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $2eb761e6a8ffbe36$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $2eb761e6a8ffbe36$export$2e2bcd8739ae039(dispatch, _ref) {
    let { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _ref, options = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_ref, $2eb761e6a8ffbe36$var$_excluded);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $2eb761e6a8ffbe36$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}


function $6a22b9cec285f673$export$2e2bcd8739ae039(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}


/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $859ec94da7aa38c4$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}



function $e605af63e5bbc093$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $859ec94da7aa38c4$export$2e2bcd8739ae039)(value)) (0, $58c9380df5fc9ad2$export$2e2bcd8739ae039)(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}


function $2d566511964cb2c4$export$710f7c60f68acd3e(//  It seems that the dispatch argument
//  could be a dispatch function in some cases (ex: whenMapDispatchToPropsIsMissing)
//  and a state object in some others (ex: whenMapStateToPropsIsMissing)
// eslint-disable-next-line no-unused-vars
getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $2d566511964cb2c4$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $2d566511964cb2c4$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, undefined);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $2d566511964cb2c4$export$e561b938df936d57(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $2d566511964cb2c4$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}


function $f019d9508e58fcb7$export$19ef7b929f7e2559(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}


function $d4dd493c66c4df43$export$b69a785ceac019a6(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? (0, $2d566511964cb2c4$export$710f7c60f68acd3e)((dispatch)=>(0, $6a22b9cec285f673$export$2e2bcd8739ae039)(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? (0, $2d566511964cb2c4$export$710f7c60f68acd3e)((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? (0, $2d566511964cb2c4$export$8d46c7f53c8c602f)(mapDispatchToProps, "mapDispatchToProps") : (0, $f019d9508e58fcb7$export$19ef7b929f7e2559)(mapDispatchToProps, "mapDispatchToProps");
}




function $f337fd5395077a96$export$e00e93951827eda7(mapStateToProps) {
    return !mapStateToProps ? (0, $2d566511964cb2c4$export$710f7c60f68acd3e)(()=>({})) : typeof mapStateToProps === "function" ? (0, $2d566511964cb2c4$export$8d46c7f53c8c602f)(mapStateToProps, "mapStateToProps") : (0, $f019d9508e58fcb7$export$19ef7b929f7e2559)(mapStateToProps, "mapStateToProps");
}





function $59349e43bbd01749$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    // @ts-ignore
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, ownProps, stateProps, dispatchProps);
}
function $59349e43bbd01749$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $59349e43bbd01749$export$17457cf6fa742f84(mergeProps) {
    return !mergeProps ? ()=>$59349e43bbd01749$export$691c327fc30bc857 : typeof mergeProps === "function" ? $59349e43bbd01749$export$5b105939c84b5234(mergeProps) : (0, $f019d9508e58fcb7$export$19ef7b929f7e2559)(mergeProps, "mergeProps");
}



// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $de1db2bafb2c3b5a$var$createListenerCollection() {
    const batch = (0, $f9089991fdc24c9c$export$fc47d4c0ba3bd2c6)();
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            batch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            let listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            let listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
const $de1db2bafb2c3b5a$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $de1db2bafb2c3b5a$export$d567d2b9af322f8f(store, parentSub) {
    let unsubscribe;
    let listeners = $de1db2bafb2c3b5a$var$nullListeners; // Reasons to keep the subscription active
    let subscriptionsAmount = 0; // Is this specific subscription subscribed (or only nested ones?)
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener); // cleanup nested sub
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $de1db2bafb2c3b5a$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $de1db2bafb2c3b5a$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}



var $acw62 = parcelRequire("acw62");
const $7a11fbbe9e9ac5f8$export$71594e8a50f746f4 = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
const $7a11fbbe9e9ac5f8$export$700979bc83e7db82 = $7a11fbbe9e9ac5f8$export$71594e8a50f746f4 ? $acw62.useLayoutEffect : $acw62.useEffect;


function $66f27f2048ec2805$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $66f27f2048ec2805$export$2e2bcd8739ae039(objA, objB) {
    if ($66f27f2048ec2805$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$66f27f2048ec2805$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}





const $dbe46e5c642d971b$var$_excluded = [
    "reactReduxForwardedRef"
];
let $dbe46e5c642d971b$var$useSyncExternalStore = (0, $d2699e687deeb28e$export$20656a4825650bd0);
const $dbe46e5c642d971b$export$36d45daa6a4925b8 = (fn)=>{
    $dbe46e5c642d971b$var$useSyncExternalStore = fn;
}; // Define some constant arrays just to avoid re-creating these
const $dbe46e5c642d971b$var$EMPTY_ARRAY = [
    null,
    0
];
const $dbe46e5c642d971b$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
]; // Attempts to stringify whatever not-really-a-component value we were given
// for logging in an error message
const $dbe46e5c642d971b$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
// This is "just" a `useLayoutEffect`, but with two modifications:
// - we need to fall back to `useEffect` in SSR to avoid annoying warnings
// - we extract this to a separate function to avoid closing over values
//   and causing memory leaks
function $dbe46e5c642d971b$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $7a11fbbe9e9ac5f8$export$700979bc83e7db82)(()=>effectFunc(...effectArgs), dependencies);
} // Effect callback, extracted: assign the latest props values to refs for later usage
function $dbe46e5c642d971b$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
} // Effect callback, extracted: subscribe to the Redux store or nearest connected ancestor,
// check for updates after dispatched actions, and trigger re-renders.
function $dbe46e5c642d971b$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return ()=>{}; // Capture values for checking if and when this component unmounts
    let didUnsubscribe = false;
    let lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
         // TODO We're currently calling getState ourselves here, rather than letting `uSES` do it
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // TODO This is hacky and not how `uSES` is meant to be used
            // Trigger the React `useSyncExternalStore` subscriber
            additionalSubscribeListener();
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
} // Reducer initial state creation for our update reducer
const $dbe46e5c642d971b$var$initStateUpdates = ()=>$dbe46e5c642d971b$var$EMPTY_ARRAY;
function $dbe46e5c642d971b$var$strictEqual(a, b) {
    return a === b;
}
/**
 * Infers the type of props that a connector will inject into a component.
 */ let $dbe46e5c642d971b$var$hasWarnedAboutDeprecatedPureOption = false;
/**
 * Connects a React component to a Redux store.
 *
 * - Without arguments, just wraps the component, without changing the behavior / props
 *
 * - If 2 params are passed (3rd param, mergeProps, is skipped), default behavior
 * is to override ownProps (as stated in the docs), so what remains is everything that's
 * not a state or dispatch prop
 *
 * - When 3rd param is passed, we don't know if ownProps propagate and whether they
 * should be valid component props, because it depends on mergeProps implementation.
 * As such, it is the user's responsibility to extend ownProps interface from state or
 * dispatch props or both when applicable
 *
 * @param mapStateToProps A function that extracts values from state
 * @param mapDispatchToProps Setup for dispatching actions
 * @param mergeProps Optional callback to merge state and dispatch props together
 * @param options Options for configuring the connection
 *
 */ function $dbe46e5c642d971b$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $dbe46e5c642d971b$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = (0, $66f27f2048ec2805$export$2e2bcd8739ae039), areStatePropsEqual: areStatePropsEqual = (0, $66f27f2048ec2805$export$2e2bcd8739ae039), areMergedPropsEqual: areMergedPropsEqual = (0, $66f27f2048ec2805$export$2e2bcd8739ae039), forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = (0, $55099852ccad0564$export$cc80c08dc91f1c00) } = {}) {
    const Context = context;
    const initMapStateToProps = (0, $f337fd5395077a96$export$e00e93951827eda7)(mapStateToProps);
    const initMapDispatchToProps = (0, $d4dd493c66c4df43$export$b69a785ceac019a6)(mapDispatchToProps);
    const initMergeProps = (0, $59349e43bbd01749$export$17457cf6fa742f84)(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $acw62.useMemo(()=>{
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                const { reactReduxForwardedRef: reactReduxForwardedRef } = props, wrapperProps = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $dbe46e5c642d971b$var$_excluded);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]);
            const ContextToUse = $acw62.useMemo(()=>{
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && // @ts-ignore
                (0, $8eaf5463f712f9ea$exports.isContextConsumer)(/*#__PURE__*/ $acw62.createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            const contextValue = $acw62.useContext(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $acw62.useMemo(()=>{
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return (0, $2eb761e6a8ffbe36$export$2e2bcd8739ae039)(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $acw62.useMemo(()=>{
                if (!shouldHandleStateChanges) return $dbe46e5c642d971b$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                const subscription = (0, $de1db2bafb2c3b5a$export$d567d2b9af322f8f)(store, didStoreComeFromProps ? undefined : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                const notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]); // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            const overriddenContextValue = $acw62.useMemo(()=>{
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // Set up refs to coordinate values between the subscription effect and the render logic
            const lastChildProps = $acw62.useRef();
            const lastWrapperProps = $acw62.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $acw62.useRef();
            const renderIsScheduled = $acw62.useRef(false);
            const isProcessingDispatch = $acw62.useRef(false);
            const isMounted = $acw62.useRef(false);
            const latestSubscriptionCallbackError = $acw62.useRef();
            (0, $7a11fbbe9e9ac5f8$export$700979bc83e7db82)(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $acw62.useMemo(()=>{
                const selector = ()=>{
                    // Tricky logic here:
                    // - This render may have been triggered by a Redux store update that produced new child props
                    // - However, we may have gotten new wrapper props after that
                    // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                    // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                    // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                     // TODO We're reading the store directly in render() here. Bad idea?
                    // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                    // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                    // to determine what the child props should be.
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            const subscribeForReact = $acw62.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $dbe46e5c642d971b$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $dbe46e5c642d971b$var$useIsomorphicLayoutEffectWithArgs($dbe46e5c642d971b$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $dbe46e5c642d971b$var$useSyncExternalStore(subscribeForReact, // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `\nThe error may be correlated with this previous error:\n${latestSubscriptionCallbackError.current.stack}\n\n`;
                throw err;
            }
            (0, $7a11fbbe9e9ac5f8$export$700979bc83e7db82)(()=>{
                latestSubscriptionCallbackError.current = undefined;
                childPropsFromStoreUpdate.current = undefined;
                lastChildProps.current = actualChildProps;
            }); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            const renderedWrappedComponent = $acw62.useMemo(()=>{
                return(/*#__PURE__*/ // @ts-ignore
                $acw62.createElement(WrappedComponent, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            const renderedChild = $acw62.useMemo(()=>{
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ $acw62.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $acw62.memo(ConnectFunction);
        // Add a hacky cast to get the right output type
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $acw62.forwardRef(function forwardConnectRef(props, ref) {
                // @ts-ignore
                return /*#__PURE__*/ $acw62.createElement(Connect, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $dbe46e5c642d971b$export$2e2bcd8739ae039 = $dbe46e5c642d971b$var$connect;



var $acw62 = parcelRequire("acw62");



function $31f4d8f6ffbbb628$var$Provider({ store: store, context: context, children: children, serverState: serverState, stabilityCheck: stabilityCheck = "once", noopCheck: noopCheck = "once" }) {
    const contextValue = $acw62.useMemo(()=>{
        const subscription = (0, $de1db2bafb2c3b5a$export$d567d2b9af322f8f)(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : undefined,
            stabilityCheck: stabilityCheck,
            noopCheck: noopCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        noopCheck
    ]);
    const previousState = $acw62.useMemo(()=>store.getState(), [
        store
    ]);
    (0, $7a11fbbe9e9ac5f8$export$700979bc83e7db82)(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = undefined;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || (0, $55099852ccad0564$export$cc80c08dc91f1c00); // @ts-ignore 'AnyAction' is assignable to the constraint of type 'A', but 'A' could be instantiated with a different subtype
    return /*#__PURE__*/ $acw62.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $31f4d8f6ffbbb628$export$2e2bcd8739ae039 = $31f4d8f6ffbbb628$var$Provider;







function $391671225302c365$export$671dba69185d0304(context = (0, $55099852ccad0564$export$cc80c08dc91f1c00)) {
    const useReduxContext = context === (0, $55099852ccad0564$export$cc80c08dc91f1c00) ? (0, $11518dc3bb05d381$export$c1275ca9a6fd3ec5) : (0, $11518dc3bb05d381$export$d4d6226d5fc61558)(context);
    return function useStore() {
        const { store: store } = useReduxContext(); // @ts-ignore
        return store;
    };
}
const $391671225302c365$export$6ccbb43953eebf8 = /*#__PURE__*/ $391671225302c365$export$671dba69185d0304();


function $20d80f3cecee513e$export$bc9b55530897c558(context = (0, $55099852ccad0564$export$cc80c08dc91f1c00)) {
    const useStore = context === (0, $55099852ccad0564$export$cc80c08dc91f1c00) ? (0, $391671225302c365$export$6ccbb43953eebf8) : (0, $391671225302c365$export$671dba69185d0304)(context);
    return function useDispatch() {
        const store = useStore(); // @ts-ignore
        return store.dispatch;
    };
}
const $20d80f3cecee513e$export$8ad76b76a4c905f8 = /*#__PURE__*/ $20d80f3cecee513e$export$bc9b55530897c558();









(0, $d8fc8d639f906efc$export$e2e6e3f3f3b782e3)((0, $6ae5e5baff12bbf7$exports.useSyncExternalStoreWithSelector));
(0, $dbe46e5c642d971b$export$36d45daa6a4925b8)((0, $hfliI.useSyncExternalStore)); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)
(0, $f9089991fdc24c9c$export$4b9874722d0da7bc)((0, $11492dca620dcaa5$exports.unstable_batchedUpdates));


const $6d4b57eddd9e5082$export$3c67ec6258c4a827 = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";
const $6d4b57eddd9e5082$export$46821acf14590a5 = "https://food-wagon-backend.onrender.com/api/restaurants?lat=26.9124336&lng=75.7872709";
const $6d4b57eddd9e5082$export$f8a1af105e1b4bba = "https://food-wagon-backend.onrender.com/api/menu?lat=26.9124336&lng=75.7872709&restaurantId=";
const $6d4b57eddd9e5082$export$7fd3d2dc9ae0b7f3 = "https://www.freeiconspng.com/uploads/food-icon-7.png";


// Create Header Component which handle the toggle menu and directing the user to different pages
const $3df07944bfa6aab3$var$Header = ()=>{
    // using the useSelector hook to get the total number of items in cart
    const totalCartItems = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.cartSlice.cartItems)?.length;
    // using the useContext hook to get the user login status and name
    const { loginStatus: loginStatus, userName: userName } = (0, $acw62.useContext)((0, $c09882a49af06a79$export$38ee920e59704589));
    // create state variable for toggle menu
    const [tooggleMenu, setToggleMenu] = (0, $acw62.useState)(false);
    // this function is used to toggle the menu which which make visible or hidden a menu list according menu image
    function handleToogleMenu(e) {
        const navList = e.target.parentElement.parentElement.getElementsByTagName("ul");
        const menu = e.target.parentElement.getElementsByTagName("i");
        if (!tooggleMenu) {
            menu[0].classList.add("hidden");
            menu[1].classList.remove("hidden");
            navList[0].classList.remove("hidden");
            navList[0].classList.add("flex");
            navList[0].classList.add("translate-y-0");
            navList[0].classList.add("-translate-y-full");
        } else {
            menu[1].classList.add("hidden");
            menu[0].classList.remove("hidden");
            navList[0].classList.add("hidden");
            navList[0].classList.remove("flex");
            navList[0].classList.remove("-translate-y-full");
            navList[0].classList.remove("translate-y-0");
        }
        setToggleMenu(!tooggleMenu);
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "h-[15vh] w-full overflow-hidden bg-blue-200 flex items-center justify-between p-4 lg:px-8",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "w-2/12 cursor-pointer flex items-center justify-center gap-2 flex-col md:flex-row",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        className: "w-10 h-10 lg:w-20 lg:h-20",
                        srcSet: (0, $6d4b57eddd9e5082$export$7fd3d2dc9ae0b7f3),
                        alt: ""
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                        className: " hidden md:block text-blue-950 font-bold text-sm lg:text-xl",
                        children: "DishDazzle"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex w-9/12 items-end justify-end md:hidden gap-2 px-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "cursor-pointer text-2xl font-bold text-blue-950 md:px-3 py-1 rounded-lg lg:text-2xl",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                            to: "/cart",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                    className: "ri-shopping-cart-2-fill"
                                }),
                                " ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("sup", {
                                    children: totalCartItems
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "cursor-pointer text-2xl font-bold text-blue-950 md:px-3 py-1 rounded-lg lg:text-2xl",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                            to: loginStatus ? "/user/logout" : "/user/",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: "ri-user-fill"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                className: "w-1/12",
                onClick: (e)=>handleToogleMenu(e),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                        className: "ri-menu-line font-bold md:hidden text-3xl text-blue-950"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                        className: "ri-close-fill hidden font-bold md:hidden text-3xl text-blue-950"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                className: " z-50  hidden absolute bg-blue-200 w-1/2 h-fit top-20 p-3 right-0 flex-col gap-3 items-center transition duration-500 ease-out rounded-bl-3xl md:opacity-100 md:translate-x-0 md:relative md:block md:flex-row md:w-fit md:h-fit md:rounded-bl-none md:bg-transparent md:flex md:flex-row md:top-0  lg:gap-8",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                        className: "cursor-pointer text-lg font-bold hover:bg-blue-800 hover:text-white px-3 py-1 rounded-lg lg:text-2xl",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                            to: "/",
                            children: "Home"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                        className: "cursor-pointer text-lg font-bold hover:bg-blue-800 hover:text-white px-3 py-1 rounded-lg lg:text-2xl",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                            to: "/about",
                            children: "About"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                        className: "cursor-pointer text-lg font-bold hover:bg-blue-800 hover:text-white px-3 py-1 rounded-lg lg:text-2xl",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                            to: "/contact",
                            children: "Contact"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                        className: " hidden md:block cursor-pointer text-2xl font-bold text-blue-950 py-1 rounded-lg lg:text-2xl",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                            to: "/cart",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                    className: "ri-shopping-cart-2-fill"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("sup", {
                                    children: totalCartItems
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                        className: "hidden md:block cursor-pointer  font-bold text-blue-950 py-1 rounded-lg",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                            to: loginStatus ? "/user/logout" : "/user/",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                        className: "ri-user-fill text-2xl"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "hidden md:block text-md",
                                        children: [
                                            " ",
                                            loginStatus ? userName.split(" ")[0] : "Login"
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var $3df07944bfa6aab3$export$2e2bcd8739ae039 = $3df07944bfa6aab3$var$Header;



parcelRequire("acw62");
// create a footer of the website
const $d5c7001fb908dd0e$var$Footer = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: " h-[5vh]  w-full flex  items-center justify-center bg-blue-950 text-white text-sm text-center font-bold py-4 md:text-lg lg:text-2xl",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
            children: "\xa9 2023 | All Rights Reserved by Dish Dazzle"
        })
    });
};
var $d5c7001fb908dd0e$export$2e2bcd8739ae039 = $d5c7001fb908dd0e$var$Footer;





var $acw62 = parcelRequire("acw62");

parcelRequire("acw62");


// This main component which show the list of all restaurants in the form of cards
const $bea13f367d75ec6c$var$RestaurantsCards = (props)=>{
    const { id: id, name: name, cloudinaryImageId: cloudinaryImageId, cuisines: cuisines, avgRating: avgRating, locality: locality, sla: sla, costForTwo: costForTwo, promoted: promoted } = props.restaurant;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
        className: " transition-all ease-linear duration-300 truncate relative w-full h-1/3 flex mx-2 items-center overflow-hidden hover:bg-blue-300 hover:shadow-lg hover:shadow-blue-500 md:items-start md:mx-auto  my-4 rounded-xl border-4 border-blue-300 md:flex-col md:w-5/12 md:h-5/6 lg:h-4/5 lg:justify-center lg:my-4 lg:mx-14 lg:w-3/12 ",
        to: `/menu/${id}/${name}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                className: " w-1/3 h-full md:h-2/3 md:w-screen lg:w-full  lg:h-2/3 p-2 lg:px-2 lg:py-0 rounded-2xl",
                src: (0, $6d4b57eddd9e5082$export$3c67ec6258c4a827) + cloudinaryImageId,
                alt: ""
            }),
            promoted ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "hidden absolute top-1 left-1 bg-blue-900 text-white px-2 py-2 rounded-tl-lg md:block",
                children: "Promoted"
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: " flex flex-col lg-gap-2    ",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                        className: " w-full font-extrabold px-2 md:px-4 md:text-md lg:text-lg",
                        children: name
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "h-fit flex px-1 gap-1  font-bold items-center item-center md:gap-1 md:mt-1 md:px-4 lg:gap-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                className: "h-5 w-5 md:h-8 md:w-8",
                                src: "https://i.postimg.cc/435BQMtQ/icons8-rating-circled-48.png",
                                alt: "rating-circled"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: avgRating
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: " font-black relative bottom-1 text-lg",
                                children: "."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-xs md:text-[15px]",
                                children: sla.slaString
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: " text-xs bg-blue-900 rounded-xl py-1 px-1  text-white md:text-[15px] md:px-2 md:mx-2",
                                children: costForTwo
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "px-2 md:px-5 text-clip",
                        children: cuisines.slice(0, 1).join(", ")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "px-2 md:px-5",
                        children: locality
                    })
                ]
            })
        ]
    });
};
var $bea13f367d75ec6c$export$2e2bcd8739ae039 = $bea13f367d75ec6c$var$RestaurantsCards;




var $acw62 = parcelRequire("acw62");
var $a3478a115f13707d$exports = {};
"use client";
"use strict";
var $a3478a115f13707d$var$Y = Object.create;
var $a3478a115f13707d$var$E = Object.defineProperty;
var $a3478a115f13707d$var$q = Object.getOwnPropertyDescriptor;
var $a3478a115f13707d$var$G = Object.getOwnPropertyNames;
var $a3478a115f13707d$var$K = Object.getPrototypeOf, $a3478a115f13707d$var$Z = Object.prototype.hasOwnProperty;
var $a3478a115f13707d$var$ee = (e, t)=>{
    for(var o in t)$a3478a115f13707d$var$E(e, o, {
        get: t[o],
        enumerable: !0
    });
}, $a3478a115f13707d$var$j = (e, t, o, s)=>{
    if (t && typeof t == "object" || typeof t == "function") for (let r of $a3478a115f13707d$var$G(t))!$a3478a115f13707d$var$Z.call(e, r) && r !== o && $a3478a115f13707d$var$E(e, r, {
        get: ()=>t[r],
        enumerable: !(s = $a3478a115f13707d$var$q(t, r)) || s.enumerable
    });
    return e;
};
var $a3478a115f13707d$var$W = (e, t, o)=>(o = e != null ? $a3478a115f13707d$var$Y($a3478a115f13707d$var$K(e)) : {}, $a3478a115f13707d$var$j(t || !e || !e.__esModule ? $a3478a115f13707d$var$E(o, "default", {
        value: e,
        enumerable: !0
    }) : o, e)), $a3478a115f13707d$var$te = (e)=>$a3478a115f13707d$var$j($a3478a115f13707d$var$E({}, "__esModule", {
        value: !0
    }), e);
var $a3478a115f13707d$var$Ve = {};
$a3478a115f13707d$var$ee($a3478a115f13707d$var$Ve, {
    CheckmarkIcon: ()=>$a3478a115f13707d$var$F,
    ErrorIcon: ()=>$a3478a115f13707d$var$w,
    LoaderIcon: ()=>$a3478a115f13707d$var$M,
    ToastBar: ()=>$a3478a115f13707d$var$$,
    ToastIcon: ()=>$a3478a115f13707d$var$U,
    Toaster: ()=>$a3478a115f13707d$var$J,
    default: ()=>$a3478a115f13707d$var$_e,
    resolveValue: ()=>$a3478a115f13707d$var$u,
    toast: ()=>$a3478a115f13707d$var$n,
    useToaster: ()=>$a3478a115f13707d$var$V,
    useToasterStore: ()=>$a3478a115f13707d$var$_
});
$a3478a115f13707d$exports = $a3478a115f13707d$var$te($a3478a115f13707d$var$Ve);
var $a3478a115f13707d$var$oe = (e)=>typeof e == "function", $a3478a115f13707d$var$u = (e, t)=>$a3478a115f13707d$var$oe(e) ? e(t) : e;
var $a3478a115f13707d$var$Q = (()=>{
    let e = 0;
    return ()=>(++e).toString();
})(), $a3478a115f13707d$var$R = (()=>{
    let e;
    return ()=>{
        if (e === void 0 && typeof window < "u") {
            let t = matchMedia("(prefers-reduced-motion: reduce)");
            e = !t || t.matches;
        }
        return e;
    };
})();

var $a3478a115f13707d$var$re = 20;
var $a3478a115f13707d$var$v = new Map, $a3478a115f13707d$var$se = 1e3, $a3478a115f13707d$var$X = (e)=>{
    if ($a3478a115f13707d$var$v.has(e)) return;
    let t = setTimeout(()=>{
        $a3478a115f13707d$var$v.delete(e), $a3478a115f13707d$var$l({
            type: 4,
            toastId: e
        });
    }, $a3478a115f13707d$var$se);
    $a3478a115f13707d$var$v.set(e, t);
}, $a3478a115f13707d$var$ae = (e)=>{
    let t = $a3478a115f13707d$var$v.get(e);
    t && clearTimeout(t);
}, $a3478a115f13707d$var$H = (e, t)=>{
    switch(t.type){
        case 0:
            return {
                ...e,
                toasts: [
                    t.toast,
                    ...e.toasts
                ].slice(0, $a3478a115f13707d$var$re)
            };
        case 1:
            return t.toast.id && $a3478a115f13707d$var$ae(t.toast.id), {
                ...e,
                toasts: e.toasts.map((a)=>a.id === t.toast.id ? {
                        ...a,
                        ...t.toast
                    } : a)
            };
        case 2:
            let { toast: o } = t;
            return e.toasts.find((a)=>a.id === o.id) ? $a3478a115f13707d$var$H(e, {
                type: 1,
                toast: o
            }) : $a3478a115f13707d$var$H(e, {
                type: 0,
                toast: o
            });
        case 3:
            let { toastId: s } = t;
            return s ? $a3478a115f13707d$var$X(s) : e.toasts.forEach((a)=>{
                $a3478a115f13707d$var$X(a.id);
            }), {
                ...e,
                toasts: e.toasts.map((a)=>a.id === s || s === void 0 ? {
                        ...a,
                        visible: !1
                    } : a)
            };
        case 4:
            return t.toastId === void 0 ? {
                ...e,
                toasts: []
            } : {
                ...e,
                toasts: e.toasts.filter((a)=>a.id !== t.toastId)
            };
        case 5:
            return {
                ...e,
                pausedAt: t.time
            };
        case 6:
            let r = t.time - (e.pausedAt || 0);
            return {
                ...e,
                pausedAt: void 0,
                toasts: e.toasts.map((a)=>({
                        ...a,
                        pauseDuration: a.pauseDuration + r
                    }))
            };
    }
}, $a3478a115f13707d$var$I = [], $a3478a115f13707d$var$D = {
    toasts: [],
    pausedAt: void 0
}, $a3478a115f13707d$var$l = (e)=>{
    $a3478a115f13707d$var$D = $a3478a115f13707d$var$H($a3478a115f13707d$var$D, e), $a3478a115f13707d$var$I.forEach((t)=>{
        t($a3478a115f13707d$var$D);
    });
}, $a3478a115f13707d$var$ie = {
    blank: 4e3,
    error: 4e3,
    success: 2e3,
    loading: 1 / 0,
    custom: 4e3
}, $a3478a115f13707d$var$_ = (e = {})=>{
    let [t, o] = (0, (parcelRequire("acw62")).useState)($a3478a115f13707d$var$D);
    (0, (parcelRequire("acw62")).useEffect)(()=>($a3478a115f13707d$var$I.push(o), ()=>{
            let r = $a3478a115f13707d$var$I.indexOf(o);
            r > -1 && $a3478a115f13707d$var$I.splice(r, 1);
        }), [
        t
    ]);
    let s = t.toasts.map((r)=>{
        var a, c;
        return {
            ...e,
            ...e[r.type],
            ...r,
            duration: r.duration || ((a = e[r.type]) == null ? void 0 : a.duration) || (e == null ? void 0 : e.duration) || $a3478a115f13707d$var$ie[r.type],
            style: {
                ...e.style,
                ...(c = e[r.type]) == null ? void 0 : c.style,
                ...r.style
            }
        };
    });
    return {
        ...t,
        toasts: s
    };
};
var $a3478a115f13707d$var$ce = (e, t = "blank", o)=>({
        createdAt: Date.now(),
        visible: !0,
        type: t,
        ariaProps: {
            role: "status",
            "aria-live": "polite"
        },
        message: e,
        pauseDuration: 0,
        ...o,
        id: (o == null ? void 0 : o.id) || $a3478a115f13707d$var$Q()
    }), $a3478a115f13707d$var$S = (e)=>(t, o)=>{
        let s = $a3478a115f13707d$var$ce(t, e, o);
        return $a3478a115f13707d$var$l({
            type: 2,
            toast: s
        }), s.id;
    }, $a3478a115f13707d$var$n = (e, t)=>$a3478a115f13707d$var$S("blank")(e, t);
$a3478a115f13707d$var$n.error = $a3478a115f13707d$var$S("error");
$a3478a115f13707d$var$n.success = $a3478a115f13707d$var$S("success");
$a3478a115f13707d$var$n.loading = $a3478a115f13707d$var$S("loading");
$a3478a115f13707d$var$n.custom = $a3478a115f13707d$var$S("custom");
$a3478a115f13707d$var$n.dismiss = (e)=>{
    $a3478a115f13707d$var$l({
        type: 3,
        toastId: e
    });
};
$a3478a115f13707d$var$n.remove = (e)=>$a3478a115f13707d$var$l({
        type: 4,
        toastId: e
    });
$a3478a115f13707d$var$n.promise = (e, t, o)=>{
    let s = $a3478a115f13707d$var$n.loading(t.loading, {
        ...o,
        ...o == null ? void 0 : o.loading
    });
    return e.then((r)=>($a3478a115f13707d$var$n.success($a3478a115f13707d$var$u(t.success, r), {
            id: s,
            ...o,
            ...o == null ? void 0 : o.success
        }), r)).catch((r)=>{
        $a3478a115f13707d$var$n.error($a3478a115f13707d$var$u(t.error, r), {
            id: s,
            ...o,
            ...o == null ? void 0 : o.error
        });
    }), e;
};

var $a3478a115f13707d$var$pe = (e, t)=>{
    $a3478a115f13707d$var$l({
        type: 1,
        toast: {
            id: e,
            height: t
        }
    });
}, $a3478a115f13707d$var$de = ()=>{
    $a3478a115f13707d$var$l({
        type: 5,
        time: Date.now()
    });
}, $a3478a115f13707d$var$V = (e)=>{
    let { toasts: t, pausedAt: o } = $a3478a115f13707d$var$_(e);
    (0, (parcelRequire("acw62")).useEffect)(()=>{
        if (o) return;
        let a = Date.now(), c = t.map((i)=>{
            if (i.duration === 1 / 0) return;
            let d = (i.duration || 0) + i.pauseDuration - (a - i.createdAt);
            if (d < 0) {
                i.visible && $a3478a115f13707d$var$n.dismiss(i.id);
                return;
            }
            return setTimeout(()=>$a3478a115f13707d$var$n.dismiss(i.id), d);
        });
        return ()=>{
            c.forEach((i)=>i && clearTimeout(i));
        };
    }, [
        t,
        o
    ]);
    let s = (0, (parcelRequire("acw62")).useCallback)(()=>{
        o && $a3478a115f13707d$var$l({
            type: 6,
            time: Date.now()
        });
    }, [
        o
    ]), r = (0, (parcelRequire("acw62")).useCallback)((a, c)=>{
        let { reverseOrder: i = !1, gutter: d = 8, defaultPosition: p } = c || {}, g = t.filter((m)=>(m.position || p) === (a.position || p) && m.height), z = g.findIndex((m)=>m.id === a.id), O = g.filter((m, B)=>B < z && m.visible).length;
        return g.filter((m)=>m.visible).slice(...i ? [
            O + 1
        ] : [
            0,
            O
        ]).reduce((m, B)=>m + (B.height || 0) + d, 0);
    }, [
        t
    ]);
    return {
        toasts: t,
        handlers: {
            updateHeight: $a3478a115f13707d$var$pe,
            startPause: $a3478a115f13707d$var$de,
            endPause: s,
            calculateOffset: r
        }
    };
};

var $a3478a115f13707d$var$T = $a3478a115f13707d$var$W((parcelRequire("acw62")));
let $59bacf62d0c4a6b9$var$e = {
    data: ""
}, $59bacf62d0c4a6b9$var$t = (t)=>"object" == typeof window ? ((t ? t.querySelector("#_goober") : window._goober) || Object.assign((t || document.head).appendChild(document.createElement("style")), {
        innerHTML: " ",
        id: "_goober"
    })).firstChild : t || $59bacf62d0c4a6b9$var$e, $59bacf62d0c4a6b9$export$54aba348a7896325 = (e)=>{
    let r = $59bacf62d0c4a6b9$var$t(e), l = r.data;
    return r.data = "", l;
}, $59bacf62d0c4a6b9$var$l = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g, $59bacf62d0c4a6b9$var$a = /\/\*[^]*?\*\/|  +/g, $59bacf62d0c4a6b9$var$n = /\n+/g, $59bacf62d0c4a6b9$var$o = (e, t)=>{
    let r = "", l = "", a = "";
    for(let n in e){
        let c = e[n];
        "@" == n[0] ? "i" == n[1] ? r = n + " " + c + ";" : l += "f" == n[1] ? $59bacf62d0c4a6b9$var$o(c, n) : n + "{" + $59bacf62d0c4a6b9$var$o(c, "k" == n[1] ? "" : t) + "}" : "object" == typeof c ? l += $59bacf62d0c4a6b9$var$o(c, t ? t.replace(/([^,])+/g, (e)=>n.replace(/(^:.*)|([^,])+/g, (t)=>/&/.test(t) ? t.replace(/&/g, e) : e ? e + " " + t : t)) : n) : null != c && (n = /^--/.test(n) ? n : n.replace(/[A-Z]/g, "-$&").toLowerCase(), a += $59bacf62d0c4a6b9$var$o.p ? $59bacf62d0c4a6b9$var$o.p(n, c) : n + ":" + c + ";");
    }
    return r + (t && a ? t + "{" + a + "}" : a) + l;
}, $59bacf62d0c4a6b9$var$c = {}, $59bacf62d0c4a6b9$var$s = (e)=>{
    if ("object" == typeof e) {
        let t = "";
        for(let r in e)t += r + $59bacf62d0c4a6b9$var$s(e[r]);
        return t;
    }
    return e;
}, $59bacf62d0c4a6b9$var$i = (e, t, r, i, p)=>{
    let u = $59bacf62d0c4a6b9$var$s(e), d = $59bacf62d0c4a6b9$var$c[u] || ($59bacf62d0c4a6b9$var$c[u] = ((e)=>{
        let t = 0, r = 11;
        for(; t < e.length;)r = 101 * r + e.charCodeAt(t++) >>> 0;
        return "go" + r;
    })(u));
    if (!$59bacf62d0c4a6b9$var$c[d]) {
        let t = u !== e ? e : ((e)=>{
            let t, r, o = [
                {}
            ];
            for(; t = $59bacf62d0c4a6b9$var$l.exec(e.replace($59bacf62d0c4a6b9$var$a, ""));)t[4] ? o.shift() : t[3] ? (r = t[3].replace($59bacf62d0c4a6b9$var$n, " ").trim(), o.unshift(o[0][r] = o[0][r] || {})) : o[0][t[1]] = t[2].replace($59bacf62d0c4a6b9$var$n, " ").trim();
            return o[0];
        })(e);
        $59bacf62d0c4a6b9$var$c[d] = $59bacf62d0c4a6b9$var$o(p ? {
            ["@keyframes " + d]: t
        } : t, r ? "" : "." + d);
    }
    let f = r && $59bacf62d0c4a6b9$var$c.g ? $59bacf62d0c4a6b9$var$c.g : null;
    return r && ($59bacf62d0c4a6b9$var$c.g = $59bacf62d0c4a6b9$var$c[d]), ((e, t, r, l)=>{
        l ? t.data = t.data.replace(l, e) : -1 === t.data.indexOf(e) && (t.data = r ? e + t.data : t.data + e);
    })($59bacf62d0c4a6b9$var$c[d], t, i, f), d;
}, $59bacf62d0c4a6b9$var$p = (e, t, r)=>e.reduce((e, l, a)=>{
        let n = t[a];
        if (n && n.call) {
            let e = n(r), t = e && e.props && e.props.className || /^go/.test(e) && e;
            n = t ? "." + t : e && "object" == typeof e ? e.props ? "" : $59bacf62d0c4a6b9$var$o(e, "") : !1 === e ? "" : e;
        }
        return e + l + (null == n ? "" : n);
    }, "");
function $59bacf62d0c4a6b9$export$dbf350e5966cf602(e) {
    let r = this || {}, l = e.call ? e(r.p) : e;
    return $59bacf62d0c4a6b9$var$i(l.unshift ? l.raw ? $59bacf62d0c4a6b9$var$p(l, [].slice.call(arguments, 1), r.p) : l.reduce((e, t)=>Object.assign(e, t && t.call ? t(r.p) : t), {}) : l, $59bacf62d0c4a6b9$var$t(r.target), r.g, r.o, r.k);
}
let $59bacf62d0c4a6b9$var$d, $59bacf62d0c4a6b9$var$f, $59bacf62d0c4a6b9$var$g, $59bacf62d0c4a6b9$export$442f1a04865e4790 = $59bacf62d0c4a6b9$export$dbf350e5966cf602.bind({
    g: 1
}), $59bacf62d0c4a6b9$export$d25ddfdf17c3ad3e = $59bacf62d0c4a6b9$export$dbf350e5966cf602.bind({
    k: 1
});
function $59bacf62d0c4a6b9$export$de27182ff8187d6c(e, t, r, l) {
    $59bacf62d0c4a6b9$var$o.p = t, $59bacf62d0c4a6b9$var$d = e, $59bacf62d0c4a6b9$var$f = r, $59bacf62d0c4a6b9$var$g = l;
}
function $59bacf62d0c4a6b9$export$3817b7a54a07cec7(e, t) {
    let r = this || {};
    return function() {
        let l = arguments;
        function a(n, o) {
            let c = Object.assign({}, n), s = c.className || a.className;
            r.p = Object.assign({
                theme: $59bacf62d0c4a6b9$var$f && $59bacf62d0c4a6b9$var$f()
            }, c), r.o = / *go\d+/.test(s), c.className = $59bacf62d0c4a6b9$export$dbf350e5966cf602.apply(r, l) + (s ? " " + s : ""), t && (c.ref = o);
            let i = e;
            return e[0] && (i = c.as || e, delete c.as), $59bacf62d0c4a6b9$var$g && i[0] && $59bacf62d0c4a6b9$var$g(c), $59bacf62d0c4a6b9$var$d(i, c);
        }
        return t ? t(a) : a;
    };
}



var $a3478a115f13707d$var$y = $a3478a115f13707d$var$W((parcelRequire("acw62")));


var $a3478a115f13707d$var$me = $59bacf62d0c4a6b9$export$d25ddfdf17c3ad3e`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
 transform: scale(1) rotate(45deg);
  opacity: 1;
}`, $a3478a115f13707d$var$ue = $59bacf62d0c4a6b9$export$d25ddfdf17c3ad3e`
from {
  transform: scale(0);
  opacity: 0;
}
to {
  transform: scale(1);
  opacity: 1;
}`, $a3478a115f13707d$var$le = $59bacf62d0c4a6b9$export$d25ddfdf17c3ad3e`
from {
  transform: scale(0) rotate(90deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(90deg);
	opacity: 1;
}`, $a3478a115f13707d$var$w = (0, $59bacf62d0c4a6b9$export$3817b7a54a07cec7)("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(e)=>e.primary || "#ff4b4b"};
  position: relative;
  transform: rotate(45deg);

  animation: ${$a3478a115f13707d$var$me} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;

  &:after,
  &:before {
    content: '';
    animation: ${$a3478a115f13707d$var$ue} 0.15s ease-out forwards;
    animation-delay: 150ms;
    position: absolute;
    border-radius: 3px;
    opacity: 0;
    background: ${(e)=>e.secondary || "#fff"};
    bottom: 9px;
    left: 4px;
    height: 2px;
    width: 12px;
  }

  &:before {
    animation: ${$a3478a115f13707d$var$le} 0.15s ease-out forwards;
    animation-delay: 180ms;
    transform: rotate(90deg);
  }
`;

var $a3478a115f13707d$var$Te = $59bacf62d0c4a6b9$export$d25ddfdf17c3ad3e`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`, $a3478a115f13707d$var$M = (0, $59bacf62d0c4a6b9$export$3817b7a54a07cec7)("div")`
  width: 12px;
  height: 12px;
  box-sizing: border-box;
  border: 2px solid;
  border-radius: 100%;
  border-color: ${(e)=>e.secondary || "#e0e0e0"};
  border-right-color: ${(e)=>e.primary || "#616161"};
  animation: ${$a3478a115f13707d$var$Te} 1s linear infinite;
`;

var $a3478a115f13707d$var$fe = $59bacf62d0c4a6b9$export$d25ddfdf17c3ad3e`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(45deg);
	opacity: 1;
}`, $a3478a115f13707d$var$ye = $59bacf62d0c4a6b9$export$d25ddfdf17c3ad3e`
0% {
	height: 0;
	width: 0;
	opacity: 0;
}
40% {
  height: 0;
	width: 6px;
	opacity: 1;
}
100% {
  opacity: 1;
  height: 10px;
}`, $a3478a115f13707d$var$F = (0, $59bacf62d0c4a6b9$export$3817b7a54a07cec7)("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(e)=>e.primary || "#61d345"};
  position: relative;
  transform: rotate(45deg);

  animation: ${$a3478a115f13707d$var$fe} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;
  &:after {
    content: '';
    box-sizing: border-box;
    animation: ${$a3478a115f13707d$var$ye} 0.2s ease-out forwards;
    opacity: 0;
    animation-delay: 200ms;
    position: absolute;
    border-right: 2px solid;
    border-bottom: 2px solid;
    border-color: ${(e)=>e.secondary || "#fff"};
    bottom: 6px;
    left: 6px;
    height: 10px;
    width: 6px;
  }
`;
var $a3478a115f13707d$var$ge = (0, $59bacf62d0c4a6b9$export$3817b7a54a07cec7)("div")`
  position: absolute;
`, $a3478a115f13707d$var$he = (0, $59bacf62d0c4a6b9$export$3817b7a54a07cec7)("div")`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 20px;
  min-height: 20px;
`, $a3478a115f13707d$var$xe = $59bacf62d0c4a6b9$export$d25ddfdf17c3ad3e`
from {
  transform: scale(0.6);
  opacity: 0.4;
}
to {
  transform: scale(1);
  opacity: 1;
}`, $a3478a115f13707d$var$be = (0, $59bacf62d0c4a6b9$export$3817b7a54a07cec7)("div")`
  position: relative;
  transform: scale(0.6);
  opacity: 0.4;
  min-width: 20px;
  animation: ${$a3478a115f13707d$var$xe} 0.3s 0.12s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
`, $a3478a115f13707d$var$U = ({ toast: e })=>{
    let { icon: t, type: o, iconTheme: s } = e;
    return t !== void 0 ? typeof t == "string" ? $a3478a115f13707d$var$y.createElement($a3478a115f13707d$var$be, null, t) : t : o === "blank" ? null : $a3478a115f13707d$var$y.createElement($a3478a115f13707d$var$he, null, $a3478a115f13707d$var$y.createElement($a3478a115f13707d$var$M, {
        ...s
    }), o !== "loading" && $a3478a115f13707d$var$y.createElement($a3478a115f13707d$var$ge, null, o === "error" ? $a3478a115f13707d$var$y.createElement($a3478a115f13707d$var$w, {
        ...s
    }) : $a3478a115f13707d$var$y.createElement($a3478a115f13707d$var$F, {
        ...s
    })));
};
var $a3478a115f13707d$var$Se = (e)=>`
0% {transform: translate3d(0,${e * -200}%,0) scale(.6); opacity:.5;}
100% {transform: translate3d(0,0,0) scale(1); opacity:1;}
`, $a3478a115f13707d$var$Ae = (e)=>`
0% {transform: translate3d(0,0,-1px) scale(1); opacity:1;}
100% {transform: translate3d(0,${e * -150}%,-1px) scale(.6); opacity:0;}
`, $a3478a115f13707d$var$Pe = "0%{opacity:0;} 100%{opacity:1;}", $a3478a115f13707d$var$Oe = "0%{opacity:1;} 100%{opacity:0;}", $a3478a115f13707d$var$Ee = (0, $59bacf62d0c4a6b9$export$3817b7a54a07cec7)("div")`
  display: flex;
  align-items: center;
  background: #fff;
  color: #363636;
  line-height: 1.3;
  will-change: transform;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05);
  max-width: 350px;
  pointer-events: auto;
  padding: 8px 10px;
  border-radius: 8px;
`, $a3478a115f13707d$var$Re = (0, $59bacf62d0c4a6b9$export$3817b7a54a07cec7)("div")`
  display: flex;
  justify-content: center;
  margin: 4px 10px;
  color: inherit;
  flex: 1 1 auto;
  white-space: pre-line;
`, $a3478a115f13707d$var$ve = (e, t)=>{
    let s = e.includes("top") ? 1 : -1, [r, a] = $a3478a115f13707d$var$R() ? [
        $a3478a115f13707d$var$Pe,
        $a3478a115f13707d$var$Oe
    ] : [
        $a3478a115f13707d$var$Se(s),
        $a3478a115f13707d$var$Ae(s)
    ];
    return {
        animation: t ? `${(0, $59bacf62d0c4a6b9$export$d25ddfdf17c3ad3e)(r)} 0.35s cubic-bezier(.21,1.02,.73,1) forwards` : `${(0, $59bacf62d0c4a6b9$export$d25ddfdf17c3ad3e)(a)} 0.4s forwards cubic-bezier(.06,.71,.55,1)`
    };
}, $a3478a115f13707d$var$$ = $a3478a115f13707d$var$T.memo(({ toast: e, position: t, style: o, children: s })=>{
    let r = e.height ? $a3478a115f13707d$var$ve(e.position || t || "top-center", e.visible) : {
        opacity: 0
    }, a = $a3478a115f13707d$var$T.createElement($a3478a115f13707d$var$U, {
        toast: e
    }), c = $a3478a115f13707d$var$T.createElement($a3478a115f13707d$var$Re, {
        ...e.ariaProps
    }, $a3478a115f13707d$var$u(e.message, e));
    return $a3478a115f13707d$var$T.createElement($a3478a115f13707d$var$Ee, {
        className: e.className,
        style: {
            ...r,
            ...o,
            ...e.style
        }
    }, typeof s == "function" ? s({
        icon: a,
        message: c
    }) : $a3478a115f13707d$var$T.createElement($a3478a115f13707d$var$T.Fragment, null, a, c));
});


var $a3478a115f13707d$var$f = $a3478a115f13707d$var$W((parcelRequire("acw62")));
(0, $59bacf62d0c4a6b9$export$de27182ff8187d6c)($a3478a115f13707d$var$f.createElement);
var $a3478a115f13707d$var$Ie = ({ id: e, className: t, style: o, onHeightUpdate: s, children: r })=>{
    let a = $a3478a115f13707d$var$f.useCallback((c)=>{
        if (c) {
            let i = ()=>{
                let d = c.getBoundingClientRect().height;
                s(e, d);
            };
            i(), new MutationObserver(i).observe(c, {
                subtree: !0,
                childList: !0,
                characterData: !0
            });
        }
    }, [
        e,
        s
    ]);
    return $a3478a115f13707d$var$f.createElement("div", {
        ref: a,
        className: t,
        style: o
    }, r);
}, $a3478a115f13707d$var$De = (e, t)=>{
    let o = e.includes("top"), s = o ? {
        top: 0
    } : {
        bottom: 0
    }, r = e.includes("center") ? {
        justifyContent: "center"
    } : e.includes("right") ? {
        justifyContent: "flex-end"
    } : {};
    return {
        left: 0,
        right: 0,
        display: "flex",
        position: "absolute",
        transition: $a3478a115f13707d$var$R() ? void 0 : "all 230ms cubic-bezier(.21,1.02,.73,1)",
        transform: `translateY(${t * (o ? 1 : -1)}px)`,
        ...s,
        ...r
    };
}, $a3478a115f13707d$var$ke = $59bacf62d0c4a6b9$export$dbf350e5966cf602`
  z-index: 9999;
  > * {
    pointer-events: auto;
  }
`, $a3478a115f13707d$var$L = 16, $a3478a115f13707d$var$J = ({ reverseOrder: e, position: t = "top-center", toastOptions: o, gutter: s, children: r, containerStyle: a, containerClassName: c })=>{
    let { toasts: i, handlers: d } = $a3478a115f13707d$var$V(o);
    return $a3478a115f13707d$var$f.createElement("div", {
        style: {
            position: "fixed",
            zIndex: 9999,
            top: $a3478a115f13707d$var$L,
            left: $a3478a115f13707d$var$L,
            right: $a3478a115f13707d$var$L,
            bottom: $a3478a115f13707d$var$L,
            pointerEvents: "none",
            ...a
        },
        className: c,
        onMouseEnter: d.startPause,
        onMouseLeave: d.endPause
    }, i.map((p)=>{
        let g = p.position || t, z = d.calculateOffset(p, {
            reverseOrder: e,
            gutter: s,
            defaultPosition: t
        }), O = $a3478a115f13707d$var$De(g, z);
        return $a3478a115f13707d$var$f.createElement($a3478a115f13707d$var$Ie, {
            id: p.id,
            key: p.id,
            onHeightUpdate: d.updateHeight,
            className: p.visible ? $a3478a115f13707d$var$ke : "",
            style: O
        }, p.type === "custom" ? $a3478a115f13707d$var$u(p.message, p) : r ? r(p) : $a3478a115f13707d$var$f.createElement($a3478a115f13707d$var$$, {
            toast: p,
            position: g
        }));
    }));
};
var $a3478a115f13707d$var$_e = $a3478a115f13707d$var$n;


// This component is responsible for searching functionality on homepage
const $7081eca13e312070$var$SearchRestaurants = (props)=>{
    const { defaultRestaurants: defaultRestaurants, setRestaurantsList: setRestaurantsList, notSearchFiltered: notSearchFiltered, setSearchNotFiltered: setSearchNotFiltered } = props;
    const [searchValue, setSearchValue] = (0, $acw62.useState)(" ");
    // inside handler Search Button we are filtering the list of restaurants according to search value
    const handleSearchButton = (e)=>{
        e.preventDefault();
        const searchValueLower = searchValue.toLowerCase();
        const filteredRestaurants = defaultRestaurants.filter((restaurant)=>{
            return restaurant?.info?.name?.toLowerCase()?.includes(searchValueLower);
        });
        setRestaurantsList([]);
        setTimeout(()=>{
            // if filteredRestaurants is empty then set notSearchFiltered to true
            // else set notSearchFiltered to false
            if (filteredRestaurants.length === 0) setSearchNotFiltered(true);
            else setSearchNotFiltered(false);
            setRestaurantsList(filteredRestaurants);
            setSearchValue("");
        }, 1000);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "w-screen h-1/2 mb-2 mx-auto flex justify-center gap-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                type: "search",
                name: "search",
                value: searchValue,
                onChange: (e)=>{
                    setSearchValue(e.target.value);
                },
                className: " rounded-xl h-full px-3 w-44 focus:outline-none border-2 border-blue-300 md:w-1/3 lg:w-1/4"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                disabled: notSearchFiltered,
                type: "button",
                onClick: (e)=>handleSearchButton(e),
                className: "  disabled:opacity-30 transition-all ease-in-out duration-300 rounded-xl w-20 h-full border-2 border-blue-300  hover:bg-blue-900 hover:text-white",
                children: "Search"
            })
        ]
    });
};
var $7081eca13e312070$export$2e2bcd8739ae039 = $7081eca13e312070$var$SearchRestaurants;



parcelRequire("acw62");
// Creating a loading screen and that shown according to different uiType on page if the fetching data from API is not done 
const $0e2e610bf1b1dc33$var$ShimmerUI = (props)=>{
    const { uiType: uiType } = props;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-wrap gap-5 w-screen justify-center  h-full",
        children: [
            uiType === "ResturantCardList" && Array(6).fill(0).map((item, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: " w-full h-2/6 gap-3 rounded-xl animate-pulse  md:h-3/4  flex flex-wrap mx-5 my-5  border-4 border-blue-200 p-3 md:w-5/12 lg:w-1/4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "w-1/3 h-full md:w-full md:h-2/3 animate-pulse bg-blue-100 rounded-lg"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "w-7/12 h-full flex flex-col gap-1 mt-2 md:w-full md:h-1/3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "animate-pulse bg-blue-100 w-full h-1/6"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "animate-pulse bg-blue-100 w-full h-1/6"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "animate-pulse bg-blue-100 w-full h-1/6"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "animate-pulse bg-blue-100 w-full h-1/6"
                                })
                            ]
                        })
                    ]
                }, index)),
            uiType === "ResturantMenuList" && Array(6).fill(0).map((item, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: " w-full h-2/6 gap-3 rounded-xl animate-pulse  md:h-3/4  flex flex-wrap mx-5 my-5  border-4 border-blue-200 p-3 md:w-5/12 lg:w-1/4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "w-1/3 h-full md:w-full md:h-2/3 animate-pulse bg-blue-100 rounded-lg"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "w-7/12 h-full flex flex-col gap-1 mt-2 md:w-full md:h-1/3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "animate-pulse bg-blue-100 w-full h-1/6"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "animate-pulse bg-blue-100 w-full h-1/6"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "animate-pulse bg-blue-100 w-full h-1/6"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "animate-pulse bg-blue-100 w-full h-1/6"
                                })
                            ]
                        })
                    ]
                }, index)),
            uiType === "RestaurantMenuList" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "-z-50 h-full w-full",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "w-11/12 h-1/6 flex justify-between gap-4 mx-auto my-5 border-4 border-blue-200 rounded-xl animate-pulse p-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "hidden md:block w-2/12 rounded-xl h-full bg-blue-200"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: " h-full flex flex-col gap-2 w-8/12 mx-auto justify-center",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "h-[15px] w-10/12  bg-blue-200",
                                        children: " "
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "h-[10px] w-10/12  bg-blue-100",
                                        children: " "
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "h-[10px] w-10/12  bg-blue-100",
                                        children: " "
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "w-2/12 rounded-xl h-full bg-blue-200"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: " w-11/12 h-5/6 overflow-y-scroll scrollbar-hide flex flex-col justify-between gap-4 mx-auto my-5  rounded-xl animate-pulse p-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: " h-1/6 flex flex-col gap-2 w-full bg-blue-200 p-2 rounded-xl justify-center",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: " h-full flex flex-col gap-2 w-full bg-blue-300  rounded-xl justify-center"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: " h-1/6 flex flex-col gap-2 w-full bg-blue-200 p-2 rounded-xl justify-center",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: " h-full flex flex-col gap-2 w-full bg-blue-300  rounded-xl justify-center"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: " h-1/6 flex flex-col gap-2 w-full bg-blue-200 p-2 rounded-xl justify-center",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: " h-full flex flex-col gap-2 w-full bg-blue-300  rounded-xl justify-center"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: " h-1/6 flex flex-col gap-2 w-full bg-blue-200 p-2 rounded-xl justify-center",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: " h-full flex flex-col gap-2 w-full bg-blue-300  rounded-xl justify-center"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: " h-1/6 flex flex-col gap-2 w-full bg-blue-200 p-2 rounded-xl justify-center",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: " h-full flex flex-col gap-2 w-full bg-blue-300  rounded-xl justify-center"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $0e2e610bf1b1dc33$export$2e2bcd8739ae039 = $0e2e610bf1b1dc33$var$ShimmerUI;



var $acw62 = parcelRequire("acw62");

var $0832bcb514572bd4$exports = {};
$0832bcb514572bd4$exports = JSON.parse('[{"info":{"id":"361172","name":"Burger Farm","cloudinaryImageId":"e8avnyvqur7u7hbxboio","locality":"Ridhi Sidhi Enclave","areaName":"Saraswati Nagar","costForTwo":"\u20B9200 for two","cuisines":["Burgers","Ice Cream"],"avgRating":4,"feeDetails":{"restaurantId":"361172","fees":[{"name":"BASE_DISTANCE","fee":1400},{"name":"BASE_TIME"},{"name":"ANCILLARY_SURGE_FEE"}],"totalFee":1400},"parentId":"4660","avgRatingString":"4.0","totalRatingsString":"1K+","promoted":true,"adTrackingId":"cid=9593868~p=1~eid=0000018c-072c-320e-6d0c-2aad00d30143~srvts=1700927386126~45826","sla":{"deliveryTime":18,"lastMileTravel":2.5,"serviceability":"SERVICEABLE","slaString":"18 mins","lastMileTravelString":"2.5 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2023-11-25 23:00:00","opened":true},"badges":{},"isOpen":true,"type":"F","badgesV2":{"entityBadges":{"textBased":{},"imageBased":{},"textExtendedBadges":{}}},"aggregatedDiscountInfoV3":{"header":"40% OFF","subHeader":"UPTO \u20B980"},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE","lottie":{},"video":{}}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{}},"analytics":{},"cta":{"link":"swiggy://menu?restaurant_id=361172","text":"RESTAURANT_MENU","type":"DEEPLINK"}},{"info":{"id":"459567","name":"The Spicy Saga","cloudinaryImageId":"z0vnyr2ufktodp6dkd4s","locality":"Jawahar Nagar","areaName":"Saraswati Nagar","costForTwo":"\u20B9150 for two","cuisines":["North Indian","Chinese","American"],"avgRating":3.8,"veg":true,"feeDetails":{"restaurantId":"459567","fees":[{"name":"BASE_DISTANCE","fee":1400},{"name":"BASE_TIME"},{"name":"ANCILLARY_SURGE_FEE"}],"totalFee":1400},"parentId":"214193","avgRatingString":"3.8","totalRatingsString":"500+","sla":{"deliveryTime":18,"lastMileTravel":0.9,"serviceability":"SERVICEABLE","slaString":"18 mins","lastMileTravelString":"0.9 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2023-11-25 22:49:00","opened":true},"badges":{"imageBadges":[{"imageId":"v1695133679/badges/Pure_Veg111.png","description":"pureveg"}]},"isOpen":true,"type":"F","badgesV2":{"entityBadges":{"textBased":{},"imageBased":{"badgeObject":[{"attributes":{"imageId":"v1695133679/badges/Pure_Veg111.png","description":"pureveg"}}]},"textExtendedBadges":{}}},"aggregatedDiscountInfoV3":{"header":"\u20B9125 OFF","subHeader":"ABOVE \u20B9299","discountTag":"FLAT DEAL"},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE","lottie":{},"video":{}}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{}},"analytics":{},"cta":{"link":"swiggy://menu?restaurant_id=459567","text":"RESTAURANT_MENU","type":"DEEPLINK"}},{"info":{"id":"230243","name":"Pratap Vaishno Dhaba","cloudinaryImageId":"hg8trnh2fmbzdscpisas","locality":"Sector 17","areaName":"Saraswati Nagar","costForTwo":"\u20B9100 for two","cuisines":["North Indian","Biryani"],"avgRating":3.4,"veg":true,"feeDetails":{"restaurantId":"230243","fees":[{"name":"BASE_DISTANCE","fee":1400},{"name":"BASE_TIME"},{"name":"ANCILLARY_SURGE_FEE"}],"totalFee":1400},"parentId":"160724","avgRatingString":"3.4","totalRatingsString":"1K+","sla":{"deliveryTime":19,"lastMileTravel":1.1,"serviceability":"SERVICEABLE","slaString":"19 mins","lastMileTravelString":"1.1 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2023-11-25 23:00:00","opened":true},"badges":{"imageBadges":[{"imageId":"v1695133679/badges/Pure_Veg111.png","description":"pureveg"}]},"isOpen":true,"type":"F","badgesV2":{"entityBadges":{"textBased":{},"imageBased":{"badgeObject":[{"attributes":{"imageId":"v1695133679/badges/Pure_Veg111.png","description":"pureveg"}}]},"textExtendedBadges":{}}},"aggregatedDiscountInfoV3":{"header":"\u20B9150 OFF","subHeader":"ABOVE \u20B9249","discountTag":"FLAT DEAL"},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE","lottie":{},"video":{}}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{}},"analytics":{},"cta":{"link":"swiggy://menu?restaurant_id=230243","text":"RESTAURANT_MENU","type":"DEEPLINK"}},{"info":{"id":"151998","name":"Down Town Cafe","cloudinaryImageId":"bihx6du5xu4cykohvlzl","locality":"Block G","areaName":"Saraswati Nagar","costForTwo":"\u20B9100 for two","cuisines":["Pizzas","Fast Food","Chinese","Pastas","Ice Cream","Desserts"],"avgRating":3.9,"veg":true,"feeDetails":{"restaurantId":"151998","fees":[{"name":"BASE_DISTANCE","fee":1400},{"name":"BASE_TIME"},{"name":"ANCILLARY_SURGE_FEE"}],"totalFee":1400},"parentId":"74489","avgRatingString":"3.9","totalRatingsString":"5K+","promoted":true,"adTrackingId":"cid=9556401~p=3~eid=0000018c-072c-320e-6d0c-2aaf00d30332~srvts=1700927386126~45826","sla":{"deliveryTime":20,"lastMileTravel":1.7,"serviceability":"SERVICEABLE","slaString":"20 mins","lastMileTravelString":"1.7 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2023-11-25 23:59:00","opened":true},"badges":{"imageBadges":[{"imageId":"v1695133679/badges/Pure_Veg111.png","description":"pureveg"}]},"isOpen":true,"type":"F","badgesV2":{"entityBadges":{"imageBased":{"badgeObject":[{"attributes":{"imageId":"v1695133679/badges/Pure_Veg111.png","description":"pureveg"}}]},"textExtendedBadges":{},"textBased":{}}},"aggregatedDiscountInfoV3":{"header":"\u20B9125 OFF","subHeader":"ABOVE \u20B9249","discountTag":"FLAT DEAL"},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE","lottie":{},"video":{}}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{}},"analytics":{},"cta":{"link":"swiggy://menu?restaurant_id=151998","text":"RESTAURANT_MENU","type":"DEEPLINK"}},{"info":{"id":"152255","name":"American\'s Pizza With A Twist","cloudinaryImageId":"azjtcreuc4jxenmfjpdb","locality":"Block P","areaName":"Saraswati Nagar","costForTwo":"\u20B9150 for two","cuisines":["Pastas","Burgers","Ice Cream","Pizzas"],"avgRating":3.4,"veg":true,"feeDetails":{"restaurantId":"152255","fees":[{"name":"BASE_DISTANCE","fee":1400},{"name":"BASE_TIME"},{"name":"ANCILLARY_SURGE_FEE"}],"totalFee":1400},"parentId":"31506","avgRatingString":"3.4","totalRatingsString":"1K+","sla":{"deliveryTime":21,"lastMileTravel":2.4,"serviceability":"SERVICEABLE","slaString":"21 mins","lastMileTravelString":"2.4 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2023-11-26 02:00:00","opened":true},"badges":{},"isOpen":true,"type":"F","badgesV2":{"entityBadges":{"textExtendedBadges":{},"textBased":{},"imageBased":{}}},"aggregatedDiscountInfoV3":{"header":"\u20B9125 OFF","subHeader":"ABOVE \u20B9199","discountTag":"FLAT DEAL"},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE","lottie":{},"video":{}}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{}},"analytics":{},"cta":{"link":"swiggy://menu?restaurant_id=152255","text":"RESTAURANT_MENU","type":"DEEPLINK"}},{"info":{"id":"159219","name":"Chanderlok Hotel & Restaurant","cloudinaryImageId":"jt9hjbds4r4wzhwccque","locality":"Hardeep Colony","areaName":"Saraswati Nagar","costForTwo":"\u20B9149 for two","cuisines":["Pastas","Chinese","Burgers","Ice Cream","Biryani"],"avgRating":4,"veg":true,"feeDetails":{"restaurantId":"159219","fees":[{"name":"BASE_DISTANCE","fee":1400},{"name":"BASE_TIME"},{"name":"ANCILLARY_SURGE_FEE"}],"totalFee":1400},"parentId":"57767","avgRatingString":"4.0","totalRatingsString":"1K+","sla":{"deliveryTime":18,"lastMileTravel":0.7,"serviceability":"SERVICEABLE","slaString":"18 mins","lastMileTravelString":"0.7 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2023-11-25 23:00:00","opened":true},"badges":{"imageBadges":[{"imageId":"v1695133679/badges/Pure_Veg111.png","description":"pureveg"}]},"isOpen":true,"aggregatedDiscountInfoV2":{},"type":"F","badgesV2":{"entityBadges":{"textBased":{},"imageBased":{"badgeObject":[{"attributes":{"imageId":"v1695133679/badges/Pure_Veg111.png","description":"pureveg"}}]},"textExtendedBadges":{}}},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE","lottie":{},"video":{}}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{}},"analytics":{},"cta":{"link":"swiggy://menu?restaurant_id=159219","text":"RESTAURANT_MENU","type":"DEEPLINK"}},{"info":{"id":"416082","name":"Anandam Restaurant","cloudinaryImageId":"gogxonpimpfz2tyceagb","locality":"Block G","areaName":"Saraswati Nagar","costForTwo":"\u20B9150 for two","cuisines":["North Indian"],"avgRating":4.2,"veg":true,"feeDetails":{"restaurantId":"416082","fees":[{"name":"BASE_DISTANCE","fee":1400},{"name":"BASE_TIME"},{"name":"ANCILLARY_SURGE_FEE"}],"totalFee":1400},"parentId":"32885","avgRatingString":"4.2","totalRatingsString":"100+","promoted":true,"adTrackingId":"cid=9556432~p=5~eid=0000018c-072c-320e-6d0c-2ab200d3050c~srvts=1700927386126~45826","sla":{"deliveryTime":29,"lastMileTravel":1.9,"serviceability":"SERVICEABLE","slaString":"29 mins","lastMileTravelString":"1.9 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2023-11-25 23:00:00","opened":true},"badges":{"imageBadges":[{"imageId":"v1695133679/badges/Pure_Veg111.png","description":"pureveg"}]},"isOpen":true,"aggregatedDiscountInfoV2":{},"type":"F","badgesV2":{"entityBadges":{"textBased":{},"imageBased":{"badgeObject":[{"attributes":{"imageId":"v1695133679/badges/Pure_Veg111.png","description":"pureveg"}}]},"textExtendedBadges":{}}},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE","lottie":{},"video":{}}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{}},"analytics":{},"cta":{"link":"swiggy://menu?restaurant_id=416082","text":"RESTAURANT_MENU","type":"DEEPLINK"}},{"info":{"id":"274147","name":"The Bonfire","cloudinaryImageId":"mif7l1gmmfglfacegcgq","locality":"Saraswati Nagar","areaName":"Sri Ganganagar Locality","costForTwo":"\u20B9149 for two","cuisines":["North Indian","Biryani"],"avgRating":3.8,"feeDetails":{"restaurantId":"274147","fees":[{"name":"BASE_DISTANCE","fee":1400},{"name":"BASE_TIME"},{"name":"ANCILLARY_SURGE_FEE"}],"totalFee":1400},"parentId":"205684","avgRatingString":"3.8","totalRatingsString":"1K+","sla":{"deliveryTime":17,"lastMileTravel":0.6,"serviceability":"SERVICEABLE","slaString":"17 mins","lastMileTravelString":"0.6 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2023-11-25 23:58:00","opened":true},"badges":{"imageBadges":[{"imageId":"v1690360529/Ratnesh_Badges/Only_on_swiggy_badge_4x.png","description":"OnlyOnSwiggy"},{"imageId":"v1690360529/Ratnesh_Badges/Only_on_swiggy_badge_4x.png","description":"OnlyOnSwiggy"}]},"isOpen":true,"type":"F","badgesV2":{"entityBadges":{"textBased":{},"imageBased":{"badgeObject":[{"attributes":{"imageId":"v1690360529/Ratnesh_Badges/Only_on_swiggy_badge_4x.png","description":"OnlyOnSwiggy"}},{"attributes":{"imageId":"v1690360529/Ratnesh_Badges/Only_on_swiggy_badge_4x.png","description":"OnlyOnSwiggy"}}]},"textExtendedBadges":{}}},"aggregatedDiscountInfoV3":{"header":"\u20B9125 OFF","subHeader":"ABOVE \u20B9199","discountTag":"FLAT DEAL"},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE","lottie":{},"video":{}}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{}},"analytics":{},"cta":{"link":"swiggy://menu?restaurant_id=274147","text":"RESTAURANT_MENU","type":"DEEPLINK"}},{"info":{"id":"151994","name":"Yummy Rolls","cloudinaryImageId":"oxeftnfrbe70ogummfzb","locality":"Block P","areaName":"Saraswati Nagar","costForTwo":"\u20B9149 for two","cuisines":["North Indian","Burgers","Ice Cream","Pizzas"],"avgRating":4,"feeDetails":{"restaurantId":"151994","fees":[{"name":"BASE_DISTANCE","fee":1400},{"name":"BASE_TIME"},{"name":"ANCILLARY_SURGE_FEE"}],"totalFee":1400},"parentId":"228742","avgRatingString":"4.0","totalRatingsString":"1K+","sla":{"deliveryTime":20,"lastMileTravel":2.5,"serviceability":"SERVICEABLE","slaString":"20 mins","lastMileTravelString":"2.5 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2023-11-25 23:00:00","opened":true},"badges":{},"isOpen":true,"type":"F","badgesV2":{"entityBadges":{"textBased":{},"imageBased":{},"textExtendedBadges":{}}},"aggregatedDiscountInfoV3":{"header":"\u20B9125 OFF","subHeader":"ABOVE \u20B9199","discountTag":"FLAT DEAL"},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE","lottie":{},"video":{}}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{}},"analytics":{},"cta":{"link":"swiggy://menu?restaurant_id=151994","text":"RESTAURANT_MENU","type":"DEEPLINK"}},{"info":{"id":"151992","name":"Talk Of The Town, Bahl Foods","cloudinaryImageId":"q3d8ozj36kx27us2khlp","locality":"Kotwali Road","areaName":"Saraswati Nagar","costForTwo":"\u20B9149 for two","cuisines":["North Indian","Biryani"],"avgRating":3.9,"feeDetails":{"restaurantId":"151992","fees":[{"name":"BASE_DISTANCE","fee":1400},{"name":"BASE_TIME"},{"name":"ANCILLARY_SURGE_FEE"}],"totalFee":1400},"parentId":"200312","avgRatingString":"3.9","totalRatingsString":"1K+","promoted":true,"adTrackingId":"cid=9556400~p=6~eid=0000018c-072c-320e-6d0c-2ab300d30656~srvts=1700927386126~45826","sla":{"deliveryTime":22,"lastMileTravel":2.8,"serviceability":"SERVICEABLE","slaString":"22 mins","lastMileTravelString":"2.8 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2023-11-25 23:00:00","opened":true},"badges":{},"isOpen":true,"type":"F","badgesV2":{"entityBadges":{"textBased":{},"imageBased":{},"textExtendedBadges":{}}},"aggregatedDiscountInfoV3":{"header":"\u20B950 OFF","subHeader":"ABOVE \u20B9249","discountTag":"FLAT DEAL"},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE","lottie":{},"video":{}}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{}},"analytics":{},"cta":{"link":"swiggy://menu?restaurant_id=151992","text":"RESTAURANT_MENU","type":"DEEPLINK"}},{"info":{"id":"538406","name":"Shaina Cafe","cloudinaryImageId":"t6jchid5nzeslx7to6gb","locality":"Ridhi Sidhi Mall","areaName":"Saraswati Nagar","costForTwo":"\u20B9200 for two","cuisines":["Fast Food"],"avgRating":3.8,"veg":true,"feeDetails":{"restaurantId":"538406","fees":[{"name":"BASE_DISTANCE","fee":1400},{"name":"BASE_TIME"},{"name":"ANCILLARY_SURGE_FEE"}],"totalFee":1400},"parentId":"180939","avgRatingString":"3.8","totalRatingsString":"100+","sla":{"deliveryTime":21,"lastMileTravel":2.6,"serviceability":"SERVICEABLE","slaString":"21 mins","lastMileTravelString":"2.6 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2023-11-25 22:00:00","opened":true},"badges":{"imageBadges":[{"imageId":"v1695133679/badges/Pure_Veg111.png","description":"pureveg"}]},"isOpen":true,"type":"F","badgesV2":{"entityBadges":{"textBased":{},"imageBased":{"badgeObject":[{"attributes":{"imageId":"v1695133679/badges/Pure_Veg111.png","description":"pureveg"}}]},"textExtendedBadges":{}}},"aggregatedDiscountInfoV3":{"header":"\u20B9125 OFF","subHeader":"ABOVE \u20B9199","discountTag":"FLAT DEAL"},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE","lottie":{},"video":{}}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{}},"analytics":{},"cta":{"link":"swiggy://menu?restaurant_id=538406","text":"RESTAURANT_MENU","type":"DEEPLINK"}},{"info":{"id":"668596","name":"Apna Vaishno Dhaba","cloudinaryImageId":"4b0a80423a5bf1443493578a8a09dd63","locality":"Mukharjee Nagar","areaName":"Saraswati Nagar","costForTwo":"\u20B9300 for two","cuisines":["Indian","Desserts"],"avgRating":4,"veg":true,"feeDetails":{"restaurantId":"668596","fees":[{"name":"BASE_DISTANCE","fee":1400},{"name":"BASE_TIME"},{"name":"ANCILLARY_SURGE_FEE"}],"totalFee":1400},"parentId":"16369","avgRatingString":"4.0","totalRatingsString":"20+","sla":{"deliveryTime":26,"lastMileTravel":2.8,"serviceability":"SERVICEABLE","slaString":"26 mins","lastMileTravelString":"2.8 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2023-11-25 22:00:00","opened":true},"badges":{},"isOpen":true,"aggregatedDiscountInfoV2":{},"type":"F","badgesV2":{"entityBadges":{"textBased":{},"imageBased":{},"textExtendedBadges":{}}},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE","lottie":{},"video":{}}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{}},"analytics":{},"cta":{"link":"swiggy://menu?restaurant_id=668596","text":"RESTAURANT_MENU","type":"DEEPLINK"}},{"info":{"id":"152251","name":"TIPSY by Desert Gold","cloudinaryImageId":"d0a24240cc6350a003fc9c7d48c882d7","locality":"Meera Marg","areaName":"Saraswati Nagar","costForTwo":"\u20B9200 for two","cuisines":["Pastas","Desserts","Chinese","North Indian","Burgers","Ice Cream","Pizzas","Biryani"],"avgRating":3.6,"feeDetails":{"restaurantId":"152251","fees":[{"name":"BASE_DISTANCE","fee":1400},{"name":"BASE_TIME"},{"name":"ANCILLARY_SURGE_FEE"}],"totalFee":1400},"parentId":"374948","avgRatingString":"3.6","totalRatingsString":"100+","promoted":true,"adTrackingId":"cid=9556403~p=7~eid=0000018c-072c-320e-6d0c-2ab400d3071a~srvts=1700927386126~45826","sla":{"deliveryTime":19,"lastMileTravel":1.5,"serviceability":"SERVICEABLE","slaString":"19 mins","lastMileTravelString":"1.5 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2023-11-25 23:00:00","opened":true},"badges":{},"isOpen":true,"type":"F","badgesV2":{"entityBadges":{"imageBased":{},"textExtendedBadges":{},"textBased":{}}},"aggregatedDiscountInfoV3":{"header":"\u20B9125 OFF","subHeader":"ABOVE \u20B9249","discountTag":"FLAT DEAL"},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE","lottie":{},"video":{}}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{}},"analytics":{},"cta":{"link":"swiggy://menu?restaurant_id=152251","text":"RESTAURANT_MENU","type":"DEEPLINK"}},{"info":{"id":"615515","name":"Cakes","cloudinaryImageId":"ypkn32su1echzuqa5w0c","locality":"Jawahar Nagar","areaName":"Saraswati Nagar","costForTwo":"\u20B9600 for two","cuisines":["Bakery"],"avgRating":2.6,"veg":true,"feeDetails":{"restaurantId":"615515","fees":[{"name":"BASE_DISTANCE","fee":1400},{"name":"BASE_TIME"},{"name":"ANCILLARY_SURGE_FEE"}],"totalFee":1400},"parentId":"4861","avgRatingString":"2.6","totalRatingsString":"20+","sla":{"deliveryTime":19,"lastMileTravel":1.5,"serviceability":"SERVICEABLE","slaString":"19 mins","lastMileTravelString":"1.5 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2023-11-25 22:30:00","opened":true},"badges":{"imageBadges":[{"imageId":"v1695133679/badges/Pure_Veg111.png","description":"pureveg"}]},"isOpen":true,"type":"F","badgesV2":{"entityBadges":{"textBased":{},"imageBased":{"badgeObject":[{"attributes":{"imageId":"v1695133679/badges/Pure_Veg111.png","description":"pureveg"}}]},"textExtendedBadges":{}}},"aggregatedDiscountInfoV3":{"header":"\u20B9125 OFF","subHeader":"ABOVE \u20B9199","discountTag":"FLAT DEAL"},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE","lottie":{},"video":{}}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{}},"analytics":{},"cta":{"link":"swiggy://menu?restaurant_id=615515","text":"RESTAURANT_MENU","type":"DEEPLINK"}},{"info":{"id":"741922","name":"Cake","cloudinaryImageId":"24092d9db646efb22e9937b0c62dafac","locality":"Meera Chock","areaName":"Saraswati Nagar","costForTwo":"\u20B9399 for two","cuisines":["Bakery"],"avgRating":3.5,"veg":true,"feeDetails":{"restaurantId":"741922","fees":[{"name":"BASE_DISTANCE","fee":1400},{"name":"BASE_TIME"},{"name":"ANCILLARY_SURGE_FEE"}],"totalFee":1400},"parentId":"3862","avgRatingString":"3.5","totalRatingsString":"8","sla":{"deliveryTime":19,"lastMileTravel":1.4,"serviceability":"SERVICEABLE","slaString":"19 mins","lastMileTravelString":"1.4 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2023-11-25 23:20:00","opened":true},"badges":{"imageBadges":[{"imageId":"v1695133679/badges/Pure_Veg111.png","description":"pureveg"}]},"isOpen":true,"aggregatedDiscountInfoV2":{},"type":"F","badgesV2":{"entityBadges":{"textBased":{},"imageBased":{"badgeObject":[{"attributes":{"imageId":"v1695133679/badges/Pure_Veg111.png","description":"pureveg"}}]},"textExtendedBadges":{}}},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE","lottie":{},"video":{}}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","isNewlyOnboarded":true,"restaurantOfferPresentationInfo":{}},"analytics":{},"cta":{"link":"swiggy://menu?restaurant_id=741922","text":"RESTAURANT_MENU","type":"DEEPLINK"}},{"info":{"id":"153155","name":"Fooderia","cloudinaryImageId":"p1riypgnnojvgl0dtikq","locality":"Sector 17","areaName":"Saraswati Nagar","costForTwo":"\u20B9150 for two","cuisines":["Pastas","Chinese","Burgers","Biryani"],"avgRating":2.8,"veg":true,"feeDetails":{"restaurantId":"153155","fees":[{"name":"BASE_DISTANCE","fee":1400},{"name":"BASE_TIME"},{"name":"ANCILLARY_SURGE_FEE"}],"totalFee":1400},"parentId":"82304","avgRatingString":"2.8","totalRatingsString":"1K+","promoted":true,"adTrackingId":"cid=9556408~p=8~eid=0000018c-072c-320e-6d0c-2ab500d3086d~srvts=1700927386126~45826","sla":{"deliveryTime":17,"lastMileTravel":1.4,"serviceability":"SERVICEABLE","slaString":"17 mins","lastMileTravelString":"1.4 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2023-11-25 23:00:00","opened":true},"badges":{"imageBadges":[{"imageId":"v1695133679/badges/Pure_Veg111.png","description":"pureveg"}]},"isOpen":true,"type":"F","badgesV2":{"entityBadges":{"textBased":{},"imageBased":{"badgeObject":[{"attributes":{"imageId":"v1695133679/badges/Pure_Veg111.png","description":"pureveg"}}]},"textExtendedBadges":{}}},"aggregatedDiscountInfoV3":{"header":"\u20B9125 OFF","subHeader":"ABOVE \u20B9199","discountTag":"FLAT DEAL"},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE","lottie":{},"video":{}}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{}},"analytics":{},"cta":{"link":"swiggy://menu?restaurant_id=153155","text":"RESTAURANT_MENU","type":"DEEPLINK"}},{"info":{"id":"739555","name":"Snakkers","cloudinaryImageId":"5425c8bec985c70b464a29ac6ca1ceeb","locality":"Jawahar Nagar","areaName":"Saraswati Nagar","costForTwo":"\u20B9249 for two","cuisines":["Fast Food","Pizzas","Pastas"],"avgRating":4.2,"feeDetails":{"restaurantId":"739555","fees":[{"name":"BASE_DISTANCE","fee":1400},{"name":"BASE_TIME"},{"name":"ANCILLARY_SURGE_FEE"}],"totalFee":1400},"parentId":"21794","avgRatingString":"4.2","totalRatingsString":"50+","sla":{"deliveryTime":17,"lastMileTravel":0.7,"serviceability":"SERVICEABLE","slaString":"17 mins","lastMileTravelString":"0.7 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2023-11-25 23:59:00","opened":true},"badges":{},"isOpen":true,"type":"F","badgesV2":{"entityBadges":{"textBased":{},"imageBased":{},"textExtendedBadges":{}}},"aggregatedDiscountInfoV3":{"header":"10% OFF","subHeader":"UPTO \u20B940"},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE","lottie":{},"video":{}}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","isNewlyOnboarded":true,"restaurantOfferPresentationInfo":{}},"analytics":{},"cta":{"link":"swiggy://menu?restaurant_id=739555","text":"RESTAURANT_MENU","type":"DEEPLINK"}},{"info":{"id":"680493","name":"Rasoi","cloudinaryImageId":"fcee676df41abe3fa8b474ece9d2b77d","locality":"Jawahar Nagar","areaName":"Saraswati Nagar","costForTwo":"\u20B9298 for two","cuisines":["Beverages","Chinese","Indian","Thalis"],"avgRating":3.9,"veg":true,"feeDetails":{"restaurantId":"680493","fees":[{"name":"BASE_DISTANCE","fee":1400},{"name":"BASE_TIME"},{"name":"ANCILLARY_SURGE_FEE"}],"totalFee":1400},"parentId":"764","avgRatingString":"3.9","totalRatingsString":"100+","sla":{"deliveryTime":16,"lastMileTravel":0.2,"serviceability":"SERVICEABLE","slaString":"16 mins","lastMileTravelString":"0.2 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2023-11-25 23:00:00","opened":true},"badges":{"imageBadges":[{"imageId":"v1695133679/badges/Pure_Veg111.png","description":"pureveg"}]},"isOpen":true,"type":"F","badgesV2":{"entityBadges":{"imageBased":{"badgeObject":[{"attributes":{"imageId":"v1695133679/badges/Pure_Veg111.png","description":"pureveg"}}]},"textExtendedBadges":{},"textBased":{}}},"aggregatedDiscountInfoV3":{"header":"40% OFF","subHeader":"UPTO \u20B980"},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE","lottie":{},"video":{}}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{}},"analytics":{},"cta":{"link":"swiggy://menu?restaurant_id=680493","text":"RESTAURANT_MENU","type":"DEEPLINK"}},{"info":{"id":"157822","name":"Shree Ram Balaji Dhaba","cloudinaryImageId":"qlrhdababkwfm8bawd8y","locality":"Setia Colony","areaName":"Saraswati Nagar","costForTwo":"\u20B9150 for two","cuisines":["North Indian","Biryani"],"avgRating":4.2,"veg":true,"feeDetails":{"restaurantId":"157822","fees":[{"name":"BASE_DISTANCE","fee":1400},{"name":"BASE_TIME"},{"name":"ANCILLARY_SURGE_FEE"}],"totalFee":1400},"parentId":"185345","avgRatingString":"4.2","totalRatingsString":"1K+","promoted":true,"adTrackingId":"cid=9432477~p=9~eid=0000018c-072c-320e-6d0c-2ab700d3092c~srvts=1700927386126~45826","sla":{"deliveryTime":22,"lastMileTravel":2.5,"serviceability":"SERVICEABLE","slaString":"22 mins","lastMileTravelString":"2.5 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2023-11-25 23:00:00","opened":true},"badges":{"imageBadges":[{"imageId":"v1695133679/badges/Pure_Veg111.png","description":"pureveg"}]},"isOpen":true,"aggregatedDiscountInfoV2":{},"type":"F","badgesV2":{"entityBadges":{"imageBased":{"badgeObject":[{"attributes":{"description":"pureveg","imageId":"v1695133679/badges/Pure_Veg111.png"}}]},"textExtendedBadges":{},"textBased":{}}},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE","lottie":{},"video":{}}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{}},"analytics":{},"cta":{"link":"swiggy://menu?restaurant_id=157822","text":"RESTAURANT_MENU","type":"DEEPLINK"}},{"info":{"id":"331880","name":"Punjabi Tadka","cloudinaryImageId":"bjgrjw1bw30vx7fb4cau","locality":"Adarsh Nagar Road","areaName":"Saraswati Nagar","costForTwo":"\u20B9150 for two","cuisines":["Indian","Chinese"],"avgRating":3.7,"feeDetails":{"restaurantId":"331880","fees":[{"name":"BASE_DISTANCE","fee":1400},{"name":"BASE_TIME"},{"name":"ANCILLARY_SURGE_FEE"}],"totalFee":1400},"parentId":"435887","avgRatingString":"3.7","totalRatingsString":"10+","sla":{"deliveryTime":21,"lastMileTravel":2.5,"serviceability":"SERVICEABLE","slaString":"21 mins","lastMileTravelString":"2.5 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2023-11-25 22:00:00","opened":true},"badges":{},"isOpen":true,"type":"F","badgesV2":{"entityBadges":{"textBased":{},"imageBased":{},"textExtendedBadges":{}}},"aggregatedDiscountInfoV3":{"header":"25% OFF","subHeader":"UPTO \u20B965"},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE","lottie":{},"video":{}}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{}},"analytics":{},"cta":{"link":"swiggy://menu?restaurant_id=331880","text":"RESTAURANT_MENU","type":"DEEPLINK"}},{"info":{"id":"198073","name":"Raj Sheronz and Raj lemon & Jeera","cloudinaryImageId":"rrz3ltl5ktywrbmxip1w","locality":"Kedar Chowk","areaName":"Saraswati Nagar","costForTwo":"\u20B9100 for two","cuisines":["Chinese","South Indian","North Indian","Continental","Desserts","Italian","Beverages","Mughlai","Punjabi","Hyderabadi"],"avgRating":3.6,"feeDetails":{"restaurantId":"198073","fees":[{"name":"BASE_DISTANCE","fee":1400},{"name":"BASE_TIME"},{"name":"ANCILLARY_SURGE_FEE"}],"totalFee":1400},"parentId":"165084","avgRatingString":"3.6","totalRatingsString":"500+","promoted":true,"adTrackingId":"cid=9480075~p=10~eid=0000018c-072c-320e-6d0c-2ab800d30a45~srvts=1700927386126~45826","sla":{"deliveryTime":22,"lastMileTravel":3,"serviceability":"SERVICEABLE","slaString":"22 mins","lastMileTravelString":"3.0 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2023-11-25 22:00:00","opened":true},"badges":{},"isOpen":true,"type":"F","badgesV2":{"entityBadges":{"textBased":{},"imageBased":{},"textExtendedBadges":{}}},"aggregatedDiscountInfoV3":{"header":"10% OFF","subHeader":"UPTO \u20B940"},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE","lottie":{},"video":{}}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{}},"analytics":{},"cta":{"link":"swiggy://menu?restaurant_id=198073","text":"RESTAURANT_MENU","type":"DEEPLINK"}},{"info":{"id":"177259","name":"Punjabi Dhaba","cloudinaryImageId":"ozayywaiews52ajwq9in","locality":"Setia Colony","areaName":"Saraswati Nagar","costForTwo":"\u20B9200 for two","cuisines":["North Indian","Punjabi"],"avgRating":1.6,"veg":true,"feeDetails":{"restaurantId":"177259","fees":[{"name":"BASE_DISTANCE","fee":1400},{"name":"BASE_TIME"},{"name":"ANCILLARY_SURGE_FEE"}],"totalFee":1400},"parentId":"1476","avgRatingString":"1.6","totalRatingsString":"1K+","sla":{"deliveryTime":26,"lastMileTravel":1.8,"serviceability":"SERVICEABLE","slaString":"26 mins","lastMileTravelString":"1.8 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2023-11-25 23:01:00","opened":true},"badges":{},"isOpen":true,"type":"F","badgesV2":{"entityBadges":{"textExtendedBadges":{},"textBased":{},"imageBased":{}}},"aggregatedDiscountInfoV3":{"header":"10% OFF","subHeader":"UPTO \u20B9100"},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE","lottie":{},"video":{}}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{}},"analytics":{},"cta":{"link":"swiggy://menu?restaurant_id=177259","text":"RESTAURANT_MENU","type":"DEEPLINK"}},{"info":{"id":"151990","name":"Sip & Bite","cloudinaryImageId":"zcotw9pv1l8mbjxmqs9l","locality":"Block G","areaName":"Saraswati Nagar","costForTwo":"\u20B9100 for two","cuisines":["Pastas","Desserts","Chinese","Burgers","Ice Cream","Pizzas"],"avgRating":3.7,"veg":true,"feeDetails":{"restaurantId":"151990","fees":[{"name":"BASE_DISTANCE","fee":1400},{"name":"BASE_TIME"},{"name":"ANCILLARY_SURGE_FEE"}],"totalFee":1400},"parentId":"188690","avgRatingString":"3.7","totalRatingsString":"1K+","sla":{"deliveryTime":23,"lastMileTravel":1.7,"serviceability":"SERVICEABLE","slaString":"23 mins","lastMileTravelString":"1.7 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2023-11-25 23:59:00","opened":true},"badges":{"imageBadges":[{"imageId":"v1695133679/badges/Pure_Veg111.png","description":"pureveg"}]},"isOpen":true,"type":"F","badgesV2":{"entityBadges":{"textBased":{},"imageBased":{"badgeObject":[{"attributes":{"imageId":"v1695133679/badges/Pure_Veg111.png","description":"pureveg"}}]},"textExtendedBadges":{}}},"aggregatedDiscountInfoV3":{"header":"\u20B9125 OFF","subHeader":"ABOVE \u20B9249","discountTag":"FLAT DEAL"},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE","lottie":{},"video":{}}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{}},"analytics":{},"cta":{"link":"swiggy://menu?restaurant_id=151990","text":"RESTAURANT_MENU","type":"DEEPLINK"}},{"info":{"id":"608093","name":"Silver Spoon","cloudinaryImageId":"ypxmi489woqjtxalkzg6","locality":"Block A","areaName":"Saraswati Nagar","costForTwo":"\u20B9200 for two","cuisines":["Burgers","Pizzas","Beverages"],"avgRating":4.6,"veg":true,"feeDetails":{"restaurantId":"608093","fees":[{"name":"BASE_DISTANCE","fee":1400},{"name":"BASE_TIME"},{"name":"ANCILLARY_SURGE_FEE"}],"totalFee":1400},"parentId":"11717","avgRatingString":"4.6","totalRatingsString":"10+","sla":{"deliveryTime":22,"lastMileTravel":2.6,"serviceability":"SERVICEABLE","slaString":"22 mins","lastMileTravelString":"2.6 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2023-11-25 23:45:00","opened":true},"badges":{"imageBadges":[{"imageId":"v1695133679/badges/Pure_Veg111.png","description":"pureveg"}]},"isOpen":true,"type":"F","badgesV2":{"entityBadges":{"imageBased":{"badgeObject":[{"attributes":{"imageId":"v1695133679/badges/Pure_Veg111.png","description":"pureveg"}}]},"textExtendedBadges":{},"textBased":{}}},"aggregatedDiscountInfoV3":{"header":"30% OFF","subHeader":"UPTO \u20B975"},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE","lottie":{},"video":{}}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{}},"analytics":{},"cta":{"link":"swiggy://menu?restaurant_id=608093","text":"RESTAURANT_MENU","type":"DEEPLINK"}},{"info":{"id":"438355","name":"Hudson Chopsticks","cloudinaryImageId":"csdr52szfuon6z2wmjpv","locality":"Ridhi Sidhi Mall","areaName":"Saraswati Nagar","costForTwo":"\u20B9300 for two","cuisines":["Chinese","Thai","Asian","Snacks","Tibetan","Nepalese","Pan-Asian","Seafood","Beverages","Desserts","Barbecue","Grill","Fast Food"],"avgRating":4,"feeDetails":{"restaurantId":"438355","fees":[{"name":"BASE_DISTANCE","fee":1400},{"name":"BASE_TIME"},{"name":"ANCILLARY_SURGE_FEE"}],"totalFee":1400},"parentId":"7129","avgRatingString":"4.0","totalRatingsString":"500+","sla":{"deliveryTime":20,"lastMileTravel":2.6,"serviceability":"SERVICEABLE","slaString":"20 mins","lastMileTravelString":"2.6 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2023-11-25 23:00:00","opened":true},"badges":{},"isOpen":true,"aggregatedDiscountInfoV2":{},"type":"F","badgesV2":{"entityBadges":{"imageBased":{},"textExtendedBadges":{},"textBased":{}}},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE","lottie":{},"video":{}}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{}},"analytics":{},"cta":{"link":"swiggy://menu?restaurant_id=438355","text":"RESTAURANT_MENU","type":"DEEPLINK"}}]');


const $ed66c99b456fe484$export$3763d9602159e397 = (setDefaultRestaurants, setRestaurantsList)=>{
    (0, $acw62.useEffect)(()=>{
        fetchData();
    }, []);
    const fetchData = async ()=>{
        try {
            const response = await fetch((0, $6d4b57eddd9e5082$export$46821acf14590a5));
            const data = await response.json();
            setTimeout(()=>{
                setDefaultRestaurants(data?.data?.data?.cards[1]?.card?.card?.gridElements?.infoWithStyle?.restaurants);
                setRestaurantsList(data?.data?.data?.cards[1]?.card?.card?.gridElements?.infoWithStyle?.restaurants);
            }, 500);
        } catch (error) {
            setTimeout(()=>{
                setDefaultRestaurants($0832bcb514572bd4$exports);
                setRestaurantsList($0832bcb514572bd4$exports);
            }, 500);
        }
    };
};



parcelRequire("acw62");
// This component is responsible for filtering the list of restaurants according the filter basis
const $dc743b2b44554668$var$FilterRestaurants = (props)=>{
    const { defaultRestaurants: defaultRestaurants, setRestaurantsList: setRestaurantsList, setNotFiltered: setNotFiltered, notFiltered: notFiltered } = props;
    //this is used to get filtered list of restaurants according to filter basis and set the state variable (restaurantsList) with filtered list variable 
    const filterTopRatingRestaurants = (e, filterBasis)=>{
        e.preventDefault();
        let filteredRestaurants = [];
        filteredRestaurants = defaultRestaurants.filter((restaurant)=>{
            switch(filterBasis){
                case "rating":
                    return restaurant?.info?.avgRating > 4.5;
                case "time":
                    return restaurant?.info?.sla?.deliveryTime < 25;
                case "cost":
                    return Number(restaurant?.info?.costForTwo.split(" ")[0].split("\u20B9")[1]) < 250;
                case "veg":
                    return restaurant?.info?.veg === true;
                default:
                    return restaurant;
            }
        });
        if (notFiltered === true && filteredRestaurants.length > 0) setNotFiltered(false);
        setRestaurantsList([]);
        setTimeout(()=>{
            if (filteredRestaurants.length === 0) setNotFiltered(true);
            else {
                setNotFiltered(false);
                setRestaurantsList(filteredRestaurants);
            }
        }, 1000);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "w-screen h-1/3 flex gap-4 overflow-y-hidden overflow-x-scroll px-5 items-center justify-center scrollbar-hide ",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                disabled: notFiltered,
                name: "rating",
                onClick: (e)=>{
                    let filterBasis = "rating";
                    filterTopRatingRestaurants(e, filterBasis);
                },
                className: "disabled:opacity-30 transition-all ease-linear duration-300 min-w-max h-fit ml-48  md:w-1/4 px-4 py-2 bg-blue-100 rounded-3xl hover:bg-blue-900 hover:text-white md:ml-0",
                children: "Rating 4.5+."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                disabled: notFiltered,
                name: "time",
                onClick: (e)=>{
                    let filterBasis = "time";
                    filterTopRatingRestaurants(e, filterBasis);
                },
                className: "disabled:opacity-30 transition-all ease-linear duration-300 min-w-max h-fit  md:w-1/4 px-4 py-2 bg-blue-100 rounded-3xl hover:bg-blue-900 hover:text-white",
                children: "Fast Delivery"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                disabled: notFiltered,
                name: "veg",
                onClick: (e)=>{
                    let filterBasis = "veg";
                    filterTopRatingRestaurants(e, filterBasis);
                },
                className: "disabled:opacity-30 transition-all ease-linear duration-300 min-w-max h-fit  md:w-1/4 break-normal py-2 px-4 bg-blue-100 rounded-3xl hover:bg-blue-900 hover:text-white ",
                children: "Veg"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                disabled: notFiltered,
                name: "cost",
                onClick: (e)=>{
                    let filterBasis = "cost";
                    filterTopRatingRestaurants(e, filterBasis);
                },
                className: "disabled:opacity-30 transition-all ease-linear duration-300 min-w-max h-fit md:w-1/4 px-4 py-2 bg-blue-100 rounded-3xl hover:bg-blue-900 hover:text-white",
                children: "Cost Less Than 250"
            })
        ]
    });
};
var $dc743b2b44554668$export$2e2bcd8739ae039 = $dc743b2b44554668$var$FilterRestaurants;


// Render Homepage Page Component
const $00b513cc47574162$var$HomePage = ()=>{
    // create three state variable one for actual restaurants list,  for default restaurants list and at last third for finding if restaurant is filtered or not
    const [defaultRestaurants, setDefaultRestaurants] = (0, $acw62.useState)([]);
    const [restaurantsList, setRestaurantsList] = (0, $acw62.useState)([]);
    const [notFiltered, setNotFiltered] = (0, $acw62.useState)(false);
    // fetch restaurants data and set it in defaultRestaurants state and restaurantsList state
    (0, $ed66c99b456fe484$export$3763d9602159e397)(setDefaultRestaurants, setRestaurantsList);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "h-[80vh]",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "h-1/6 pt-2 ",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7081eca13e312070$export$2e2bcd8739ae039), {
                        notSearchFiltered: notFiltered,
                        setSearchNotFiltered: setNotFiltered,
                        defaultRestaurants: defaultRestaurants,
                        setRestaurantsList: setRestaurantsList
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dc743b2b44554668$export$2e2bcd8739ae039), {
                        defaultRestaurants: defaultRestaurants,
                        setRestaurantsList: setRestaurantsList,
                        notFiltered: notFiltered,
                        setNotFiltered: setNotFiltered
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: " h-5/6 overflow-y-scroll overflow-x-hidden flex flex-wrap md:pb-6 scrollbar-hide",
                children: [
                    // show shimmer Ui while fetching data is not completing 
                    restaurantsList?.length === 0 && notFiltered === false && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0e2e610bf1b1dc33$export$2e2bcd8739ae039), {
                        uiType: "ResturantCardList"
                    }),
                    // show no result found if filtered list is empty
                    restaurantsList?.length === 0 && notFiltered === true && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "w-full h-full flex flex-col item-center gap-4 pt-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                className: "text-xl text-center md:text-3xl",
                                children: "No Resturants Found"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "text-lg py-1 px-2  bg-white border border-blue-900 text-blue-900 transition-all ease-in-out duration-300 hover:bg-blue-900 hover:text-white  rounded-xl md:w-4/12 mx-auto md:p-2 md:text-2xl",
                                onClick: ()=>{
                                    setNotFiltered(false);
                                    setTimeout(()=>{
                                        setRestaurantsList(defaultRestaurants);
                                    }, 1000);
                                },
                                children: "Go To Restaurant List"
                            })
                        ]
                    }),
                    // show resturant card list
                    restaurantsList?.length > 0 && notFiltered === false && restaurantsList?.map((restaurant)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bea13f367d75ec6c$export$2e2bcd8739ae039), {
                            restaurant: restaurant?.info
                        }, restaurant?.info?.id))
                ]
            })
        ]
    });
};
var $00b513cc47574162$export$2e2bcd8739ae039 = $00b513cc47574162$var$HomePage;



parcelRequire("acw62");


var $i4CZ2 = parcelRequire("i4CZ2");
function $b8f57191916382d3$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $b8f57191916382d3$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b8f57191916382d3$export$2e2bcd8739ae039(o);
}



function $96eac03571e01dbf$export$2e2bcd8739ae039(input, hint) {
    if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}


function $3a21fd50cbcd11cf$export$2e2bcd8739ae039(arg) {
    var key = (0, $96eac03571e01dbf$export$2e2bcd8739ae039)(arg, "string");
    return (0, $b8f57191916382d3$export$2e2bcd8739ae039)(key) === "symbol" ? key : String(key);
}


function $f329557dcab6d0bb$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $3a21fd50cbcd11cf$export$2e2bcd8739ae039)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $983350b7b3960a26$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $983350b7b3960a26$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $983350b7b3960a26$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $983350b7b3960a26$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $ad4393542232627c$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + "use the non-minified dev environment for full errors. ";
}
// Inlined version of the `symbol-observable` polyfill
var $ad4393542232627c$var$$$observable = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $ad4393542232627c$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var $ad4393542232627c$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $ad4393542232627c$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $ad4393542232627c$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $ad4393542232627c$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $ad4393542232627c$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $ad4393542232627c$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($ad4393542232627c$var$isDate(val)) return "date";
    if ($ad4393542232627c$var$isError(val)) return "error";
    var constructorName = $ad4393542232627c$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $ad4393542232627c$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $ad4393542232627c$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $ad4393542232627c$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $ad4393542232627c$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $ad4393542232627c$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($ad4393542232627c$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($ad4393542232627c$var$formatProdErrorMessage(1));
        return enhancer($ad4393542232627c$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== "function") throw new Error($ad4393542232627c$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($ad4393542232627c$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($ad4393542232627c$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($ad4393542232627c$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($ad4393542232627c$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$ad4393542232627c$var$isPlainObject(action)) throw new Error($ad4393542232627c$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($ad4393542232627c$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($ad4393542232627c$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($ad4393542232627c$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $ad4393542232627c$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($ad4393542232627c$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$ad4393542232627c$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $ad4393542232627c$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$ad4393542232627c$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $ad4393542232627c$export$8928921ea2d3b126 = $ad4393542232627c$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $ad4393542232627c$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $ad4393542232627c$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $ad4393542232627c$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$ad4393542232627c$var$isPlainObject(inputState)) return "The " + argumentName + ' has unexpected type of "' + $ad4393542232627c$var$kindOf(inputState) + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $ad4393542232627c$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? "keys" : "key") + " " + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function $ad4393542232627c$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $ad4393542232627c$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($ad4393542232627c$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $ad4393542232627c$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($ad4393542232627c$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $ad4393542232627c$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $ad4393542232627c$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error($ad4393542232627c$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $ad4393542232627c$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $ad4393542232627c$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $ad4393542232627c$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($ad4393542232627c$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $ad4393542232627c$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $ad4393542232627c$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $ad4393542232627c$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($ad4393542232627c$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $ad4393542232627c$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}


// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var $7062a3595350e02d$var$NOT_FOUND = "NOT_FOUND";
function $7062a3595350e02d$var$createSingletonCache(equals) {
    var entry;
    return {
        get: function get(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $7062a3595350e02d$var$NOT_FOUND;
        },
        put: function put(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function getEntries() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function clear() {
            entry = undefined;
        }
    };
}
function $7062a3595350e02d$var$createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        }); // We found a cached entry
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        } // No entry found in cache, return sentinel
        return $7062a3595350e02d$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $7062a3595350e02d$var$NOT_FOUND) {
            // TODO Is unshift slow?
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $7062a3595350e02d$export$e0b28855d0126ccc = function defaultEqualityCheck(a, b) {
    return a === b;
};
function $7062a3595350e02d$export$823674481ed171f9(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
         // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $7062a3595350e02d$export$281bff7f05488aa2(func, equalityCheckOrOptions) {
    var providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions$equa = providedOptions.equalityCheck, equalityCheck = _providedOptions$equa === void 0 ? $7062a3595350e02d$export$e0b28855d0126ccc : _providedOptions$equa, _providedOptions$maxS = providedOptions.maxSize, maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = $7062a3595350e02d$export$823674481ed171f9(equalityCheck);
    var cache = maxSize === 1 ? $7062a3595350e02d$var$createSingletonCache(comparator) : $7062a3595350e02d$var$createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons
    function memoized() {
        var value = cache.get(arguments);
        if (value === $7062a3595350e02d$var$NOT_FOUND) {
            // @ts-ignore
            value = func.apply(null, arguments);
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) value = matchingEntry.value;
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}


function $501bc638b8425ea6$var$getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === "function";
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep === "function" ? "function " + (dep.name || "unnamed") + "()" : typeof dep;
        }).join(", ");
        throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
    }
    return dependencies;
}
function $501bc638b8425ea6$export$5943f4447f6ef248(memoize) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    var createSelector = function createSelector() {
        for(var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var _recomputations = 0;
        var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
        // So, start by declaring the default value here.
        // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)
        var directlyPassedOptions = {
            memoizeOptions: undefined
        }; // Normally, the result func or "output selector" is the last arg
        var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc; // and pop the real result func off
            resultFunc = funcs.pop();
        }
        if (typeof resultFunc !== "function") throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
         // Determine which set of options we're using. Prefer options passed directly,
        // but fall back to options given to createSelectorCreator.
        var _directlyPassedOption = directlyPassedOptions, _directlyPassedOption2 = _directlyPassedOption.memoizeOptions, memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
        // is an array. In most libs I've looked at, it's an equality function or options object.
        // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
        // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
        // we wrap it in an array so we can apply it.
        var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [
            memoizeOptions
        ];
        var dependencies = $501bc638b8425ea6$var$getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                _recomputations++; // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = memoize(function dependenciesChecker() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            // @ts-ignore
            params.push(dependencies[i].apply(null, arguments));
             // apply arguments instead of spreading for performance.
            _lastResult = memoizedResultFunc.apply(null, params);
            return _lastResult;
        });
        Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            lastResult: function lastResult() {
                return _lastResult;
            },
            recomputations: function recomputations() {
                return _recomputations;
            },
            resetRecomputations: function resetRecomputations() {
                return _recomputations = 0;
            }
        });
        return selector;
    }; // @ts-ignore
    return createSelector;
}
var $501bc638b8425ea6$export$595d22ed68ca2841 = /* #__PURE__ */ $501bc638b8425ea6$export$5943f4447f6ef248((0, $7062a3595350e02d$export$281bff7f05488aa2));
var $501bc638b8425ea6$export$75979cfcd91bf38f = function createStructuredSelector(selectors, selectorCreator) {
    if (selectorCreator === void 0) selectorCreator = $501bc638b8425ea6$export$595d22ed68ca2841;
    if (typeof selectors !== "object") throw new Error("createStructuredSelector expects first argument to be an object " + ("where each property is a selector, instead received a " + typeof selectors));
    var objectKeys = Object.keys(selectors);
    var resultSelector = selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
    return resultSelector;
};


/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */ function $ac5d5956ce0b399b$var$createThunkMiddleware(extraArgument) {
    // Standard Redux middleware definition pattern:
    // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
    var middleware = function middleware(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                // The thunk middleware looks for any functions that were passed to `store.dispatch`.
                // If this "action" is really a function, call it and return the result.
                if (typeof action === "function") // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
                return action(dispatch, getState, extraArgument);
                 // Otherwise, pass the action down the middleware chain as usual
                return next(action);
            };
        };
    };
    return middleware;
}
var $ac5d5956ce0b399b$var$thunk = $ac5d5956ce0b399b$var$createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks
$ac5d5956ce0b399b$var$thunk.withExtraArgument = $ac5d5956ce0b399b$var$createThunkMiddleware;
var $ac5d5956ce0b399b$export$2e2bcd8739ae039 = $ac5d5956ce0b399b$var$thunk;


var $cfae44f0dfdf62c0$exports = {};
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = $cfae44f0dfdf62c0$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};


var $74cf642ba7fa99c2$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $74cf642ba7fa99c2$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $74cf642ba7fa99c2$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
var $74cf642ba7fa99c2$var$__defProp = Object.defineProperty;
var $74cf642ba7fa99c2$var$__defProps = Object.defineProperties;
var $74cf642ba7fa99c2$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $74cf642ba7fa99c2$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $74cf642ba7fa99c2$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $74cf642ba7fa99c2$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $74cf642ba7fa99c2$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $74cf642ba7fa99c2$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $74cf642ba7fa99c2$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($74cf642ba7fa99c2$var$__hasOwnProp.call(b, prop)) $74cf642ba7fa99c2$var$__defNormalProp(a, prop, b[prop]);
    if ($74cf642ba7fa99c2$var$__getOwnPropSymbols) for(var _i = 0, _c = $74cf642ba7fa99c2$var$__getOwnPropSymbols(b); _i < _c.length; _i++){
        var prop = _c[_i];
        if ($74cf642ba7fa99c2$var$__propIsEnum.call(b, prop)) $74cf642ba7fa99c2$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $74cf642ba7fa99c2$var$__spreadProps = function(a, b) {
    return $74cf642ba7fa99c2$var$__defProps(a, $74cf642ba7fa99c2$var$__getOwnPropDescs(b));
};
var $74cf642ba7fa99c2$var$__async = function(__this, __arguments, generator) {
    return new Promise(function(resolve, reject) {
        var fulfilled = function(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function(value) {
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function(x) {
            return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
var $74cf642ba7fa99c2$export$a5d3c27355e35910 = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var selector = (0, $501bc638b8425ea6$export$595d22ed68ca2841).apply(void 0, args);
    var wrappedSelector = function(value) {
        var rest = [];
        for(var _i = 1; _i < arguments.length; _i++)rest[_i - 1] = arguments[_i];
        return selector.apply(void 0, $74cf642ba7fa99c2$var$__spreadArray([
            (0, $i4CZ2.isDraft)(value) ? (0, $i4CZ2.current)(value) : value
        ], rest));
    };
    return wrappedSelector;
};
var $74cf642ba7fa99c2$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $ad4393542232627c$export$f672e0b6f7222cd7;
    return (0, $ad4393542232627c$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $74cf642ba7fa99c2$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop2) {
        return noop2;
    };
};
// src/isPlainObject.ts
function $74cf642ba7fa99c2$export$53b83ca8eaab0383(value) {
    if (typeof value !== "object" || value === null) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/tsHelpers.ts
var $74cf642ba7fa99c2$var$hasMatchFunction = function(v) {
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $74cf642ba7fa99c2$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, args);
            if (!prepared) throw new Error("prepareAction did not return an object");
            return $74cf642ba7fa99c2$var$__spreadValues($74cf642ba7fa99c2$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = function() {
        return "" + type;
    };
    actionCreator.type = type;
    actionCreator.match = function(action) {
        return action.type === type;
    };
    return actionCreator;
}
function $74cf642ba7fa99c2$export$b956e38827fca970(action) {
    return $74cf642ba7fa99c2$export$53b83ca8eaab0383(action) && "type" in action;
}
function $74cf642ba7fa99c2$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && $74cf642ba7fa99c2$var$hasMatchFunction(action);
}
function $74cf642ba7fa99c2$export$ebd532f9034651f3(action) {
    return $74cf642ba7fa99c2$export$b956e38827fca970(action) && typeof action.type === "string" && Object.keys(action).every($74cf642ba7fa99c2$var$isValidKey);
}
function $74cf642ba7fa99c2$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
function $74cf642ba7fa99c2$export$e2b5c5db9e2009fd(actionCreator) {
    return "" + actionCreator;
}
// src/actionCreatorInvariantMiddleware.ts
function $74cf642ba7fa99c2$var$getMessage(type) {
    var splitType = type ? ("" + type).split("/") : [];
    var actionName = splitType[splitType.length - 1] || "actionCreator";
    return 'Detected an action creator with type "' + (type || "unknown") + "\" being dispatched. \nMake sure you're calling the action creator before dispatching, i.e. `dispatch(" + actionName + "())` instead of `dispatch(" + actionName + ")`. This is necessary even if the action has no payload.";
}
function $74cf642ba7fa99c2$export$6a1fcb4ceef578f(options) {
    if (options === void 0) options = {};
    var _c, isActionCreator2;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
function $74cf642ba7fa99c2$var$getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function(fn) {
            var started = Date.now();
            try {
                return fn();
            } finally{
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function() {
            if (elapsed > maxDelay) console.warn(fnName + " took " + elapsed + "ms, which is more than the warning threshold of " + maxDelay + "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that.");
        }
    };
}
var $74cf642ba7fa99c2$export$20df1e9bd1a54f25 = /** @class */ function(_super) {
    $74cf642ba7fa99c2$var$__extends(MiddlewareArray, _super);
    function MiddlewareArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, MiddlewareArray.prototype);
        return _this;
    }
    Object.defineProperty(MiddlewareArray, Symbol.species, {
        get: function() {
            return MiddlewareArray;
        },
        enumerable: false,
        configurable: true
    });
    MiddlewareArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    MiddlewareArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (MiddlewareArray.bind.apply(MiddlewareArray, $74cf642ba7fa99c2$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (MiddlewareArray.bind.apply(MiddlewareArray, $74cf642ba7fa99c2$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return MiddlewareArray;
}(Array);
var $74cf642ba7fa99c2$export$490d10040a0cbe8a = /** @class */ function(_super) {
    $74cf642ba7fa99c2$var$__extends(EnhancerArray, _super);
    function EnhancerArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, EnhancerArray.prototype);
        return _this;
    }
    Object.defineProperty(EnhancerArray, Symbol.species, {
        get: function() {
            return EnhancerArray;
        },
        enumerable: false,
        configurable: true
    });
    EnhancerArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    EnhancerArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (EnhancerArray.bind.apply(EnhancerArray, $74cf642ba7fa99c2$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (EnhancerArray.bind.apply(EnhancerArray, $74cf642ba7fa99c2$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return EnhancerArray;
}(Array);
function $74cf642ba7fa99c2$var$freezeDraftable(val) {
    return (0, $i4CZ2.isDraftable)(val) ? (0, $i4CZ2.default)(val, function() {}) : val;
}
// src/immutableStateInvariantMiddleware.ts
var $74cf642ba7fa99c2$var$isProduction = true;
var $74cf642ba7fa99c2$var$prefix = "Invariant failed";
function $74cf642ba7fa99c2$var$invariant(condition, message) {
    if (condition) return;
    if ($74cf642ba7fa99c2$var$isProduction) throw new Error($74cf642ba7fa99c2$var$prefix);
    throw new Error($74cf642ba7fa99c2$var$prefix + ": " + (message || ""));
}
function $74cf642ba7fa99c2$var$stringify(obj, serializer, indent, decycler) {
    return JSON.stringify(obj, $74cf642ba7fa99c2$var$getSerialize(serializer, decycler), indent);
}
function $74cf642ba7fa99c2$var$getSerialize(serializer, decycler) {
    var stack = [], keys = [];
    if (!decycler) decycler = function(_, value) {
        if (stack[0] === value) return "[Circular ~]";
        return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
    };
    return function(key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value)) value = decycler.call(this, key, value);
        } else stack.push(value);
        return serializer == null ? value : serializer.call(this, key, value);
    };
}
function $74cf642ba7fa99c2$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $74cf642ba7fa99c2$var$trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = $74cf642ba7fa99c2$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function() {
            return $74cf642ba7fa99c2$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $74cf642ba7fa99c2$var$trackProperties(isImmutable, ignorePaths, obj, path, checkedObjects) {
    if (ignorePaths === void 0) ignorePaths = [];
    if (path === void 0) path = "";
    if (checkedObjects === void 0) checkedObjects = new Set();
    var tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(var key in obj){
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $74cf642ba7fa99c2$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $74cf642ba7fa99c2$var$detectMutations(isImmutable, ignoredPaths, trackedProperty, obj, sameParentRef, path) {
    if (ignoredPaths === void 0) ignoredPaths = [];
    if (sameParentRef === void 0) sameParentRef = false;
    if (path === void 0) path = "";
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    var keysToDetect = {};
    for(var key in trackedProperty.children)keysToDetect[key] = true;
    for(var key in obj)keysToDetect[key] = true;
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_1 = function(key) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        var result = $74cf642ba7fa99c2$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return {
            value: result
        };
    };
    for(var key in keysToDetect){
        var state_1 = _loop_1(key);
        if (typeof state_1 === "object") return state_1.value;
    }
    return {
        wasMutated: false
    };
}
function $74cf642ba7fa99c2$export$9181bb1a5474289(options) {
    if (options === void 0) options = {};
    var _c, isImmutable, ignoredPaths, _d, warnAfter, ignore, track;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/serializableStateInvariantMiddleware.ts
function $74cf642ba7fa99c2$export$77670485918dab4e(val) {
    var type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || $74cf642ba7fa99c2$export$53b83ca8eaab0383(val);
}
function $74cf642ba7fa99c2$export$ada5dca0b571bc7(value, path, isSerializable, getEntries, ignoredPaths, cache) {
    if (path === void 0) path = "";
    if (isSerializable === void 0) isSerializable = $74cf642ba7fa99c2$export$77670485918dab4e;
    if (ignoredPaths === void 0) ignoredPaths = [];
    var foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_2 = function(key, nestedValue) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        if (!isSerializable(nestedValue)) return {
            value: {
                keyPath: nestedPath,
                value: nestedValue
            }
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $74cf642ba7fa99c2$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return {
                value: foundNestedSerializable
            };
        }
    };
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _c = entries_1[_i], key = _c[0], nestedValue = _c[1];
        var state_2 = _loop_2(key, nestedValue);
        if (typeof state_2 === "object") return state_2.value;
    }
    if (cache && $74cf642ba7fa99c2$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $74cf642ba7fa99c2$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for(var _i = 0, _c = Object.values(value); _i < _c.length; _i++){
        var nestedValue = _c[_i];
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$74cf642ba7fa99c2$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $74cf642ba7fa99c2$export$6dea1aad6dac5ac2(options) {
    if (options === void 0) options = {};
    var _c, isSerializable, getEntries, _d, ignoredActions, _e, ignoredActionPaths, _f, ignoredPaths, _g, warnAfter, _h, ignoreState, _j, ignoreActions, _k, disableCache, cache;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/getDefaultMiddleware.ts
function $74cf642ba7fa99c2$var$isBoolean(x) {
    return typeof x === "boolean";
}
function $74cf642ba7fa99c2$var$curryGetDefaultMiddleware() {
    return function curriedGetDefaultMiddleware(options) {
        return $74cf642ba7fa99c2$export$36c1185aeee5b0a6(options);
    };
}
function $74cf642ba7fa99c2$export$36c1185aeee5b0a6(options) {
    if (options === void 0) options = {};
    var _c = options.thunk, thunk = _c === void 0 ? true : _c, _d = options.immutableCheck, immutableCheck = _d === void 0 ? true : _d, _e = options.serializableCheck, serializableCheck = _e === void 0 ? true : _e, _f = options.actionCreatorCheck, actionCreatorCheck = _f === void 0 ? true : _f;
    var middlewareArray = new $74cf642ba7fa99c2$export$20df1e9bd1a54f25();
    if (thunk) {
        if ($74cf642ba7fa99c2$var$isBoolean(thunk)) middlewareArray.push((0, $ac5d5956ce0b399b$export$2e2bcd8739ae039));
        else middlewareArray.push((0, $ac5d5956ce0b399b$export$2e2bcd8739ae039).withExtraArgument(thunk.extraArgument));
    }
    var immutableOptions, serializableOptions, actionCreatorOptions;
    return middlewareArray;
}
// src/configureStore.ts
var $74cf642ba7fa99c2$var$IS_PRODUCTION = true;
function $74cf642ba7fa99c2$export$7d8a5b498da695ac(options) {
    var curriedGetDefaultMiddleware = $74cf642ba7fa99c2$var$curryGetDefaultMiddleware();
    var _c = options || {}, _d = _c.reducer, reducer = _d === void 0 ? void 0 : _d, _e = _c.middleware, middleware = _e === void 0 ? curriedGetDefaultMiddleware() : _e, _f = _c.devTools, devTools = _f === void 0 ? true : _f, _g = _c.preloadedState, preloadedState = _g === void 0 ? void 0 : _g, _h = _c.enhancers, enhancers = _h === void 0 ? void 0 : _h;
    var rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ($74cf642ba7fa99c2$export$53b83ca8eaab0383(reducer)) rootReducer = (0, $ad4393542232627c$export$66e4520cdb265d18)(reducer);
    else throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
    var finalMiddleware = middleware;
    if (typeof finalMiddleware === "function") {
        finalMiddleware = finalMiddleware(curriedGetDefaultMiddleware);
        if (!$74cf642ba7fa99c2$var$IS_PRODUCTION && !Array.isArray(finalMiddleware)) throw new Error("when using a middleware builder function, an array of middleware must be returned");
    }
    if (!$74cf642ba7fa99c2$var$IS_PRODUCTION && finalMiddleware.some(function(item) {
        return typeof item !== "function";
    })) throw new Error("each middleware provided to configureStore must be a function");
    var middlewareEnhancer = (0, $ad4393542232627c$export$9ff26e0402cc7b7).apply(void 0, finalMiddleware);
    var finalCompose = (0, $ad4393542232627c$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $74cf642ba7fa99c2$var$composeWithDevTools($74cf642ba7fa99c2$var$__spreadValues({
        trace: !$74cf642ba7fa99c2$var$IS_PRODUCTION
    }, typeof devTools === "object" && devTools));
    var defaultEnhancers = new $74cf642ba7fa99c2$export$490d10040a0cbe8a(middlewareEnhancer);
    var storeEnhancers = defaultEnhancers;
    if (Array.isArray(enhancers)) storeEnhancers = $74cf642ba7fa99c2$var$__spreadArray([
        middlewareEnhancer
    ], enhancers);
    else if (typeof enhancers === "function") storeEnhancers = enhancers(defaultEnhancers);
    var composedEnhancer = finalCompose.apply(void 0, storeEnhancers);
    return (0, $ad4393542232627c$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $74cf642ba7fa99c2$var$executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function(typeOrActionCreator, reducer) {
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error("`builder.addCase` cannot be called with an empty action type");
            if (type in actionsMap) throw new Error("`builder.addCase` cannot be called with two reducers for the same action type");
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function(matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase: function(reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $74cf642ba7fa99c2$var$isStateFunction(x) {
    return typeof x === "function";
}
var $74cf642ba7fa99c2$var$hasWarnedAboutObjectNotation = false;
function $74cf642ba7fa99c2$export$473eb76d322d0290(initialState, mapOrBuilderCallback, actionMatchers, defaultCaseReducer) {
    if (actionMatchers === void 0) actionMatchers = [];
    var _c = typeof mapOrBuilderCallback === "function" ? $74cf642ba7fa99c2$var$executeReducerBuilderCallback(mapOrBuilderCallback) : [
        mapOrBuilderCallback,
        actionMatchers,
        defaultCaseReducer
    ], actionsMap = _c[0], finalActionMatchers = _c[1], finalDefaultCaseReducer = _c[2];
    var getInitialState;
    if ($74cf642ba7fa99c2$var$isStateFunction(initialState)) getInitialState = function() {
        return $74cf642ba7fa99c2$var$freezeDraftable(initialState());
    };
    else {
        var frozenInitialState_1 = $74cf642ba7fa99c2$var$freezeDraftable(initialState);
        getInitialState = function() {
            return frozenInitialState_1;
        };
    }
    function reducer(state, action) {
        if (state === void 0) state = getInitialState();
        var caseReducers = $74cf642ba7fa99c2$var$__spreadArray([
            actionsMap[action.type]
        ], finalActionMatchers.filter(function(_c) {
            var matcher = _c.matcher;
            return matcher(action);
        }).map(function(_c) {
            var reducer2 = _c.reducer;
            return reducer2;
        }));
        if (caseReducers.filter(function(cr) {
            return !!cr;
        }).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce(function(previousState, caseReducer) {
            if (caseReducer) {
                if ((0, $i4CZ2.isDraft)(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $i4CZ2.isDraftable)(previousState)) {
                    var result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $i4CZ2.default)(previousState, function(draft) {
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/createSlice.ts
var $74cf642ba7fa99c2$var$hasWarnedAboutObjectNotation2 = false;
function $74cf642ba7fa99c2$var$getType2(slice, actionKey) {
    return slice + "/" + actionKey;
}
function $74cf642ba7fa99c2$export$4d8d9bd83c24ae8b(options) {
    var name = options.name;
    if (!name) throw new Error("`name` is a required option for createSlice");
    typeof $cfae44f0dfdf62c0$exports;
    var initialState = typeof options.initialState == "function" ? options.initialState : $74cf642ba7fa99c2$var$freezeDraftable(options.initialState);
    var reducers = options.reducers || {};
    var reducerNames = Object.keys(reducers);
    var sliceCaseReducersByName = {};
    var sliceCaseReducersByType = {};
    var actionCreators = {};
    reducerNames.forEach(function(reducerName) {
        var maybeReducerWithPrepare = reducers[reducerName];
        var type = $74cf642ba7fa99c2$var$getType2(name, reducerName);
        var caseReducer;
        var prepareCallback;
        if ("reducer" in maybeReducerWithPrepare) {
            caseReducer = maybeReducerWithPrepare.reducer;
            prepareCallback = maybeReducerWithPrepare.prepare;
        } else caseReducer = maybeReducerWithPrepare;
        sliceCaseReducersByName[reducerName] = caseReducer;
        sliceCaseReducersByType[type] = caseReducer;
        actionCreators[reducerName] = prepareCallback ? $74cf642ba7fa99c2$export$309c7a02b0b0bc62(type, prepareCallback) : $74cf642ba7fa99c2$export$309c7a02b0b0bc62(type);
    });
    function buildReducer() {
        var _c = typeof options.extraReducers === "function" ? $74cf642ba7fa99c2$var$executeReducerBuilderCallback(options.extraReducers) : [
            options.extraReducers
        ], _d = _c[0], extraReducers = _d === void 0 ? {} : _d, _e = _c[1], actionMatchers = _e === void 0 ? [] : _e, _f = _c[2], defaultCaseReducer = _f === void 0 ? void 0 : _f;
        var finalCaseReducers = $74cf642ba7fa99c2$var$__spreadValues($74cf642ba7fa99c2$var$__spreadValues({}, extraReducers), sliceCaseReducersByType);
        return $74cf642ba7fa99c2$export$473eb76d322d0290(initialState, function(builder) {
            for(var key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
            for(var _i = 0, actionMatchers_1 = actionMatchers; _i < actionMatchers_1.length; _i++){
                var m = actionMatchers_1[_i];
                builder.addMatcher(m.matcher, m.reducer);
            }
            if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
        });
    }
    var _reducer;
    return {
        name: name,
        reducer: function(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        },
        actions: actionCreators,
        caseReducers: sliceCaseReducersByName,
        getInitialState: function() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
    };
}
// src/entities/entity_state.ts
function $74cf642ba7fa99c2$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $74cf642ba7fa99c2$var$createInitialStateFactory() {
    function getInitialState(additionalState) {
        if (additionalState === void 0) additionalState = {};
        return Object.assign($74cf642ba7fa99c2$var$getInitialEntityState(), additionalState);
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $74cf642ba7fa99c2$var$createSelectorsFactory() {
    function getSelectors(selectState) {
        var selectIds = function(state) {
            return state.ids;
        };
        var selectEntities = function(state) {
            return state.entities;
        };
        var selectAll = $74cf642ba7fa99c2$export$a5d3c27355e35910(selectIds, selectEntities, function(ids, entities) {
            return ids.map(function(id) {
                return entities[id];
            });
        });
        var selectId = function(_, id) {
            return id;
        };
        var selectById = function(entities, id) {
            return entities[id];
        };
        var selectTotal = $74cf642ba7fa99c2$export$a5d3c27355e35910(selectIds, function(ids) {
            return ids.length;
        });
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: $74cf642ba7fa99c2$export$a5d3c27355e35910(selectEntities, selectId, selectById)
        };
        var selectGlobalizedEntities = $74cf642ba7fa99c2$export$a5d3c27355e35910(selectState, selectEntities);
        return {
            selectIds: $74cf642ba7fa99c2$export$a5d3c27355e35910(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: $74cf642ba7fa99c2$export$a5d3c27355e35910(selectState, selectAll),
            selectTotal: $74cf642ba7fa99c2$export$a5d3c27355e35910(selectState, selectTotal),
            selectById: $74cf642ba7fa99c2$export$a5d3c27355e35910(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
function $74cf642ba7fa99c2$var$createSingleArgumentStateOperator(mutator) {
    var operator = $74cf642ba7fa99c2$var$createStateOperator(function(_, state) {
        return mutator(state);
    });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $74cf642ba7fa99c2$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $74cf642ba7fa99c2$export$ebd532f9034651f3(arg2);
        }
        var runMutator = function(draft) {
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ((0, $i4CZ2.isDraft)(state)) {
            runMutator(state);
            return state;
        } else return (0, $i4CZ2.default)(state, runMutator);
    };
}
// src/entities/utils.ts
function $74cf642ba7fa99c2$var$selectIdValue(entity, selectId) {
    var key = selectId(entity);
    return key;
}
function $74cf642ba7fa99c2$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $74cf642ba7fa99c2$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $74cf642ba7fa99c2$var$ensureEntitiesArray(newEntities);
    var added = [];
    var updated = [];
    for(var _i = 0, newEntities_1 = newEntities; _i < newEntities_1.length; _i++){
        var entity = newEntities_1[_i];
        var id = $74cf642ba7fa99c2$var$selectIdValue(entity, selectId);
        if (id in state.entities) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated
    ];
}
// src/entities/unsorted_state_adapter.ts
function $74cf642ba7fa99c2$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = $74cf642ba7fa99c2$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $74cf642ba7fa99c2$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_2 = newEntities; _i < newEntities_2.length; _i++){
            var entity = newEntities_2[_i];
            addOneMutably(entity, state);
        }
    }
    function setOneMutably(entity, state) {
        var key = $74cf642ba7fa99c2$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $74cf642ba7fa99c2$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_3 = newEntities; _i < newEntities_3.length; _i++){
            var entity = newEntities_3[_i];
            setOneMutably(entity, state);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $74cf642ba7fa99c2$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function(key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter(function(id) {
            return id in state.entities;
        });
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original2 = state.entities[update.id];
        var updated = Object.assign({}, original2, update.changes);
        var newKey = $74cf642ba7fa99c2$var$selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function(update) {
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                changes: $74cf642ba7fa99c2$var$__spreadValues($74cf642ba7fa99c2$var$__spreadValues({}, updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function(update) {
                return takeNewKey(newKeys, update, state);
            }).length > 0;
            if (didMutateIds) state.ids = Object.keys(state.entities);
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $74cf642ba7fa99c2$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $74cf642ba7fa99c2$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $74cf642ba7fa99c2$var$createStateOperator(addOneMutably),
        addMany: $74cf642ba7fa99c2$var$createStateOperator(addManyMutably),
        setOne: $74cf642ba7fa99c2$var$createStateOperator(setOneMutably),
        setMany: $74cf642ba7fa99c2$var$createStateOperator(setManyMutably),
        setAll: $74cf642ba7fa99c2$var$createStateOperator(setAllMutably),
        updateOne: $74cf642ba7fa99c2$var$createStateOperator(updateOneMutably),
        updateMany: $74cf642ba7fa99c2$var$createStateOperator(updateManyMutably),
        upsertOne: $74cf642ba7fa99c2$var$createStateOperator(upsertOneMutably),
        upsertMany: $74cf642ba7fa99c2$var$createStateOperator(upsertManyMutably),
        removeOne: $74cf642ba7fa99c2$var$createStateOperator(removeOneMutably),
        removeMany: $74cf642ba7fa99c2$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $74cf642ba7fa99c2$var$createSortedStateAdapter(selectId, sort) {
    var _c = $74cf642ba7fa99c2$var$createUnsortedStateAdapter(selectId), removeOne = _c.removeOne, removeMany = _c.removeMany, removeAll = _c.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state) {
        newEntities = $74cf642ba7fa99c2$var$ensureEntitiesArray(newEntities);
        var models = newEntities.filter(function(model) {
            return !($74cf642ba7fa99c2$var$selectIdValue(model, selectId) in state.entities);
        });
        if (models.length !== 0) merge(models, state);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $74cf642ba7fa99c2$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) merge(newEntities, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $74cf642ba7fa99c2$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var appliedUpdates = false;
        for(var _i = 0, updates_1 = updates; _i < updates_1.length; _i++){
            var update = updates_1[_i];
            var entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            var newId = selectId(entity);
            if (update.id !== newId) {
                delete state.entities[update.id];
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) resortEntities(state);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $74cf642ba7fa99c2$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(var i = 0; i < a.length && i < b.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    function merge(models, state) {
        models.forEach(function(model) {
            state.entities[selectId(model)] = model;
        });
        resortEntities(state);
    }
    function resortEntities(state) {
        var allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        var newSortedIds = allEntities.map(selectId);
        var ids = state.ids;
        if (!areArraysEqual(ids, newSortedIds)) state.ids = newSortedIds;
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $74cf642ba7fa99c2$var$createStateOperator(addOneMutably),
        updateOne: $74cf642ba7fa99c2$var$createStateOperator(updateOneMutably),
        upsertOne: $74cf642ba7fa99c2$var$createStateOperator(upsertOneMutably),
        setOne: $74cf642ba7fa99c2$var$createStateOperator(setOneMutably),
        setMany: $74cf642ba7fa99c2$var$createStateOperator(setManyMutably),
        setAll: $74cf642ba7fa99c2$var$createStateOperator(setAllMutably),
        addMany: $74cf642ba7fa99c2$var$createStateOperator(addManyMutably),
        updateMany: $74cf642ba7fa99c2$var$createStateOperator(updateManyMutably),
        upsertMany: $74cf642ba7fa99c2$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $74cf642ba7fa99c2$export$abcf4037b41e0df(options) {
    if (options === void 0) options = {};
    var _c = $74cf642ba7fa99c2$var$__spreadValues({
        sortComparer: false,
        selectId: function(instance) {
            return instance.id;
        }
    }, options), selectId = _c.selectId, sortComparer = _c.sortComparer;
    var stateFactory = $74cf642ba7fa99c2$var$createInitialStateFactory();
    var selectorsFactory = $74cf642ba7fa99c2$var$createSelectorsFactory();
    var stateAdapter = sortComparer ? $74cf642ba7fa99c2$var$createSortedStateAdapter(selectId, sortComparer) : $74cf642ba7fa99c2$var$createUnsortedStateAdapter(selectId);
    return $74cf642ba7fa99c2$var$__spreadValues($74cf642ba7fa99c2$var$__spreadValues($74cf642ba7fa99c2$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/nanoid.ts
var $74cf642ba7fa99c2$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $74cf642ba7fa99c2$export$ac4959f4f1338dfc = function(size) {
    if (size === void 0) size = 21;
    var id = "";
    var i = size;
    while(i--)id += $74cf642ba7fa99c2$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $74cf642ba7fa99c2$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $74cf642ba7fa99c2$var$RejectWithValue = /** @class */ function() {
    function RejectWithValue(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return RejectWithValue;
}();
var $74cf642ba7fa99c2$var$FulfillWithMeta = /** @class */ function() {
    function FulfillWithMeta(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return FulfillWithMeta;
}();
var $74cf642ba7fa99c2$export$c97c53d0b2d5d81e = function(value) {
    if (typeof value === "object" && value !== null) {
        var simpleError = {};
        for(var _i = 0, commonProperties_1 = $74cf642ba7fa99c2$var$commonProperties; _i < commonProperties_1.length; _i++){
            var property = commonProperties_1[_i];
            if (typeof value[property] === "string") simpleError[property] = value[property];
        }
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $74cf642ba7fa99c2$export$6abd22dc03e5063f = function() {
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        var fulfilled = $74cf642ba7fa99c2$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", function(payload, requestId, arg, meta) {
            return {
                payload: payload,
                meta: $74cf642ba7fa99c2$var$__spreadProps($74cf642ba7fa99c2$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            };
        });
        var pending = $74cf642ba7fa99c2$export$309c7a02b0b0bc62(typePrefix + "/pending", function(requestId, arg, meta) {
            return {
                payload: void 0,
                meta: $74cf642ba7fa99c2$var$__spreadProps($74cf642ba7fa99c2$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            };
        });
        var rejected = $74cf642ba7fa99c2$export$309c7a02b0b0bc62(typePrefix + "/rejected", function(error, requestId, arg, payload, meta) {
            return {
                payload: payload,
                error: (options && options.serializeError || $74cf642ba7fa99c2$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $74cf642ba7fa99c2$var$__spreadProps($74cf642ba7fa99c2$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            };
        });
        var displayedWarning = false;
        var AC = typeof AbortController !== "undefined" ? AbortController : /** @class */ function() {
            function class_1() {
                this.signal = {
                    aborted: false,
                    addEventListener: function() {},
                    dispatchEvent: function() {
                        return false;
                    },
                    onabort: function() {},
                    removeEventListener: function() {},
                    reason: void 0,
                    throwIfAborted: function() {}
                };
            }
            class_1.prototype.abort = function() {};
            return class_1;
        }();
        function actionCreator(arg) {
            return function(dispatch, getState, extra) {
                var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $74cf642ba7fa99c2$export$ac4959f4f1338dfc();
                var abortController = new AC();
                var abortReason;
                var started = false;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                var promise2 = function() {
                    return $74cf642ba7fa99c2$var$__async(this, null, function() {
                        var _a, _b, finalAction, conditionResult, abortedPromise, err_1, skipDispatch;
                        return $74cf642ba7fa99c2$var$__generator(this, function(_c) {
                            switch(_c.label){
                                case 0:
                                    _c.trys.push([
                                        0,
                                        4,
                                        ,
                                        5
                                    ]);
                                    conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                                        getState: getState,
                                        extra: extra
                                    });
                                    if (!$74cf642ba7fa99c2$var$isThenable(conditionResult)) return [
                                        3 /*break*/ ,
                                        2
                                    ];
                                    return [
                                        4 /*yield*/ ,
                                        conditionResult
                                    ];
                                case 1:
                                    conditionResult = _c.sent();
                                    _c.label = 2;
                                case 2:
                                    if (conditionResult === false || abortController.signal.aborted) throw {
                                        name: "ConditionError",
                                        message: "Aborted due to condition callback returning false."
                                    };
                                    started = true;
                                    abortedPromise = new Promise(function(_, reject) {
                                        return abortController.signal.addEventListener("abort", function() {
                                            return reject({
                                                name: "AbortError",
                                                message: abortReason || "Aborted"
                                            });
                                        });
                                    });
                                    dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                                        requestId: requestId,
                                        arg: arg
                                    }, {
                                        getState: getState,
                                        extra: extra
                                    })));
                                    return [
                                        4 /*yield*/ ,
                                        Promise.race([
                                            abortedPromise,
                                            Promise.resolve(payloadCreator(arg, {
                                                dispatch: dispatch,
                                                getState: getState,
                                                extra: extra,
                                                requestId: requestId,
                                                signal: abortController.signal,
                                                abort: abort,
                                                rejectWithValue: function(value, meta) {
                                                    return new $74cf642ba7fa99c2$var$RejectWithValue(value, meta);
                                                },
                                                fulfillWithValue: function(value, meta) {
                                                    return new $74cf642ba7fa99c2$var$FulfillWithMeta(value, meta);
                                                }
                                            })).then(function(result) {
                                                if (result instanceof $74cf642ba7fa99c2$var$RejectWithValue) throw result;
                                                if (result instanceof $74cf642ba7fa99c2$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                                return fulfilled(result, requestId, arg);
                                            })
                                        ])
                                    ];
                                case 3:
                                    finalAction = _c.sent();
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 4:
                                    err_1 = _c.sent();
                                    finalAction = err_1 instanceof $74cf642ba7fa99c2$var$RejectWithValue ? rejected(null, requestId, arg, err_1.payload, err_1.meta) : rejected(err_1, requestId, arg);
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 5:
                                    skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                    if (!skipDispatch) dispatch(finalAction);
                                    return [
                                        2 /*return*/ ,
                                        finalAction
                                    ];
                            }
                        });
                    });
                }();
                return Object.assign(promise2, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap: function() {
                        return promise2.then($74cf642ba7fa99c2$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = function() {
        return createAsyncThunk2;
    };
    return createAsyncThunk2;
}();
function $74cf642ba7fa99c2$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $74cf642ba7fa99c2$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/matchers.ts
var $74cf642ba7fa99c2$var$matches = function(matcher, action) {
    if ($74cf642ba7fa99c2$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $74cf642ba7fa99c2$export$2c3435c7647f7b0d() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.some(function(matcher) {
            return $74cf642ba7fa99c2$var$matches(matcher, action);
        });
    };
}
function $74cf642ba7fa99c2$export$9dd1fb32974da385() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.every(function(matcher) {
            return $74cf642ba7fa99c2$var$matches(matcher, action);
        });
    };
}
function $74cf642ba7fa99c2$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $74cf642ba7fa99c2$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $74cf642ba7fa99c2$export$872dec21e9a69476() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $74cf642ba7fa99c2$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    };
    if (!$74cf642ba7fa99c2$var$isAsyncThunkArray(asyncThunks)) return $74cf642ba7fa99c2$export$872dec21e9a69476()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.pending;
        });
        var combinedMatcher = $74cf642ba7fa99c2$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $74cf642ba7fa99c2$export$a5c5d27e3994c5be() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $74cf642ba7fa99c2$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    };
    if (!$74cf642ba7fa99c2$var$isAsyncThunkArray(asyncThunks)) return $74cf642ba7fa99c2$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.rejected;
        });
        var combinedMatcher = $74cf642ba7fa99c2$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $74cf642ba7fa99c2$export$fcc3388fb56de601() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    var hasFlag = function(action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return function(action) {
        var combinedMatcher = $74cf642ba7fa99c2$export$9dd1fb32974da385($74cf642ba7fa99c2$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
    if (!$74cf642ba7fa99c2$var$isAsyncThunkArray(asyncThunks)) return $74cf642ba7fa99c2$export$fcc3388fb56de601()(asyncThunks[0]);
    return function(action) {
        var combinedMatcher = $74cf642ba7fa99c2$export$9dd1fb32974da385($74cf642ba7fa99c2$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
}
function $74cf642ba7fa99c2$export$1da80a6ef1307441() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $74cf642ba7fa99c2$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    };
    if (!$74cf642ba7fa99c2$var$isAsyncThunkArray(asyncThunks)) return $74cf642ba7fa99c2$export$1da80a6ef1307441()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.fulfilled;
        });
        var combinedMatcher = $74cf642ba7fa99c2$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $74cf642ba7fa99c2$export$6aa4142d99c1abce() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $74cf642ba7fa99c2$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    };
    if (!$74cf642ba7fa99c2$var$isAsyncThunkArray(asyncThunks)) return $74cf642ba7fa99c2$export$6aa4142d99c1abce()(asyncThunks[0]);
    return function(action) {
        var matchers = [];
        for(var _i = 0, asyncThunks_1 = asyncThunks; _i < asyncThunks_1.length; _i++){
            var asyncThunk = asyncThunks_1[_i];
            matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
        }
        var combinedMatcher = $74cf642ba7fa99c2$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
// src/listenerMiddleware/utils.ts
var $74cf642ba7fa99c2$var$assertFunction = function(func, expected) {
    if (typeof func !== "function") throw new TypeError(expected + " is not a function");
};
var $74cf642ba7fa99c2$var$noop = function() {};
var $74cf642ba7fa99c2$var$catchRejection = function(promise2, onError) {
    if (onError === void 0) onError = $74cf642ba7fa99c2$var$noop;
    promise2.catch(onError);
    return promise2;
};
var $74cf642ba7fa99c2$var$addAbortSignalListener = function(abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return function() {
        return abortSignal.removeEventListener("abort", callback);
    };
};
var $74cf642ba7fa99c2$var$abortControllerWithReason = function(abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/exceptions.ts
var $74cf642ba7fa99c2$var$task = "task";
var $74cf642ba7fa99c2$var$listener = "listener";
var $74cf642ba7fa99c2$var$completed = "completed";
var $74cf642ba7fa99c2$var$cancelled = "cancelled";
var $74cf642ba7fa99c2$var$taskCancelled = "task-" + $74cf642ba7fa99c2$var$cancelled;
var $74cf642ba7fa99c2$var$taskCompleted = "task-" + $74cf642ba7fa99c2$var$completed;
var $74cf642ba7fa99c2$var$listenerCancelled = $74cf642ba7fa99c2$var$listener + "-" + $74cf642ba7fa99c2$var$cancelled;
var $74cf642ba7fa99c2$var$listenerCompleted = $74cf642ba7fa99c2$var$listener + "-" + $74cf642ba7fa99c2$var$completed;
var $74cf642ba7fa99c2$export$cb1bdac908fed7f = /** @class */ function() {
    function TaskAbortError(code) {
        this.code = code;
        this.name = "TaskAbortError";
        this.message = $74cf642ba7fa99c2$var$task + " " + $74cf642ba7fa99c2$var$cancelled + " (reason: " + code + ")";
    }
    return TaskAbortError;
}();
// src/listenerMiddleware/task.ts
var $74cf642ba7fa99c2$var$validateActive = function(signal) {
    if (signal.aborted) throw new $74cf642ba7fa99c2$export$cb1bdac908fed7f(signal.reason);
};
function $74cf642ba7fa99c2$var$raceWithSignal(signal, promise2) {
    var cleanup = $74cf642ba7fa99c2$var$noop;
    return new Promise(function(resolve, reject) {
        var notifyRejection = function() {
            return reject(new $74cf642ba7fa99c2$export$cb1bdac908fed7f(signal.reason));
        };
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $74cf642ba7fa99c2$var$addAbortSignalListener(signal, notifyRejection);
        promise2.finally(function() {
            return cleanup();
        }).then(resolve, reject);
    }).finally(function() {
        cleanup = $74cf642ba7fa99c2$var$noop;
    });
}
var $74cf642ba7fa99c2$var$runTask = function(task2, cleanUp) {
    return $74cf642ba7fa99c2$var$__async(void 0, null, function() {
        var value, error_1;
        return $74cf642ba7fa99c2$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    _c.trys.push([
                        0,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        Promise.resolve()
                    ];
                case 1:
                    _c.sent();
                    return [
                        4 /*yield*/ ,
                        task2()
                    ];
                case 2:
                    value = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: "ok",
                            value: value
                        }
                    ];
                case 3:
                    error_1 = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: error_1 instanceof $74cf642ba7fa99c2$export$cb1bdac908fed7f ? "cancelled" : "rejected",
                            error: error_1
                        }
                    ];
                case 4:
                    cleanUp == null || cleanUp();
                    return [
                        7 /*endfinally*/ 
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
var $74cf642ba7fa99c2$var$createPause = function(signal) {
    return function(promise2) {
        return $74cf642ba7fa99c2$var$catchRejection($74cf642ba7fa99c2$var$raceWithSignal(signal, promise2).then(function(output) {
            $74cf642ba7fa99c2$var$validateActive(signal);
            return output;
        }));
    };
};
var $74cf642ba7fa99c2$var$createDelay = function(signal) {
    var pause = $74cf642ba7fa99c2$var$createPause(signal);
    return function(timeoutMs) {
        return pause(new Promise(function(resolve) {
            return setTimeout(resolve, timeoutMs);
        }));
    };
};
// src/listenerMiddleware/index.ts
var $74cf642ba7fa99c2$var$assign = Object.assign;
var $74cf642ba7fa99c2$var$INTERNAL_NIL_TOKEN = {};
var $74cf642ba7fa99c2$var$alm = "listenerMiddleware";
var $74cf642ba7fa99c2$var$createFork = function(parentAbortSignal, parentBlockingPromises) {
    var linkControllers = function(controller) {
        return $74cf642ba7fa99c2$var$addAbortSignalListener(parentAbortSignal, function() {
            return $74cf642ba7fa99c2$var$abortControllerWithReason(controller, parentAbortSignal.reason);
        });
    };
    return function(taskExecutor, opts) {
        $74cf642ba7fa99c2$var$assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = $74cf642ba7fa99c2$var$runTask(function() {
            return $74cf642ba7fa99c2$var$__async(void 0, null, function() {
                var result2;
                return $74cf642ba7fa99c2$var$__generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            $74cf642ba7fa99c2$var$validateActive(parentAbortSignal);
                            $74cf642ba7fa99c2$var$validateActive(childAbortController.signal);
                            return [
                                4 /*yield*/ ,
                                taskExecutor({
                                    pause: $74cf642ba7fa99c2$var$createPause(childAbortController.signal),
                                    delay: $74cf642ba7fa99c2$var$createDelay(childAbortController.signal),
                                    signal: childAbortController.signal
                                })
                            ];
                        case 1:
                            result2 = _c.sent();
                            $74cf642ba7fa99c2$var$validateActive(childAbortController.signal);
                            return [
                                2 /*return*/ ,
                                result2
                            ];
                    }
                });
            });
        }, function() {
            return $74cf642ba7fa99c2$var$abortControllerWithReason(childAbortController, $74cf642ba7fa99c2$var$taskCompleted);
        });
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result);
        return {
            result: $74cf642ba7fa99c2$var$createPause(parentAbortSignal)(result),
            cancel: function() {
                $74cf642ba7fa99c2$var$abortControllerWithReason(childAbortController, $74cf642ba7fa99c2$var$taskCancelled);
            }
        };
    };
};
var $74cf642ba7fa99c2$var$createTakePattern = function(startListening, signal) {
    var take = function(predicate, timeout) {
        return $74cf642ba7fa99c2$var$__async(void 0, null, function() {
            var unsubscribe, tuplePromise, promises, output;
            return $74cf642ba7fa99c2$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        $74cf642ba7fa99c2$var$validateActive(signal);
                        unsubscribe = function() {};
                        tuplePromise = new Promise(function(resolve, reject) {
                            var stopListening = startListening({
                                predicate: predicate,
                                effect: function(action, listenerApi) {
                                    listenerApi.unsubscribe();
                                    resolve([
                                        action,
                                        listenerApi.getState(),
                                        listenerApi.getOriginalState()
                                    ]);
                                }
                            });
                            unsubscribe = function() {
                                stopListening();
                                reject();
                            };
                        });
                        promises = [
                            tuplePromise
                        ];
                        if (timeout != null) promises.push(new Promise(function(resolve) {
                            return setTimeout(resolve, timeout, null);
                        }));
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            $74cf642ba7fa99c2$var$raceWithSignal(signal, Promise.race(promises))
                        ];
                    case 2:
                        output = _c.sent();
                        $74cf642ba7fa99c2$var$validateActive(signal);
                        return [
                            2 /*return*/ ,
                            output
                        ];
                    case 3:
                        unsubscribe();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return function(predicate, timeout) {
        return $74cf642ba7fa99c2$var$catchRejection(take(predicate, timeout));
    };
};
var $74cf642ba7fa99c2$var$getListenerEntryPropsFrom = function(options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) predicate = $74cf642ba7fa99c2$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error("Creating or removing a listener requires one of the known fields for matching an action");
    $74cf642ba7fa99c2$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $74cf642ba7fa99c2$var$createListenerEntry = function(options) {
    var _c = $74cf642ba7fa99c2$var$getListenerEntryPropsFrom(options), type = _c.type, predicate = _c.predicate, effect = _c.effect;
    var id = $74cf642ba7fa99c2$export$ac4959f4f1338dfc();
    var entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: new Set(),
        unsubscribe: function() {
            throw new Error("Unsubscribe not initialized");
        }
    };
    return entry;
};
var $74cf642ba7fa99c2$var$cancelActiveListeners = function(entry) {
    entry.pending.forEach(function(controller) {
        $74cf642ba7fa99c2$var$abortControllerWithReason(controller, $74cf642ba7fa99c2$var$listenerCancelled);
    });
};
var $74cf642ba7fa99c2$var$createClearListenerMiddleware = function(listenerMap) {
    return function() {
        listenerMap.forEach($74cf642ba7fa99c2$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $74cf642ba7fa99c2$var$safelyNotifyError = function(errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(function() {
            throw errorHandlerError;
        }, 0);
    }
};
var $74cf642ba7fa99c2$export$f03a6b845d3fb58b = $74cf642ba7fa99c2$export$309c7a02b0b0bc62($74cf642ba7fa99c2$var$alm + "/add");
var $74cf642ba7fa99c2$export$b1b8022855fb2b71 = $74cf642ba7fa99c2$export$309c7a02b0b0bc62($74cf642ba7fa99c2$var$alm + "/removeAll");
var $74cf642ba7fa99c2$export$b03e9483f936dccb = $74cf642ba7fa99c2$export$309c7a02b0b0bc62($74cf642ba7fa99c2$var$alm + "/remove");
var $74cf642ba7fa99c2$var$defaultErrorHandler = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    console.error.apply(console, $74cf642ba7fa99c2$var$__spreadArray([
        $74cf642ba7fa99c2$var$alm + "/error"
    ], args));
};
function $74cf642ba7fa99c2$export$1228acebbbcb485b(middlewareOptions) {
    var _this = this;
    if (middlewareOptions === void 0) middlewareOptions = {};
    var listenerMap = new Map();
    var extra = middlewareOptions.extra, _c = middlewareOptions.onError, onError = _c === void 0 ? $74cf642ba7fa99c2$var$defaultErrorHandler : _c;
    $74cf642ba7fa99c2$var$assertFunction(onError, "onError");
    var insertEntry = function(entry) {
        entry.unsubscribe = function() {
            return listenerMap.delete(entry.id);
        };
        listenerMap.set(entry.id, entry);
        return function(cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $74cf642ba7fa99c2$var$cancelActiveListeners(entry);
        };
    };
    var findListenerEntry = function(comparator) {
        for(var _i = 0, _c = Array.from(listenerMap.values()); _i < _c.length; _i++){
            var entry = _c[_i];
            if (comparator(entry)) return entry;
        }
        return void 0;
    };
    var startListening = function(options) {
        var entry = findListenerEntry(function(existingEntry) {
            return existingEntry.effect === options.effect;
        });
        if (!entry) entry = $74cf642ba7fa99c2$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    var stopListening = function(options) {
        var _c = $74cf642ba7fa99c2$var$getListenerEntryPropsFrom(options), type = _c.type, effect = _c.effect, predicate = _c.predicate;
        var entry = findListenerEntry(function(entry2) {
            var matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $74cf642ba7fa99c2$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    var notifyListener = function(entry, action, api, getOriginalState) {
        return $74cf642ba7fa99c2$var$__async(_this, null, function() {
            var internalTaskController, take, autoJoinPromises, listenerError_1;
            return $74cf642ba7fa99c2$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        internalTaskController = new AbortController();
                        take = $74cf642ba7fa99c2$var$createTakePattern(startListening, internalTaskController.signal);
                        autoJoinPromises = [];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            3,
                            4,
                            6
                        ]);
                        entry.pending.add(internalTaskController);
                        return [
                            4 /*yield*/ ,
                            Promise.resolve(entry.effect(action, $74cf642ba7fa99c2$var$assign({}, api, {
                                getOriginalState: getOriginalState,
                                condition: function(predicate, timeout) {
                                    return take(predicate, timeout).then(Boolean);
                                },
                                take: take,
                                delay: $74cf642ba7fa99c2$var$createDelay(internalTaskController.signal),
                                pause: $74cf642ba7fa99c2$var$createPause(internalTaskController.signal),
                                extra: extra,
                                signal: internalTaskController.signal,
                                fork: $74cf642ba7fa99c2$var$createFork(internalTaskController.signal, autoJoinPromises),
                                unsubscribe: entry.unsubscribe,
                                subscribe: function() {
                                    listenerMap.set(entry.id, entry);
                                },
                                cancelActiveListeners: function() {
                                    entry.pending.forEach(function(controller, _, set) {
                                        if (controller !== internalTaskController) {
                                            $74cf642ba7fa99c2$var$abortControllerWithReason(controller, $74cf642ba7fa99c2$var$listenerCancelled);
                                            set.delete(controller);
                                        }
                                    });
                                }
                            })))
                        ];
                    case 2:
                        _c.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 3:
                        listenerError_1 = _c.sent();
                        if (!(listenerError_1 instanceof $74cf642ba7fa99c2$export$cb1bdac908fed7f)) $74cf642ba7fa99c2$var$safelyNotifyError(onError, listenerError_1, {
                            raisedBy: "effect"
                        });
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 4:
                        return [
                            4 /*yield*/ ,
                            Promise.allSettled(autoJoinPromises)
                        ];
                    case 5:
                        _c.sent();
                        $74cf642ba7fa99c2$var$abortControllerWithReason(internalTaskController, $74cf642ba7fa99c2$var$listenerCompleted);
                        entry.pending.delete(internalTaskController);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var clearListenerMiddleware = $74cf642ba7fa99c2$var$createClearListenerMiddleware(listenerMap);
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (!$74cf642ba7fa99c2$export$b956e38827fca970(action)) return next(action);
                if ($74cf642ba7fa99c2$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($74cf642ba7fa99c2$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($74cf642ba7fa99c2$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                var originalState = api.getState();
                var getOriginalState = function() {
                    if (originalState === $74cf642ba7fa99c2$var$INTERNAL_NIL_TOKEN) throw new Error($74cf642ba7fa99c2$var$alm + ": getOriginalState can only be called synchronously");
                    return originalState;
                };
                var result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        var currentState = api.getState();
                        var listenerEntries = Array.from(listenerMap.values());
                        for(var _i = 0, listenerEntries_1 = listenerEntries; _i < listenerEntries_1.length; _i++){
                            var entry = listenerEntries_1[_i];
                            var runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $74cf642ba7fa99c2$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $74cf642ba7fa99c2$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
        };
    };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
}
// src/autoBatchEnhancer.ts
var $74cf642ba7fa99c2$export$8fb31c0f05df007b = "RTK_autoBatch";
var $74cf642ba7fa99c2$export$39fcd5145ec5e4e2 = function() {
    return function(payload) {
        var _c;
        return {
            payload: payload,
            meta: (_c = {}, _c[$74cf642ba7fa99c2$export$8fb31c0f05df007b] = true, _c)
        };
    };
};
var $74cf642ba7fa99c2$var$promise;
var $74cf642ba7fa99c2$var$queueMicrotaskShim = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : globalThis) : function(cb) {
    return ($74cf642ba7fa99c2$var$promise || ($74cf642ba7fa99c2$var$promise = Promise.resolve())).then(cb).catch(function(err) {
        return setTimeout(function() {
            throw err;
        }, 0);
    });
};
var $74cf642ba7fa99c2$var$createQueueWithTimer = function(timeout) {
    return function(notify) {
        setTimeout(notify, timeout);
    };
};
var $74cf642ba7fa99c2$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $74cf642ba7fa99c2$var$createQueueWithTimer(10);
var $74cf642ba7fa99c2$export$676277d7dca0f396 = function(options) {
    if (options === void 0) options = {
        type: "raf"
    };
    return function(next) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var store = next.apply(void 0, args);
            var notifying = true;
            var shouldNotifyAtEndOfTick = false;
            var notificationQueued = false;
            var listeners = new Set();
            var queueCallback = options.type === "tick" ? $74cf642ba7fa99c2$var$queueMicrotaskShim : options.type === "raf" ? $74cf642ba7fa99c2$var$rAF : options.type === "callback" ? options.queueNotification : $74cf642ba7fa99c2$var$createQueueWithTimer(options.timeout);
            var notifyListeners = function() {
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach(function(l) {
                        return l();
                    });
                }
            };
            return Object.assign({}, store, {
                subscribe: function(listener2) {
                    var wrappedListener = function() {
                        return notifying && listener2();
                    };
                    var unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return function() {
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                dispatch: function(action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$74cf642ba7fa99c2$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
    };
};
// src/index.ts
(0, $i4CZ2.enableES5)();



const $ecf70d86349bf38f$export$f6cef6fcf9ca4e17 = (noticationMessage)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($a3478a115f13707d$exports))).success(noticationMessage, {
        duration: 1000,
        style: {
            borderRadius: "10px",
            background: "rgb(30 58 138)",
            color: "#fff"
        },
        iconTheme: {
            secondary: "rgb(30 58 138)",
            primary: "#fff"
        }
    });
};


const $c764300c7515c1f3$var$cartSlice = (0, $74cf642ba7fa99c2$export$4d8d9bd83c24ae8b)({
    name: "cartSlice",
    initialState: {
        cartItems: []
    },
    reducers: {
        // Add an item to cart in cartSlice state variable with checking if the item is already in cart or not
        addItem: (state, item)=>{
            if (state.cartItems.some((items)=>items.itemDetail.info.id === item.payload.info.id)) (0, $ecf70d86349bf38f$export$f6cef6fcf9ca4e17)("Item already in cart");
            else {
                state.cartItems.push({
                    itemDetail: item.payload,
                    totalNumberOfItem: 1,
                    totalAmountOfAllItem: (item.payload.info.price || item.payload.info.defaultPrice) / 100
                });
                (0, $ecf70d86349bf38f$export$f6cef6fcf9ca4e17)("Added Item in cart");
            }
        },
        // Clear all items from cartSlice state variable
        clearAllItem: (state)=>{
            state.cartItems.length = 0;
        },
        // remove the particular item from cartSlice state variable
        removeItem: (state, itemId)=>{
            (0, $ecf70d86349bf38f$export$f6cef6fcf9ca4e17)("Item removed from cart");
            state.cartItems = state.cartItems.filter((items)=>items.itemDetail.info.id !== itemId.payload);
        },
        incrementInItem: (state, itemId)=>{
            // find the item which id is equal to itemId and then increment the totalNumberOfItem.After that
            // update the totalAmountOfAllItem
            state.cartItems.filter((item)=>{
                if (item.itemDetail.info.id === itemId.payload) {
                    item.totalNumberOfItem++;
                    item.totalAmountOfAllItem = (item.itemDetail.info.price || item.itemDetail.info.defaultPrice) * item.totalNumberOfItem / 100;
                }
            });
        },
        decrementInItem: (state, itemId)=>{
            // find the item which id is equal to itemId and then decrement the totalNumberOfItem.After that
            // update the totalAmountOfAllItem
            state.cartItems.filter((item)=>{
                if (item.itemDetail.info.id === itemId.payload) {
                    item.totalNumberOfItem--;
                    item.totalAmountOfAllItem = (item.itemDetail.info.price || item.itemDetail.info.defaultPrice) * item.totalNumberOfItem / 100;
                }
            });
        }
    }
});
const { addItem: $c764300c7515c1f3$export$fb9705de59d96855, clearAllItem: $c764300c7515c1f3$export$cf2d04cce5f7b536, removeItem: $c764300c7515c1f3$export$fe2d9b4e03920b4c, incrementInItem: $c764300c7515c1f3$export$14145c7f329054b8, decrementInItem: $c764300c7515c1f3$export$73500405dadd14a8 } = $c764300c7515c1f3$var$cartSlice.actions;
var $c764300c7515c1f3$export$2e2bcd8739ae039 = $c764300c7515c1f3$var$cartSlice.reducer;



parcelRequire("acw62");



// this component is used to show cart item list in the cart page with different functionalities like  add item , remove item , increment and decrement number of particular item which uses redux reducers for it
const $f007916f0583fb3f$var$CartItemList = (props)=>{
    const { cartItem: cartItem } = props;
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "text-sm flex w-full mx-auto h-[52%] my-3 p-2 bg-blue-300 rounded-xl justify-between items-center md:w-11/12 md:text-base md:h-1/3",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                className: " rounded-xl h-full w-4/12 md:w-3/12",
                src: (0, $6d4b57eddd9e5082$export$3c67ec6258c4a827) + cartItem?.itemDetail?.info?.imageId,
                alt: ""
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "w-6/12 h-full flex flex-col gap-1 md:w-7/12",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                        className: "truncate font-bold text-blue-950",
                        children: cartItem?.itemDetail?.info?.name
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "truncate",
                        children: cartItem.itemDetail?.info?.description
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "truncate flex gap-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "font-bold",
                                children: [
                                    "\u20B9",
                                    cartItem?.totalAmountOfAllItem
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                children: [
                                    "(",
                                    cartItem?.totalAmountOfAllItem / cartItem?.totalNumberOfItem,
                                    "\xd7",
                                    cartItem?.totalNumberOfItem,
                                    ")"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex gap-2 bg-blue-900 text-white w-fit px-2 py-1",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: ()=>dispatch((0, $c764300c7515c1f3$export$73500405dadd14a8)(cartItem?.itemDetail?.info?.id)),
                                className: "disabled:text-blue-500 hover:scale-150 transition-all ease-in-out duration-300",
                                disabled: cartItem.totalNumberOfItem <= 1,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                    className: "ri-subtract-line"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: cartItem?.totalNumberOfItem
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "hover:scale-150 transition-all ease-in-out duration-300",
                                onClick: ()=>dispatch((0, $c764300c7515c1f3$export$14145c7f329054b8)(cartItem?.itemDetail?.info?.id)),
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                    className: "ri-add-line "
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                onClick: ()=>dispatch((0, $c764300c7515c1f3$export$fe2d9b4e03920b4c)(cartItem?.itemDetail?.info?.id)),
                className: "w-1/12 mr-2 text-white transition duration-500 ease-linear hover:text-blue-900 hover:scale-150 ",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                    className: "ri-close-circle-fill text-4xl"
                })
            })
        ]
    });
};
var $f007916f0583fb3f$export$2e2bcd8739ae039 = $f007916f0583fb3f$var$CartItemList;




parcelRequire("acw62");



// this component is show the total item ,saved money and total amount paid by user in cart page section at the bottom in mobile view and at the right in tablet view and laptop view
const $73cd3ad8bf51c8f1$var$CartSummary = ()=>{
    const cartItems = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.cartSlice.cartItems);
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const totalAmountPaid = cartItems.reduce((acc, item)=>acc + item.totalAmountOfAllItem, 0);
    const discountedAmount = totalAmountPaid * 10 / 100;
    const deliveryCharge = totalAmountPaid * 5 / 100;
    const totalActualAmountPaid = totalAmountPaid - discountedAmount + deliveryCharge;
    const savedAmount = totalAmountPaid - totalActualAmountPaid;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "h-[30%] w-full mx-auto md:h-full md:w-6/12 md:flex md:flex-col md:gap-3 md:py-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: " px-2 font-bold text-xl text-center text-blue-900 border-b-2 mx-2 border-blue-100 md:text-3xl py-2 lg:text-4xl",
                children: "Order Summary"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: " py-1 mt-1 w-11/12 bg-blue-100 px-1 mx-auto flex flex-col gap-1 md:gap-4 md:py-5 rounded-xl lg:px-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "flex justify-between",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "md:text-lg lg:text-2xl",
                                children: [
                                    " ",
                                    "Price (",
                                    cartItems.length,
                                    " items)"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "md:text-lg font-bold text-blue-900 lg:text-2xl",
                                children: [
                                    "\u20B9 ",
                                    (totalAmountPaid - 0).toFixed(2)
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "flex justify-between",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "md:text-lg lg:text-2xl",
                                children: "Discount (10%)"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "md:text-lg font-bold text-blue-900 lg:text-2xl",
                                children: [
                                    "- \u20B9 ",
                                    (discountedAmount - 0).toFixed(2)
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "flex justify-between",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "md:text-lg lg:text-2xl",
                                children: "Delivery Charge (5%)"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "md:text-lg font-bold text-blue-900 lg:text-2xl",
                                children: [
                                    "+ \u20B9 ",
                                    (deliveryCharge - 0).toFixed(2)
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "border-y-2 border-blue-900 text-blue-900 py-1 :text-md md:py-3 text-center lg:text-2xl",
                        children: [
                            "You'll save ",
                            (savedAmount - 0).toFixed(2),
                            " on this order \uD83C\uDF89"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex justify-between md:flex-col gap-3 items-center lg:gap-6",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "md:text-xl lg:text-2xl",
                                        children: " Total Amount "
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "text-blue-100 rounded  md:rounded-md font-bold md:text-xl lg:text-2xl md:px-1 bg-blue-900 lg:px-3 lg:py-1 lg:rounded-xl",
                                        children: [
                                            "\u20B9",
                                            (totalActualAmountPaid - 0).toFixed(2)
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: ()=>{
                                    dispatch((0, $c764300c7515c1f3$export$cf2d04cce5f7b536)());
                                    (0, $ecf70d86349bf38f$export$f6cef6fcf9ca4e17)("Place Order Successfully");
                                },
                                className: "bg-white border border-blue-900 text-blue-900 transition duration-500 ease-linear hover:bg-blue-900 hover:text-white font-bold rounded-lg px-2 md:text-lg lg:text-2xl lg:px-5 lg:py-3",
                                children: "Place Order"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $73cd3ad8bf51c8f1$export$2e2bcd8739ae039 = $73cd3ad8bf51c8f1$var$CartSummary;



// this component show cart page with cart item list and cart summary component
const $fa5cada1489effcc$var$CartPage = ()=>{
    const cartItems = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.cartSlice.cartItems);
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "h-[80vh] flex flex-col md:gap-4 lg:gap-10",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: "h-[7%] text-2xl font-bold md:text-3xl text-center text-blue-900 md:pt-1 lg:text-5xl lg:pt-3",
                children: "Cart"
            }),
            !cartItems.length && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: " w-11/12 px-3 mx-auto gap-3 bg-blue-100 h-[30%] flex flex-col justify-center items-center md:text-xl font-bold lg:gap-4 lg:h-[90%]",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-center",
                        children: "Turn an empty cart into a culinary canvas with Dish Dazzel\u2014where every cart is a chance to create a delicious masterpiece."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        to: "/",
                        className: "text-blue-900 font-bold ",
                        children: "Explore our irresistible food now!"
                    })
                ]
            }),
            cartItems.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "h-[93%] w-full flex flex-col md:flex-row",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "h-[56%] bg-blue-50 rounded-3xl py-2 w-full mx-auto  md:h-[90%] md:w-7/12 flex flex-col justify-center",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "h-full overflow-y-scroll overflow-x-hidden scrollbar-hide m-2",
                                children: cartItems.map((items)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f007916f0583fb3f$export$2e2bcd8739ae039), {
                                        cartItem: items
                                    }, items.itemDetail.info.id))
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: ()=>{
                                    dispatch((0, $c764300c7515c1f3$export$cf2d04cce5f7b536)());
                                    (0, $ecf70d86349bf38f$export$f6cef6fcf9ca4e17)("Cart Cleared");
                                },
                                className: "h-8 rounded-xl border border-blue-900 bg-white text-blue-900 transition duration-500 ease-linear hover:bg-blue-900 hover:text-white w-3/12 mx-auto md:text-xl md:h-10 md:w-1/5 ",
                                children: "Clear All"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $73cd3ad8bf51c8f1$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    });
};
var $fa5cada1489effcc$export$2e2bcd8739ae039 = $fa5cada1489effcc$var$CartPage;



parcelRequire("acw62");

// Generate Component About Page 
const $213e0fec855ce3bb$var$AboutPage = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "h-[80vh] bg-blue-50 px-2 gap-2 flex flex-col-reverse justify-center md:py-5 md:gap-5 md:items-center  lg:gap-10 lg:flex-row",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "lg:w-8/12 h-1/2 flex flex-col md:gap-5 lg:gap-10 text-center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                        className: "text-2xl md:text-4xl lg:text-5xl font-bold text-blue-950 ",
                        children: "DishDazzle: A Culinary Extravaganza"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-md md:text-lg",
                        children: "Step into the enchanting world of DishDazzle, where every dish is a culinary masterpiece. Our menu is a symphony of flavors, a dance of spices, and a celebration of exquisite tastes. Join us in savoring the extraordinary, as DishDazzle transforms dining into an unforgettable experience."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: "https://www.dealsshutter.com/blog/wp-content/uploads/2020/01/food-577222_1280.jpg",
                className: "w-full md:w-2/3 md:h-1/2 lg:w-4/12 lg:h-5/6 rounded-full border-4 border-blue-200 p-2",
                alt: ""
            })
        ]
    });
};
var $213e0fec855ce3bb$export$2e2bcd8739ae039 = $213e0fec855ce3bb$var$AboutPage;



parcelRequire("acw62");

var $7YFi7 = parcelRequire("7YFi7");
const $c798475fc5eb7ae4$export$6f57813fe9f31bf9 = {
    _origin: "https://api.emailjs.com"
};


const $521ca2b4a362b637$export$2cd8252107eb640b = (publicKey, origin = "https://api.emailjs.com")=>{
    (0, $c798475fc5eb7ae4$export$6f57813fe9f31bf9)._userID = publicKey;
    (0, $c798475fc5eb7ae4$export$6f57813fe9f31bf9)._origin = origin;
};



const $8aba84d3e3f02408$export$1f3bf48e9edf7d72 = (publicKey, serviceID, templateID)=>{
    if (!publicKey) throw "The public key is required. Visit https://dashboard.emailjs.com/admin/account";
    if (!serviceID) throw "The service ID is required. Visit https://dashboard.emailjs.com/admin";
    if (!templateID) throw "The template ID is required. Visit https://dashboard.emailjs.com/admin/templates";
    return true;
};


class $365480cad2bbacec$export$29b488039e3d4c2d {
    constructor(httpResponse){
        this.status = httpResponse ? httpResponse.status : 0;
        this.text = httpResponse ? httpResponse.responseText : "Network Error";
    }
}



const $ec190f1f3b1ae57b$export$4a68059d3a005c64 = (url, data, headers = {})=>{
    return new Promise((resolve, reject)=>{
        const xhr = new XMLHttpRequest();
        xhr.addEventListener("load", ({ target: target })=>{
            const responseStatus = new (0, $365480cad2bbacec$export$29b488039e3d4c2d)(target);
            if (responseStatus.status === 200 || responseStatus.text === "OK") resolve(responseStatus);
            else reject(responseStatus);
        });
        xhr.addEventListener("error", ({ target: target })=>{
            reject(new (0, $365480cad2bbacec$export$29b488039e3d4c2d)(target));
        });
        xhr.open("POST", (0, $c798475fc5eb7ae4$export$6f57813fe9f31bf9)._origin + url, true);
        Object.keys(headers).forEach((key)=>{
            xhr.setRequestHeader(key, headers[key]);
        });
        xhr.send(data);
    });
};


const $4e1a944052b5621b$export$89db4734f6c919c4 = (serviceID, templateID, templatePrams, publicKey)=>{
    const uID = publicKey || (0, $c798475fc5eb7ae4$export$6f57813fe9f31bf9)._userID;
    (0, $8aba84d3e3f02408$export$1f3bf48e9edf7d72)(uID, serviceID, templateID);
    const params = {
        lib_version: "3.11.0",
        user_id: uID,
        service_id: serviceID,
        template_id: templateID,
        template_params: templatePrams
    };
    return (0, $ec190f1f3b1ae57b$export$4a68059d3a005c64)("/api/v1.0/email/send", JSON.stringify(params), {
        "Content-type": "application/json"
    });
};





const $4a4df2b20f870b5d$var$findHTMLForm = (form)=>{
    let currentForm;
    if (typeof form === "string") currentForm = document.querySelector(form);
    else currentForm = form;
    if (!currentForm || currentForm.nodeName !== "FORM") throw "The 3rd parameter is expected to be the HTML form element or the style selector of form";
    return currentForm;
};
const $4a4df2b20f870b5d$export$c13a0f9407ffb567 = (serviceID, templateID, form, publicKey)=>{
    const uID = publicKey || (0, $c798475fc5eb7ae4$export$6f57813fe9f31bf9)._userID;
    const currentForm = $4a4df2b20f870b5d$var$findHTMLForm(form);
    (0, $8aba84d3e3f02408$export$1f3bf48e9edf7d72)(uID, serviceID, templateID);
    const formData = new FormData(currentForm);
    formData.append("lib_version", "3.11.0");
    formData.append("service_id", serviceID);
    formData.append("template_id", templateID);
    formData.append("user_id", uID);
    return (0, $ec190f1f3b1ae57b$export$4a68059d3a005c64)("/api/v1.0/email/send-form", formData);
};


var $e8e08de5e84870c6$export$2e2bcd8739ae039 = {
    init: $521ca2b4a362b637$export$2cd8252107eb640b,
    send: $4e1a944052b5621b$export$89db4734f6c919c4,
    sendForm: $4a4df2b20f870b5d$export$c13a0f9407ffb567
};


var $0a34a21cae127bf5$exports = {};
/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */ "use strict";
function $0a34a21cae127bf5$var$Cache(maxSize) {
    this._maxSize = maxSize;
    this.clear();
}
$0a34a21cae127bf5$var$Cache.prototype.clear = function() {
    this._size = 0;
    this._values = Object.create(null);
};
$0a34a21cae127bf5$var$Cache.prototype.get = function(key) {
    return this._values[key];
};
$0a34a21cae127bf5$var$Cache.prototype.set = function(key, value) {
    this._size >= this._maxSize && this.clear();
    if (!(key in this._values)) this._size++;
    return this._values[key] = value;
};
var $0a34a21cae127bf5$var$SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g, $0a34a21cae127bf5$var$DIGIT_REGEX = /^\d+$/, $0a34a21cae127bf5$var$LEAD_DIGIT_REGEX = /^\d/, $0a34a21cae127bf5$var$SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, $0a34a21cae127bf5$var$CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/, $0a34a21cae127bf5$var$MAX_CACHE_SIZE = 512;
var $0a34a21cae127bf5$var$pathCache = new $0a34a21cae127bf5$var$Cache($0a34a21cae127bf5$var$MAX_CACHE_SIZE), $0a34a21cae127bf5$var$setCache = new $0a34a21cae127bf5$var$Cache($0a34a21cae127bf5$var$MAX_CACHE_SIZE), $0a34a21cae127bf5$var$getCache = new $0a34a21cae127bf5$var$Cache($0a34a21cae127bf5$var$MAX_CACHE_SIZE);
var $0a34a21cae127bf5$var$config;
$0a34a21cae127bf5$exports = {
    Cache: $0a34a21cae127bf5$var$Cache,
    split: $0a34a21cae127bf5$var$split,
    normalizePath: $0a34a21cae127bf5$var$normalizePath,
    setter: function(path) {
        var parts = $0a34a21cae127bf5$var$normalizePath(path);
        return $0a34a21cae127bf5$var$setCache.get(path) || $0a34a21cae127bf5$var$setCache.set(path, function setter(obj, value) {
            var index = 0;
            var len = parts.length;
            var data = obj;
            while(index < len - 1){
                var part = parts[index];
                if (part === "__proto__" || part === "constructor" || part === "prototype") return obj;
                data = data[parts[index++]];
            }
            data[parts[index]] = value;
        });
    },
    getter: function(path, safe) {
        var parts = $0a34a21cae127bf5$var$normalizePath(path);
        return $0a34a21cae127bf5$var$getCache.get(path) || $0a34a21cae127bf5$var$getCache.set(path, function getter(data) {
            var index = 0, len = parts.length;
            while(index < len){
                if (data != null || !safe) data = data[parts[index++]];
                else return;
            }
            return data;
        });
    },
    join: function(segments) {
        return segments.reduce(function(path, part) {
            return path + ($0a34a21cae127bf5$var$isQuoted(part) || $0a34a21cae127bf5$var$DIGIT_REGEX.test(part) ? "[" + part + "]" : (path ? "." : "") + part);
        }, "");
    },
    forEach: function(path, cb, thisArg) {
        $0a34a21cae127bf5$var$forEach(Array.isArray(path) ? path : $0a34a21cae127bf5$var$split(path), cb, thisArg);
    }
};
function $0a34a21cae127bf5$var$normalizePath(path) {
    return $0a34a21cae127bf5$var$pathCache.get(path) || $0a34a21cae127bf5$var$pathCache.set(path, $0a34a21cae127bf5$var$split(path).map(function(part) {
        return part.replace($0a34a21cae127bf5$var$CLEAN_QUOTES_REGEX, "$2");
    }));
}
function $0a34a21cae127bf5$var$split(path) {
    return path.match($0a34a21cae127bf5$var$SPLIT_REGEX) || [
        ""
    ];
}
function $0a34a21cae127bf5$var$forEach(parts, iter, thisArg) {
    var len = parts.length, part, idx, isArray, isBracket;
    for(idx = 0; idx < len; idx++){
        part = parts[idx];
        if (part) {
            if ($0a34a21cae127bf5$var$shouldBeQuoted(part)) part = '"' + part + '"';
            isBracket = $0a34a21cae127bf5$var$isQuoted(part);
            isArray = !isBracket && /^\d+$/.test(part);
            iter.call(thisArg, part, isBracket, isArray, idx, parts);
        }
    }
}
function $0a34a21cae127bf5$var$isQuoted(str) {
    return typeof str === "string" && str && [
        "'",
        '"'
    ].indexOf(str.charAt(0)) !== -1;
}
function $0a34a21cae127bf5$var$hasLeadingNumber(part) {
    return part.match($0a34a21cae127bf5$var$LEAD_DIGIT_REGEX) && !part.match($0a34a21cae127bf5$var$DIGIT_REGEX);
}
function $0a34a21cae127bf5$var$hasSpecialChars(part) {
    return $0a34a21cae127bf5$var$SPEC_CHAR_REGEX.test(part);
}
function $0a34a21cae127bf5$var$shouldBeQuoted(part) {
    return !$0a34a21cae127bf5$var$isQuoted(part) && ($0a34a21cae127bf5$var$hasLeadingNumber(part) || $0a34a21cae127bf5$var$hasSpecialChars(part));
}


var $d2ed6e977f19f182$exports = {};
const $d2ed6e977f19f182$var$reWords = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:1ST|2ND|3RD|(?![123])\dTH)(?=\b|[a-z_])|\d*(?:1st|2nd|3rd|(?![123])\dth)(?=\b|[A-Z_])|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g;
const $d2ed6e977f19f182$var$words = (str)=>str.match($d2ed6e977f19f182$var$reWords) || [];
const $d2ed6e977f19f182$var$upperFirst = (str)=>str[0].toUpperCase() + str.slice(1);
const $d2ed6e977f19f182$var$join = (str, d)=>$d2ed6e977f19f182$var$words(str).join(d).toLowerCase();
const $d2ed6e977f19f182$var$camelCase = (str)=>$d2ed6e977f19f182$var$words(str).reduce((acc, next)=>`${acc}${!acc ? next.toLowerCase() : next[0].toUpperCase() + next.slice(1).toLowerCase()}`, "");
const $d2ed6e977f19f182$var$pascalCase = (str)=>$d2ed6e977f19f182$var$upperFirst($d2ed6e977f19f182$var$camelCase(str));
const $d2ed6e977f19f182$var$snakeCase = (str)=>$d2ed6e977f19f182$var$join(str, "_");
const $d2ed6e977f19f182$var$kebabCase = (str)=>$d2ed6e977f19f182$var$join(str, "-");
const $d2ed6e977f19f182$var$sentenceCase = (str)=>$d2ed6e977f19f182$var$upperFirst($d2ed6e977f19f182$var$join(str, " "));
const $d2ed6e977f19f182$var$titleCase = (str)=>$d2ed6e977f19f182$var$words(str).map($d2ed6e977f19f182$var$upperFirst).join(" ");
$d2ed6e977f19f182$exports = {
    words: $d2ed6e977f19f182$var$words,
    upperFirst: $d2ed6e977f19f182$var$upperFirst,
    camelCase: $d2ed6e977f19f182$var$camelCase,
    pascalCase: $d2ed6e977f19f182$var$pascalCase,
    snakeCase: $d2ed6e977f19f182$var$snakeCase,
    kebabCase: $d2ed6e977f19f182$var$kebabCase,
    sentenceCase: $d2ed6e977f19f182$var$sentenceCase,
    titleCase: $d2ed6e977f19f182$var$titleCase
};


var $a2cee144eac47a21$exports = {};
/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */ $a2cee144eac47a21$exports = function(edges) {
    return $a2cee144eac47a21$var$toposort($a2cee144eac47a21$var$uniqueNodes(edges), edges);
};
$a2cee144eac47a21$exports.array = $a2cee144eac47a21$var$toposort;
function $a2cee144eac47a21$var$toposort(nodes, edges) {
    var cursor = nodes.length, sorted = new Array(cursor), visited = {}, i = cursor, outgoingEdges = $a2cee144eac47a21$var$makeOutgoingEdges(edges), nodesHash = $a2cee144eac47a21$var$makeNodesHash(nodes);
    // check for unknown nodes
    edges.forEach(function(edge) {
        if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) throw new Error("Unknown node. There is an unknown node in the supplied edges.");
    });
    while(i--)if (!visited[i]) visit(nodes[i], i, new Set());
    return sorted;
    function visit(node, i, predecessors) {
        if (predecessors.has(node)) {
            var nodeRep;
            try {
                nodeRep = ", node was:" + JSON.stringify(node);
            } catch (e) {
                nodeRep = "";
            }
            throw new Error("Cyclic dependency" + nodeRep);
        }
        if (!nodesHash.has(node)) throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(node));
        if (visited[i]) return;
        visited[i] = true;
        var outgoing = outgoingEdges.get(node) || new Set();
        outgoing = Array.from(outgoing);
        if (i = outgoing.length) {
            predecessors.add(node);
            do {
                var child = outgoing[--i];
                visit(child, nodesHash.get(child), predecessors);
            }while (i);
            predecessors.delete(node);
        }
        sorted[--cursor] = node;
    }
}
function $a2cee144eac47a21$var$uniqueNodes(arr) {
    var res = new Set();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        res.add(edge[0]);
        res.add(edge[1]);
    }
    return Array.from(res);
}
function $a2cee144eac47a21$var$makeOutgoingEdges(arr) {
    var edges = new Map();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        if (!edges.has(edge[0])) edges.set(edge[0], new Set());
        if (!edges.has(edge[1])) edges.set(edge[1], new Set());
        edges.get(edge[0]).add(edge[1]);
    }
    return edges;
}
function $a2cee144eac47a21$var$makeNodesHash(arr) {
    var res = new Map();
    for(var i = 0, len = arr.length; i < len; i++)res.set(arr[i], i);
    return res;
}


const $cda9d0e1103d595f$var$toString = Object.prototype.toString;
const $cda9d0e1103d595f$var$errorToString = Error.prototype.toString;
const $cda9d0e1103d595f$var$regExpToString = RegExp.prototype.toString;
const $cda9d0e1103d595f$var$symbolToString = typeof Symbol !== "undefined" ? Symbol.prototype.toString : ()=>"";
const $cda9d0e1103d595f$var$SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
function $cda9d0e1103d595f$var$printNumber(val) {
    if (val != +val) return "NaN";
    const isNegativeZero = val === 0 && 1 / val < 0;
    return isNegativeZero ? "-0" : "" + val;
}
function $cda9d0e1103d595f$var$printSimpleValue(val, quoteStrings = false) {
    if (val == null || val === true || val === false) return "" + val;
    const typeOf = typeof val;
    if (typeOf === "number") return $cda9d0e1103d595f$var$printNumber(val);
    if (typeOf === "string") return quoteStrings ? `"${val}"` : val;
    if (typeOf === "function") return "[Function " + (val.name || "anonymous") + "]";
    if (typeOf === "symbol") return $cda9d0e1103d595f$var$symbolToString.call(val).replace($cda9d0e1103d595f$var$SYMBOL_REGEXP, "Symbol($1)");
    const tag = $cda9d0e1103d595f$var$toString.call(val).slice(8, -1);
    if (tag === "Date") return isNaN(val.getTime()) ? "" + val : val.toISOString(val);
    if (tag === "Error" || val instanceof Error) return "[" + $cda9d0e1103d595f$var$errorToString.call(val) + "]";
    if (tag === "RegExp") return $cda9d0e1103d595f$var$regExpToString.call(val);
    return null;
}
function $cda9d0e1103d595f$export$5790025c6e6c2ba6(value, quoteStrings) {
    let result = $cda9d0e1103d595f$var$printSimpleValue(value, quoteStrings);
    if (result !== null) return result;
    return JSON.stringify(value, function(key, value) {
        let result = $cda9d0e1103d595f$var$printSimpleValue(this[key], quoteStrings);
        if (result !== null) return result;
        return value;
    }, 2);
}
function $cda9d0e1103d595f$var$toArray(value) {
    return value == null ? [] : [].concat(value);
}
let $cda9d0e1103d595f$var$_Symbol$toStringTag;
let $cda9d0e1103d595f$var$strReg = /\$\{\s*(\w+)\s*\}/g;
$cda9d0e1103d595f$var$_Symbol$toStringTag = Symbol.toStringTag;
class $cda9d0e1103d595f$export$2191b9da168c6cf0 extends Error {
    static formatError(message, params) {
        const path = params.label || params.path || "this";
        if (path !== params.path) params = Object.assign({}, params, {
            path: path
        });
        if (typeof message === "string") return message.replace($cda9d0e1103d595f$var$strReg, (_, key)=>$cda9d0e1103d595f$export$5790025c6e6c2ba6(params[key]));
        if (typeof message === "function") return message(params);
        return message;
    }
    static isError(err) {
        return err && err.name === "ValidationError";
    }
    constructor(errorOrErrors, value, field, type, disableStack){
        super();
        this.value = void 0;
        this.path = void 0;
        this.type = void 0;
        this.errors = void 0;
        this.params = void 0;
        this.inner = void 0;
        this[$cda9d0e1103d595f$var$_Symbol$toStringTag] = "Error";
        this.name = "ValidationError";
        this.value = value;
        this.path = field;
        this.type = type;
        this.errors = [];
        this.inner = [];
        $cda9d0e1103d595f$var$toArray(errorOrErrors).forEach((err)=>{
            if ($cda9d0e1103d595f$export$2191b9da168c6cf0.isError(err)) {
                this.errors.push(...err.errors);
                const innerErrors = err.inner.length ? err.inner : [
                    err
                ];
                this.inner.push(...innerErrors);
            } else this.errors.push(err);
        });
        this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
        if (!disableStack && Error.captureStackTrace) Error.captureStackTrace(this, $cda9d0e1103d595f$export$2191b9da168c6cf0);
    }
}
let $cda9d0e1103d595f$var$mixed = {
    default: "${path} is invalid",
    required: "${path} is a required field",
    defined: "${path} must be defined",
    notNull: "${path} cannot be null",
    oneOf: "${path} must be one of the following values: ${values}",
    notOneOf: "${path} must not be one of the following values: ${values}",
    notType: ({ path: path, type: type, value: value, originalValue: originalValue })=>{
        const castMsg = originalValue != null && originalValue !== value ? ` (cast from the value \`${$cda9d0e1103d595f$export$5790025c6e6c2ba6(originalValue, true)}\`).` : ".";
        return type !== "mixed" ? `${path} must be a \`${type}\` type, ` + `but the final value was: \`${$cda9d0e1103d595f$export$5790025c6e6c2ba6(value, true)}\`` + castMsg : `${path} must match the configured type. ` + `The validated value was: \`${$cda9d0e1103d595f$export$5790025c6e6c2ba6(value, true)}\`` + castMsg;
    }
};
let $cda9d0e1103d595f$var$string = {
    length: "${path} must be exactly ${length} characters",
    min: "${path} must be at least ${min} characters",
    max: "${path} must be at most ${max} characters",
    matches: '${path} must match the following: "${regex}"',
    email: "${path} must be a valid email",
    url: "${path} must be a valid URL",
    uuid: "${path} must be a valid UUID",
    trim: "${path} must be a trimmed string",
    lowercase: "${path} must be a lowercase string",
    uppercase: "${path} must be a upper case string"
};
let $cda9d0e1103d595f$var$number = {
    min: "${path} must be greater than or equal to ${min}",
    max: "${path} must be less than or equal to ${max}",
    lessThan: "${path} must be less than ${less}",
    moreThan: "${path} must be greater than ${more}",
    positive: "${path} must be a positive number",
    negative: "${path} must be a negative number",
    integer: "${path} must be an integer"
};
let $cda9d0e1103d595f$var$date = {
    min: "${path} field must be later than ${min}",
    max: "${path} field must be at earlier than ${max}"
};
let $cda9d0e1103d595f$var$boolean = {
    isValue: "${path} field must be ${value}"
};
let $cda9d0e1103d595f$var$object = {
    noUnknown: "${path} field has unspecified keys: ${unknown}"
};
let $cda9d0e1103d595f$var$array = {
    min: "${path} field must have at least ${min} items",
    max: "${path} field must have less than or equal to ${max} items",
    length: "${path} must have ${length} items"
};
let $cda9d0e1103d595f$var$tuple = {
    notType: (params)=>{
        const { path: path, value: value, spec: spec } = params;
        const typeLen = spec.types.length;
        if (Array.isArray(value)) {
            if (value.length < typeLen) return `${path} tuple value has too few items, expected a length of ${typeLen} but got ${value.length} for value: \`${$cda9d0e1103d595f$export$5790025c6e6c2ba6(value, true)}\``;
            if (value.length > typeLen) return `${path} tuple value has too many items, expected a length of ${typeLen} but got ${value.length} for value: \`${$cda9d0e1103d595f$export$5790025c6e6c2ba6(value, true)}\``;
        }
        return $cda9d0e1103d595f$export$2191b9da168c6cf0.formatError($cda9d0e1103d595f$var$mixed.notType, params);
    }
};
var $cda9d0e1103d595f$export$d7f512c98c859244 = Object.assign(Object.create(null), {
    mixed: $cda9d0e1103d595f$var$mixed,
    string: $cda9d0e1103d595f$var$string,
    number: $cda9d0e1103d595f$var$number,
    date: $cda9d0e1103d595f$var$date,
    object: $cda9d0e1103d595f$var$object,
    array: $cda9d0e1103d595f$var$array,
    boolean: $cda9d0e1103d595f$var$boolean,
    tuple: $cda9d0e1103d595f$var$tuple
});
const $cda9d0e1103d595f$export$213e2a3e7c4f326e = (obj)=>obj && obj.__isYupSchema__;
class $cda9d0e1103d595f$var$Condition {
    static fromOptions(refs, config) {
        if (!config.then && !config.otherwise) throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
        let { is: is, then: then, otherwise: otherwise } = config;
        let check = typeof is === "function" ? is : (...values)=>values.every((value)=>value === is);
        return new $cda9d0e1103d595f$var$Condition(refs, (values, schema)=>{
            var _branch;
            let branch = check(...values) ? then : otherwise;
            return (_branch = branch == null ? void 0 : branch(schema)) != null ? _branch : schema;
        });
    }
    constructor(refs, builder){
        this.fn = void 0;
        this.refs = refs;
        this.refs = refs;
        this.fn = builder;
    }
    resolve(base, options) {
        let values = this.refs.map((ref)=>// TODO: ? operator here?
            ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
        let schema = this.fn(values, base, options);
        if (schema === undefined || // @ts-ignore this can be base
        schema === base) return base;
        if (!$cda9d0e1103d595f$export$213e2a3e7c4f326e(schema)) throw new TypeError("conditions must return a schema object");
        return schema.resolve(options);
    }
}
const $cda9d0e1103d595f$var$prefixes = {
    context: "$",
    value: "."
};
function $cda9d0e1103d595f$export$eff4d24c3ff7876e(key, options) {
    return new $cda9d0e1103d595f$var$Reference(key, options);
}
class $cda9d0e1103d595f$var$Reference {
    constructor(key, options = {}){
        this.key = void 0;
        this.isContext = void 0;
        this.isValue = void 0;
        this.isSibling = void 0;
        this.path = void 0;
        this.getter = void 0;
        this.map = void 0;
        if (typeof key !== "string") throw new TypeError("ref must be a string, got: " + key);
        this.key = key.trim();
        if (key === "") throw new TypeError("ref must be a non-empty string");
        this.isContext = this.key[0] === $cda9d0e1103d595f$var$prefixes.context;
        this.isValue = this.key[0] === $cda9d0e1103d595f$var$prefixes.value;
        this.isSibling = !this.isContext && !this.isValue;
        let prefix = this.isContext ? $cda9d0e1103d595f$var$prefixes.context : this.isValue ? $cda9d0e1103d595f$var$prefixes.value : "";
        this.path = this.key.slice(prefix.length);
        this.getter = this.path && (0, $0a34a21cae127bf5$exports.getter)(this.path, true);
        this.map = options.map;
    }
    getValue(value, parent, context) {
        let result = this.isContext ? context : this.isValue ? value : parent;
        if (this.getter) result = this.getter(result || {});
        if (this.map) result = this.map(result);
        return result;
    }
    /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */ cast(value, options) {
        return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
    }
    resolve() {
        return this;
    }
    describe() {
        return {
            type: "ref",
            key: this.key
        };
    }
    toString() {
        return `Ref(${this.key})`;
    }
    static isRef(value) {
        return value && value.__isYupRef;
    }
}
// @ts-ignore
$cda9d0e1103d595f$var$Reference.prototype.__isYupRef = true;
const $cda9d0e1103d595f$var$isAbsent = (value)=>value == null;
function $cda9d0e1103d595f$var$createValidation(config) {
    function validate({ value: value, path: path = "", options: options, originalValue: originalValue, schema: schema }, panic, next) {
        const { name: name, test: test, params: params, message: message, skipAbsent: skipAbsent } = config;
        let { parent: parent, context: context, abortEarly: abortEarly = schema.spec.abortEarly, disableStackTrace: disableStackTrace = schema.spec.disableStackTrace } = options;
        function resolve(item) {
            return $cda9d0e1103d595f$var$Reference.isRef(item) ? item.getValue(value, parent, context) : item;
        }
        function createError(overrides = {}) {
            var _overrides$disableSta;
            const nextParams = Object.assign({
                value: value,
                originalValue: originalValue,
                label: schema.spec.label,
                path: overrides.path || path,
                spec: schema.spec
            }, params, overrides.params);
            for (const key of Object.keys(nextParams))nextParams[key] = resolve(nextParams[key]);
            const error = new $cda9d0e1103d595f$export$2191b9da168c6cf0($cda9d0e1103d595f$export$2191b9da168c6cf0.formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name, (_overrides$disableSta = overrides.disableStackTrace) != null ? _overrides$disableSta : disableStackTrace);
            error.params = nextParams;
            return error;
        }
        const invalid = abortEarly ? panic : next;
        let ctx = {
            path: path,
            parent: parent,
            type: name,
            from: options.from,
            createError: createError,
            resolve: resolve,
            options: options,
            originalValue: originalValue,
            schema: schema
        };
        const handleResult = (validOrError)=>{
            if ($cda9d0e1103d595f$export$2191b9da168c6cf0.isError(validOrError)) invalid(validOrError);
            else if (!validOrError) invalid(createError());
            else next(null);
        };
        const handleError = (err)=>{
            if ($cda9d0e1103d595f$export$2191b9da168c6cf0.isError(err)) invalid(err);
            else panic(err);
        };
        const shouldSkip = skipAbsent && $cda9d0e1103d595f$var$isAbsent(value);
        if (shouldSkip) return handleResult(true);
        let result;
        try {
            var _result;
            result = test.call(ctx, value, ctx);
            if (typeof ((_result = result) == null ? void 0 : _result.then) === "function") {
                if (options.sync) throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. ` + `This test will finish after the validate call has returned`);
                return Promise.resolve(result).then(handleResult, handleError);
            }
        } catch (err) {
            handleError(err);
            return;
        }
        handleResult(result);
    }
    validate.OPTIONS = config;
    return validate;
}
function $cda9d0e1103d595f$export$c52e5867d5879e24(schema, path, value, context = value) {
    let parent, lastPart, lastPartDebug;
    // root path: ''
    if (!path) return {
        parent: parent,
        parentPath: path,
        schema: schema
    };
    (0, $0a34a21cae127bf5$exports.forEach)(path, (_part, isBracket, isArray)=>{
        let part = isBracket ? _part.slice(1, _part.length - 1) : _part;
        schema = schema.resolve({
            context: context,
            parent: parent,
            value: value
        });
        let isTuple = schema.type === "tuple";
        let idx = isArray ? parseInt(part, 10) : 0;
        if (schema.innerType || isTuple) {
            if (isTuple && !isArray) throw new Error(`Yup.reach cannot implicitly index into a tuple type. the path part "${lastPartDebug}" must contain an index to the tuple element, e.g. "${lastPartDebug}[0]"`);
            if (value && idx >= value.length) throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. ` + `because there is no value at that index. `);
            parent = value;
            value = value && value[idx];
            schema = isTuple ? schema.spec.types[idx] : schema.innerType;
        }
        // sometimes the array index part of a path doesn't exist: "nested.arr.child"
        // in these cases the current part is the next schema and should be processed
        // in this iteration. For cases where the index signature is included this
        // check will fail and we'll handle the `child` part on the next iteration like normal
        if (!isArray) {
            if (!schema.fields || !schema.fields[part]) throw new Error(`The schema does not contain the path: ${path}. ` + `(failed at: ${lastPartDebug} which is a type: "${schema.type}")`);
            parent = value;
            value = value && value[part];
            schema = schema.fields[part];
        }
        lastPart = part;
        lastPartDebug = isBracket ? "[" + _part + "]" : "." + _part;
    });
    return {
        schema: schema,
        parent: parent,
        parentPath: lastPart
    };
}
function $cda9d0e1103d595f$export$cfedb76369cc7782(obj, path, value, context) {
    return $cda9d0e1103d595f$export$c52e5867d5879e24(obj, path, value, context).schema;
}
class $cda9d0e1103d595f$var$ReferenceSet extends Set {
    describe() {
        const description = [];
        for (const item of this.values())description.push($cda9d0e1103d595f$var$Reference.isRef(item) ? item.describe() : item);
        return description;
    }
    resolveAll(resolve) {
        let result = [];
        for (const item of this.values())result.push(resolve(item));
        return result;
    }
    clone() {
        return new $cda9d0e1103d595f$var$ReferenceSet(this.values());
    }
    merge(newItems, removeItems) {
        const next = this.clone();
        newItems.forEach((value)=>next.add(value));
        removeItems.forEach((value)=>next.delete(value));
        return next;
    }
}
// tweaked from https://github.com/Kelin2025/nanoclone/blob/0abeb7635bda9b68ef2277093f76dbe3bf3948e1/src/index.js
function $cda9d0e1103d595f$var$clone(src, seen = new Map()) {
    if ($cda9d0e1103d595f$export$213e2a3e7c4f326e(src) || !src || typeof src !== "object") return src;
    if (seen.has(src)) return seen.get(src);
    let copy;
    if (src instanceof Date) {
        // Date
        copy = new Date(src.getTime());
        seen.set(src, copy);
    } else if (src instanceof RegExp) {
        // RegExp
        copy = new RegExp(src);
        seen.set(src, copy);
    } else if (Array.isArray(src)) {
        // Array
        copy = new Array(src.length);
        seen.set(src, copy);
        for(let i = 0; i < src.length; i++)copy[i] = $cda9d0e1103d595f$var$clone(src[i], seen);
    } else if (src instanceof Map) {
        // Map
        copy = new Map();
        seen.set(src, copy);
        for (const [k, v] of src.entries())copy.set(k, $cda9d0e1103d595f$var$clone(v, seen));
    } else if (src instanceof Set) {
        // Set
        copy = new Set();
        seen.set(src, copy);
        for (const v of src)copy.add($cda9d0e1103d595f$var$clone(v, seen));
    } else if (src instanceof Object) {
        // Object
        copy = {};
        seen.set(src, copy);
        for (const [k, v] of Object.entries(src))copy[k] = $cda9d0e1103d595f$var$clone(v, seen);
    } else throw Error(`Unable to clone ${src}`);
    return copy;
}
// If `CustomSchemaMeta` isn't extended with any keys, we'll fall back to a
// loose Record definition allowing free form usage.
class $cda9d0e1103d595f$export$19342e026b58ebb7 {
    constructor(options){
        this.type = void 0;
        this.deps = [];
        this.tests = void 0;
        this.transforms = void 0;
        this.conditions = [];
        this._mutate = void 0;
        this.internalTests = {};
        this._whitelist = new $cda9d0e1103d595f$var$ReferenceSet();
        this._blacklist = new $cda9d0e1103d595f$var$ReferenceSet();
        this.exclusiveTests = Object.create(null);
        this._typeCheck = void 0;
        this.spec = void 0;
        this.tests = [];
        this.transforms = [];
        this.withMutation(()=>{
            this.typeError($cda9d0e1103d595f$var$mixed.notType);
        });
        this.type = options.type;
        this._typeCheck = options.check;
        this.spec = Object.assign({
            strip: false,
            strict: false,
            abortEarly: true,
            recursive: true,
            disableStackTrace: false,
            nullable: false,
            optional: true,
            coerce: true
        }, options == null ? void 0 : options.spec);
        this.withMutation((s)=>{
            s.nonNullable();
        });
    }
    // TODO: remove
    get _type() {
        return this.type;
    }
    clone(spec) {
        if (this._mutate) {
            if (spec) Object.assign(this.spec, spec);
            return this;
        }
        // if the nested value is a schema we can skip cloning, since
        // they are already immutable
        const next = Object.create(Object.getPrototypeOf(this));
        // @ts-expect-error this is readonly
        next.type = this.type;
        next._typeCheck = this._typeCheck;
        next._whitelist = this._whitelist.clone();
        next._blacklist = this._blacklist.clone();
        next.internalTests = Object.assign({}, this.internalTests);
        next.exclusiveTests = Object.assign({}, this.exclusiveTests);
        // @ts-expect-error this is readonly
        next.deps = [
            ...this.deps
        ];
        next.conditions = [
            ...this.conditions
        ];
        next.tests = [
            ...this.tests
        ];
        next.transforms = [
            ...this.transforms
        ];
        next.spec = $cda9d0e1103d595f$var$clone(Object.assign({}, this.spec, spec));
        return next;
    }
    label(label) {
        let next = this.clone();
        next.spec.label = label;
        return next;
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
    withMutation(fn) {
        let before = this._mutate;
        this._mutate = true;
        let result = fn(this);
        this._mutate = before;
        return result;
    }
    concat(schema) {
        if (!schema || schema === this) return this;
        if (schema.type !== this.type && this.type !== "mixed") throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
        let base = this;
        let combined = schema.clone();
        const mergedSpec = Object.assign({}, base.spec, combined.spec);
        combined.spec = mergedSpec;
        combined.internalTests = Object.assign({}, base.internalTests, combined.internalTests);
        // manually merge the blacklist/whitelist (the other `schema` takes
        // precedence in case of conflicts)
        combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
        combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist);
        // start with the current tests
        combined.tests = base.tests;
        combined.exclusiveTests = base.exclusiveTests;
        // manually add the new tests to ensure
        // the deduping logic is consistent
        combined.withMutation((next)=>{
            schema.tests.forEach((fn)=>{
                next.test(fn.OPTIONS);
            });
        });
        combined.transforms = [
            ...base.transforms,
            ...combined.transforms
        ];
        return combined;
    }
    isType(v) {
        if (v == null) {
            if (this.spec.nullable && v === null) return true;
            if (this.spec.optional && v === undefined) return true;
            return false;
        }
        return this._typeCheck(v);
    }
    resolve(options) {
        let schema = this;
        if (schema.conditions.length) {
            let conditions = schema.conditions;
            schema = schema.clone();
            schema.conditions = [];
            schema = conditions.reduce((prevSchema, condition)=>condition.resolve(prevSchema, options), schema);
            schema = schema.resolve(options);
        }
        return schema;
    }
    resolveOptions(options) {
        var _options$strict, _options$abortEarly, _options$recursive, _options$disableStack;
        return Object.assign({}, options, {
            from: options.from || [],
            strict: (_options$strict = options.strict) != null ? _options$strict : this.spec.strict,
            abortEarly: (_options$abortEarly = options.abortEarly) != null ? _options$abortEarly : this.spec.abortEarly,
            recursive: (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive,
            disableStackTrace: (_options$disableStack = options.disableStackTrace) != null ? _options$disableStack : this.spec.disableStackTrace
        });
    }
    /**
   * Run the configured transform pipeline over an input value.
   */ cast(value, options = {}) {
        let resolvedSchema = this.resolve(Object.assign({
            value: value
        }, options));
        let allowOptionality = options.assert === "ignore-optionality";
        let result = resolvedSchema._cast(value, options);
        if (options.assert !== false && !resolvedSchema.isType(result)) {
            if (allowOptionality && $cda9d0e1103d595f$var$isAbsent(result)) return result;
            let formattedValue = $cda9d0e1103d595f$export$5790025c6e6c2ba6(value);
            let formattedResult = $cda9d0e1103d595f$export$5790025c6e6c2ba6(result);
            throw new TypeError(`The value of ${options.path || "field"} could not be cast to a value ` + `that satisfies the schema type: "${resolvedSchema.type}". \n\n` + `attempted value: ${formattedValue} \n` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ""));
        }
        return result;
    }
    _cast(rawValue, options) {
        let value = rawValue === undefined ? rawValue : this.transforms.reduce((prevValue, fn)=>fn.call(this, prevValue, rawValue, this), rawValue);
        if (value === undefined) value = this.getDefault(options);
        return value;
    }
    _validate(_value, options = {}, panic, next) {
        let { path: path, originalValue: originalValue = _value, strict: strict = this.spec.strict } = options;
        let value = _value;
        if (!strict) value = this._cast(value, Object.assign({
            assert: false
        }, options));
        let initialTests = [];
        for (let test of Object.values(this.internalTests))if (test) initialTests.push(test);
        this.runTests({
            path: path,
            value: value,
            originalValue: originalValue,
            options: options,
            tests: initialTests
        }, panic, (initialErrors)=>{
            // even if we aren't ending early we can't proceed further if the types aren't correct
            if (initialErrors.length) return next(initialErrors, value);
            this.runTests({
                path: path,
                value: value,
                originalValue: originalValue,
                options: options,
                tests: this.tests
            }, panic, next);
        });
    }
    /**
   * Executes a set of validations, either schema, produced Tests or a nested
   * schema validate result.
   */ runTests(runOptions, panic, next) {
        let fired = false;
        let { tests: tests, value: value, originalValue: originalValue, path: path, options: options } = runOptions;
        let panicOnce = (arg)=>{
            if (fired) return;
            fired = true;
            panic(arg, value);
        };
        let nextOnce = (arg)=>{
            if (fired) return;
            fired = true;
            next(arg, value);
        };
        let count = tests.length;
        let nestedErrors = [];
        if (!count) return nextOnce([]);
        let args = {
            value: value,
            originalValue: originalValue,
            path: path,
            options: options,
            schema: this
        };
        for(let i = 0; i < tests.length; i++){
            const test = tests[i];
            test(args, panicOnce, function finishTestRun(err) {
                if (err) Array.isArray(err) ? nestedErrors.push(...err) : nestedErrors.push(err);
                if (--count <= 0) nextOnce(nestedErrors);
            });
        }
    }
    asNestedTest({ key: key, index: index, parent: parent, parentPath: parentPath, originalParent: originalParent, options: options }) {
        const k = key != null ? key : index;
        if (k == null) throw TypeError("Must include `key` or `index` for nested validations");
        const isIndex = typeof k === "number";
        let value = parent[k];
        const testOptions = Object.assign({}, options, {
            // Nested validations fields are always strict:
            //    1. parent isn't strict so the casting will also have cast inner values
            //    2. parent is strict in which case the nested values weren't cast either
            strict: true,
            parent: parent,
            value: value,
            originalValue: originalParent[k],
            // FIXME: tests depend on `index` being passed around deeply,
            //   we should not let the options.key/index bleed through
            key: undefined,
            // index: undefined,
            [isIndex ? "index" : "key"]: k,
            path: isIndex || k.includes(".") ? `${parentPath || ""}[${value ? k : `"${k}"`}]` : (parentPath ? `${parentPath}.` : "") + key
        });
        return (_, panic, next)=>this.resolve(testOptions)._validate(value, testOptions, panic, next);
    }
    validate(value, options) {
        var _options$disableStack2;
        let schema = this.resolve(Object.assign({}, options, {
            value: value
        }));
        let disableStackTrace = (_options$disableStack2 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack2 : schema.spec.disableStackTrace;
        return new Promise((resolve, reject)=>schema._validate(value, options, (error, parsed)=>{
                if ($cda9d0e1103d595f$export$2191b9da168c6cf0.isError(error)) error.value = parsed;
                reject(error);
            }, (errors, validated)=>{
                if (errors.length) reject(new $cda9d0e1103d595f$export$2191b9da168c6cf0(errors, validated, undefined, undefined, disableStackTrace));
                else resolve(validated);
            }));
    }
    validateSync(value, options) {
        var _options$disableStack3;
        let schema = this.resolve(Object.assign({}, options, {
            value: value
        }));
        let result;
        let disableStackTrace = (_options$disableStack3 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack3 : schema.spec.disableStackTrace;
        schema._validate(value, Object.assign({}, options, {
            sync: true
        }), (error, parsed)=>{
            if ($cda9d0e1103d595f$export$2191b9da168c6cf0.isError(error)) error.value = parsed;
            throw error;
        }, (errors, validated)=>{
            if (errors.length) throw new $cda9d0e1103d595f$export$2191b9da168c6cf0(errors, value, undefined, undefined, disableStackTrace);
            result = validated;
        });
        return result;
    }
    isValid(value, options) {
        return this.validate(value, options).then(()=>true, (err)=>{
            if ($cda9d0e1103d595f$export$2191b9da168c6cf0.isError(err)) return false;
            throw err;
        });
    }
    isValidSync(value, options) {
        try {
            this.validateSync(value, options);
            return true;
        } catch (err) {
            if ($cda9d0e1103d595f$export$2191b9da168c6cf0.isError(err)) return false;
            throw err;
        }
    }
    _getDefault(options) {
        let defaultValue = this.spec.default;
        if (defaultValue == null) return defaultValue;
        return typeof defaultValue === "function" ? defaultValue.call(this, options) : $cda9d0e1103d595f$var$clone(defaultValue);
    }
    getDefault(options) {
        let schema = this.resolve(options || {});
        return schema._getDefault(options);
    }
    default(def) {
        if (arguments.length === 0) return this._getDefault();
        let next = this.clone({
            default: def
        });
        return next;
    }
    strict(isStrict = true) {
        return this.clone({
            strict: isStrict
        });
    }
    nullability(nullable, message) {
        const next = this.clone({
            nullable: nullable
        });
        next.internalTests.nullable = $cda9d0e1103d595f$var$createValidation({
            message: message,
            name: "nullable",
            test (value) {
                return value === null ? this.schema.spec.nullable : true;
            }
        });
        return next;
    }
    optionality(optional, message) {
        const next = this.clone({
            optional: optional
        });
        next.internalTests.optionality = $cda9d0e1103d595f$var$createValidation({
            message: message,
            name: "optionality",
            test (value) {
                return value === undefined ? this.schema.spec.optional : true;
            }
        });
        return next;
    }
    optional() {
        return this.optionality(true);
    }
    defined(message = $cda9d0e1103d595f$var$mixed.defined) {
        return this.optionality(false, message);
    }
    nullable() {
        return this.nullability(true);
    }
    nonNullable(message = $cda9d0e1103d595f$var$mixed.notNull) {
        return this.nullability(false, message);
    }
    required(message = $cda9d0e1103d595f$var$mixed.required) {
        return this.clone().withMutation((next)=>next.nonNullable(message).defined(message));
    }
    notRequired() {
        return this.clone().withMutation((next)=>next.nullable().optional());
    }
    transform(fn) {
        let next = this.clone();
        next.transforms.push(fn);
        return next;
    }
    /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */ test(...args) {
        let opts;
        if (args.length === 1) {
            if (typeof args[0] === "function") opts = {
                test: args[0]
            };
            else opts = args[0];
        } else if (args.length === 2) opts = {
            name: args[0],
            test: args[1]
        };
        else opts = {
            name: args[0],
            message: args[1],
            test: args[2]
        };
        if (opts.message === undefined) opts.message = $cda9d0e1103d595f$var$mixed.default;
        if (typeof opts.test !== "function") throw new TypeError("`test` is a required parameters");
        let next = this.clone();
        let validate = $cda9d0e1103d595f$var$createValidation(opts);
        let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;
        if (opts.exclusive) {
            if (!opts.name) throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
        }
        if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
        next.tests = next.tests.filter((fn)=>{
            if (fn.OPTIONS.name === opts.name) {
                if (isExclusive) return false;
                if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
            }
            return true;
        });
        next.tests.push(validate);
        return next;
    }
    when(keys, options) {
        if (!Array.isArray(keys) && typeof keys !== "string") {
            options = keys;
            keys = ".";
        }
        let next = this.clone();
        let deps = $cda9d0e1103d595f$var$toArray(keys).map((key)=>new $cda9d0e1103d595f$var$Reference(key));
        deps.forEach((dep)=>{
            // @ts-ignore readonly array
            if (dep.isSibling) next.deps.push(dep.key);
        });
        next.conditions.push(typeof options === "function" ? new $cda9d0e1103d595f$var$Condition(deps, options) : $cda9d0e1103d595f$var$Condition.fromOptions(deps, options));
        return next;
    }
    typeError(message) {
        let next = this.clone();
        next.internalTests.typeError = $cda9d0e1103d595f$var$createValidation({
            message: message,
            name: "typeError",
            skipAbsent: true,
            test (value) {
                if (!this.schema._typeCheck(value)) return this.createError({
                    params: {
                        type: this.schema.type
                    }
                });
                return true;
            }
        });
        return next;
    }
    oneOf(enums, message = $cda9d0e1103d595f$var$mixed.oneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._whitelist.add(val);
            next._blacklist.delete(val);
        });
        next.internalTests.whiteList = $cda9d0e1103d595f$var$createValidation({
            message: message,
            name: "oneOf",
            skipAbsent: true,
            test (value) {
                let valids = this.schema._whitelist;
                let resolved = valids.resolveAll(this.resolve);
                return resolved.includes(value) ? true : this.createError({
                    params: {
                        values: Array.from(valids).join(", "),
                        resolved: resolved
                    }
                });
            }
        });
        return next;
    }
    notOneOf(enums, message = $cda9d0e1103d595f$var$mixed.notOneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._blacklist.add(val);
            next._whitelist.delete(val);
        });
        next.internalTests.blacklist = $cda9d0e1103d595f$var$createValidation({
            message: message,
            name: "notOneOf",
            test (value) {
                let invalids = this.schema._blacklist;
                let resolved = invalids.resolveAll(this.resolve);
                if (resolved.includes(value)) return this.createError({
                    params: {
                        values: Array.from(invalids).join(", "),
                        resolved: resolved
                    }
                });
                return true;
            }
        });
        return next;
    }
    strip(strip = true) {
        let next = this.clone();
        next.spec.strip = strip;
        return next;
    }
    /**
   * Return a serialized description of the schema including validations, flags, types etc.
   *
   * @param options Provide any needed context for resolving runtime schema alterations (lazy, when conditions, etc).
   */ describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const { label: label, meta: meta, optional: optional, nullable: nullable } = next.spec;
        const description = {
            meta: meta,
            label: label,
            optional: optional,
            nullable: nullable,
            default: next.getDefault(options),
            type: next.type,
            oneOf: next._whitelist.describe(),
            notOneOf: next._blacklist.describe(),
            tests: next.tests.map((fn)=>({
                    name: fn.OPTIONS.name,
                    params: fn.OPTIONS.params
                })).filter((n, idx, list)=>list.findIndex((c)=>c.name === n.name) === idx)
        };
        return description;
    }
}
// @ts-expect-error
$cda9d0e1103d595f$export$19342e026b58ebb7.prototype.__isYupSchema__ = true;
for (const method of [
    "validate",
    "validateSync"
])$cda9d0e1103d595f$export$19342e026b58ebb7.prototype[`${method}At`] = function(path, value, options = {}) {
    const { parent: parent, parentPath: parentPath, schema: schema } = $cda9d0e1103d595f$export$c52e5867d5879e24(this, path, value, options.context);
    return schema[method](parent && parent[parentPath], Object.assign({}, options, {
        parent: parent,
        path: path
    }));
};
for (const alias of [
    "equals",
    "is"
])$cda9d0e1103d595f$export$19342e026b58ebb7.prototype[alias] = $cda9d0e1103d595f$export$19342e026b58ebb7.prototype.oneOf;
for (const alias of [
    "not",
    "nope"
])$cda9d0e1103d595f$export$19342e026b58ebb7.prototype[alias] = $cda9d0e1103d595f$export$19342e026b58ebb7.prototype.notOneOf;
const $cda9d0e1103d595f$var$returnsTrue = ()=>true;
function $cda9d0e1103d595f$export$9b30b6294c1449a8(spec) {
    return new $cda9d0e1103d595f$export$1e88358c94ddec71(spec);
}
class $cda9d0e1103d595f$export$1e88358c94ddec71 extends $cda9d0e1103d595f$export$19342e026b58ebb7 {
    constructor(spec){
        super(typeof spec === "function" ? {
            type: "mixed",
            check: spec
        } : Object.assign({
            type: "mixed",
            check: $cda9d0e1103d595f$var$returnsTrue
        }, spec));
    }
}
$cda9d0e1103d595f$export$9b30b6294c1449a8.prototype = $cda9d0e1103d595f$export$1e88358c94ddec71.prototype;
function $cda9d0e1103d595f$export$87b259aa03e3d267() {
    return new $cda9d0e1103d595f$export$c7980688f11e1f49();
}
class $cda9d0e1103d595f$export$c7980688f11e1f49 extends $cda9d0e1103d595f$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: "boolean",
            check (v) {
                if (v instanceof Boolean) v = v.valueOf();
                return typeof v === "boolean";
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                if (ctx.spec.coerce && !ctx.isType(value)) {
                    if (/^(true|1)$/i.test(String(value))) return true;
                    if (/^(false|0)$/i.test(String(value))) return false;
                }
                return value;
            });
        });
    }
    isTrue(message = $cda9d0e1103d595f$var$boolean.isValue) {
        return this.test({
            message: message,
            name: "is-value",
            exclusive: true,
            params: {
                value: "true"
            },
            test (value) {
                return $cda9d0e1103d595f$var$isAbsent(value) || value === true;
            }
        });
    }
    isFalse(message = $cda9d0e1103d595f$var$boolean.isValue) {
        return this.test({
            message: message,
            name: "is-value",
            exclusive: true,
            params: {
                value: "false"
            },
            test (value) {
                return $cda9d0e1103d595f$var$isAbsent(value) || value === false;
            }
        });
    }
    default(def) {
        return super.default(def);
    }
    defined(msg) {
        return super.defined(msg);
    }
    optional() {
        return super.optional();
    }
    required(msg) {
        return super.required(msg);
    }
    notRequired() {
        return super.notRequired();
    }
    nullable() {
        return super.nullable();
    }
    nonNullable(msg) {
        return super.nonNullable(msg);
    }
    strip(v) {
        return super.strip(v);
    }
}
$cda9d0e1103d595f$export$87b259aa03e3d267.prototype = $cda9d0e1103d595f$export$c7980688f11e1f49.prototype;
// Taken from HTML spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
let $cda9d0e1103d595f$var$rEmail = // eslint-disable-next-line
/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
let $cda9d0e1103d595f$var$rUrl = // eslint-disable-next-line
/^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i;
// eslint-disable-next-line
let $cda9d0e1103d595f$var$rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
let $cda9d0e1103d595f$var$isTrimmed = (value)=>$cda9d0e1103d595f$var$isAbsent(value) || value === value.trim();
let $cda9d0e1103d595f$var$objStringTag = ({}).toString();
function $cda9d0e1103d595f$export$22b082955e083ec3() {
    return new $cda9d0e1103d595f$export$49bf8b2ede5138eb();
}
class $cda9d0e1103d595f$export$49bf8b2ede5138eb extends $cda9d0e1103d595f$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: "string",
            check (value) {
                if (value instanceof String) value = value.valueOf();
                return typeof value === "string";
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                if (!ctx.spec.coerce || ctx.isType(value)) return value;
                // don't ever convert arrays
                if (Array.isArray(value)) return value;
                const strValue = value != null && value.toString ? value.toString() : value;
                // no one wants plain objects converted to [Object object]
                if (strValue === $cda9d0e1103d595f$var$objStringTag) return value;
                return strValue;
            });
        });
    }
    required(message) {
        return super.required(message).withMutation((schema)=>schema.test({
                message: message || $cda9d0e1103d595f$var$mixed.required,
                name: "required",
                skipAbsent: true,
                test: (value)=>!!value.length
            }));
    }
    notRequired() {
        return super.notRequired().withMutation((schema)=>{
            schema.tests = schema.tests.filter((t)=>t.OPTIONS.name !== "required");
            return schema;
        });
    }
    length(length, message = $cda9d0e1103d595f$var$string.length) {
        return this.test({
            message: message,
            name: "length",
            exclusive: true,
            params: {
                length: length
            },
            skipAbsent: true,
            test (value) {
                return value.length === this.resolve(length);
            }
        });
    }
    min(min, message = $cda9d0e1103d595f$var$string.min) {
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value.length >= this.resolve(min);
            }
        });
    }
    max(max, message = $cda9d0e1103d595f$var$string.max) {
        return this.test({
            name: "max",
            exclusive: true,
            message: message,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value.length <= this.resolve(max);
            }
        });
    }
    matches(regex, options) {
        let excludeEmptyString = false;
        let message;
        let name;
        if (options) {
            if (typeof options === "object") ({ excludeEmptyString: excludeEmptyString = false, message: message, name: name } = options);
            else message = options;
        }
        return this.test({
            name: name || "matches",
            message: message || $cda9d0e1103d595f$var$string.matches,
            params: {
                regex: regex
            },
            skipAbsent: true,
            test: (value)=>value === "" && excludeEmptyString || value.search(regex) !== -1
        });
    }
    email(message = $cda9d0e1103d595f$var$string.email) {
        return this.matches($cda9d0e1103d595f$var$rEmail, {
            name: "email",
            message: message,
            excludeEmptyString: true
        });
    }
    url(message = $cda9d0e1103d595f$var$string.url) {
        return this.matches($cda9d0e1103d595f$var$rUrl, {
            name: "url",
            message: message,
            excludeEmptyString: true
        });
    }
    uuid(message = $cda9d0e1103d595f$var$string.uuid) {
        return this.matches($cda9d0e1103d595f$var$rUUID, {
            name: "uuid",
            message: message,
            excludeEmptyString: false
        });
    }
    //-- transforms --
    ensure() {
        return this.default("").transform((val)=>val === null ? "" : val);
    }
    trim(message = $cda9d0e1103d595f$var$string.trim) {
        return this.transform((val)=>val != null ? val.trim() : val).test({
            message: message,
            name: "trim",
            test: $cda9d0e1103d595f$var$isTrimmed
        });
    }
    lowercase(message = $cda9d0e1103d595f$var$string.lowercase) {
        return this.transform((value)=>!$cda9d0e1103d595f$var$isAbsent(value) ? value.toLowerCase() : value).test({
            message: message,
            name: "string_case",
            exclusive: true,
            skipAbsent: true,
            test: (value)=>$cda9d0e1103d595f$var$isAbsent(value) || value === value.toLowerCase()
        });
    }
    uppercase(message = $cda9d0e1103d595f$var$string.uppercase) {
        return this.transform((value)=>!$cda9d0e1103d595f$var$isAbsent(value) ? value.toUpperCase() : value).test({
            message: message,
            name: "string_case",
            exclusive: true,
            skipAbsent: true,
            test: (value)=>$cda9d0e1103d595f$var$isAbsent(value) || value === value.toUpperCase()
        });
    }
}
$cda9d0e1103d595f$export$22b082955e083ec3.prototype = $cda9d0e1103d595f$export$49bf8b2ede5138eb.prototype;
//
// String Interfaces
//
let $cda9d0e1103d595f$var$isNaN$1 = (value)=>value != +value;
function $cda9d0e1103d595f$export$98e628dec113755e() {
    return new $cda9d0e1103d595f$export$f192ec5e9228ab19();
}
class $cda9d0e1103d595f$export$f192ec5e9228ab19 extends $cda9d0e1103d595f$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: "number",
            check (value) {
                if (value instanceof Number) value = value.valueOf();
                return typeof value === "number" && !$cda9d0e1103d595f$var$isNaN$1(value);
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                if (!ctx.spec.coerce) return value;
                let parsed = value;
                if (typeof parsed === "string") {
                    parsed = parsed.replace(/\s/g, "");
                    if (parsed === "") return NaN;
                    // don't use parseFloat to avoid positives on alpha-numeric strings
                    parsed = +parsed;
                }
                // null -> NaN isn't useful; treat all nulls as null and let it fail on
                // nullability check vs TypeErrors
                if (ctx.isType(parsed) || parsed === null) return parsed;
                return parseFloat(parsed);
            });
        });
    }
    min(min, message = $cda9d0e1103d595f$var$number.min) {
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value >= this.resolve(min);
            }
        });
    }
    max(max, message = $cda9d0e1103d595f$var$number.max) {
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value <= this.resolve(max);
            }
        });
    }
    lessThan(less, message = $cda9d0e1103d595f$var$number.lessThan) {
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                less: less
            },
            skipAbsent: true,
            test (value) {
                return value < this.resolve(less);
            }
        });
    }
    moreThan(more, message = $cda9d0e1103d595f$var$number.moreThan) {
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                more: more
            },
            skipAbsent: true,
            test (value) {
                return value > this.resolve(more);
            }
        });
    }
    positive(msg = $cda9d0e1103d595f$var$number.positive) {
        return this.moreThan(0, msg);
    }
    negative(msg = $cda9d0e1103d595f$var$number.negative) {
        return this.lessThan(0, msg);
    }
    integer(message = $cda9d0e1103d595f$var$number.integer) {
        return this.test({
            name: "integer",
            message: message,
            skipAbsent: true,
            test: (val)=>Number.isInteger(val)
        });
    }
    truncate() {
        return this.transform((value)=>!$cda9d0e1103d595f$var$isAbsent(value) ? value | 0 : value);
    }
    round(method) {
        var _method;
        let avail = [
            "ceil",
            "floor",
            "round",
            "trunc"
        ];
        method = ((_method = method) == null ? void 0 : _method.toLowerCase()) || "round";
        // this exists for symemtry with the new Math.trunc
        if (method === "trunc") return this.truncate();
        if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError("Only valid options for round() are: " + avail.join(", "));
        return this.transform((value)=>!$cda9d0e1103d595f$var$isAbsent(value) ? Math[method](value) : value);
    }
}
$cda9d0e1103d595f$export$98e628dec113755e.prototype = $cda9d0e1103d595f$export$f192ec5e9228ab19.prototype;
//
// Number Interfaces
//
/**
 * This file is a modified version of the file from the following repository:
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */ // prettier-ignore
//                1 YYYY                2 MM        3 DD              4 HH     5 mm        6 ss           7 msec         8 Z 9 ±   10 tzHH    11 tzmm
const $cda9d0e1103d595f$var$isoReg = /^(\d{4}|[+-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,.](\d{1,}))?)?(?:(Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/;
function $cda9d0e1103d595f$var$toNumber(str, defaultValue = 0) {
    return Number(str) || defaultValue;
}
function $cda9d0e1103d595f$var$parseIsoDate(date) {
    const regexResult = $cda9d0e1103d595f$var$isoReg.exec(date);
    if (!regexResult) return Date.parse ? Date.parse(date) : Number.NaN;
    // use of toNumber() avoids NaN timestamps caused by “undefined”
    // values being passed to Date constructor
    const struct = {
        year: $cda9d0e1103d595f$var$toNumber(regexResult[1]),
        month: $cda9d0e1103d595f$var$toNumber(regexResult[2], 1) - 1,
        day: $cda9d0e1103d595f$var$toNumber(regexResult[3], 1),
        hour: $cda9d0e1103d595f$var$toNumber(regexResult[4]),
        minute: $cda9d0e1103d595f$var$toNumber(regexResult[5]),
        second: $cda9d0e1103d595f$var$toNumber(regexResult[6]),
        millisecond: regexResult[7] ? // allow arbitrary sub-second precision beyond milliseconds
        $cda9d0e1103d595f$var$toNumber(regexResult[7].substring(0, 3)) : 0,
        z: regexResult[8] || undefined,
        plusMinus: regexResult[9] || undefined,
        hourOffset: $cda9d0e1103d595f$var$toNumber(regexResult[10]),
        minuteOffset: $cda9d0e1103d595f$var$toNumber(regexResult[11])
    };
    // timestamps without timezone identifiers should be considered local time
    if (struct.z === undefined && struct.plusMinus === undefined) return new Date(struct.year, struct.month, struct.day, struct.hour, struct.minute, struct.second, struct.millisecond).valueOf();
    let totalMinutesOffset = 0;
    if (struct.z !== "Z" && struct.plusMinus !== undefined) {
        totalMinutesOffset = struct.hourOffset * 60 + struct.minuteOffset;
        if (struct.plusMinus === "+") totalMinutesOffset = 0 - totalMinutesOffset;
    }
    return Date.UTC(struct.year, struct.month, struct.day, struct.hour, struct.minute + totalMinutesOffset, struct.second, struct.millisecond);
}
let $cda9d0e1103d595f$var$invalidDate = new Date("");
let $cda9d0e1103d595f$var$isDate = (obj)=>Object.prototype.toString.call(obj) === "[object Date]";
function $cda9d0e1103d595f$export$324d90190a8b822a() {
    return new $cda9d0e1103d595f$export$18ec3cc5a157503f();
}
class $cda9d0e1103d595f$export$18ec3cc5a157503f extends $cda9d0e1103d595f$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: "date",
            check (v) {
                return $cda9d0e1103d595f$var$isDate(v) && !isNaN(v.getTime());
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                // null -> InvalidDate isn't useful; treat all nulls as null and let it fail on
                // nullability check vs TypeErrors
                if (!ctx.spec.coerce || ctx.isType(value) || value === null) return value;
                value = $cda9d0e1103d595f$var$parseIsoDate(value);
                // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.
                return !isNaN(value) ? new Date(value) : $cda9d0e1103d595f$export$18ec3cc5a157503f.INVALID_DATE;
            });
        });
    }
    prepareParam(ref, name) {
        let param;
        if (!$cda9d0e1103d595f$var$Reference.isRef(ref)) {
            let cast = this.cast(ref);
            if (!this._typeCheck(cast)) throw new TypeError(`\`${name}\` must be a Date or a value that can be \`cast()\` to a Date`);
            param = cast;
        } else param = ref;
        return param;
    }
    min(min, message = $cda9d0e1103d595f$var$date.min) {
        let limit = this.prepareParam(min, "min");
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value >= this.resolve(limit);
            }
        });
    }
    max(max, message = $cda9d0e1103d595f$var$date.max) {
        let limit = this.prepareParam(max, "max");
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value <= this.resolve(limit);
            }
        });
    }
}
$cda9d0e1103d595f$export$18ec3cc5a157503f.INVALID_DATE = $cda9d0e1103d595f$var$invalidDate;
$cda9d0e1103d595f$export$324d90190a8b822a.prototype = $cda9d0e1103d595f$export$18ec3cc5a157503f.prototype;
$cda9d0e1103d595f$export$324d90190a8b822a.INVALID_DATE = $cda9d0e1103d595f$var$invalidDate;
// @ts-expect-error
function $cda9d0e1103d595f$var$sortFields(fields, excludedEdges = []) {
    let edges = [];
    let nodes = new Set();
    let excludes = new Set(excludedEdges.map(([a, b])=>`${a}-${b}`));
    function addNode(depPath, key) {
        let node = (0, $0a34a21cae127bf5$exports.split)(depPath)[0];
        nodes.add(node);
        if (!excludes.has(`${key}-${node}`)) edges.push([
            key,
            node
        ]);
    }
    for (const key of Object.keys(fields)){
        let value = fields[key];
        nodes.add(key);
        if ($cda9d0e1103d595f$var$Reference.isRef(value) && value.isSibling) addNode(value.path, key);
        else if ($cda9d0e1103d595f$export$213e2a3e7c4f326e(value) && "deps" in value) value.deps.forEach((path)=>addNode(path, key));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($a2cee144eac47a21$exports))).array(Array.from(nodes), edges).reverse();
}
function $cda9d0e1103d595f$var$findIndex(arr, err) {
    let idx = Infinity;
    arr.some((key, ii)=>{
        var _err$path;
        if ((_err$path = err.path) != null && _err$path.includes(key)) {
            idx = ii;
            return true;
        }
    });
    return idx;
}
function $cda9d0e1103d595f$var$sortByKeyOrder(keys) {
    return (a, b)=>{
        return $cda9d0e1103d595f$var$findIndex(keys, a) - $cda9d0e1103d595f$var$findIndex(keys, b);
    };
}
const $cda9d0e1103d595f$var$parseJson = (value, _, ctx)=>{
    if (typeof value !== "string") return value;
    let parsed = value;
    try {
        parsed = JSON.parse(value);
    } catch (err) {
    /* */ }
    return ctx.isType(parsed) ? parsed : value;
};
// @ts-ignore
function $cda9d0e1103d595f$var$deepPartial(schema) {
    if ("fields" in schema) {
        const partial = {};
        for (const [key, fieldSchema] of Object.entries(schema.fields))partial[key] = $cda9d0e1103d595f$var$deepPartial(fieldSchema);
        return schema.setFields(partial);
    }
    if (schema.type === "array") {
        const nextArray = schema.optional();
        if (nextArray.innerType) nextArray.innerType = $cda9d0e1103d595f$var$deepPartial(nextArray.innerType);
        return nextArray;
    }
    if (schema.type === "tuple") return schema.optional().clone({
        types: schema.spec.types.map($cda9d0e1103d595f$var$deepPartial)
    });
    if ("optional" in schema) return schema.optional();
    return schema;
}
const $cda9d0e1103d595f$var$deepHas = (obj, p)=>{
    const path = [
        ...(0, $0a34a21cae127bf5$exports.normalizePath)(p)
    ];
    if (path.length === 1) return path[0] in obj;
    let last = path.pop();
    let parent = (0, $0a34a21cae127bf5$exports.getter)((0, $0a34a21cae127bf5$exports.join)(path), true)(obj);
    return !!(parent && last in parent);
};
let $cda9d0e1103d595f$var$isObject = (obj)=>Object.prototype.toString.call(obj) === "[object Object]";
function $cda9d0e1103d595f$var$unknown(ctx, value) {
    let known = Object.keys(ctx.fields);
    return Object.keys(value).filter((key)=>known.indexOf(key) === -1);
}
const $cda9d0e1103d595f$var$defaultSort = $cda9d0e1103d595f$var$sortByKeyOrder([]);
function $cda9d0e1103d595f$export$be5493f9613cbbe(spec) {
    return new $cda9d0e1103d595f$export$18b4fc70ec7eccf8(spec);
}
class $cda9d0e1103d595f$export$18b4fc70ec7eccf8 extends $cda9d0e1103d595f$export$19342e026b58ebb7 {
    constructor(spec){
        super({
            type: "object",
            check (value) {
                return $cda9d0e1103d595f$var$isObject(value) || typeof value === "function";
            }
        });
        this.fields = Object.create(null);
        this._sortErrors = $cda9d0e1103d595f$var$defaultSort;
        this._nodes = [];
        this._excludedEdges = [];
        this.withMutation(()=>{
            if (spec) this.shape(spec);
        });
    }
    _cast(_value, options = {}) {
        var _options$stripUnknown;
        let value = super._cast(_value, options);
        //should ignore nulls here
        if (value === undefined) return this.getDefault(options);
        if (!this._typeCheck(value)) return value;
        let fields = this.fields;
        let strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;
        let props = [].concat(this._nodes, Object.keys(value).filter((v)=>!this._nodes.includes(v)));
        let intermediateValue = {}; // is filled during the transform below
        let innerOptions = Object.assign({}, options, {
            parent: intermediateValue,
            __validating: options.__validating || false
        });
        let isChanged = false;
        for (const prop of props){
            let field = fields[prop];
            let exists = prop in value;
            if (field) {
                let fieldValue;
                let inputValue = value[prop];
                // safe to mutate since this is fired in sequence
                innerOptions.path = (options.path ? `${options.path}.` : "") + prop;
                field = field.resolve({
                    value: inputValue,
                    context: options.context,
                    parent: intermediateValue
                });
                let fieldSpec = field instanceof $cda9d0e1103d595f$export$19342e026b58ebb7 ? field.spec : undefined;
                let strict = fieldSpec == null ? void 0 : fieldSpec.strict;
                if (fieldSpec != null && fieldSpec.strip) {
                    isChanged = isChanged || prop in value;
                    continue;
                }
                fieldValue = !options.__validating || !strict ? // TODO: use _cast, this is double resolving
                field.cast(value[prop], innerOptions) : value[prop];
                if (fieldValue !== undefined) intermediateValue[prop] = fieldValue;
            } else if (exists && !strip) intermediateValue[prop] = value[prop];
            if (exists !== prop in intermediateValue || intermediateValue[prop] !== value[prop]) isChanged = true;
        }
        return isChanged ? intermediateValue : value;
    }
    _validate(_value, options = {}, panic, next) {
        let { from: from = [], originalValue: originalValue = _value, recursive: recursive = this.spec.recursive } = options;
        options.from = [
            {
                schema: this,
                value: originalValue
            },
            ...from
        ];
        // this flag is needed for handling `strict` correctly in the context of
        // validation vs just casting. e.g strict() on a field is only used when validating
        options.__validating = true;
        options.originalValue = originalValue;
        super._validate(_value, options, panic, (objectErrors, value)=>{
            if (!recursive || !$cda9d0e1103d595f$var$isObject(value)) {
                next(objectErrors, value);
                return;
            }
            originalValue = originalValue || value;
            let tests = [];
            for (let key of this._nodes){
                let field = this.fields[key];
                if (!field || $cda9d0e1103d595f$var$Reference.isRef(field)) continue;
                tests.push(field.asNestedTest({
                    options: options,
                    key: key,
                    parent: value,
                    parentPath: options.path,
                    originalParent: originalValue
                }));
            }
            this.runTests({
                tests: tests,
                value: value,
                originalValue: originalValue,
                options: options
            }, panic, (fieldErrors)=>{
                next(fieldErrors.sort(this._sortErrors).concat(objectErrors), value);
            });
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        next.fields = Object.assign({}, this.fields);
        next._nodes = this._nodes;
        next._excludedEdges = this._excludedEdges;
        next._sortErrors = this._sortErrors;
        return next;
    }
    concat(schema) {
        let next = super.concat(schema);
        let nextFields = next.fields;
        for (let [field, schemaOrRef] of Object.entries(this.fields)){
            const target = nextFields[field];
            nextFields[field] = target === undefined ? schemaOrRef : target;
        }
        return next.withMutation((s)=>// XXX: excludes here is wrong
            s.setFields(nextFields, [
                ...this._excludedEdges,
                ...schema._excludedEdges
            ]));
    }
    _getDefault(options) {
        if ("default" in this.spec) return super._getDefault(options);
        // if there is no default set invent one
        if (!this._nodes.length) return undefined;
        let dft = {};
        this._nodes.forEach((key)=>{
            var _innerOptions;
            const field = this.fields[key];
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[key]
            });
            dft[key] = field && "getDefault" in field ? field.getDefault(innerOptions) : undefined;
        });
        return dft;
    }
    setFields(shape, excludedEdges) {
        let next = this.clone();
        next.fields = shape;
        next._nodes = $cda9d0e1103d595f$var$sortFields(shape, excludedEdges);
        next._sortErrors = $cda9d0e1103d595f$var$sortByKeyOrder(Object.keys(shape));
        // XXX: this carries over edges which may not be what you want
        if (excludedEdges) next._excludedEdges = excludedEdges;
        return next;
    }
    shape(additions, excludes = []) {
        return this.clone().withMutation((next)=>{
            let edges = next._excludedEdges;
            if (excludes.length) {
                if (!Array.isArray(excludes[0])) excludes = [
                    excludes
                ];
                edges = [
                    ...next._excludedEdges,
                    ...excludes
                ];
            }
            // XXX: excludes here is wrong
            return next.setFields(Object.assign(next.fields, additions), edges);
        });
    }
    partial() {
        const partial = {};
        for (const [key, schema] of Object.entries(this.fields))partial[key] = "optional" in schema && schema.optional instanceof Function ? schema.optional() : schema;
        return this.setFields(partial);
    }
    deepPartial() {
        const next = $cda9d0e1103d595f$var$deepPartial(this);
        return next;
    }
    pick(keys) {
        const picked = {};
        for (const key of keys)if (this.fields[key]) picked[key] = this.fields[key];
        return this.setFields(picked, this._excludedEdges.filter(([a, b])=>keys.includes(a) && keys.includes(b)));
    }
    omit(keys) {
        const remaining = [];
        for (const key of Object.keys(this.fields)){
            if (keys.includes(key)) continue;
            remaining.push(key);
        }
        return this.pick(remaining);
    }
    from(from, to, alias) {
        let fromGetter = (0, $0a34a21cae127bf5$exports.getter)(from, true);
        return this.transform((obj)=>{
            if (!obj) return obj;
            let newObj = obj;
            if ($cda9d0e1103d595f$var$deepHas(obj, from)) {
                newObj = Object.assign({}, obj);
                if (!alias) delete newObj[from];
                newObj[to] = fromGetter(obj);
            }
            return newObj;
        });
    }
    /** Parse an input JSON string to an object */ json() {
        return this.transform($cda9d0e1103d595f$var$parseJson);
    }
    noUnknown(noAllow = true, message = $cda9d0e1103d595f$var$object.noUnknown) {
        if (typeof noAllow !== "boolean") {
            message = noAllow;
            noAllow = true;
        }
        let next = this.test({
            name: "noUnknown",
            exclusive: true,
            message: message,
            test (value) {
                if (value == null) return true;
                const unknownKeys = $cda9d0e1103d595f$var$unknown(this.schema, value);
                return !noAllow || unknownKeys.length === 0 || this.createError({
                    params: {
                        unknown: unknownKeys.join(", ")
                    }
                });
            }
        });
        next.spec.noUnknown = noAllow;
        return next;
    }
    unknown(allow = true, message = $cda9d0e1103d595f$var$object.noUnknown) {
        return this.noUnknown(!allow, message);
    }
    transformKeys(fn) {
        return this.transform((obj)=>{
            if (!obj) return obj;
            const result = {};
            for (const key of Object.keys(obj))result[fn(key)] = obj[key];
            return result;
        });
    }
    camelCase() {
        return this.transformKeys((0, $d2ed6e977f19f182$exports.camelCase));
    }
    snakeCase() {
        return this.transformKeys((0, $d2ed6e977f19f182$exports.snakeCase));
    }
    constantCase() {
        return this.transformKeys((key)=>(0, $d2ed6e977f19f182$exports.snakeCase)(key).toUpperCase());
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        base.fields = {};
        for (const [key, value] of Object.entries(next.fields)){
            var _innerOptions2;
            let innerOptions = options;
            if ((_innerOptions2 = innerOptions) != null && _innerOptions2.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[key]
            });
            base.fields[key] = value.describe(innerOptions);
        }
        return base;
    }
}
$cda9d0e1103d595f$export$be5493f9613cbbe.prototype = $cda9d0e1103d595f$export$18b4fc70ec7eccf8.prototype;
function $cda9d0e1103d595f$export$2f23118c22fb2630(type) {
    return new $cda9d0e1103d595f$export$4347112b8447a7d(type);
}
class $cda9d0e1103d595f$export$4347112b8447a7d extends $cda9d0e1103d595f$export$19342e026b58ebb7 {
    constructor(type){
        super({
            type: "array",
            spec: {
                types: type
            },
            check (v) {
                return Array.isArray(v);
            }
        });
        // `undefined` specifically means uninitialized, as opposed to "no subtype"
        this.innerType = void 0;
        this.innerType = type;
    }
    _cast(_value, _opts) {
        const value = super._cast(_value, _opts);
        // should ignore nulls here
        if (!this._typeCheck(value) || !this.innerType) return value;
        let isChanged = false;
        const castArray = value.map((v, idx)=>{
            const castElement = this.innerType.cast(v, Object.assign({}, _opts, {
                path: `${_opts.path || ""}[${idx}]`
            }));
            if (castElement !== v) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, panic, next) {
        var _options$recursive;
        // let sync = options.sync;
        // let path = options.path;
        let innerType = this.innerType;
        // let endEarly = options.abortEarly ?? this.spec.abortEarly;
        let recursive = (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive;
        options.originalValue != null ? options.originalValue : _value;
        super._validate(_value, options, panic, (arrayErrors, value)=>{
            var _options$originalValu2;
            if (!recursive || !innerType || !this._typeCheck(value)) {
                next(arrayErrors, value);
                return;
            }
            // #950 Ensure that sparse array empty slots are validated
            let tests = new Array(value.length);
            for(let index = 0; index < value.length; index++){
                var _options$originalValu;
                tests[index] = innerType.asNestedTest({
                    options: options,
                    index: index,
                    parent: value,
                    parentPath: options.path,
                    originalParent: (_options$originalValu = options.originalValue) != null ? _options$originalValu : _value
                });
            }
            this.runTests({
                value: value,
                tests: tests,
                originalValue: (_options$originalValu2 = options.originalValue) != null ? _options$originalValu2 : _value,
                options: options
            }, panic, (innerTypeErrors)=>next(innerTypeErrors.concat(arrayErrors), value));
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        // @ts-expect-error readonly
        next.innerType = this.innerType;
        return next;
    }
    /** Parse an input JSON string to an object */ json() {
        return this.transform($cda9d0e1103d595f$var$parseJson);
    }
    concat(schema) {
        let next = super.concat(schema);
        // @ts-expect-error readonly
        next.innerType = this.innerType;
        if (schema.innerType) // @ts-expect-error readonly
        next.innerType = next.innerType ? // @ts-expect-error Lazy doesn't have concat and will break
        next.innerType.concat(schema.innerType) : schema.innerType;
        return next;
    }
    of(schema) {
        // FIXME: this should return a new instance of array without the default to be
        let next = this.clone();
        if (!$cda9d0e1103d595f$export$213e2a3e7c4f326e(schema)) throw new TypeError("`array.of()` sub-schema must be a valid yup schema not: " + $cda9d0e1103d595f$export$5790025c6e6c2ba6(schema));
        // @ts-expect-error readonly
        next.innerType = schema;
        next.spec = Object.assign({}, next.spec, {
            types: schema
        });
        return next;
    }
    length(length, message = $cda9d0e1103d595f$var$array.length) {
        return this.test({
            message: message,
            name: "length",
            exclusive: true,
            params: {
                length: length
            },
            skipAbsent: true,
            test (value) {
                return value.length === this.resolve(length);
            }
        });
    }
    min(min, message) {
        message = message || $cda9d0e1103d595f$var$array.min;
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            // FIXME(ts): Array<typeof T>
            test (value) {
                return value.length >= this.resolve(min);
            }
        });
    }
    max(max, message) {
        message = message || $cda9d0e1103d595f$var$array.max;
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value.length <= this.resolve(max);
            }
        });
    }
    ensure() {
        return this.default(()=>[]).transform((val, original)=>{
            // We don't want to return `null` for nullable schema
            if (this._typeCheck(val)) return val;
            return original == null ? [] : [].concat(original);
        });
    }
    compact(rejector) {
        let reject = !rejector ? (v)=>!!v : (v, i, a)=>!rejector(v, i, a);
        return this.transform((values)=>values != null ? values.filter(reject) : values);
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        if (next.innerType) {
            var _innerOptions;
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[0]
            });
            base.innerType = next.innerType.describe(innerOptions);
        }
        return base;
    }
}
$cda9d0e1103d595f$export$2f23118c22fb2630.prototype = $cda9d0e1103d595f$export$4347112b8447a7d.prototype;
// @ts-ignore
function $cda9d0e1103d595f$export$65e3907585753458(schemas) {
    return new $cda9d0e1103d595f$export$411c3b3687e8ecc8(schemas);
}
class $cda9d0e1103d595f$export$411c3b3687e8ecc8 extends $cda9d0e1103d595f$export$19342e026b58ebb7 {
    constructor(schemas){
        super({
            type: "tuple",
            spec: {
                types: schemas
            },
            check (v) {
                const types = this.spec.types;
                return Array.isArray(v) && v.length === types.length;
            }
        });
        this.withMutation(()=>{
            this.typeError($cda9d0e1103d595f$var$tuple.notType);
        });
    }
    _cast(inputValue, options) {
        const { types: types } = this.spec;
        const value = super._cast(inputValue, options);
        if (!this._typeCheck(value)) return value;
        let isChanged = false;
        const castArray = types.map((type, idx)=>{
            const castElement = type.cast(value[idx], Object.assign({}, options, {
                path: `${options.path || ""}[${idx}]`
            }));
            if (castElement !== value[idx]) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, panic, next) {
        let itemTypes = this.spec.types;
        super._validate(_value, options, panic, (tupleErrors, value)=>{
            var _options$originalValu2;
            // intentionally not respecting recursive
            if (!this._typeCheck(value)) {
                next(tupleErrors, value);
                return;
            }
            let tests = [];
            for (let [index, itemSchema] of itemTypes.entries()){
                var _options$originalValu;
                tests[index] = itemSchema.asNestedTest({
                    options: options,
                    index: index,
                    parent: value,
                    parentPath: options.path,
                    originalParent: (_options$originalValu = options.originalValue) != null ? _options$originalValu : _value
                });
            }
            this.runTests({
                value: value,
                tests: tests,
                originalValue: (_options$originalValu2 = options.originalValue) != null ? _options$originalValu2 : _value,
                options: options
            }, panic, (innerTypeErrors)=>next(innerTypeErrors.concat(tupleErrors), value));
        });
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        base.innerType = next.spec.types.map((schema, index)=>{
            var _innerOptions;
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[index]
            });
            return schema.describe(innerOptions);
        });
        return base;
    }
}
$cda9d0e1103d595f$export$65e3907585753458.prototype = $cda9d0e1103d595f$export$411c3b3687e8ecc8.prototype;
function $cda9d0e1103d595f$export$488013bae63b21da(builder) {
    return new $cda9d0e1103d595f$var$Lazy(builder);
}
class $cda9d0e1103d595f$var$Lazy {
    constructor(builder){
        this.type = "lazy";
        this.__isYupSchema__ = true;
        this.spec = void 0;
        this._resolve = (value, options = {})=>{
            let schema = this.builder(value, options);
            if (!$cda9d0e1103d595f$export$213e2a3e7c4f326e(schema)) throw new TypeError("lazy() functions must return a valid schema");
            if (this.spec.optional) schema = schema.optional();
            return schema.resolve(options);
        };
        this.builder = builder;
        this.spec = {
            meta: undefined,
            optional: false
        };
    }
    clone(spec) {
        const next = new $cda9d0e1103d595f$var$Lazy(this.builder);
        next.spec = Object.assign({}, this.spec, spec);
        return next;
    }
    optionality(optional) {
        const next = this.clone({
            optional: optional
        });
        return next;
    }
    optional() {
        return this.optionality(true);
    }
    resolve(options) {
        return this._resolve(options.value, options);
    }
    cast(value, options) {
        return this._resolve(value, options).cast(value, options);
    }
    asNestedTest(config) {
        let { key: key, index: index, parent: parent, options: options } = config;
        let value = parent[index != null ? index : key];
        return this._resolve(value, Object.assign({}, options, {
            value: value,
            parent: parent
        })).asNestedTest(config);
    }
    validate(value, options) {
        return this._resolve(value, options).validate(value, options);
    }
    validateSync(value, options) {
        return this._resolve(value, options).validateSync(value, options);
    }
    validateAt(path, value, options) {
        return this._resolve(value, options).validateAt(path, value, options);
    }
    validateSyncAt(path, value, options) {
        return this._resolve(value, options).validateSyncAt(path, value, options);
    }
    isValid(value, options) {
        return this._resolve(value, options).isValid(value, options);
    }
    isValidSync(value, options) {
        return this._resolve(value, options).isValidSync(value, options);
    }
    describe(options) {
        return options ? this.resolve(options).describe(options) : {
            type: "lazy",
            meta: this.spec.meta,
            label: undefined
        };
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
}
function $cda9d0e1103d595f$export$c8aadf3621e41efb(custom) {
    Object.keys(custom).forEach((type)=>{
        // @ts-ignore
        Object.keys(custom[type]).forEach((method)=>{
            // @ts-ignore
            $cda9d0e1103d595f$export$d7f512c98c859244[type][method] = custom[type][method];
        });
    });
}
function $cda9d0e1103d595f$export$20be359f745f973c(schemaType, name, fn) {
    if (!schemaType || !$cda9d0e1103d595f$export$213e2a3e7c4f326e(schemaType.prototype)) throw new TypeError("You must provide a yup schema constructor function");
    if (typeof name !== "string") throw new TypeError("A Method name must be provided");
    if (typeof fn !== "function") throw new TypeError("Method function must be provided");
    schemaType.prototype[name] = fn;
}



// Create Contact Page Component
const $0a02757af33993aa$var$ContactPage = ()=>{
    // Add From Validation on filling the data in input tag
    const validateForm = $cda9d0e1103d595f$export$be5493f9613cbbe({
        name: $cda9d0e1103d595f$export$22b082955e083ec3().required("Required").max(20, "Name Must be less than 20 character").min(3, "Name Must be greater than 2 charcter "),
        email: $cda9d0e1103d595f$export$22b082955e083ec3().email("Invalid Email").required("Required"),
        message: $cda9d0e1103d595f$export$22b082955e083ec3().max(50, "Message Must be less than 20 character").min(11, "Message Must be greater than 10 charcter ").required("Required")
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "h-[80vh] flex flex-col md:flex-row-reverse items-center justify-center",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                srcSet: "https://img.freepik.com/free-vector/flat-design-illustration-customer-support_23-2148887720.jpg?w=740&t=st=1700769019~exp=1700769619~hmac=0b07f971e3a34e0c87e2254259ede4e6bff70f3b6bc3ac69245b9713331fe62c",
                className: "hidden md:block md:w-1/2  -z-50 lg:p-20",
                alt: ""
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "w-full md:w-1/2 p-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                        className: " text-3xl text-blue-950 font-bold text-center lg:text-5xl",
                        children: "Contact Us"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7YFi7.Formik), {
                        initialValues: {
                            email: "",
                            message: "",
                            name: ""
                        },
                        validationSchema: validateForm,
                        onSubmit: (values, { setSubmitting: setSubmitting })=>{
                            // send email from contact from to emailjs registered email which user id is iMIpxJjQ5-YTe1ZQd template id is template_ukvpp87 and service id is service_pdx2crh 
                            (0, $e8e08de5e84870c6$export$2e2bcd8739ae039).send("service_pdx2crh", "template_ukvpp87", {
                                form_name: values.name,
                                form_email: values.email,
                                message: values.message
                            }, "iMIpxJjQ5-YTe1ZQd").then(function(response) {
                                console.log("SUCCESS!", response.status, response.text);
                            }, function(error) {
                                console.log("FAILED...", error);
                            });
                            (0, $ecf70d86349bf38f$export$f6cef6fcf9ca4e17)("Feedback Sent Successfully");
                            values.email = "";
                            values.message = "";
                            values.name = "";
                            setSubmitting(false);
                        },
                        children: ({ errors: errors, touched: touched, handleSubmit: handleSubmit, isSubmitting: isSubmitting })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7YFi7.Form), {
                                onSubmit: handleSubmit,
                                className: " p-5 flex flex-col",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        htmlFor: "name",
                                        children: "Enter Your Name"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7YFi7.Field), {
                                        type: "name",
                                        name: "name",
                                        className: "rounded-lg px-4 py-2 focus:outline-none border-2 w-full " + (errors.name ? "focus:border-red-600 border-red-300" : "focus:border-blue-600 border-blue-200")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "mb-4 h-5 text-red-500",
                                        children: errors.name && touched.name && errors.name
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        htmlFor: "name",
                                        children: "Enter Your Email"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7YFi7.Field), {
                                        type: "email",
                                        name: "email",
                                        className: " rounded-lg px-4 py-2 focus:outline-none border-2 w-full " + (errors.email ? "focus:border-red-600 border-red-300" : "focus:border-blue-600 border-blue-200")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "mb-4 h-5 text-red-500",
                                        children: errors.email && touched.email && errors.email
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        htmlFor: "name",
                                        children: "Enter Your Message"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7YFi7.Field), {
                                        as: "textarea",
                                        type: "text",
                                        name: "message",
                                        className: "text-start h-24 max-h-28 rounded-lg px-4 py-2 focus:outline-none border-2 w-full " + (errors.message ? "focus:border-red-600 border-red-300" : "focus:border-blue-600 border-blue-200")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "mb-2 h-5 text-red-500",
                                        children: errors.message && touched.message && errors.message
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "submit",
                                        disabled: isSubmitting,
                                        className: "w-1/2  border-blue-300 hover:bg-blue-900 hover:text-white border-4 px-4 py-2 mx-auto lg:w-1/3",
                                        children: "Submit"
                                    })
                                ]
                            })
                    })
                ]
            })
        ]
    });
};
var $0a02757af33993aa$export$2e2bcd8739ae039 = $0a02757af33993aa$var$ContactPage;




var $acw62 = parcelRequire("acw62");


// This component is used to show the user page and logout page depending on the login status
const $96335adcb8d4055b$var$UserPage = ()=>{
    const { loginStatus: loginStatus } = (0, $acw62.useContext)((0, $c09882a49af06a79$export$38ee920e59704589));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: " h-[80vh] flex items-center py-10",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "w-full lg:w-1/2 flex flex-col gap-1",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                        className: "text-4xl font-bold text-blue-950 text-center md:text-5xl",
                        children: loginStatus ? "Logout Page" : "Login Page"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$910ae8079b2c2852), {})
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                className: " hidden lg:block w-1/2 h-2/3 lg:h-full",
                src: "https://cdn.shopify.com/s/files/1/0502/7286/2366/files/crazyjoint_640x640.png?v=1622797540",
                alt: ""
            })
        ]
    });
};
var $96335adcb8d4055b$export$2e2bcd8739ae039 = $96335adcb8d4055b$var$UserPage;





var $acw62 = parcelRequire("acw62");

var $7YFi7 = parcelRequire("7YFi7");




// This compoenet is used to show the login page which manipulate the state variables of ConText Api using from data
const $2521ba5eca4440dd$var$Login = ()=>{
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const { setUserLoginName: setUserLoginName, loginStatus: loginStatus, setLiveLoginStatus: setLiveLoginStatus } = (0, $acw62.useContext)((0, $c09882a49af06a79$export$38ee920e59704589));
    // Create validation for login form input values
    const LoginValidate = $cda9d0e1103d595f$export$be5493f9613cbbe().shape({
        name: $cda9d0e1103d595f$export$22b082955e083ec3().required("Required").max(24, "Name Must be less than 25 character").min(3, "Name Must be greater than 2 charcter "),
        email: $cda9d0e1103d595f$export$22b082955e083ec3().email("Invalid email").required("Required"),
        password: $cda9d0e1103d595f$export$22b082955e083ec3().required("Required").min(6, "Password must be greater than 6 character")
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7YFi7.Formik), {
            initialValues: {
                name: "",
                email: "",
                password: ""
            },
            onSubmit: (values, { setSubmitting: setSubmitting })=>{
                // Set the user login name and navigate to home page
                (0, $ecf70d86349bf38f$export$f6cef6fcf9ca4e17)("Login Successfull");
                setTimeout(()=>{
                    setUserLoginName(values.name);
                    values.name = "";
                    values.email = "";
                    values.password = "";
                    setLiveLoginStatus(!loginStatus);
                    setSubmitting(false);
                    navigate("/");
                }, 1000);
            },
            validationSchema: LoginValidate,
            children: ({ errors: errors, touched: touched, handleSubmit: handleSubmit, isSubmitting: isSubmitting })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7YFi7.Form), {
                    className: "w-full flex flex-col md:w-5/6 mx-auto gap-2 mt-4 px-10 ",
                    onSubmit: handleSubmit,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            htmlFor: "name",
                            children: "Enter Your Name"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7YFi7.Field), {
                            type: "name",
                            name: "name",
                            className: "rounded-lg px-4 py-2 focus:outline-none border-2 w-full " + (errors.name ? "focus:border-red-600 border-red-300" : "focus:border-blue-600 border-blue-200")
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "mb-4 h-5 text-red-500",
                            children: errors.name && touched.name && errors.name
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            htmlFor: "email",
                            children: "Enter Your Email"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7YFi7.Field), {
                            type: "email",
                            name: "email",
                            className: "rounded-lg px-4 py-2 focus:outline-none border-2 w-full " + (errors.email ? "focus:border-red-600 border-red-300" : "focus:border-blue-600 border-blue-200")
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "mb-4 h-5 text-red-500",
                            children: errors.email && touched.email && errors.email
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            htmlFor: "password",
                            children: "Enter Your Password"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7YFi7.Field), {
                            type: "password",
                            name: "password",
                            className: " rounded-lg px-4 py-2 focus:outline-none border-2 w-full " + (errors.password ? "focus:border-red-600 border-red-300" : "focus:border-blue-600 border-blue-200")
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "mb-4 h-5 text-red-500",
                            children: errors.password && touched.password && errors.password
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            onClick: ()=>{},
                            type: "submit",
                            disabled: isSubmitting,
                            className: "w-1/2  border-blue-300 hover:bg-blue-900 hover:text-white border-4 px-4 py-2 mx-auto lg:w-1/3",
                            children: "Login"
                        })
                    ]
                })
        })
    });
};
var $2521ba5eca4440dd$export$2e2bcd8739ae039 = $2521ba5eca4440dd$var$Login;




var $acw62 = parcelRequire("acw62");



// This logout page component is used to redirect the user to login page or to home page which uses Context Api state variables.
const $384020c1894d4253$var$Logout = ()=>{
    const { userName: userName, loginStatus: loginStatus, setLiveLoginStatus: setLiveLoginStatus, setUserLoginName: setUserLoginName } = (0, $acw62.useContext)((0, $c09882a49af06a79$export$38ee920e59704589));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col items-center mt-5 gap-4 ",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h1", {
                className: "text-center text-lg font-bold text-blue-900 md:text-2xl",
                children: [
                    "You have login as ",
                    userName
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col justify-between w-7/12 mt-5 gap-4 md:flex-row",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        onClick: ()=>{
                            (0, $ecf70d86349bf38f$export$f6cef6fcf9ca4e17)("Please Login with Email Id");
                            setLiveLoginStatus(!loginStatus);
                            setUserLoginName("Guest");
                        },
                        to: "/user/",
                        className: "text-xl bg-blue-100 px-2 py-1 rounded-xl border-4 border-blue-300 hover:bg-blue-900 hover:text-white md:px-4 md:py-3",
                        children: "Go To Login Page"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        to: "/",
                        className: "text-xl bg-blue-100 px-2 py-1 rounded-xl border-4 border-blue-300 hover:bg-blue-900 hover:text-white md:px-4 md:py-3",
                        children: "Go To Home"
                    })
                ]
            })
        ]
    });
};
var $384020c1894d4253$export$2e2bcd8739ae039 = $384020c1894d4253$var$Logout;




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

var $6ffdc4461e22ed7a$exports = {};
$6ffdc4461e22ed7a$exports = JSON.parse('[{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Restaurant","info":{"id":"151990","name":"Sip & Bite","city":"Sri Ganganagar","slugs":{"restaurant":"days-and-night-bakers-sri-ganganagar-saraswati-nagar","city":"sri-ganganagar"},"uniqueId":"e51e6528-4859-48c8-8fed-e84c17dc2d76","cloudinaryImageId":"zcotw9pv1l8mbjxmqs9l","locality":"Block G","areaName":"Saraswati Nagar","costForTwo":"10000","costForTwoMessage":"\u20B9100 for two","cuisines":["Pastas","Desserts"],"avgRating":3.7,"veg":true,"feeDetails":{"restaurantId":"151990","fees":[{"name":"time"},{"name":"distance","fee":2000},{"name":"special"}],"totalFee":2000,"icon":"v1648208530/surgecreatives/info","message":"Very Far (1,923.6 kms) | Additional delivery fee will apply"},"parentId":"188690","avgRatingString":"3.7","totalRatingsString":"1K+ ratings","sla":{"restaurantId":"151990","lastMileTravel":1923.7,"serviceability":"NON_SERVICEABLE","rainMode":"RAIN_MODE_NONE","longDistance":"LONG_DISTANCE_NOT_LONG_DISTANCE","lastMileTravelString":"1923.6 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2023-11-28 23:59:00","visibility":true,"opened":true,"restaurantClosedMeta":{}},"aggregatedDiscountInfo":{"header":"50% off","shortDescriptionList":[{"meta":"50% off | Use TRYNEW","discountType":"Percentage","operationType":"RESTAURANT"},{"discountType":"Percentage","operationType":"RESTAURANT"}],"descriptionList":[{"meta":"50% off up to \u20B9100 | Use code TRYNEW","discountType":"Percentage","operationType":"RESTAURANT"},{"meta":"20% off upto \u20B9125 | Use BOBFEST Above \u20B9299","discountType":"Percentage","operationType":"RESTAURANT"}],"visible":true},"badges":{},"slugString":"days-and-night-bakers-sri-ganganagar-saraswati-nagar","isOpen":true,"labels":[{"title":"Timings","message":"null"},{"title":"Address","message":"180 G Block, Sri Ganganagar"},{"title":"Cuisines","message":"Pastas,Desserts"}],"totalRatings":1000,"aggregatedDiscountInfoV2":{"header":"50% off","shortDescriptionList":[{"meta":"50% off | Use TRYNEW","discountType":"Percentage","operationType":"RESTAURANT"},{"discountType":"Percentage","operationType":"RESTAURANT"}],"descriptionList":[{"meta":"50% off up to \u20B9100 | Use code TRYNEW","discountType":"Percentage","operationType":"RESTAURANT"},{"meta":"20% off upto \u20B9125 | Use BOBFEST Above \u20B9299","discountType":"Percentage","operationType":"RESTAURANT"}],"couponDetailsCta":"View coupon details"},"type":"F","headerBanner":{"url":"swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/151990"},"ratingSlab":"RATING_SLAB_4","availabilityServiceabilityMessage":"Does not deliver to your location","orderabilityCommunication":{"title":{"text":"Wish you were"},"subTitle":{"text":"CLOSER!"},"message":{"text":"This location is outside the outlet\'s delivery area","textColour":"negative"},"customIcon":{"bgGradientColorStart":"#F64C41","bgGradientColorEnd":"#E53554"}},"hasBestsellerItems":true,"cartOrderabilityNudgeBanner":{"parameters":{},"presentation":{}},"latLong":"29.92039066794756,73.87180288158419"},"analytics":{}}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget","layout":{"rows":1,"columns":3,"horizontalScrollEnabled":true,"itemSpacing":12,"lineSpacing":10,"widgetPadding":{},"containerStyle":{"containerPadding":{"left":10,"right":10}},"scrollBar":{"scrollThumbColor":"#E46D47","scrollTrackColor":"#e4e4e4","width":54,"height":4,"scrollStyling":{"padding":{"top":20,"bottom":20}}}},"id":"offerCollectionWidget","gridElements":{"infoWithStyle":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle","offers":[{"info":{"header":"50% OFF UPTO \u20B9100","offerTagColor":"#E46D47","offerIds":["95d0ee29-6923-4a2c-97fe-afaadbaee172"],"expiryTime":"1970-01-01T00:00:00Z","couponCode":"USE TRYNEW","description":"ABOVE \u20B9129","offerType":"offers","restId":"151990","offerLogo":"offers/generic","descriptionTextColor":"#7302060C"},"cta":{"type":"OFFER_HALF_CARD"}},{"info":{"header":"20% OFF UPTO \u20B9125","offerTagColor":"#E46D47","logoBottom":"rng/md/ads/production/41883e85327a5a799d45d9b95f3510a3","offerIds":["49e2c1e9-c4a0-494e-b8e7-d18a6d138138"],"expiryTime":"1970-01-01T00:00:00Z","couponCode":"USE BOBFEST","description":"ABOVE \u20B9299","offerType":"offers","restId":"151990","offerLogo":"rng/md/ads/production/41883e85327a5a799d45d9b95f3510a3","descriptionTextColor":"#7302060C"},"cta":{"type":"OFFER_HALF_CARD"}},{"info":{"header":"FLAT \u20B9200 OFF","offerTagColor":"#E46D47","logoBottom":"rng/md/ads/production/32b9f8a87957f8c1ca369622f6a1ca77","offerIds":["30457c66-5829-4767-82c5-89b791ba7155"],"expiryTime":"1970-01-01T00:00:00Z","couponCode":"USE AXIS200","description":"ABOVE \u20B9500","offerType":"offers","restId":"151990","offerLogo":"rng/md/ads/production/32b9f8a87957f8c1ca369622f6a1ca77","descriptionTextColor":"#7302060C"},"cta":{"type":"OFFER_HALF_CARD"}}],"habitMilestoneInfo":{"callout":{}}}}}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.MenuTab","tabs":[{"id":"REGULAR","title":"Full Menu","selected":true,"analytics":{},"selectedImage":"v1594205104/fullMenuActive_qcsdzt.png","unselectedImage":"v1594205107/fullMenuInactive_fbdtp2.png"}]}}},{"groupedCard":{"cardGroupMap":{"REGULAR":{"cards":[{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge","isPureVeg":true,"badges":{},"vegOnlyDetails":{"imageId":"AutoVegOnly_qkjowj","title":"Showing only vegetarian options.","description":"Tap on the VEG ONLY button to turn off the setting"},"topRatedFilter":{},"kidsCategoryFilter":{"attributes":{"displayText":"Kids Favourites","tooltip":{"enabled":true,"displayText":"Kids Favourites Filter applied. Remove this filter to see the full Menu."}}},"vegFilter":{"attributes":{"displayText":"VEG"}},"nonvegFilter":{"attributes":{"displayText":"NONVEG"}}}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"Recommended","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"57814978","name":"Spicy Tandoori Sandwich","category":"Burgers And Sandwiches","imageId":"125cbc99ee12ae38cffd920457c7475e","inStock":1,"isVeg":1,"price":18000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76095499","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095498","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"showImage":true,"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.7","ratingCount":"3 ratings","ratingCountV2":"3"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"57814981","name":"Cheese Corn Sandwich","category":"Burgers And Sandwiches","imageId":"c99019c2fe99fa7aa6e63a86abbd4076","inStock":1,"isVeg":1,"price":19000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76095490","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095489","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"showImage":true,"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.1","ratingCount":"18 ratings","ratingCountV2":"18"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"75106358","name":"Falafel Sub","category":"Sub","imageId":"u1ufmirwo13udeame9re","inStock":1,"isVeg":1,"price":17000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76094947","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76094946","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"showImage":true,"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.8","ratingCount":"8 ratings","ratingCountV2":"8"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"75106359","name":"Hara Bhara Kabab Sub","category":"Sub","imageId":"vfevo8dvkp3jelpxmnlx","inStock":1,"isVeg":1,"price":17000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76094950","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76094949","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"showImage":true,"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.0","ratingCount":"3 ratings","ratingCountV2":"3"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"57901444","name":"Cheesy Paneer Pasta","category":"Pasta","description":"Mushroom, Golden Corn, Broccoli, Mixed Capsicum With Cheesy Creamy Red Sauce.","imageId":"lwizmtizfrgz4nonjskf","inStock":1,"isVeg":1,"price":25000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76095043","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095041","groupName":"Extra Bread","choices":[{"id":"60999858","name":"Extra Bread","price":1500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095042","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"showImage":true,"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"57901449","name":"Makhani Gravy Pasta","category":"Pasta","description":"Golden Corn, Green Zucchini, Mushroom, Mix Capsicum, Broccoli Red Sauce.","imageId":"hht1kgq5vjnwvrosmkcu","inStock":1,"isVeg":1,"price":25000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76095055","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095052","groupName":"Extra Bread","choices":[{"id":"60999858","name":"Extra Bread","price":1500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095054","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"showImage":true,"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"57901452","name":"Red Sause Pasta","category":"Pasta","description":"Mushroom, Zucchini, Broccoli, Mixed Capsicum With Italian Napoli Red Sauce.","imageId":"6b4fd15230669d12ed5243bd695abf6e","inStock":1,"isVeg":1,"price":21000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76095063","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095060","groupName":"Extra Bread","choices":[{"id":"60999858","name":"Extra Bread","price":1500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095062","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"showImage":true,"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"2.5","ratingCount":"14 ratings","ratingCountV2":"14"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"100777492","name":"Creamy Alferado Pasta","category":"Pasta","description":"Broccoli, Mushrooms, Capsicum, Golden Corns With Chef\'S Special White Sauce.","imageId":"bebhwh4vdput2n5xhhox","inStock":1,"isVeg":1,"price":26000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76095047","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095045","groupName":"Extra Bread","choices":[{"id":"60999858","name":"Extra Bread","price":1500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095046","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"showImage":true,"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"1.5","ratingCount":"16 ratings","ratingCountV2":"16"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"57814315","name":"Chilly Paneer Pizza","category":"Pizza","description":"Onions, Green Capsicum, Mushrooms Marinated Paneer And Sliced Black Olives.","imageId":"y4qvzirgfp5jr0dbs0eo","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"23987176","name":"Portion","variations":[{"name":"Regular [8 Inches]","price":280,"default":1,"id":"77571762","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Medium [10 Inches]","price":380,"id":"77571763","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Large [12 Inches]","price":480,"id":"77571764","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"23987176","variationId":"77571762"}],"price":28000,"addonCombinations":[{"groupId":"76095132","addonId":"60999864"},{"groupId":"76095133","addonId":"60999865"},{"groupId":"76095133","addonId":"60999866"},{"groupId":"76095133","addonId":"60999867"},{"groupId":"76095133","addonId":"60999868"},{"groupId":"76095133","addonId":"60999869"},{"groupId":"76095133","addonId":"60999870"},{"groupId":"76095133","addonId":"60999871"},{"groupId":"76095133","addonId":"60999872"},{"groupId":"76095133","addonId":"60999873"},{"groupId":"76095135","addonId":"60999874"},{"groupId":"76095136","addonId":"60998438"},{"groupId":"76095136","addonId":"60998439"},{"groupId":"76095137","addonId":"60998441"},{"groupId":"76095137","addonId":"60998442"},{"groupId":"76095137","addonId":"60998443"},{"groupId":"76095137","addonId":"60998432"},{"groupId":"76095137","addonId":"60998433"},{"groupId":"76095137","addonId":"60998434"},{"groupId":"76095137","addonId":"60998435"}]},{"variations":[{"groupId":"23987176","variationId":"77571763"}],"price":38000,"addonCombinations":[{"groupId":"76095139","addonId":"60999876"},{"groupId":"76095139","addonId":"60999877"},{"groupId":"76095139","addonId":"60999878"},{"groupId":"76095139","addonId":"60999879"},{"groupId":"76095139","addonId":"60999880"},{"groupId":"76095139","addonId":"60999881"},{"groupId":"76095139","addonId":"60999882"},{"groupId":"76095139","addonId":"60999883"},{"groupId":"76095139","addonId":"60999884"},{"groupId":"76095140","addonId":"60999885"},{"groupId":"76095136","addonId":"60998438"},{"groupId":"76095136","addonId":"60998439"},{"groupId":"76095137","addonId":"60998441"},{"groupId":"76095137","addonId":"60998442"},{"groupId":"76095137","addonId":"60998443"},{"groupId":"76095137","addonId":"60998432"},{"groupId":"76095137","addonId":"60998433"},{"groupId":"76095137","addonId":"60998434"},{"groupId":"76095137","addonId":"60998435"},{"groupId":"76095138","addonId":"60999875"}]},{"variations":[{"groupId":"23987176","variationId":"77571764"}],"price":48000,"addonCombinations":[{"groupId":"76095141","addonId":"60999886"},{"groupId":"76095143","addonId":"60999896"},{"groupId":"76095136","addonId":"60998438"},{"groupId":"76095136","addonId":"60998439"},{"groupId":"76095137","addonId":"60998441"},{"groupId":"76095137","addonId":"60998442"},{"groupId":"76095137","addonId":"60998443"},{"groupId":"76095137","addonId":"60998432"},{"groupId":"76095137","addonId":"60998433"},{"groupId":"76095137","addonId":"60998434"},{"groupId":"76095137","addonId":"60998435"},{"groupId":"76095142","addonId":"60999887"},{"groupId":"76095142","addonId":"60999888"},{"groupId":"76095142","addonId":"60999889"},{"groupId":"76095142","addonId":"60999890"},{"groupId":"76095142","addonId":"60999891"},{"groupId":"76095142","addonId":"60999892"},{"groupId":"76095142","addonId":"60999893"},{"groupId":"76095142","addonId":"60999894"},{"groupId":"76095142","addonId":"60999895"}]}]},"addons":[{"groupId":"76095133","groupName":"Extra Toppings [8 Inches]","choices":[{"id":"60999869","name":"Zucchini","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999865","name":"Paneer","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999866","name":"Broccoli","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999867","name":"Capsicum","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999868","name":"Red Paprika","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999872","name":"Olive","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999873","name":"Jalapeno","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999870","name":"Onion","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999871","name":"Corn","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095142","groupName":"Extra Toppings [12 Inches]","choices":[{"id":"60999887","name":"Paneer","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999888","name":"Broccoli","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999889","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999894","name":"Olive","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999895","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999890","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999891","name":"Zucchini","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999892","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999893","name":"Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095139","groupName":"Extra Toppings [10 Inches]","choices":[{"id":"60999876","name":"Paneer","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999877","name":"Broccoli","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999878","name":"Capsicum","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999879","name":"Red Paprika","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999883","name":"Olive","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999884","name":"Jalapeno","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999880","name":"Zucchini","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999881","name":"Onion","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999882","name":"Corn","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095137","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095132","groupName":"Extra Cheese brust [Reg]","choices":[{"id":"60999864","name":"Cheese Brust","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095138","groupName":"Extra Cheese brust [Med]","choices":[{"id":"60999875","name":"Cheese Brust","price":10000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095141","groupName":"Extra Cheese brust [Large]","choices":[{"id":"60999886","name":"Cheese Brust","price":13000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095135","groupName":"Extra Cheese [regular]","choices":[{"id":"60999874","name":"Extra Cheese","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095140","groupName":"Extra [medium]","choices":[{"id":"60999885","name":"Extra Cheese","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095143","groupName":"Extras [large]","choices":[{"id":"60999896","name":"Extra Cheese","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095136","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"defaultPrice":28000,"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"showImage":true,"itemBadge":{},"badgesV2":{},"isBestseller":true,"ratings":{"aggregatedRating":{"rating":"3.8","ratingCount":"5 ratings","ratingCountV2":"5"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"57814419","name":"Veg Fiesta Pizza","category":"Pizza","description":"Sweet Corn, Onion, Capsicum And Broccoli.","imageId":"79ca19af04ebdeaa48f1a48715e21b37","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"23987197","name":"Portion","variations":[{"name":"Regular [8 Inches]","price":210,"default":1,"id":"77571826","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Medium [10 Inches]","price":310,"id":"77571827","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Large [12 Inches]","price":410,"id":"77571828","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"23987197","variationId":"77571826"}],"price":21000,"addonCombinations":[{"groupId":"76095381","addonId":"60999865"},{"groupId":"76095381","addonId":"60999866"},{"groupId":"76095381","addonId":"60999867"},{"groupId":"76095381","addonId":"60999868"},{"groupId":"76095381","addonId":"60999869"},{"groupId":"76095381","addonId":"60999870"},{"groupId":"76095381","addonId":"60999871"},{"groupId":"76095381","addonId":"60999872"},{"groupId":"76095381","addonId":"60999873"},{"groupId":"76095382","addonId":"60999864"},{"groupId":"76095384","addonId":"60999874"},{"groupId":"76095385","addonId":"60998438"},{"groupId":"76095385","addonId":"60998439"},{"groupId":"76095386","addonId":"60998441"},{"groupId":"76095386","addonId":"60998442"},{"groupId":"76095386","addonId":"60998443"},{"groupId":"76095386","addonId":"60998432"},{"groupId":"76095386","addonId":"60998433"},{"groupId":"76095386","addonId":"60998434"},{"groupId":"76095386","addonId":"60998435"}]},{"variations":[{"groupId":"23987197","variationId":"77571827"}],"price":31000,"addonCombinations":[{"groupId":"76095387","addonId":"60999876"},{"groupId":"76095387","addonId":"60999877"},{"groupId":"76095387","addonId":"60999878"},{"groupId":"76095387","addonId":"60999879"},{"groupId":"76095387","addonId":"60999880"},{"groupId":"76095387","addonId":"60999881"},{"groupId":"76095387","addonId":"60999882"},{"groupId":"76095387","addonId":"60999883"},{"groupId":"76095387","addonId":"60999884"},{"groupId":"76095389","addonId":"60999885"},{"groupId":"76095385","addonId":"60998438"},{"groupId":"76095385","addonId":"60998439"},{"groupId":"76095386","addonId":"60998441"},{"groupId":"76095386","addonId":"60998442"},{"groupId":"76095386","addonId":"60998443"},{"groupId":"76095386","addonId":"60998432"},{"groupId":"76095386","addonId":"60998433"},{"groupId":"76095386","addonId":"60998434"},{"groupId":"76095386","addonId":"60998435"},{"groupId":"76095388","addonId":"60999875"}]},{"variations":[{"groupId":"23987197","variationId":"77571828"}],"price":41000,"addonCombinations":[{"groupId":"76095391","addonId":"60999886"},{"groupId":"76095392","addonId":"60999896"},{"groupId":"76095385","addonId":"60998438"},{"groupId":"76095385","addonId":"60998439"},{"groupId":"76095386","addonId":"60998441"},{"groupId":"76095386","addonId":"60998442"},{"groupId":"76095386","addonId":"60998443"},{"groupId":"76095386","addonId":"60998432"},{"groupId":"76095386","addonId":"60998433"},{"groupId":"76095386","addonId":"60998434"},{"groupId":"76095386","addonId":"60998435"},{"groupId":"76095390","addonId":"60999887"},{"groupId":"76095390","addonId":"60999888"},{"groupId":"76095390","addonId":"60999889"},{"groupId":"76095390","addonId":"60999890"},{"groupId":"76095390","addonId":"60999891"},{"groupId":"76095390","addonId":"60999892"},{"groupId":"76095390","addonId":"60999893"},{"groupId":"76095390","addonId":"60999894"},{"groupId":"76095390","addonId":"60999895"}]}]},"addons":[{"groupId":"76095381","groupName":"Extra Toppings [8 Inches]","choices":[{"id":"60999869","name":"Zucchini","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999865","name":"Paneer","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999866","name":"Broccoli","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999867","name":"Capsicum","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999868","name":"Red Paprika","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999872","name":"Olive","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999873","name":"Jalapeno","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999870","name":"Onion","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999871","name":"Corn","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095390","groupName":"Extra Toppings [12 Inches]","choices":[{"id":"60999887","name":"Paneer","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999888","name":"Broccoli","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999889","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999894","name":"Olive","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999895","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999890","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999891","name":"Zucchini","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999892","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999893","name":"Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095387","groupName":"Extra Toppings [10 Inches]","choices":[{"id":"60999876","name":"Paneer","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999877","name":"Broccoli","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999878","name":"Capsicum","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999879","name":"Red Paprika","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999883","name":"Olive","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999884","name":"Jalapeno","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999880","name":"Zucchini","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999881","name":"Onion","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999882","name":"Corn","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095386","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095382","groupName":"Extra Cheese brust [Reg]","choices":[{"id":"60999864","name":"Cheese Brust","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095388","groupName":"Extra Cheese brust [Med]","choices":[{"id":"60999875","name":"Cheese Brust","price":10000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095391","groupName":"Extra Cheese brust [Large]","choices":[{"id":"60999886","name":"Cheese Brust","price":13000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095384","groupName":"Extra Cheese [regular]","choices":[{"id":"60999874","name":"Extra Cheese","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095389","groupName":"Extra [medium]","choices":[{"id":"60999885","name":"Extra Cheese","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095392","groupName":"Extras [large]","choices":[{"id":"60999896","name":"Extra Cheese","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095385","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"defaultPrice":21000,"ribbon":{},"showImage":true,"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.2","ratingCount":"27 ratings","ratingCountV2":"27"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"57814460","name":"Cheese Corn Pizza","category":"Pizza","description":"Hot Cheese, Corn And Basil With Spices.","imageId":"627d39f2d09159ecd8a6c660207032bf","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"23987172","name":"Portion","variations":[{"name":"Regular [8 Inches]","price":148,"default":1,"id":"77571750","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Medium [10 Inches]","price":248,"id":"77571751","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Large [12 Inches]","price":348,"id":"77571752","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"23987172","variationId":"77571750"}],"price":14800,"addonCombinations":[{"groupId":"76095084","addonId":"60999865"},{"groupId":"76095084","addonId":"60999866"},{"groupId":"76095084","addonId":"60999867"},{"groupId":"76095084","addonId":"60999868"},{"groupId":"76095084","addonId":"60999869"},{"groupId":"76095084","addonId":"60999870"},{"groupId":"76095084","addonId":"60999871"},{"groupId":"76095084","addonId":"60999872"},{"groupId":"76095084","addonId":"60999873"},{"groupId":"76095089","addonId":"60998441"},{"groupId":"76095089","addonId":"60998442"},{"groupId":"76095089","addonId":"60998443"},{"groupId":"76095089","addonId":"60998432"},{"groupId":"76095089","addonId":"60998433"},{"groupId":"76095089","addonId":"60998434"},{"groupId":"76095089","addonId":"60998435"},{"groupId":"76095085","addonId":"60999864"},{"groupId":"76095087","addonId":"60999874"},{"groupId":"76095088","addonId":"60998438"},{"groupId":"76095088","addonId":"60998439"}]},{"variations":[{"groupId":"23987172","variationId":"77571751"}],"price":24800,"addonCombinations":[{"groupId":"76095090","addonId":"60999876"},{"groupId":"76095090","addonId":"60999877"},{"groupId":"76095090","addonId":"60999878"},{"groupId":"76095090","addonId":"60999879"},{"groupId":"76095090","addonId":"60999880"},{"groupId":"76095090","addonId":"60999881"},{"groupId":"76095090","addonId":"60999882"},{"groupId":"76095090","addonId":"60999883"},{"groupId":"76095090","addonId":"60999884"},{"groupId":"76095089","addonId":"60998441"},{"groupId":"76095089","addonId":"60998442"},{"groupId":"76095089","addonId":"60998443"},{"groupId":"76095089","addonId":"60998432"},{"groupId":"76095089","addonId":"60998433"},{"groupId":"76095089","addonId":"60998434"},{"groupId":"76095089","addonId":"60998435"},{"groupId":"76095092","addonId":"60999885"},{"groupId":"76095088","addonId":"60998438"},{"groupId":"76095088","addonId":"60998439"},{"groupId":"76095091","addonId":"60999875"}]},{"variations":[{"groupId":"23987172","variationId":"77571752"}],"price":34800,"addonCombinations":[{"groupId":"76095089","addonId":"60998441"},{"groupId":"76095089","addonId":"60998442"},{"groupId":"76095089","addonId":"60998443"},{"groupId":"76095089","addonId":"60998432"},{"groupId":"76095089","addonId":"60998433"},{"groupId":"76095089","addonId":"60998434"},{"groupId":"76095089","addonId":"60998435"},{"groupId":"76095094","addonId":"60999886"},{"groupId":"76095095","addonId":"60999896"},{"groupId":"76095088","addonId":"60998438"},{"groupId":"76095088","addonId":"60998439"},{"groupId":"76095093","addonId":"60999887"},{"groupId":"76095093","addonId":"60999888"},{"groupId":"76095093","addonId":"60999889"},{"groupId":"76095093","addonId":"60999890"},{"groupId":"76095093","addonId":"60999891"},{"groupId":"76095093","addonId":"60999892"},{"groupId":"76095093","addonId":"60999893"},{"groupId":"76095093","addonId":"60999894"},{"groupId":"76095093","addonId":"60999895"}]}]},"addons":[{"groupId":"76095084","groupName":"Extra Toppings [8 Inches]","choices":[{"id":"60999869","name":"Zucchini","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999865","name":"Paneer","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999866","name":"Broccoli","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999867","name":"Capsicum","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999868","name":"Red Paprika","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999872","name":"Olive","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999873","name":"Jalapeno","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999870","name":"Onion","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999871","name":"Corn","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095093","groupName":"Extra Toppings [12 Inches]","choices":[{"id":"60999887","name":"Paneer","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999888","name":"Broccoli","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999889","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999894","name":"Olive","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999895","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999890","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999891","name":"Zucchini","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999892","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999893","name":"Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095090","groupName":"Extra Toppings [10 Inches]","choices":[{"id":"60999876","name":"Paneer","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999877","name":"Broccoli","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999878","name":"Capsicum","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999879","name":"Red Paprika","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999883","name":"Olive","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999884","name":"Jalapeno","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999880","name":"Zucchini","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999881","name":"Onion","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999882","name":"Corn","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095089","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095085","groupName":"Extra Cheese brust [Reg]","choices":[{"id":"60999864","name":"Cheese Brust","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095091","groupName":"Extra Cheese brust [Med]","choices":[{"id":"60999875","name":"Cheese Brust","price":10000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095094","groupName":"Extra Cheese brust [Large]","choices":[{"id":"60999886","name":"Cheese Brust","price":13000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095087","groupName":"Extra Cheese [regular]","choices":[{"id":"60999874","name":"Extra Cheese","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095092","groupName":"Extra [medium]","choices":[{"id":"60999885","name":"Extra Cheese","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095095","groupName":"Extras [large]","choices":[{"id":"60999896","name":"Extra Cheese","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095088","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"defaultPrice":14800,"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"showImage":true,"itemBadge":{},"badgesV2":{},"isBestseller":true,"ratings":{"aggregatedRating":{"rating":"4.2","ratingCount":"134 ratings","ratingCountV2":"134"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"75106399","name":"Masala Paneer Makhani Pizza","category":"Pizza","description":"Marinated Paneer, Onion, Capsicum Red Paprika,Tomatoes, Coriander Cheese With Hot Cheese Topping.","imageId":"1f9dd9907f24daf44583e7b34673bef1","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"23987183","name":"Portion","variations":[{"name":"Regular [8 Inches]","price":280,"default":1,"id":"77571784","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Medium [10 Inches]","price":380,"id":"77571785","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Large [12 Inches]","price":480,"id":"77571786","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"23987183","variationId":"77571784"}],"price":28000,"addonCombinations":[{"groupId":"76095216","addonId":"60999865"},{"groupId":"76095216","addonId":"60999866"},{"groupId":"76095216","addonId":"60999867"},{"groupId":"76095216","addonId":"60999868"},{"groupId":"76095216","addonId":"60999869"},{"groupId":"76095216","addonId":"60999870"},{"groupId":"76095216","addonId":"60999871"},{"groupId":"76095216","addonId":"60999872"},{"groupId":"76095216","addonId":"60999873"},{"groupId":"76095217","addonId":"60999864"},{"groupId":"76095219","addonId":"60999874"},{"groupId":"76095220","addonId":"60998438"},{"groupId":"76095220","addonId":"60998439"},{"groupId":"76095221","addonId":"60998441"},{"groupId":"76095221","addonId":"60998442"},{"groupId":"76095221","addonId":"60998443"},{"groupId":"76095221","addonId":"60998432"},{"groupId":"76095221","addonId":"60998433"},{"groupId":"76095221","addonId":"60998434"},{"groupId":"76095221","addonId":"60998435"}]},{"variations":[{"groupId":"23987183","variationId":"77571785"}],"price":38000,"addonCombinations":[{"groupId":"76095222","addonId":"60999876"},{"groupId":"76095222","addonId":"60999877"},{"groupId":"76095222","addonId":"60999878"},{"groupId":"76095222","addonId":"60999879"},{"groupId":"76095222","addonId":"60999880"},{"groupId":"76095222","addonId":"60999881"},{"groupId":"76095222","addonId":"60999882"},{"groupId":"76095222","addonId":"60999883"},{"groupId":"76095222","addonId":"60999884"},{"groupId":"76095224","addonId":"60999885"},{"groupId":"76095220","addonId":"60998438"},{"groupId":"76095220","addonId":"60998439"},{"groupId":"76095221","addonId":"60998441"},{"groupId":"76095221","addonId":"60998442"},{"groupId":"76095221","addonId":"60998443"},{"groupId":"76095221","addonId":"60998432"},{"groupId":"76095221","addonId":"60998433"},{"groupId":"76095221","addonId":"60998434"},{"groupId":"76095221","addonId":"60998435"},{"groupId":"76095223","addonId":"60999875"}]},{"variations":[{"groupId":"23987183","variationId":"77571786"}],"price":48000,"addonCombinations":[{"groupId":"76095226","addonId":"60999886"},{"groupId":"76095227","addonId":"60999896"},{"groupId":"76095220","addonId":"60998438"},{"groupId":"76095220","addonId":"60998439"},{"groupId":"76095221","addonId":"60998441"},{"groupId":"76095221","addonId":"60998442"},{"groupId":"76095221","addonId":"60998443"},{"groupId":"76095221","addonId":"60998432"},{"groupId":"76095221","addonId":"60998433"},{"groupId":"76095221","addonId":"60998434"},{"groupId":"76095221","addonId":"60998435"},{"groupId":"76095225","addonId":"60999887"},{"groupId":"76095225","addonId":"60999888"},{"groupId":"76095225","addonId":"60999889"},{"groupId":"76095225","addonId":"60999890"},{"groupId":"76095225","addonId":"60999891"},{"groupId":"76095225","addonId":"60999892"},{"groupId":"76095225","addonId":"60999893"},{"groupId":"76095225","addonId":"60999894"},{"groupId":"76095225","addonId":"60999895"}]}]},"addons":[{"groupId":"76095216","groupName":"Extra Toppings [8 Inches]","choices":[{"id":"60999869","name":"Zucchini","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999865","name":"Paneer","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999866","name":"Broccoli","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999867","name":"Capsicum","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999868","name":"Red Paprika","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999872","name":"Olive","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999873","name":"Jalapeno","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999870","name":"Onion","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999871","name":"Corn","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095225","groupName":"Extra Toppings [12 Inches]","choices":[{"id":"60999887","name":"Paneer","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999888","name":"Broccoli","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999889","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999894","name":"Olive","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999895","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999890","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999891","name":"Zucchini","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999892","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999893","name":"Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095222","groupName":"Extra Toppings [10 Inches]","choices":[{"id":"60999876","name":"Paneer","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999877","name":"Broccoli","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999878","name":"Capsicum","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999879","name":"Red Paprika","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999883","name":"Olive","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999884","name":"Jalapeno","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999880","name":"Zucchini","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999881","name":"Onion","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999882","name":"Corn","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095221","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095217","groupName":"Extra Cheese brust [Reg]","choices":[{"id":"60999864","name":"Cheese Brust","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095223","groupName":"Extra Cheese brust [Med]","choices":[{"id":"60999875","name":"Cheese Brust","price":10000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095226","groupName":"Extra Cheese brust [Large]","choices":[{"id":"60999886","name":"Cheese Brust","price":13000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095219","groupName":"Extra Cheese [regular]","choices":[{"id":"60999874","name":"Extra Cheese","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095224","groupName":"Extra [medium]","choices":[{"id":"60999885","name":"Extra Cheese","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095227","groupName":"Extras [large]","choices":[{"id":"60999896","name":"Extra Cheese","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095220","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"defaultPrice":28000,"ribbon":{},"showImage":true,"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.6","ratingCount":"6 ratings","ratingCountV2":"6"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"75106404","name":"Ultimate Paneer Pizza","category":"Pizza","description":"Peppy Paneer, Onion Tomato, Green Chilies, Corn, Italian Sprinkle","imageId":"ocafwv6i9csobnarmj5d","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"23987195","name":"Portion","variations":[{"name":"Regular [8 Inches]","price":280,"default":1,"id":"77571820","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Medium [10 Inches]","price":380,"id":"77571821","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Large [12 Inches]","price":480,"id":"77571822","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"23987195","variationId":"77571820"}],"price":28000,"addonCombinations":[{"groupId":"76095358","addonId":"60999865"},{"groupId":"76095358","addonId":"60999866"},{"groupId":"76095358","addonId":"60999867"},{"groupId":"76095358","addonId":"60999868"},{"groupId":"76095358","addonId":"60999869"},{"groupId":"76095358","addonId":"60999870"},{"groupId":"76095358","addonId":"60999871"},{"groupId":"76095358","addonId":"60999872"},{"groupId":"76095358","addonId":"60999873"},{"groupId":"76095359","addonId":"60999864"},{"groupId":"76095361","addonId":"60999874"},{"groupId":"76095362","addonId":"60998438"},{"groupId":"76095362","addonId":"60998439"},{"groupId":"76095363","addonId":"60998441"},{"groupId":"76095363","addonId":"60998442"},{"groupId":"76095363","addonId":"60998443"},{"groupId":"76095363","addonId":"60998432"},{"groupId":"76095363","addonId":"60998433"},{"groupId":"76095363","addonId":"60998434"},{"groupId":"76095363","addonId":"60998435"}]},{"variations":[{"groupId":"23987195","variationId":"77571821"}],"price":38000,"addonCombinations":[{"groupId":"76095364","addonId":"60999876"},{"groupId":"76095364","addonId":"60999877"},{"groupId":"76095364","addonId":"60999878"},{"groupId":"76095364","addonId":"60999879"},{"groupId":"76095364","addonId":"60999880"},{"groupId":"76095364","addonId":"60999881"},{"groupId":"76095364","addonId":"60999882"},{"groupId":"76095364","addonId":"60999883"},{"groupId":"76095364","addonId":"60999884"},{"groupId":"76095362","addonId":"60998438"},{"groupId":"76095362","addonId":"60998439"},{"groupId":"76095363","addonId":"60998441"},{"groupId":"76095363","addonId":"60998442"},{"groupId":"76095363","addonId":"60998443"},{"groupId":"76095363","addonId":"60998432"},{"groupId":"76095363","addonId":"60998433"},{"groupId":"76095363","addonId":"60998434"},{"groupId":"76095363","addonId":"60998435"},{"groupId":"115661957","addonId":"60999885"},{"groupId":"76095365","addonId":"60999875"}]},{"variations":[{"groupId":"23987195","variationId":"77571822"}],"price":48000,"addonCombinations":[{"groupId":"76095367","addonId":"60999886"},{"groupId":"76095368","addonId":"60999896"},{"groupId":"76095362","addonId":"60998438"},{"groupId":"76095362","addonId":"60998439"},{"groupId":"76095363","addonId":"60998441"},{"groupId":"76095363","addonId":"60998442"},{"groupId":"76095363","addonId":"60998443"},{"groupId":"76095363","addonId":"60998432"},{"groupId":"76095363","addonId":"60998433"},{"groupId":"76095363","addonId":"60998434"},{"groupId":"76095363","addonId":"60998435"},{"groupId":"76095366","addonId":"60999887"},{"groupId":"76095366","addonId":"60999888"},{"groupId":"76095366","addonId":"60999889"},{"groupId":"76095366","addonId":"60999890"},{"groupId":"76095366","addonId":"60999891"},{"groupId":"76095366","addonId":"60999892"},{"groupId":"76095366","addonId":"60999893"},{"groupId":"76095366","addonId":"60999894"},{"groupId":"76095366","addonId":"60999895"}]}]},"addons":[{"groupId":"76095358","groupName":"Extra Toppings [8 Inches]","choices":[{"id":"60999869","name":"Zucchini","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999865","name":"Paneer","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999866","name":"Broccoli","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999867","name":"Capsicum","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999868","name":"Red Paprika","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999872","name":"Olive","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999873","name":"Jalapeno","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999870","name":"Onion","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999871","name":"Corn","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095366","groupName":"Extra Toppings [12 Inches]","choices":[{"id":"60999887","name":"Paneer","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999888","name":"Broccoli","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999889","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999894","name":"Olive","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999895","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999890","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999891","name":"Zucchini","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999892","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999893","name":"Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095364","groupName":"Extra Toppings [10 Inches]","choices":[{"id":"60999876","name":"Paneer","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999877","name":"Broccoli","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999878","name":"Capsicum","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999879","name":"Red Paprika","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999883","name":"Olive","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999884","name":"Jalapeno","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999880","name":"Zucchini","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999881","name":"Onion","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999882","name":"Corn","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095363","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095359","groupName":"Extra Cheese brust [Reg]","choices":[{"id":"60999864","name":"Cheese Brust","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095365","groupName":"Extra Cheese brust [Med]","choices":[{"id":"60999875","name":"Cheese Brust","price":10000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095367","groupName":"Extra Cheese brust [Large]","choices":[{"id":"60999886","name":"Cheese Brust","price":13000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095361","groupName":"Extra Cheese [regular]","choices":[{"id":"60999874","name":"Extra Cheese","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661957","groupName":"Extra [medium]","choices":[{"id":"60999885","name":"Extra Cheese","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095368","groupName":"Extras [large]","choices":[{"id":"60999896","name":"Extra Cheese","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095362","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"defaultPrice":28000,"ribbon":{},"showImage":true,"itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.7","ratingCount":"4 ratings","ratingCountV2":"4"}}},"analytics":{},"hideRestaurantDetails":true}}],"type":"CATEGORY_TYPE_RECOMMENDED"}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"Combos","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"109225779","name":"Aaloo Tikki Burger + Cold Drink [400 Ml]","category":"Combos","imageId":"a5522bb0496cd1ed083a0a75ae7864e8","inStock":1,"isVeg":1,"price":11900,"variants":{},"variantsV2":{},"addons":[{"groupId":"76094796","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76094798","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"2.3","ratingCount":"4 ratings","ratingCountV2":"4"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"109225780","name":"Aaloo Tikki Burger + Fries + Cold Drink [400 Ml]","category":"Combos","imageId":"57f7eb944bb9fd029de30b045fa70b92","inStock":1,"isVeg":1,"price":19900,"variants":{},"variantsV2":{},"addons":[{"groupId":"76094799","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76094801","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"type":"ITEM","itemBadge":{},"badgesV2":{},"isBestseller":true,"ratings":{"aggregatedRating":{"rating":"3.3","ratingCount":"13 ratings","ratingCountV2":"13"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"109225781","name":"Creamy Burger + Cold Drink [400 Ml]","category":"Combos","imageId":"d81206fa8f48f822bcfa31b854f1ddcb","inStock":1,"isVeg":1,"price":11900,"variants":{},"variantsV2":{},"addons":[{"groupId":"76094802","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76094804","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"109225782","name":"Creamy Burger\\t+ Fries + Cold Drink [400ml]","category":"Combos","imageId":"529725b4faa78b70fc2ce2ec95d69d94","inStock":1,"isVeg":1,"price":19900,"variants":{},"variantsV2":{},"addons":[{"groupId":"76094805","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76094807","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.2","ratingCount":"6 ratings","ratingCountV2":"6"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"109225783","name":"Tandoori Burger + Cold Drink [400 Ml]","category":"Combos","imageId":"0b0338a181b8f9eb6dca46c273311bb5","inStock":1,"isVeg":1,"price":11900,"variants":{},"variantsV2":{},"addons":[{"groupId":"76094808","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76094810","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"109225784","name":"Tandoori Burger + Fries + Cold Drink [400 Ml]","category":"Combos","imageId":"a1a418f5faf3616d308898da7d10fe07","inStock":1,"isVeg":1,"price":19900,"variants":{},"variantsV2":{},"addons":[{"groupId":"76094811","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76094813","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.7","ratingCount":"7 ratings","ratingCountV2":"7"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"109225785","name":"Veg Spicy Burger + Cold Drink [400 Ml]","category":"Combos","imageId":"42952df844492d1a3f48f47222607fc9","inStock":1,"isVeg":1,"price":11900,"variants":{},"variantsV2":{},"addons":[{"groupId":"76094814","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76094816","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"109225786","name":"Veg Spicy Burger + Fries + Cold Drink [400 Ml]","category":"Combos","imageId":"0625aed2f51e3e6db76eab35628dc6ce","inStock":1,"isVeg":1,"price":19900,"variants":{},"variantsV2":{},"addons":[{"groupId":"76094817","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76094819","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"115995652","name":"Chef Special Stuffed Garlic Breadfully Loaded+ Cold Drink (400 Ml)","category":"Combos","imageId":"14d2b090e56780dcbb71305d13206bc1","inStock":1,"isVeg":1,"price":19900,"variants":{},"variantsV2":{},"addons":[{"groupId":"115661915","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661914","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.0","ratingCount":"3 ratings","ratingCountV2":"3"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"119599216","name":"Aaloo Patty Sub + Cold Drink (400 Ml)","category":"Combos","imageId":"96908c8e2cc842ed00846f7181277bdf","inStock":1,"isVeg":1,"price":19900,"variants":{},"variantsV2":{},"addons":[{"groupId":"115661909","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661908","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"119599217","name":"Cheese Corn Pizza (small) + Cold Drink (400 Ml)","category":"Combos","imageId":"abfe644c509d13054f9349790ea49e94","inStock":1,"isVeg":1,"price":17900,"variants":{},"variantsV2":{},"addons":[{"groupId":"115661911","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661910","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"119599218","name":"Cheese Maggie + Cold Drink (400 Ml)","category":"Combos","imageId":"d9faef274eb22ee2b4eceebf6fe352db","inStock":1,"isVeg":1,"price":15900,"variants":{},"variantsV2":{},"addons":[{"groupId":"115661913","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661912","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"2.9","ratingCount":"6 ratings","ratingCountV2":"6"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"119599223","name":"Punjabi Pizza ( Small) + Cold Drink (400ml)","category":"Combos","imageId":"e039ea234695bc4dab11489ead973cf7","inStock":1,"isVeg":1,"price":20900,"variants":{},"variantsV2":{},"addons":[{"groupId":"115661917","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661916","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"type":"ITEM","itemBadge":{},"badgesV2":{},"isBestseller":true,"ratings":{"aggregatedRating":{"rating":"4.2","ratingCount":"22 ratings","ratingCountV2":"22"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"119599226","name":"Veegie Delight Sub + Cold Drink (400ml)","category":"Combos","imageId":"3ef7e4b7fbba99a4d1b838015995710b","inStock":1,"isVeg":1,"price":18900,"variants":{},"variantsV2":{},"addons":[{"groupId":"115661921","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661920","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"119599227","name":"Veg Exotic Sandwich + Cold Dink (400ml)","category":"Combos","imageId":"385b0eb9bf226a99752a4b5005274211","inStock":1,"isVeg":1,"price":17900,"variants":{},"variantsV2":{},"addons":[{"groupId":"115661923","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661922","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"121572662","name":"Spicy Tandoori Sandwich + Cold Drink (400ml)","category":"Combos","imageId":"a8cb1344dcb9a7d8c0ad90174652b613","inStock":1,"isVeg":1,"price":19900,"variants":{},"variantsV2":{},"addons":[{"groupId":"115661919","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661918","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}}]}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"Starters","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"57814702","name":"French Fries","category":"Starters","imageId":"5216ecf85f34e1fd8990a7c8fffdab66","inStock":1,"isVeg":1,"price":14000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76094826","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76094828","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.0","ratingCount":"16 ratings","ratingCountV2":"16"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"75106445","name":"Spicy French Fries","category":"Starters","imageId":"a3268c499fa40f6771a65dacf7c272d9","inStock":1,"isVeg":1,"price":17000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76094835","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76094837","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"79934704","name":"Cheese Balls","category":"Starters","imageId":"d230588ecef03cb2bc82f0e128352d1e","inStock":1,"isVeg":1,"price":18000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76094820","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76094822","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.5","ratingCount":"3 ratings","ratingCountV2":"3"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"79934728","name":"Cheese Fries","category":"Starters","inStock":1,"isVeg":1,"price":20000,"variants":{},"variantsV2":{},"addons":[{"groupId":"115668580","groupName":"Add On Vanila Ice","choices":[{"id":"102291573","name":"Vanilla Ice Cream","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115668581","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115668582","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"100777471","name":"Loaded  Fries","category":"Starters","inStock":1,"isVeg":1,"price":19000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76094829","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76094831","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"100777473","name":"Peri-peri Fries.","category":"Starters","imageId":"fdd8802b236d90e501aeda161da77e82","inStock":1,"isVeg":1,"price":17000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76094832","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76094834","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}}]}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"Momo\'s","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"113482128","name":"Veg Fried Momo","category":"Momo\'s","imageId":"ad8574dc00e631548548bf6e47a2a23c","inStock":1,"isVeg":1,"price":16000,"variants":{},"variantsV2":{},"addons":[{"groupId":"115661929","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661928","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"125797776","name":"Cheese Corn Momo","category":"Momo\'s","imageId":"ada83b9e74adb5661e7df7963d58620a","inStock":1,"isVeg":1,"price":15000,"variants":{},"variantsV2":{},"addons":[{"groupId":"115661925","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661924","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"125797777","name":"Cheese Loded Momo","category":"Momo\'s","imageId":"1debc96fafdb96c81410d35c1f7f5809","inStock":1,"isVeg":1,"price":19500,"variants":{},"variantsV2":{},"addons":[{"groupId":"115661927","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661926","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"125797778","name":"Mushroom Momo","category":"Momo\'s","imageId":"2ce5977563eb5fcf561da9a5ceebc605","inStock":1,"isVeg":1,"price":15500,"variants":{},"variantsV2":{},"addons":[{"groupId":"115661931","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661930","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"125797779","name":"Paneer Fried Momo","category":"Momo\'s","imageId":"a3061a04469ffce42d70a1d13e72337d","inStock":1,"isVeg":1,"price":16000,"variants":{},"variantsV2":{},"addons":[{"groupId":"115661933","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661932","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"125797780","name":"Paneer Momo","category":"Momo\'s","imageId":"d42569ea31da9a4987b7a76f04d5e177","inStock":1,"isVeg":1,"price":15000,"variants":{},"variantsV2":{},"addons":[{"groupId":"115661935","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661934","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"125797781","name":"Veg Momo","category":"Momo\'s","imageId":"255b2fbc02810fd8048dea596e1c2410","inStock":1,"isVeg":1,"price":13000,"variants":{},"variantsV2":{},"addons":[{"groupId":"115661937","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661936","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}}]}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"Spring Roll","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"125797783","name":"Paneer Spring Roll","category":"Spring Roll","imageId":"be73fe0c6d617a4ccd23974306bd0849","inStock":1,"isVeg":1,"price":18000,"variants":{},"variantsV2":{},"addons":[{"groupId":"115661939","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661938","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"125797784","name":"Veg Spring Roll","category":"Spring Roll","imageId":"4bcc27f90dc1e49d4a91522ae32575fd","inStock":1,"isVeg":1,"price":16000,"variants":{},"variantsV2":{},"addons":[{"groupId":"115661941","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661940","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}}]}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"CHINESE Starters ","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"104495437","name":"Veg Crispy","category":"CHINESE Starters ","imageId":"866840dd7559df5dc05ea145a4e064d1","inStock":1,"isVeg":1,"price":23000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76094868","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76094870","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"104509837","name":"Lemon Paneer Gravy","category":"CHINESE Starters ","inStock":1,"isVeg":1,"price":26000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76094856","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76094858","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"104509838","name":"Honey Chilli Potato","category":"CHINESE Starters ","imageId":"bfa8d337415d606d39f2fe5b69defc47","inStock":1,"isVeg":1,"price":21000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76094853","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76094855","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.3","ratingCount":"6 ratings","ratingCountV2":"6"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"104509839","name":"Schezwan Manchurian Gravy","category":"CHINESE Starters ","imageId":"9a49f30efa63fc823328934e8ebcc10b","inStock":1,"isVeg":1,"price":22000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76094862","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76094864","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"104509840","name":"Schezwan Manchurian Dry","category":"CHINESE Starters ","imageId":"612ac9681ddd7582451a5f552df5c7e9","inStock":1,"isVeg":1,"price":22000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76094859","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76094861","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"104509841","name":"Cheese Chilli Gravy","category":"CHINESE Starters ","imageId":"0b001a3bba5c5b8e4183469358e8b880","inStock":1,"isVeg":1,"price":26000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76094841","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76094843","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"104509842","name":"Cheese Chilli Dry","category":"CHINESE Starters ","imageId":"fa6d67315e0bd5a563ae2f0349c47a29","inStock":1,"isVeg":1,"price":26000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76094838","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76094840","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.0","ratingCount":"8 ratings","ratingCountV2":"8"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"104509843","name":"Veg Manchurian Gravy","category":"CHINESE Starters ","imageId":"0784262769c817c4bed9a028c5cdf491","inStock":1,"isVeg":1,"price":21000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76094874","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76094876","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"2.3","ratingCount":"9 ratings","ratingCountV2":"9"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"104509844","name":"Veg Manchurian Dry","category":"CHINESE Starters ","imageId":"43bf8e48caf000f1058f13f21b78565b","inStock":1,"isVeg":1,"price":21000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76094871","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76094873","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"104509845","name":"Chilli Mushroom Gravy","category":"CHINESE Starters ","imageId":"558004c2db9dc6463c73bd14d851c80c","inStock":1,"isVeg":1,"price":23000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76094847","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76094849","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"104509846","name":"Chilli Mushroom Dry","category":"CHINESE Starters ","imageId":"6f7c00ed34842adc8ecd5cebbde4a505","inStock":1,"isVeg":1,"price":23000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76094844","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76094846","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"104509848","name":"Crispy Paneer","category":"CHINESE Starters ","imageId":"4ede9e6513758321289b99f848484832","inStock":1,"isVeg":1,"price":27000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76094850","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76094852","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"113237892","name":"Corn Salt & Pepper","category":"CHINESE Starters ","inStock":1,"isVeg":1,"price":22000,"variants":{},"variantsV2":{},"addons":[{"groupId":"83899713","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"83899712","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}}]}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"Rice & Noodles","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"104495434","name":"Mushroom & Corn Fried Rice","category":"Rice & Noodles","imageId":"0f3c419c83037538054dc1f632b1d029","inStock":1,"isVeg":1,"price":17000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76094892","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76094894","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.3","ratingCount":"5 ratings","ratingCountV2":"5"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"104495435","name":"Cheese Noodles","category":"Rice & Noodles","imageId":"d4f5fb0e3fcd092959c8bb56c97cf781","inStock":1,"isVeg":1,"price":18000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76094877","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76094879","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"2.2","ratingCount":"5 ratings","ratingCountV2":"5"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"104495436","name":"Fried Rice","category":"Rice & Noodles","imageId":"d559f9583f6b3a21fee2443909f3ebad","inStock":1,"isVeg":1,"price":16000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76094883","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76094885","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.7","ratingCount":"7 ratings","ratingCountV2":"7"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"104495439","name":"Hakka Noodles","category":"Rice & Noodles","imageId":"7cfdd7e392d26414b33536e851a29f75","inStock":1,"isVeg":1,"price":17000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76094889","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76094891","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"2.9","ratingCount":"5 ratings","ratingCountV2":"5"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"104495440","name":"Singapore Noodles","category":"Rice & Noodles","imageId":"0110e211e51028e48a9527cac773f6c9","inStock":1,"isVeg":1,"price":19000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76094898","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76094900","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.0","ratingCount":"5 ratings","ratingCountV2":"5"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"104495441","name":"Veg Noodles","category":"Rice & Noodles","imageId":"307488252c58c0390e18414200bcbeb7","inStock":1,"isVeg":1,"price":14800,"variants":{},"variantsV2":{},"addons":[{"groupId":"76094904","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76094906","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"104495442","name":"Chilli Garlic Noodles","category":"Rice & Noodles","imageId":"0b30d989878777ce96396327b67c55de","inStock":1,"isVeg":1,"price":16000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76094880","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76094882","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"1.0","ratingCount":"3 ratings","ratingCountV2":"3"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"125808416","name":"Punjabi Fried Rice","category":"Rice & Noodles","inStock":1,"isVeg":1,"price":22000,"variants":{},"variantsV2":{},"addons":[{"groupId":"115661943","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661942","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"125808417","name":"Sechwan Noodles","category":"Rice & Noodles","inStock":1,"isVeg":1,"price":16000,"variants":{},"variantsV2":{},"addons":[{"groupId":"115661945","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661944","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}}]}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"Soups","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"104495429","name":"Tomato Soup","category":"Soups","inStock":1,"isVeg":1,"price":12000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76094909","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76094908","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"104495431","name":"Veg Manchow Soup","category":"Soups","imageId":"135a7566c6a089a4cf7df85cdfddfed0","inStock":1,"isVeg":1,"price":12000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76094912","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76094911","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"104495432","name":"Veg Sweet Corn Soup","category":"Soups","inStock":1,"isVeg":1,"price":12000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76094915","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76094914","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}}]}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory","title":"Burgers And Sandwiches","categories":[{"title":"Burgers","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"57814749","name":"Farm Fresh Burger","category":"Burgers And Sandwiches","imageId":"8d96c925e3b3896d5872bbbfb46cb516","inStock":1,"isVeg":1,"price":11000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76095453","groupName":"Make it a Meal","choices":[{"id":"60999854","name":"French Fries+pepsi [450 Ml]","price":10000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095456","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095455","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.5","ratingCount":"37 ratings","ratingCountV2":"37"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"57814790","name":"Paneer Tikka Burger","category":"Burgers And Sandwiches","imageId":"38a3e788bd9414d61c6a081e1880ca83","inStock":1,"isVeg":1,"price":13000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76095473","groupName":"Make it a Meal","choices":[{"id":"60999854","name":"French Fries+pepsi [450 Ml]","price":10000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095476","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095475","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.0","ratingCount":"6 ratings","ratingCountV2":"6"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"57814811","name":"King Size Burger","category":"Burgers And Sandwiches","imageId":"55dabefdf7f87c3a12ca0a28f606535e","inStock":1,"isVeg":1,"price":15000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76095461","groupName":"Make it a Meal","choices":[{"id":"60999854","name":"French Fries+pepsi [450 Ml]","price":10000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095464","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095463","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.7","ratingCount":"9 ratings","ratingCountV2":"9"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"57814815","name":"Cheese Cheddar Burger","category":"Burgers And Sandwiches","imageId":"75c76f5c52246b118a9901382f37231d","inStock":1,"isVeg":1,"price":13000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76095433","groupName":"Make it a Meal","choices":[{"id":"60999854","name":"French Fries+pepsi [450 Ml]","price":10000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095436","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095435","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.6","ratingCount":"5 ratings","ratingCountV2":"5"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"57814817","name":"Crunchy Paneer Burger","category":"Burgers And Sandwiches","imageId":"krgvd8t20uits69obs11","inStock":1,"isVeg":1,"price":12000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76095445","groupName":"Make it a Meal","choices":[{"id":"60999854","name":"French Fries+pepsi [450 Ml]","price":10000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095448","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095447","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"1.6","ratingCount":"7 ratings","ratingCountV2":"7"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"75106428","name":"Paneer Makhani Burger","category":"Burgers And Sandwiches","imageId":"0d10020e2c8f359c5f57c619571ee5f9","inStock":1,"isVeg":1,"price":12000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76095469","groupName":"Make it a Meal","choices":[{"id":"60999854","name":"French Fries+pepsi [450 Ml]","price":10000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095472","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095471","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"102704350","name":"Chef\'s Favourite Burger","category":"Burgers And Sandwiches","imageId":"f15da0f9ead6eb4be2122336fcbf72ce","inStock":1,"isVeg":1,"price":17000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76095437","groupName":"Make it a Meal","choices":[{"id":"60999854","name":"French Fries+pepsi [450 Ml]","price":10000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095440","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095439","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.9","ratingCount":"4 ratings","ratingCountV2":"4"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"109225814","name":"Aalo Tikki Burger","category":"Burgers And Sandwiches","imageId":"131ed917bf2497c965ac0379f4028784","inStock":1,"isVeg":1,"price":7000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76095429","groupName":"Make it a Meal","choices":[{"id":"60999854","name":"French Fries+pepsi [450 Ml]","price":10000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095430","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095432","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"type":"ITEM","itemBadge":{},"badgesV2":{},"isBestseller":true,"ratings":{"aggregatedRating":{"rating":"4.3","ratingCount":"37 ratings","ratingCountV2":"37"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"109225815","name":"Creamy Burger","category":"Burgers And Sandwiches","imageId":"fea355a5b3a886ade7839db4be40d944","inStock":1,"isVeg":1,"price":7500,"variants":{},"variantsV2":{},"addons":[{"groupId":"76095441","groupName":"Make it a Meal","choices":[{"id":"60999854","name":"French Fries+pepsi [450 Ml]","price":10000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095442","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095444","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"type":"ITEM","itemBadge":{},"badgesV2":{},"isBestseller":true,"ratings":{"aggregatedRating":{"rating":"3.8","ratingCount":"16 ratings","ratingCountV2":"16"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"109225816","name":"Tandoori Burger","category":"Burgers And Sandwiches","imageId":"b57bd02598a83439cecbdf4d4149febc","inStock":1,"isVeg":1,"price":9000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76095477","groupName":"Make it a Meal","choices":[{"id":"60999854","name":"French Fries+pepsi [450 Ml]","price":10000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095478","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095480","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.3","ratingCount":"14 ratings","ratingCountV2":"14"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"109225817","name":"Veg Spicy Burger","category":"Burgers And Sandwiches","imageId":"31a93d3aa08c2cdca0ce7091a88d6006","inStock":1,"isVeg":1,"price":8000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76095481","groupName":"Make it a Meal","choices":[{"id":"60999854","name":"French Fries+pepsi [450 Ml]","price":10000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095482","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095484","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.8","ratingCount":"6 ratings","ratingCountV2":"6"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"125808418","name":"Double Tikki Burger","category":"Burgers And Sandwiches","inStock":1,"isVeg":1,"price":9000,"variants":{},"variantsV2":{},"addons":[{"groupId":"115661960","groupName":"Make it a Meal","choices":[{"id":"60999854","name":"French Fries+pepsi [450 Ml]","price":10000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661959","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661958","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}}]},{"title":"Sandwiches","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"57812715","name":"Veg Exotic Sandwich","category":"Burgers And Sandwiches","imageId":"5b339d6205ba8dc0b05c05bf95d95749","inStock":1,"isVeg":1,"price":16000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76095502","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095501","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.3","ratingCount":"8 ratings","ratingCountV2":"8"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"57814977","name":"Bombay Club Sandwich","category":"Burgers And Sandwiches","inStock":1,"isVeg":1,"price":24000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76095487","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095486","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"57814978","name":"Spicy Tandoori Sandwich","category":"Burgers And Sandwiches","imageId":"125cbc99ee12ae38cffd920457c7475e","inStock":1,"isVeg":1,"price":18000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76095499","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095498","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.7","ratingCount":"3 ratings","ratingCountV2":"3"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"57814981","name":"Cheese Corn Sandwich","category":"Burgers And Sandwiches","imageId":"c99019c2fe99fa7aa6e63a86abbd4076","inStock":1,"isVeg":1,"price":19000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76095490","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095489","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.1","ratingCount":"18 ratings","ratingCountV2":"18"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"75106432","name":"Paneer Makhani Sandwich","category":"Burgers And Sandwiches","imageId":"e10b840bc4de6f5162bdbd944c8ac1ce","inStock":1,"isVeg":1,"price":17500,"variants":{},"variantsV2":{},"addons":[{"groupId":"76095493","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095492","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"125911172","name":"Mashroom Delight Sandwich","category":"Burgers And Sandwiches","imageId":"5f4680df5dac5440fbcfdef7b502e792","inStock":1,"isVeg":1,"price":19500,"variants":{},"variantsV2":{},"addons":[{"groupId":"115661903","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661902","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}}]}]}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory","title":"Snacks","categories":[{"title":"Garlic Bread","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"75106464","name":"Supreme Stuffed Garlic Bread","category":"Snacks","imageId":"ce429edf30063a612dafe9eba1b3c503","inStock":1,"isVeg":1,"price":16000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76095533","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095532","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"102704358","name":"Stuffed Garlic Bread Cheese","category":"Snacks","imageId":"9585aefafa5a2945a6b785ec9997f968","inStock":1,"isVeg":1,"price":11900,"variants":{},"variantsV2":{},"addons":[{"groupId":"76095518","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095517","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"102704359","name":"Stuffed Garlic Mushroom And Corn","category":"Snacks","imageId":"b8a6bba2deec8651de2c3505581e54d9","inStock":1,"isVeg":1,"price":15000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76095524","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095523","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"102704365","name":"Slice Garlic Bread Cheese [4 Slice]","category":"Snacks","imageId":"651f78ec204d4fd93bb8ac0fabb23153","inStock":1,"isVeg":1,"price":14800,"variants":{},"variantsV2":{},"addons":[{"groupId":"76095505","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095504","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"102704372","name":"Slice Mushroom And Corn [4 Slice]","category":"Snacks","imageId":"dfa031b94e9b4ff8bf9fc426595d7fcd","inStock":1,"isVeg":1,"price":17000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76095508","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095507","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"102704475","name":"Supreme Garlic Bread [4 Slice]","category":"Snacks","imageId":"f864187f8d4a6cd105eadd82f9b39808","inStock":1,"isVeg":1,"price":16000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76095530","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095529","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"102704490","name":"Stuffed Chef Spiceal Fully Loded Garlic Bread","category":"Snacks","imageId":"cf0ac1cc32290a22f18199875d271409","inStock":1,"isVeg":1,"price":19000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76095527","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095526","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"2.8","ratingCount":"4 ratings","ratingCountV2":"4"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"102704495","name":"Chef Spiceal Fully Loded Garlic Bread [6 Slice].","category":"Snacks","imageId":"42c85176e954de6e1c62b7ed6ed20180","inStock":1,"isVeg":1,"price":19000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76095511","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095510","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}}]},{"title":"Calzone Cave","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"102704361","name":"Peri Peri Calzone Cave","category":"Snacks","imageId":"c2674b7f640b4e8c34b9e847f4573be2","inStock":1,"isVeg":1,"price":15000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76095539","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095538","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"102704364","name":"Spicy Tandoori Calzone Cave","category":"Snacks","imageId":"3ffd274d0a9fe700cbd6beacc9fd3647","inStock":1,"isVeg":1,"price":15000,"variants":{},"variantsV2":{},"addons":[{"groupId":"115661905","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661904","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"104495454","name":"Cheese Corn Calzone Cave","category":"Snacks","imageId":"238ba3cd452159d33b623a01ff047fda","inStock":1,"isVeg":1,"price":15000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76095536","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095535","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}}]}]}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"Sub","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"57814529","name":"Paneer Tikka Sub","category":"Sub","imageId":"13777b96e4f72ff2bad275c71a466eea","inStock":1,"isVeg":1,"price":18000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76094953","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76094952","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"2.3","ratingCount":"19 ratings","ratingCountV2":"19"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"75106358","name":"Falafel Sub","category":"Sub","imageId":"u1ufmirwo13udeame9re","inStock":1,"isVeg":1,"price":17000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76094947","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76094946","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.8","ratingCount":"8 ratings","ratingCountV2":"8"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"75106359","name":"Hara Bhara Kabab Sub","category":"Sub","imageId":"vfevo8dvkp3jelpxmnlx","inStock":1,"isVeg":1,"price":17000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76094950","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76094949","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.0","ratingCount":"3 ratings","ratingCountV2":"3"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"79934764","name":"Aloo Patty Sub","category":"Sub","imageId":"7780d7c21717906a1eeef94ac03f02fa","inStock":1,"isVeg":1,"price":17000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76094941","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76094940","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"100777478","name":"Tandoori Paneer Sub.","category":"Sub","imageId":"630a7d7b8ccb91be572eb5d437a7268a","inStock":1,"isVeg":1,"price":19000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76094956","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76094955","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"100777479","name":"Veggie Delight Sub.","category":"Sub","imageId":"b46dbab4e49cb7583201eedfa44715d6","inStock":1,"isVeg":1,"price":16000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76094959","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76094958","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}}]}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"Wraps","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"57814513","name":"Kohlapuri Paneer Wrap","category":"Wraps","imageId":"aa9e714ba569ff65c746fbf50b6bc32a","inStock":1,"isVeg":1,"price":16000,"variants":{},"variantsV2":{},"addons":[{"groupId":"115661811","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661810","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"75106366","name":"Cheese Mushroom Wrap","category":"Wraps","imageId":"1db297216ec26dadc6aa7dd475a1c3d7","inStock":1,"isVeg":1,"price":15000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76095013","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095012","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"5.0","ratingCount":"4 ratings","ratingCountV2":"4"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"75106367","name":"Hara Bhara Kabab Wrap","category":"Wraps","imageId":"ac2cf86e28331221f896abda28ae8013","inStock":1,"isVeg":1,"price":14000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76095019","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095018","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"75106370","name":"Spicy Aloo Tikki Wrap","category":"Wraps","imageId":"68775a6849306a9c3570d90dbfacceb9","inStock":1,"isVeg":1,"price":15000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76095031","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095030","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"79934923","name":"Paneer Cheese Wrap","category":"Wraps","imageId":"fefe3e3ce10b792edffe111414b673f8","inStock":1,"isVeg":1,"price":16000,"variants":{},"variantsV2":{},"addons":[{"groupId":"115661813","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661812","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.7","ratingCount":"3 ratings","ratingCountV2":"3"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"79934924","name":"Veggie Delight Wrap","category":"Wraps","imageId":"a56ffb17cb2b7ff7a418d3ad6a4fa679","inStock":1,"isVeg":1,"price":14000,"variants":{},"variantsV2":{},"addons":[{"groupId":"115661815","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661814","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}}]}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"Maggi","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"57814492","name":"Tandoori Maggi","category":"Maggi","imageId":"b5c5a2d80c0ee9efb347544658d47e60","inStock":1,"isVeg":1,"price":12000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76094989","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76094988","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.0","ratingCount":"15 ratings","ratingCountV2":"15"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"75106372","name":"Cheese Maggi","category":"Maggi","imageId":"b3879cdfa377206ba373dbc31568edba","inStock":1,"isVeg":1,"price":12500,"variants":{},"variantsV2":{},"addons":[{"groupId":"76094965","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76094964","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.7","ratingCount":"6 ratings","ratingCountV2":"6"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"75106377","name":"Masala Mix Veg Maggi","category":"Maggi","imageId":"afcc80c9a6f71892e4dce5ba2f7db849","inStock":1,"isVeg":1,"price":13000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76094974","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76094973","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.9","ratingCount":"3 ratings","ratingCountV2":"3"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"75106382","name":"Spicy Maggi","category":"Maggi","imageId":"34f0a2d36f5af10506c729cc70605a92","inStock":1,"isVeg":1,"price":12000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76094983","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76094982","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.1","ratingCount":"6 ratings","ratingCountV2":"6"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"79934930","name":"Cheese Corn Maggie","category":"Maggi","imageId":"d60af22054ac45619f1f126db617d038","inStock":1,"isVeg":1,"price":13000,"variants":{},"variantsV2":{},"addons":[{"groupId":"115661817","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661816","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"79934932","name":"Double Cheese Maggie","category":"Maggi","imageId":"f283baaaf68ce0548be4f51cef1ff354","inStock":1,"isVeg":1,"price":14000,"variants":{},"variantsV2":{},"addons":[{"groupId":"115661819","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661818","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"79934935","name":"Makhni Veggie Maggie","category":"Maggi","imageId":"03fdb480ab3e91614703b9b6773c5fd5","inStock":1,"isVeg":1,"price":12000,"variants":{},"variantsV2":{},"addons":[{"groupId":"115661821","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661820","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"79934944","name":"Masala Pyaza Maggie","category":"Maggi","imageId":"0cea1cf2f53443b3bf46324266b59cc1","inStock":1,"isVeg":1,"price":12000,"variants":{},"variantsV2":{},"addons":[{"groupId":"115661823","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661822","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"79934970","name":"Peri-peri Veggie Maggie","category":"Maggi","imageId":"efa06ba2242a3551b4dc5079feeae2eb","inStock":1,"isVeg":1,"price":12500,"variants":{},"variantsV2":{},"addons":[{"groupId":"115661829","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661828","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"79935040","name":"Tandoori Veggie Maggie","category":"Maggi","imageId":"6c84ff635fb67c2e54c7d4e6097db3af","inStock":1,"isVeg":1,"price":13000,"variants":{},"variantsV2":{},"addons":[{"groupId":"115661831","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661830","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"125925046","name":"Spicy Paneer Maggie","category":"Maggi","imageId":"9e8c64db59aaae4202ea399d7be899b3","inStock":1,"isVeg":1,"price":13000,"variants":{},"variantsV2":{},"addons":[{"groupId":"115668583","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115668584","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}}]}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"Salads","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"57814543","name":"Farm Fresh Salad","category":"Salads","description":"Iceberg, Tamato, Cucumber, Onion, Black Olives, Pineapple, Jelapino 7 Sweet Corn","imageId":"1acddae5d1f37b507e15e61dfc9a4cdd","inStock":1,"isVeg":1,"price":18000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76094998","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76094997","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"1.9","ratingCount":"4 ratings","ratingCountV2":"4"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"57815003","name":"English Salad","category":"Salads","description":"Ice Berg, Tamato, Cucumber, Onion, Bellpepper, Olives, Pineapple, Jelaphino & Sweet Corn With Paneer","imageId":"85064ddb8fec533b5c0a381fb699abf0","inStock":1,"isVeg":1,"price":19000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76094995","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76094994","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"1.1","ratingCount":"3 ratings","ratingCountV2":"3"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"75106362","name":"Mexican Salad","category":"Salads","description":"Ice Berg, Tamato, Cucumber, Onion, Mix Fruit Wit Bellpepper","imageId":"9df974723f35f20c4cfa2bcba133aef3","inStock":1,"isVeg":1,"price":18000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76095004","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095003","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"79934916","name":"Maxican Patty Salad","category":"Salads","description":"(ice burg, tomato, cucumber, onion, pineapple, jalapeno, sweet corn and serve with Fried patato patty )","imageId":"007bc34fbd44c9c19448dcfcfd8fd0f1","inStock":1,"isVeg":1,"price":21000,"variants":{},"variantsV2":{},"addons":[{"groupId":"115661833","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661832","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"79934917","name":"Paneer Diet Salad","category":"Salads","description":"(ice burg, tomato, cucumber, onion, mixed fruit, broccli, paneer with bell pepper and without sause)","imageId":"a994eda6526f32a16369a0279ce89cb1","inStock":1,"isVeg":1,"price":19000,"variants":{},"variantsV2":{},"addons":[{"groupId":"115661835","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661834","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.4","ratingCount":"4 ratings","ratingCountV2":"4"}}},"analytics":{},"hideRestaurantDetails":true}}]}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"Lava Burgers","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"100777487","name":"Cheese Corn Lava Burger.","category":"Lava Burgers","imageId":"0b8ec976e850f1127701303d2e0c7af0","inStock":1,"isVeg":1,"price":11000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76094923","groupName":"Make it a Meal","choices":[{"id":"60999854","name":"French Fries+pepsi [450 Ml]","price":10000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76094926","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76094925","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.5","ratingCount":"5 ratings","ratingCountV2":"5"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"100777488","name":"Peri- Peri Lava Burger.","category":"Lava Burgers","imageId":"1385462555ba23b7b3ec28811bdb7af7","inStock":1,"isVeg":1,"price":11000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76094927","groupName":"Make it a Meal","choices":[{"id":"60999854","name":"French Fries+pepsi [450 Ml]","price":10000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76094930","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76094929","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"100777490","name":"Veggie Makhni Lava Burger.","category":"Lava Burgers","imageId":"877e55d5159da7c5cb35de4403f52f71","inStock":1,"isVeg":1,"price":11000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76094935","groupName":"Make it a Meal","choices":[{"id":"60999854","name":"French Fries+pepsi [450 Ml]","price":10000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76094938","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76094937","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}}]}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"Pasta","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"57901444","name":"Cheesy Paneer Pasta","category":"Pasta","description":"Mushroom, Golden Corn, Broccoli, Mixed Capsicum With Cheesy Creamy Red Sauce.","imageId":"lwizmtizfrgz4nonjskf","inStock":1,"isVeg":1,"price":25000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76095043","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095041","groupName":"Extra Bread","choices":[{"id":"60999858","name":"Extra Bread","price":1500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095042","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"57901448","name":"Cheese Mushroom Pasta","category":"Pasta","description":"Broccoli, Black Olives, Mushrooms, Mozzarella Cheese With Cheesy Creamy White Sauce.","imageId":"8ccad97dec185982953fdfd53da55f06","inStock":1,"isVeg":1,"price":26000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76095039","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095036","groupName":"Extra Bread","choices":[{"id":"60999858","name":"Extra Bread","price":1500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095038","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"5.0","ratingCount":"5 ratings","ratingCountV2":"5"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"57901449","name":"Makhani Gravy Pasta","category":"Pasta","description":"Golden Corn, Green Zucchini, Mushroom, Mix Capsicum, Broccoli Red Sauce.","imageId":"hht1kgq5vjnwvrosmkcu","inStock":1,"isVeg":1,"price":25000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76095055","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095052","groupName":"Extra Bread","choices":[{"id":"60999858","name":"Extra Bread","price":1500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095054","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"57901452","name":"Red Sause Pasta","category":"Pasta","description":"Mushroom, Zucchini, Broccoli, Mixed Capsicum With Italian Napoli Red Sauce.","imageId":"6b4fd15230669d12ed5243bd695abf6e","inStock":1,"isVeg":1,"price":21000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76095063","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095060","groupName":"Extra Bread","choices":[{"id":"60999858","name":"Extra Bread","price":1500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095062","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"2.5","ratingCount":"14 ratings","ratingCountV2":"14"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"57901454","name":"Tandoori Pasta","category":"Pasta","description":"Mushroom, Mix Capsicum With Cheesy Blend And Tandoori Red Sauce.","imageId":"48ea2071b0026eef75cb253174870f23","inStock":1,"isVeg":1,"price":25000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76095067","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095064","groupName":"Extra Bread","choices":[{"id":"60999858","name":"Extra Bread","price":1500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095066","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"100777492","name":"Creamy Alferado Pasta","category":"Pasta","description":"Broccoli, Mushrooms, Capsicum, Golden Corns With Chef\'S Special White Sauce.","imageId":"bebhwh4vdput2n5xhhox","inStock":1,"isVeg":1,"price":26000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76095047","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095045","groupName":"Extra Bread","choices":[{"id":"60999858","name":"Extra Bread","price":1500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095046","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"1.5","ratingCount":"16 ratings","ratingCountV2":"16"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"100777493","name":"Mix N Match Pasta","category":"Pasta","description":"Mushrooms, Tomato, Golden Corn, Zucchini, Mixed Capsicums, Mozzarella Cheese With Cheesy Creamy Red Sauce.","imageId":"98865607107605e9bfba8e91c4b730be","inStock":1,"isVeg":1,"price":25000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76095059","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095056","groupName":"Extra Bread","choices":[{"id":"60999858","name":"Extra Bread","price":1500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095058","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"100777494","name":"White Pasta","category":"Pasta","description":"Mix Capsicum, Onion With Cheesy Creamy White Sauce.","imageId":"ddeaf0511029ccd50760be0a8be2af90","inStock":1,"isVeg":1,"price":24000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76095071","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095068","groupName":"Extra Bread","choices":[{"id":"60999858","name":"Extra Bread","price":1500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095070","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"5.0","ratingCount":"4 ratings","ratingCountV2":"4"}}},"analytics":{},"hideRestaurantDetails":true}}]}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"Pizza","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"57814293","name":"Tandoori Paneer Pizza","category":"Pizza","description":"Onion, Capcicum And Paneer In Tandoori Sauce.","imageId":"7573eec339d60fd4b215092d9a15dd3d","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"23987194","name":"Portion","variations":[{"name":"Regular [8 Inches]","price":280,"default":1,"id":"77571817","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Medium [10 Inches]","price":380,"id":"77571818","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Large [12 Inches]","price":480,"id":"77571819","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"23987194","variationId":"77571817"}],"price":28000,"addonCombinations":[{"groupId":"76095347","addonId":"60999865"},{"groupId":"76095347","addonId":"60999866"},{"groupId":"76095347","addonId":"60999867"},{"groupId":"76095347","addonId":"60999868"},{"groupId":"76095347","addonId":"60999869"},{"groupId":"76095347","addonId":"60999870"},{"groupId":"76095347","addonId":"60999871"},{"groupId":"76095347","addonId":"60999872"},{"groupId":"76095347","addonId":"60999873"},{"groupId":"76095351","addonId":"60998441"},{"groupId":"76095351","addonId":"60998442"},{"groupId":"76095351","addonId":"60998443"},{"groupId":"76095351","addonId":"60998432"},{"groupId":"76095351","addonId":"60998433"},{"groupId":"76095351","addonId":"60998434"},{"groupId":"76095351","addonId":"60998435"},{"groupId":"76095346","addonId":"60999864"},{"groupId":"76095349","addonId":"60999874"},{"groupId":"76095350","addonId":"60998438"},{"groupId":"76095350","addonId":"60998439"}]},{"variations":[{"groupId":"23987194","variationId":"77571818"}],"price":38000,"addonCombinations":[{"groupId":"76095353","addonId":"60999876"},{"groupId":"76095353","addonId":"60999877"},{"groupId":"76095353","addonId":"60999878"},{"groupId":"76095353","addonId":"60999879"},{"groupId":"76095353","addonId":"60999880"},{"groupId":"76095353","addonId":"60999881"},{"groupId":"76095353","addonId":"60999882"},{"groupId":"76095353","addonId":"60999883"},{"groupId":"76095353","addonId":"60999884"},{"groupId":"76095351","addonId":"60998441"},{"groupId":"76095351","addonId":"60998442"},{"groupId":"76095351","addonId":"60998443"},{"groupId":"76095351","addonId":"60998432"},{"groupId":"76095351","addonId":"60998433"},{"groupId":"76095351","addonId":"60998434"},{"groupId":"76095351","addonId":"60998435"},{"groupId":"76095354","addonId":"60999885"},{"groupId":"76095350","addonId":"60998438"},{"groupId":"76095350","addonId":"60998439"},{"groupId":"76095352","addonId":"60999875"}]},{"variations":[{"groupId":"23987194","variationId":"77571819"}],"price":48000,"addonCombinations":[{"groupId":"76095351","addonId":"60998441"},{"groupId":"76095351","addonId":"60998442"},{"groupId":"76095351","addonId":"60998443"},{"groupId":"76095351","addonId":"60998432"},{"groupId":"76095351","addonId":"60998433"},{"groupId":"76095351","addonId":"60998434"},{"groupId":"76095351","addonId":"60998435"},{"groupId":"76095355","addonId":"60999886"},{"groupId":"76095357","addonId":"60999896"},{"groupId":"76095350","addonId":"60998438"},{"groupId":"76095350","addonId":"60998439"},{"groupId":"76095356","addonId":"60999887"},{"groupId":"76095356","addonId":"60999888"},{"groupId":"76095356","addonId":"60999889"},{"groupId":"76095356","addonId":"60999890"},{"groupId":"76095356","addonId":"60999891"},{"groupId":"76095356","addonId":"60999892"},{"groupId":"76095356","addonId":"60999893"},{"groupId":"76095356","addonId":"60999894"},{"groupId":"76095356","addonId":"60999895"}]}]},"addons":[{"groupId":"76095347","groupName":"Extra Toppings [8 Inches]","choices":[{"id":"60999869","name":"Zucchini","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999865","name":"Paneer","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999866","name":"Broccoli","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999867","name":"Capsicum","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999868","name":"Red Paprika","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999872","name":"Olive","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999873","name":"Jalapeno","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999870","name":"Onion","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999871","name":"Corn","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095356","groupName":"Extra Toppings [12 Inches]","choices":[{"id":"60999887","name":"Paneer","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999888","name":"Broccoli","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999889","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999894","name":"Olive","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999895","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999890","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999891","name":"Zucchini","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999892","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999893","name":"Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095353","groupName":"Extra Toppings [10 Inches]","choices":[{"id":"60999876","name":"Paneer","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999877","name":"Broccoli","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999878","name":"Capsicum","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999879","name":"Red Paprika","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999883","name":"Olive","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999884","name":"Jalapeno","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999880","name":"Zucchini","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999881","name":"Onion","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999882","name":"Corn","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095351","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095346","groupName":"Extra Cheese brust [Reg]","choices":[{"id":"60999864","name":"Cheese Brust","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095352","groupName":"Extra Cheese brust [Med]","choices":[{"id":"60999875","name":"Cheese Brust","price":10000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095355","groupName":"Extra Cheese brust [Large]","choices":[{"id":"60999886","name":"Cheese Brust","price":13000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095349","groupName":"Extra Cheese [regular]","choices":[{"id":"60999874","name":"Extra Cheese","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095354","groupName":"Extra [medium]","choices":[{"id":"60999885","name":"Extra Cheese","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095357","groupName":"Extras [large]","choices":[{"id":"60999896","name":"Extra Cheese","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095350","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"defaultPrice":28000,"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"5.0","ratingCount":"17 ratings","ratingCountV2":"17"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"57814315","name":"Chilly Paneer Pizza","category":"Pizza","description":"Onions, Green Capsicum, Mushrooms Marinated Paneer And Sliced Black Olives.","imageId":"y4qvzirgfp5jr0dbs0eo","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"23987176","name":"Portion","variations":[{"name":"Regular [8 Inches]","price":280,"default":1,"id":"77571762","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Medium [10 Inches]","price":380,"id":"77571763","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Large [12 Inches]","price":480,"id":"77571764","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"23987176","variationId":"77571762"}],"price":28000,"addonCombinations":[{"groupId":"76095132","addonId":"60999864"},{"groupId":"76095133","addonId":"60999865"},{"groupId":"76095133","addonId":"60999866"},{"groupId":"76095133","addonId":"60999867"},{"groupId":"76095133","addonId":"60999868"},{"groupId":"76095133","addonId":"60999869"},{"groupId":"76095133","addonId":"60999870"},{"groupId":"76095133","addonId":"60999871"},{"groupId":"76095133","addonId":"60999872"},{"groupId":"76095133","addonId":"60999873"},{"groupId":"76095135","addonId":"60999874"},{"groupId":"76095136","addonId":"60998438"},{"groupId":"76095136","addonId":"60998439"},{"groupId":"76095137","addonId":"60998441"},{"groupId":"76095137","addonId":"60998442"},{"groupId":"76095137","addonId":"60998443"},{"groupId":"76095137","addonId":"60998432"},{"groupId":"76095137","addonId":"60998433"},{"groupId":"76095137","addonId":"60998434"},{"groupId":"76095137","addonId":"60998435"}]},{"variations":[{"groupId":"23987176","variationId":"77571763"}],"price":38000,"addonCombinations":[{"groupId":"76095139","addonId":"60999876"},{"groupId":"76095139","addonId":"60999877"},{"groupId":"76095139","addonId":"60999878"},{"groupId":"76095139","addonId":"60999879"},{"groupId":"76095139","addonId":"60999880"},{"groupId":"76095139","addonId":"60999881"},{"groupId":"76095139","addonId":"60999882"},{"groupId":"76095139","addonId":"60999883"},{"groupId":"76095139","addonId":"60999884"},{"groupId":"76095140","addonId":"60999885"},{"groupId":"76095136","addonId":"60998438"},{"groupId":"76095136","addonId":"60998439"},{"groupId":"76095137","addonId":"60998441"},{"groupId":"76095137","addonId":"60998442"},{"groupId":"76095137","addonId":"60998443"},{"groupId":"76095137","addonId":"60998432"},{"groupId":"76095137","addonId":"60998433"},{"groupId":"76095137","addonId":"60998434"},{"groupId":"76095137","addonId":"60998435"},{"groupId":"76095138","addonId":"60999875"}]},{"variations":[{"groupId":"23987176","variationId":"77571764"}],"price":48000,"addonCombinations":[{"groupId":"76095141","addonId":"60999886"},{"groupId":"76095143","addonId":"60999896"},{"groupId":"76095136","addonId":"60998438"},{"groupId":"76095136","addonId":"60998439"},{"groupId":"76095137","addonId":"60998441"},{"groupId":"76095137","addonId":"60998442"},{"groupId":"76095137","addonId":"60998443"},{"groupId":"76095137","addonId":"60998432"},{"groupId":"76095137","addonId":"60998433"},{"groupId":"76095137","addonId":"60998434"},{"groupId":"76095137","addonId":"60998435"},{"groupId":"76095142","addonId":"60999887"},{"groupId":"76095142","addonId":"60999888"},{"groupId":"76095142","addonId":"60999889"},{"groupId":"76095142","addonId":"60999890"},{"groupId":"76095142","addonId":"60999891"},{"groupId":"76095142","addonId":"60999892"},{"groupId":"76095142","addonId":"60999893"},{"groupId":"76095142","addonId":"60999894"},{"groupId":"76095142","addonId":"60999895"}]}]},"addons":[{"groupId":"76095133","groupName":"Extra Toppings [8 Inches]","choices":[{"id":"60999869","name":"Zucchini","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999865","name":"Paneer","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999866","name":"Broccoli","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999867","name":"Capsicum","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999868","name":"Red Paprika","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999872","name":"Olive","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999873","name":"Jalapeno","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999870","name":"Onion","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999871","name":"Corn","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095142","groupName":"Extra Toppings [12 Inches]","choices":[{"id":"60999887","name":"Paneer","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999888","name":"Broccoli","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999889","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999894","name":"Olive","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999895","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999890","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999891","name":"Zucchini","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999892","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999893","name":"Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095139","groupName":"Extra Toppings [10 Inches]","choices":[{"id":"60999876","name":"Paneer","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999877","name":"Broccoli","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999878","name":"Capsicum","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999879","name":"Red Paprika","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999883","name":"Olive","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999884","name":"Jalapeno","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999880","name":"Zucchini","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999881","name":"Onion","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999882","name":"Corn","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095137","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095132","groupName":"Extra Cheese brust [Reg]","choices":[{"id":"60999864","name":"Cheese Brust","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095138","groupName":"Extra Cheese brust [Med]","choices":[{"id":"60999875","name":"Cheese Brust","price":10000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095141","groupName":"Extra Cheese brust [Large]","choices":[{"id":"60999886","name":"Cheese Brust","price":13000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095135","groupName":"Extra Cheese [regular]","choices":[{"id":"60999874","name":"Extra Cheese","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095140","groupName":"Extra [medium]","choices":[{"id":"60999885","name":"Extra Cheese","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095143","groupName":"Extras [large]","choices":[{"id":"60999896","name":"Extra Cheese","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095136","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"defaultPrice":28000,"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"type":"ITEM","itemBadge":{},"badgesV2":{},"isBestseller":true,"ratings":{"aggregatedRating":{"rating":"3.8","ratingCount":"5 ratings","ratingCountV2":"5"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"57814419","name":"Veg Fiesta Pizza","category":"Pizza","description":"Sweet Corn, Onion, Capsicum And Broccoli.","imageId":"79ca19af04ebdeaa48f1a48715e21b37","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"23987197","name":"Portion","variations":[{"name":"Regular [8 Inches]","price":210,"default":1,"id":"77571826","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Medium [10 Inches]","price":310,"id":"77571827","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Large [12 Inches]","price":410,"id":"77571828","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"23987197","variationId":"77571826"}],"price":21000,"addonCombinations":[{"groupId":"76095381","addonId":"60999865"},{"groupId":"76095381","addonId":"60999866"},{"groupId":"76095381","addonId":"60999867"},{"groupId":"76095381","addonId":"60999868"},{"groupId":"76095381","addonId":"60999869"},{"groupId":"76095381","addonId":"60999870"},{"groupId":"76095381","addonId":"60999871"},{"groupId":"76095381","addonId":"60999872"},{"groupId":"76095381","addonId":"60999873"},{"groupId":"76095382","addonId":"60999864"},{"groupId":"76095384","addonId":"60999874"},{"groupId":"76095385","addonId":"60998438"},{"groupId":"76095385","addonId":"60998439"},{"groupId":"76095386","addonId":"60998441"},{"groupId":"76095386","addonId":"60998442"},{"groupId":"76095386","addonId":"60998443"},{"groupId":"76095386","addonId":"60998432"},{"groupId":"76095386","addonId":"60998433"},{"groupId":"76095386","addonId":"60998434"},{"groupId":"76095386","addonId":"60998435"}]},{"variations":[{"groupId":"23987197","variationId":"77571827"}],"price":31000,"addonCombinations":[{"groupId":"76095387","addonId":"60999876"},{"groupId":"76095387","addonId":"60999877"},{"groupId":"76095387","addonId":"60999878"},{"groupId":"76095387","addonId":"60999879"},{"groupId":"76095387","addonId":"60999880"},{"groupId":"76095387","addonId":"60999881"},{"groupId":"76095387","addonId":"60999882"},{"groupId":"76095387","addonId":"60999883"},{"groupId":"76095387","addonId":"60999884"},{"groupId":"76095389","addonId":"60999885"},{"groupId":"76095385","addonId":"60998438"},{"groupId":"76095385","addonId":"60998439"},{"groupId":"76095386","addonId":"60998441"},{"groupId":"76095386","addonId":"60998442"},{"groupId":"76095386","addonId":"60998443"},{"groupId":"76095386","addonId":"60998432"},{"groupId":"76095386","addonId":"60998433"},{"groupId":"76095386","addonId":"60998434"},{"groupId":"76095386","addonId":"60998435"},{"groupId":"76095388","addonId":"60999875"}]},{"variations":[{"groupId":"23987197","variationId":"77571828"}],"price":41000,"addonCombinations":[{"groupId":"76095391","addonId":"60999886"},{"groupId":"76095392","addonId":"60999896"},{"groupId":"76095385","addonId":"60998438"},{"groupId":"76095385","addonId":"60998439"},{"groupId":"76095386","addonId":"60998441"},{"groupId":"76095386","addonId":"60998442"},{"groupId":"76095386","addonId":"60998443"},{"groupId":"76095386","addonId":"60998432"},{"groupId":"76095386","addonId":"60998433"},{"groupId":"76095386","addonId":"60998434"},{"groupId":"76095386","addonId":"60998435"},{"groupId":"76095390","addonId":"60999887"},{"groupId":"76095390","addonId":"60999888"},{"groupId":"76095390","addonId":"60999889"},{"groupId":"76095390","addonId":"60999890"},{"groupId":"76095390","addonId":"60999891"},{"groupId":"76095390","addonId":"60999892"},{"groupId":"76095390","addonId":"60999893"},{"groupId":"76095390","addonId":"60999894"},{"groupId":"76095390","addonId":"60999895"}]}]},"addons":[{"groupId":"76095381","groupName":"Extra Toppings [8 Inches]","choices":[{"id":"60999869","name":"Zucchini","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999865","name":"Paneer","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999866","name":"Broccoli","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999867","name":"Capsicum","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999868","name":"Red Paprika","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999872","name":"Olive","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999873","name":"Jalapeno","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999870","name":"Onion","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999871","name":"Corn","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095390","groupName":"Extra Toppings [12 Inches]","choices":[{"id":"60999887","name":"Paneer","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999888","name":"Broccoli","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999889","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999894","name":"Olive","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999895","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999890","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999891","name":"Zucchini","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999892","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999893","name":"Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095387","groupName":"Extra Toppings [10 Inches]","choices":[{"id":"60999876","name":"Paneer","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999877","name":"Broccoli","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999878","name":"Capsicum","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999879","name":"Red Paprika","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999883","name":"Olive","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999884","name":"Jalapeno","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999880","name":"Zucchini","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999881","name":"Onion","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999882","name":"Corn","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095386","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095382","groupName":"Extra Cheese brust [Reg]","choices":[{"id":"60999864","name":"Cheese Brust","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095388","groupName":"Extra Cheese brust [Med]","choices":[{"id":"60999875","name":"Cheese Brust","price":10000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095391","groupName":"Extra Cheese brust [Large]","choices":[{"id":"60999886","name":"Cheese Brust","price":13000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095384","groupName":"Extra Cheese [regular]","choices":[{"id":"60999874","name":"Extra Cheese","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095389","groupName":"Extra [medium]","choices":[{"id":"60999885","name":"Extra Cheese","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095392","groupName":"Extras [large]","choices":[{"id":"60999896","name":"Extra Cheese","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095385","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"defaultPrice":21000,"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.2","ratingCount":"27 ratings","ratingCountV2":"27"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"57814429","name":"Spicy Veg Pizza","category":"Pizza","description":"Onion And Capsicum In Chilli Garlic Dip.","imageId":"65eb883aa100bbf62b9d3d1213735e32","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"23987192","name":"Portion","variations":[{"name":"Regular [8 Inches]","price":210,"default":1,"id":"77571811","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Medium [10 Inches]","price":310,"id":"77571812","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Large [12 Inches]","price":410,"id":"77571813","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"23987192","variationId":"77571811"}],"price":21000,"addonCombinations":[{"groupId":"76095322","addonId":"60999865"},{"groupId":"76095322","addonId":"60999866"},{"groupId":"76095322","addonId":"60999867"},{"groupId":"76095322","addonId":"60999868"},{"groupId":"76095322","addonId":"60999869"},{"groupId":"76095322","addonId":"60999870"},{"groupId":"76095322","addonId":"60999871"},{"groupId":"76095322","addonId":"60999872"},{"groupId":"76095322","addonId":"60999873"},{"groupId":"76095323","addonId":"60999864"},{"groupId":"76095325","addonId":"60999874"},{"groupId":"76095326","addonId":"60998438"},{"groupId":"76095326","addonId":"60998439"},{"groupId":"76095327","addonId":"60998441"},{"groupId":"76095327","addonId":"60998442"},{"groupId":"76095327","addonId":"60998443"},{"groupId":"76095327","addonId":"60998432"},{"groupId":"76095327","addonId":"60998433"},{"groupId":"76095327","addonId":"60998434"},{"groupId":"76095327","addonId":"60998435"}]},{"variations":[{"groupId":"23987192","variationId":"77571812"}],"price":31000,"addonCombinations":[{"groupId":"76095328","addonId":"60999876"},{"groupId":"76095328","addonId":"60999877"},{"groupId":"76095328","addonId":"60999878"},{"groupId":"76095328","addonId":"60999879"},{"groupId":"76095328","addonId":"60999880"},{"groupId":"76095328","addonId":"60999881"},{"groupId":"76095328","addonId":"60999882"},{"groupId":"76095328","addonId":"60999883"},{"groupId":"76095328","addonId":"60999884"},{"groupId":"76095330","addonId":"60999885"},{"groupId":"76095326","addonId":"60998438"},{"groupId":"76095326","addonId":"60998439"},{"groupId":"76095327","addonId":"60998441"},{"groupId":"76095327","addonId":"60998442"},{"groupId":"76095327","addonId":"60998443"},{"groupId":"76095327","addonId":"60998432"},{"groupId":"76095327","addonId":"60998433"},{"groupId":"76095327","addonId":"60998434"},{"groupId":"76095327","addonId":"60998435"},{"groupId":"76095329","addonId":"60999875"}]},{"variations":[{"groupId":"23987192","variationId":"77571813"}],"price":41000,"addonCombinations":[{"groupId":"76095332","addonId":"60999886"},{"groupId":"76095333","addonId":"60999896"},{"groupId":"76095326","addonId":"60998438"},{"groupId":"76095326","addonId":"60998439"},{"groupId":"76095327","addonId":"60998441"},{"groupId":"76095327","addonId":"60998442"},{"groupId":"76095327","addonId":"60998443"},{"groupId":"76095327","addonId":"60998432"},{"groupId":"76095327","addonId":"60998433"},{"groupId":"76095327","addonId":"60998434"},{"groupId":"76095327","addonId":"60998435"},{"groupId":"76095331","addonId":"60999887"},{"groupId":"76095331","addonId":"60999888"},{"groupId":"76095331","addonId":"60999889"},{"groupId":"76095331","addonId":"60999890"},{"groupId":"76095331","addonId":"60999891"},{"groupId":"76095331","addonId":"60999892"},{"groupId":"76095331","addonId":"60999893"},{"groupId":"76095331","addonId":"60999894"},{"groupId":"76095331","addonId":"60999895"}]}]},"addons":[{"groupId":"76095322","groupName":"Extra Toppings [8 Inches]","choices":[{"id":"60999869","name":"Zucchini","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999865","name":"Paneer","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999866","name":"Broccoli","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999867","name":"Capsicum","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999868","name":"Red Paprika","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999872","name":"Olive","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999873","name":"Jalapeno","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999870","name":"Onion","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999871","name":"Corn","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095331","groupName":"Extra Toppings [12 Inches]","choices":[{"id":"60999887","name":"Paneer","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999888","name":"Broccoli","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999889","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999894","name":"Olive","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999895","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999890","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999891","name":"Zucchini","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999892","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999893","name":"Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095328","groupName":"Extra Toppings [10 Inches]","choices":[{"id":"60999876","name":"Paneer","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999877","name":"Broccoli","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999878","name":"Capsicum","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999879","name":"Red Paprika","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999883","name":"Olive","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999884","name":"Jalapeno","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999880","name":"Zucchini","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999881","name":"Onion","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999882","name":"Corn","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095327","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095323","groupName":"Extra Cheese brust [Reg]","choices":[{"id":"60999864","name":"Cheese Brust","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095329","groupName":"Extra Cheese brust [Med]","choices":[{"id":"60999875","name":"Cheese Brust","price":10000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095332","groupName":"Extra Cheese brust [Large]","choices":[{"id":"60999886","name":"Cheese Brust","price":13000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095325","groupName":"Extra Cheese [regular]","choices":[{"id":"60999874","name":"Extra Cheese","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095330","groupName":"Extra [medium]","choices":[{"id":"60999885","name":"Extra Cheese","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095333","groupName":"Extras [large]","choices":[{"id":"60999896","name":"Extra Cheese","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095326","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"defaultPrice":21000,"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"type":"ITEM","itemBadge":{},"badgesV2":{},"isBestseller":true,"ratings":{"aggregatedRating":{"rating":"4.0","ratingCount":"23 ratings","ratingCountV2":"23"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"57814437","name":"Capsicum Pizza","category":"Pizza","description":"Hot Cheese, Capcicum And Basil With Spices.","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"23987171","name":"Portion","variations":[{"name":"Regular [8 Inches]","price":148,"default":1,"id":"77571747","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Medium [10 Inches]","price":248,"id":"77571748","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Large [12 Inches]","price":348,"id":"77571749","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"23987171","variationId":"77571747"}],"price":14800,"addonCombinations":[{"groupId":"76095072","addonId":"60999864"},{"groupId":"76095073","addonId":"60999865"},{"groupId":"76095073","addonId":"60999866"},{"groupId":"76095073","addonId":"60999867"},{"groupId":"76095073","addonId":"60999868"},{"groupId":"76095073","addonId":"60999869"},{"groupId":"76095073","addonId":"60999870"},{"groupId":"76095073","addonId":"60999871"},{"groupId":"76095073","addonId":"60999872"},{"groupId":"76095073","addonId":"60999873"},{"groupId":"76095075","addonId":"60999874"},{"groupId":"76095076","addonId":"60998438"},{"groupId":"76095076","addonId":"60998439"},{"groupId":"76095077","addonId":"60998441"},{"groupId":"76095077","addonId":"60998442"},{"groupId":"76095077","addonId":"60998443"},{"groupId":"76095077","addonId":"60998432"},{"groupId":"76095077","addonId":"60998433"},{"groupId":"76095077","addonId":"60998434"},{"groupId":"76095077","addonId":"60998435"}]},{"variations":[{"groupId":"23987171","variationId":"77571748"}],"price":24800,"addonCombinations":[{"groupId":"76095079","addonId":"60999876"},{"groupId":"76095079","addonId":"60999877"},{"groupId":"76095079","addonId":"60999878"},{"groupId":"76095079","addonId":"60999879"},{"groupId":"76095079","addonId":"60999880"},{"groupId":"76095079","addonId":"60999881"},{"groupId":"76095079","addonId":"60999882"},{"groupId":"76095079","addonId":"60999883"},{"groupId":"76095079","addonId":"60999884"},{"groupId":"76095080","addonId":"60999885"},{"groupId":"76095076","addonId":"60998438"},{"groupId":"76095076","addonId":"60998439"},{"groupId":"76095077","addonId":"60998441"},{"groupId":"76095077","addonId":"60998442"},{"groupId":"76095077","addonId":"60998443"},{"groupId":"76095077","addonId":"60998432"},{"groupId":"76095077","addonId":"60998433"},{"groupId":"76095077","addonId":"60998434"},{"groupId":"76095077","addonId":"60998435"},{"groupId":"76095078","addonId":"60999875"}]},{"variations":[{"groupId":"23987171","variationId":"77571749"}],"price":34800,"addonCombinations":[{"groupId":"76095081","addonId":"60999886"},{"groupId":"76095083","addonId":"60999896"},{"groupId":"76095076","addonId":"60998438"},{"groupId":"76095076","addonId":"60998439"},{"groupId":"76095077","addonId":"60998441"},{"groupId":"76095077","addonId":"60998442"},{"groupId":"76095077","addonId":"60998443"},{"groupId":"76095077","addonId":"60998432"},{"groupId":"76095077","addonId":"60998433"},{"groupId":"76095077","addonId":"60998434"},{"groupId":"76095077","addonId":"60998435"},{"groupId":"76095082","addonId":"60999887"},{"groupId":"76095082","addonId":"60999888"},{"groupId":"76095082","addonId":"60999889"},{"groupId":"76095082","addonId":"60999890"},{"groupId":"76095082","addonId":"60999891"},{"groupId":"76095082","addonId":"60999892"},{"groupId":"76095082","addonId":"60999893"},{"groupId":"76095082","addonId":"60999894"},{"groupId":"76095082","addonId":"60999895"}]}]},"addons":[{"groupId":"76095073","groupName":"Extra Toppings [8 Inches]","choices":[{"id":"60999869","name":"Zucchini","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999865","name":"Paneer","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999866","name":"Broccoli","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999867","name":"Capsicum","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999868","name":"Red Paprika","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999872","name":"Olive","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999873","name":"Jalapeno","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999870","name":"Onion","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999871","name":"Corn","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095082","groupName":"Extra Toppings [12 Inches]","choices":[{"id":"60999887","name":"Paneer","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999888","name":"Broccoli","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999889","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999894","name":"Olive","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999895","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999890","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999891","name":"Zucchini","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999892","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999893","name":"Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095079","groupName":"Extra Toppings [10 Inches]","choices":[{"id":"60999876","name":"Paneer","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999877","name":"Broccoli","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999878","name":"Capsicum","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999879","name":"Red Paprika","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999883","name":"Olive","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999884","name":"Jalapeno","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999880","name":"Zucchini","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999881","name":"Onion","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999882","name":"Corn","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095077","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095072","groupName":"Extra Cheese brust [Reg]","choices":[{"id":"60999864","name":"Cheese Brust","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095078","groupName":"Extra Cheese brust [Med]","choices":[{"id":"60999875","name":"Cheese Brust","price":10000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095081","groupName":"Extra Cheese brust [Large]","choices":[{"id":"60999886","name":"Cheese Brust","price":13000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095075","groupName":"Extra Cheese [regular]","choices":[{"id":"60999874","name":"Extra Cheese","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095080","groupName":"Extra [medium]","choices":[{"id":"60999885","name":"Extra Cheese","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095083","groupName":"Extras [large]","choices":[{"id":"60999896","name":"Extra Cheese","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095076","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"defaultPrice":14800,"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.1","ratingCount":"9 ratings","ratingCountV2":"9"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"57814444","name":"Onion Pizza","category":"Pizza","description":"Hot Cheese, Slice Onion And Basil With Spice.","imageId":"fa5b61e33859bf752976bb2fed8e3a82","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"23987186","name":"Portion","variations":[{"name":"Regular [8 Inches]","price":148,"default":1,"id":"77571793","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Medium [10 Inches]","price":248,"id":"77571794","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Large [12 Inches]","price":348,"id":"77571795","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"23987186","variationId":"77571793"}],"price":14800,"addonCombinations":[{"groupId":"76095252","addonId":"60999865"},{"groupId":"76095252","addonId":"60999866"},{"groupId":"76095252","addonId":"60999867"},{"groupId":"76095252","addonId":"60999868"},{"groupId":"76095252","addonId":"60999869"},{"groupId":"76095252","addonId":"60999870"},{"groupId":"76095252","addonId":"60999871"},{"groupId":"76095252","addonId":"60999872"},{"groupId":"76095252","addonId":"60999873"},{"groupId":"76095253","addonId":"60999864"},{"groupId":"76095255","addonId":"60999874"},{"groupId":"76095256","addonId":"60998438"},{"groupId":"76095256","addonId":"60998439"},{"groupId":"76095257","addonId":"60998441"},{"groupId":"76095257","addonId":"60998442"},{"groupId":"76095257","addonId":"60998443"},{"groupId":"76095257","addonId":"60998432"},{"groupId":"76095257","addonId":"60998433"},{"groupId":"76095257","addonId":"60998434"},{"groupId":"76095257","addonId":"60998435"}]},{"variations":[{"groupId":"23987186","variationId":"77571794"}],"price":24800,"addonCombinations":[{"groupId":"76095258","addonId":"60999876"},{"groupId":"76095258","addonId":"60999877"},{"groupId":"76095258","addonId":"60999878"},{"groupId":"76095258","addonId":"60999879"},{"groupId":"76095258","addonId":"60999880"},{"groupId":"76095258","addonId":"60999881"},{"groupId":"76095258","addonId":"60999882"},{"groupId":"76095258","addonId":"60999883"},{"groupId":"76095258","addonId":"60999884"},{"groupId":"76095260","addonId":"60999885"},{"groupId":"76095256","addonId":"60998438"},{"groupId":"76095256","addonId":"60998439"},{"groupId":"76095257","addonId":"60998441"},{"groupId":"76095257","addonId":"60998442"},{"groupId":"76095257","addonId":"60998443"},{"groupId":"76095257","addonId":"60998432"},{"groupId":"76095257","addonId":"60998433"},{"groupId":"76095257","addonId":"60998434"},{"groupId":"76095257","addonId":"60998435"},{"groupId":"76095259","addonId":"60999875"}]},{"variations":[{"groupId":"23987186","variationId":"77571795"}],"price":34800,"addonCombinations":[{"groupId":"76095262","addonId":"60999886"},{"groupId":"76095263","addonId":"60999896"},{"groupId":"76095256","addonId":"60998438"},{"groupId":"76095256","addonId":"60998439"},{"groupId":"76095257","addonId":"60998441"},{"groupId":"76095257","addonId":"60998442"},{"groupId":"76095257","addonId":"60998443"},{"groupId":"76095257","addonId":"60998432"},{"groupId":"76095257","addonId":"60998433"},{"groupId":"76095257","addonId":"60998434"},{"groupId":"76095257","addonId":"60998435"},{"groupId":"76095261","addonId":"60999887"},{"groupId":"76095261","addonId":"60999888"},{"groupId":"76095261","addonId":"60999889"},{"groupId":"76095261","addonId":"60999890"},{"groupId":"76095261","addonId":"60999891"},{"groupId":"76095261","addonId":"60999892"},{"groupId":"76095261","addonId":"60999893"},{"groupId":"76095261","addonId":"60999894"},{"groupId":"76095261","addonId":"60999895"}]}]},"addons":[{"groupId":"76095252","groupName":"Extra Toppings [8 Inches]","choices":[{"id":"60999869","name":"Zucchini","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999865","name":"Paneer","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999866","name":"Broccoli","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999867","name":"Capsicum","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999868","name":"Red Paprika","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999872","name":"Olive","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999873","name":"Jalapeno","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999870","name":"Onion","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999871","name":"Corn","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095261","groupName":"Extra Toppings [12 Inches]","choices":[{"id":"60999887","name":"Paneer","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999888","name":"Broccoli","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999889","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999894","name":"Olive","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999895","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999890","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999891","name":"Zucchini","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999892","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999893","name":"Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095258","groupName":"Extra Toppings [10 Inches]","choices":[{"id":"60999876","name":"Paneer","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999877","name":"Broccoli","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999878","name":"Capsicum","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999879","name":"Red Paprika","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999883","name":"Olive","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999884","name":"Jalapeno","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999880","name":"Zucchini","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999881","name":"Onion","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999882","name":"Corn","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095257","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095253","groupName":"Extra Cheese brust [Reg]","choices":[{"id":"60999864","name":"Cheese Brust","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095259","groupName":"Extra Cheese brust [Med]","choices":[{"id":"60999875","name":"Cheese Brust","price":10000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095262","groupName":"Extra Cheese brust [Large]","choices":[{"id":"60999886","name":"Cheese Brust","price":13000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095255","groupName":"Extra Cheese [regular]","choices":[{"id":"60999874","name":"Extra Cheese","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095260","groupName":"Extra [medium]","choices":[{"id":"60999885","name":"Extra Cheese","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095263","groupName":"Extras [large]","choices":[{"id":"60999896","name":"Extra Cheese","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095256","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"defaultPrice":14800,"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.7","ratingCount":"23 ratings","ratingCountV2":"23"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"57814460","name":"Cheese Corn Pizza","category":"Pizza","description":"Hot Cheese, Corn And Basil With Spices.","imageId":"627d39f2d09159ecd8a6c660207032bf","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"23987172","name":"Portion","variations":[{"name":"Regular [8 Inches]","price":148,"default":1,"id":"77571750","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Medium [10 Inches]","price":248,"id":"77571751","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Large [12 Inches]","price":348,"id":"77571752","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"23987172","variationId":"77571750"}],"price":14800,"addonCombinations":[{"groupId":"76095084","addonId":"60999865"},{"groupId":"76095084","addonId":"60999866"},{"groupId":"76095084","addonId":"60999867"},{"groupId":"76095084","addonId":"60999868"},{"groupId":"76095084","addonId":"60999869"},{"groupId":"76095084","addonId":"60999870"},{"groupId":"76095084","addonId":"60999871"},{"groupId":"76095084","addonId":"60999872"},{"groupId":"76095084","addonId":"60999873"},{"groupId":"76095089","addonId":"60998441"},{"groupId":"76095089","addonId":"60998442"},{"groupId":"76095089","addonId":"60998443"},{"groupId":"76095089","addonId":"60998432"},{"groupId":"76095089","addonId":"60998433"},{"groupId":"76095089","addonId":"60998434"},{"groupId":"76095089","addonId":"60998435"},{"groupId":"76095085","addonId":"60999864"},{"groupId":"76095087","addonId":"60999874"},{"groupId":"76095088","addonId":"60998438"},{"groupId":"76095088","addonId":"60998439"}]},{"variations":[{"groupId":"23987172","variationId":"77571751"}],"price":24800,"addonCombinations":[{"groupId":"76095090","addonId":"60999876"},{"groupId":"76095090","addonId":"60999877"},{"groupId":"76095090","addonId":"60999878"},{"groupId":"76095090","addonId":"60999879"},{"groupId":"76095090","addonId":"60999880"},{"groupId":"76095090","addonId":"60999881"},{"groupId":"76095090","addonId":"60999882"},{"groupId":"76095090","addonId":"60999883"},{"groupId":"76095090","addonId":"60999884"},{"groupId":"76095089","addonId":"60998441"},{"groupId":"76095089","addonId":"60998442"},{"groupId":"76095089","addonId":"60998443"},{"groupId":"76095089","addonId":"60998432"},{"groupId":"76095089","addonId":"60998433"},{"groupId":"76095089","addonId":"60998434"},{"groupId":"76095089","addonId":"60998435"},{"groupId":"76095092","addonId":"60999885"},{"groupId":"76095088","addonId":"60998438"},{"groupId":"76095088","addonId":"60998439"},{"groupId":"76095091","addonId":"60999875"}]},{"variations":[{"groupId":"23987172","variationId":"77571752"}],"price":34800,"addonCombinations":[{"groupId":"76095089","addonId":"60998441"},{"groupId":"76095089","addonId":"60998442"},{"groupId":"76095089","addonId":"60998443"},{"groupId":"76095089","addonId":"60998432"},{"groupId":"76095089","addonId":"60998433"},{"groupId":"76095089","addonId":"60998434"},{"groupId":"76095089","addonId":"60998435"},{"groupId":"76095094","addonId":"60999886"},{"groupId":"76095095","addonId":"60999896"},{"groupId":"76095088","addonId":"60998438"},{"groupId":"76095088","addonId":"60998439"},{"groupId":"76095093","addonId":"60999887"},{"groupId":"76095093","addonId":"60999888"},{"groupId":"76095093","addonId":"60999889"},{"groupId":"76095093","addonId":"60999890"},{"groupId":"76095093","addonId":"60999891"},{"groupId":"76095093","addonId":"60999892"},{"groupId":"76095093","addonId":"60999893"},{"groupId":"76095093","addonId":"60999894"},{"groupId":"76095093","addonId":"60999895"}]}]},"addons":[{"groupId":"76095084","groupName":"Extra Toppings [8 Inches]","choices":[{"id":"60999869","name":"Zucchini","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999865","name":"Paneer","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999866","name":"Broccoli","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999867","name":"Capsicum","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999868","name":"Red Paprika","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999872","name":"Olive","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999873","name":"Jalapeno","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999870","name":"Onion","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999871","name":"Corn","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095093","groupName":"Extra Toppings [12 Inches]","choices":[{"id":"60999887","name":"Paneer","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999888","name":"Broccoli","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999889","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999894","name":"Olive","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999895","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999890","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999891","name":"Zucchini","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999892","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999893","name":"Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095090","groupName":"Extra Toppings [10 Inches]","choices":[{"id":"60999876","name":"Paneer","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999877","name":"Broccoli","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999878","name":"Capsicum","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999879","name":"Red Paprika","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999883","name":"Olive","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999884","name":"Jalapeno","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999880","name":"Zucchini","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999881","name":"Onion","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999882","name":"Corn","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095089","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095085","groupName":"Extra Cheese brust [Reg]","choices":[{"id":"60999864","name":"Cheese Brust","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095091","groupName":"Extra Cheese brust [Med]","choices":[{"id":"60999875","name":"Cheese Brust","price":10000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095094","groupName":"Extra Cheese brust [Large]","choices":[{"id":"60999886","name":"Cheese Brust","price":13000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095087","groupName":"Extra Cheese [regular]","choices":[{"id":"60999874","name":"Extra Cheese","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095092","groupName":"Extra [medium]","choices":[{"id":"60999885","name":"Extra Cheese","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095095","groupName":"Extras [large]","choices":[{"id":"60999896","name":"Extra Cheese","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095088","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"defaultPrice":14800,"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"type":"ITEM","itemBadge":{},"badgesV2":{},"isBestseller":true,"ratings":{"aggregatedRating":{"rating":"4.2","ratingCount":"134 ratings","ratingCountV2":"134"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"75106389","name":"Cheese Margherita Pizza","category":"Pizza","description":"Classic Italian Pizza With Hot Cheese Toppings.","imageId":"0491c52474ff2f1ffbbc799c652f05b1","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"23987173","name":"Portion","variations":[{"name":"Regular [8 Inches]","price":178,"default":1,"id":"77571753","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Medium [10 Inches]","price":278,"id":"77571754","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Large [12 Inches]","price":378,"id":"77571755","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"23987173","variationId":"77571753"}],"price":17800,"addonCombinations":[{"groupId":"76095096","addonId":"60999865"},{"groupId":"76095096","addonId":"60999866"},{"groupId":"76095096","addonId":"60999867"},{"groupId":"76095096","addonId":"60999868"},{"groupId":"76095096","addonId":"60999869"},{"groupId":"76095096","addonId":"60999870"},{"groupId":"76095096","addonId":"60999871"},{"groupId":"76095096","addonId":"60999872"},{"groupId":"76095096","addonId":"60999873"},{"groupId":"76095101","addonId":"60998441"},{"groupId":"76095101","addonId":"60998442"},{"groupId":"76095101","addonId":"60998443"},{"groupId":"76095101","addonId":"60998432"},{"groupId":"76095101","addonId":"60998433"},{"groupId":"76095101","addonId":"60998434"},{"groupId":"76095101","addonId":"60998435"},{"groupId":"76095097","addonId":"60999864"},{"groupId":"76095099","addonId":"60999874"},{"groupId":"76095100","addonId":"60998438"},{"groupId":"76095100","addonId":"60998439"}]},{"variations":[{"groupId":"23987173","variationId":"77571754"}],"price":27800,"addonCombinations":[{"groupId":"76095102","addonId":"60999876"},{"groupId":"76095102","addonId":"60999877"},{"groupId":"76095102","addonId":"60999878"},{"groupId":"76095102","addonId":"60999879"},{"groupId":"76095102","addonId":"60999880"},{"groupId":"76095102","addonId":"60999881"},{"groupId":"76095102","addonId":"60999882"},{"groupId":"76095102","addonId":"60999883"},{"groupId":"76095102","addonId":"60999884"},{"groupId":"76095101","addonId":"60998441"},{"groupId":"76095101","addonId":"60998442"},{"groupId":"76095101","addonId":"60998443"},{"groupId":"76095101","addonId":"60998432"},{"groupId":"76095101","addonId":"60998433"},{"groupId":"76095101","addonId":"60998434"},{"groupId":"76095101","addonId":"60998435"},{"groupId":"76095104","addonId":"60999885"},{"groupId":"76095100","addonId":"60998438"},{"groupId":"76095100","addonId":"60998439"},{"groupId":"76095103","addonId":"60999875"}]},{"variations":[{"groupId":"23987173","variationId":"77571755"}],"price":37800,"addonCombinations":[{"groupId":"76095101","addonId":"60998441"},{"groupId":"76095101","addonId":"60998442"},{"groupId":"76095101","addonId":"60998443"},{"groupId":"76095101","addonId":"60998432"},{"groupId":"76095101","addonId":"60998433"},{"groupId":"76095101","addonId":"60998434"},{"groupId":"76095101","addonId":"60998435"},{"groupId":"76095106","addonId":"60999886"},{"groupId":"76095107","addonId":"60999896"},{"groupId":"76095100","addonId":"60998438"},{"groupId":"76095100","addonId":"60998439"},{"groupId":"76095105","addonId":"60999887"},{"groupId":"76095105","addonId":"60999888"},{"groupId":"76095105","addonId":"60999889"},{"groupId":"76095105","addonId":"60999890"},{"groupId":"76095105","addonId":"60999891"},{"groupId":"76095105","addonId":"60999892"},{"groupId":"76095105","addonId":"60999893"},{"groupId":"76095105","addonId":"60999894"},{"groupId":"76095105","addonId":"60999895"}]}]},"addons":[{"groupId":"76095096","groupName":"Extra Toppings [8 Inches]","choices":[{"id":"60999869","name":"Zucchini","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999865","name":"Paneer","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999866","name":"Broccoli","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999867","name":"Capsicum","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999868","name":"Red Paprika","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999872","name":"Olive","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999873","name":"Jalapeno","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999870","name":"Onion","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999871","name":"Corn","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095105","groupName":"Extra Toppings [12 Inches]","choices":[{"id":"60999887","name":"Paneer","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999888","name":"Broccoli","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999889","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999894","name":"Olive","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999895","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999890","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999891","name":"Zucchini","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999892","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999893","name":"Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095102","groupName":"Extra Toppings [10 Inches]","choices":[{"id":"60999876","name":"Paneer","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999877","name":"Broccoli","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999878","name":"Capsicum","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999879","name":"Red Paprika","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999883","name":"Olive","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999884","name":"Jalapeno","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999880","name":"Zucchini","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999881","name":"Onion","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999882","name":"Corn","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095101","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095097","groupName":"Extra Cheese brust [Reg]","choices":[{"id":"60999864","name":"Cheese Brust","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095103","groupName":"Extra Cheese brust [Med]","choices":[{"id":"60999875","name":"Cheese Brust","price":10000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095106","groupName":"Extra Cheese brust [Large]","choices":[{"id":"60999886","name":"Cheese Brust","price":13000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095099","groupName":"Extra Cheese [regular]","choices":[{"id":"60999874","name":"Extra Cheese","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095104","groupName":"Extra [medium]","choices":[{"id":"60999885","name":"Extra Cheese","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095107","groupName":"Extras [large]","choices":[{"id":"60999896","name":"Extra Cheese","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095100","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"defaultPrice":17800,"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.3","ratingCount":"25 ratings","ratingCountV2":"25"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"75106390","name":"Cheese Mushroom Pizza","category":"Pizza","description":"Hot Cheese, Slice Mushroom And Basil With Spices.","imageId":"40a78c473a49e9c5303383da368eae9a","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"23987174","name":"Portion","variations":[{"name":"Regular [8 Inches]","price":180,"default":1,"id":"77571756","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Medium [10 Inches]","price":280,"id":"77571757","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Large [12 Inches]","price":380,"id":"77571758","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"23987174","variationId":"77571756"}],"price":18000,"addonCombinations":[{"groupId":"76095109","addonId":"60999865"},{"groupId":"76095109","addonId":"60999866"},{"groupId":"76095109","addonId":"60999867"},{"groupId":"76095109","addonId":"60999868"},{"groupId":"76095109","addonId":"60999869"},{"groupId":"76095109","addonId":"60999870"},{"groupId":"76095109","addonId":"60999871"},{"groupId":"76095109","addonId":"60999872"},{"groupId":"76095109","addonId":"60999873"},{"groupId":"76095113","addonId":"60998441"},{"groupId":"76095113","addonId":"60998442"},{"groupId":"76095113","addonId":"60998443"},{"groupId":"76095113","addonId":"60998432"},{"groupId":"76095113","addonId":"60998433"},{"groupId":"76095113","addonId":"60998434"},{"groupId":"76095113","addonId":"60998435"},{"groupId":"76095108","addonId":"60999864"},{"groupId":"76095111","addonId":"60999874"},{"groupId":"76095112","addonId":"60998438"},{"groupId":"76095112","addonId":"60998439"}]},{"variations":[{"groupId":"23987174","variationId":"77571757"}],"price":28000,"addonCombinations":[{"groupId":"76095115","addonId":"60999876"},{"groupId":"76095115","addonId":"60999877"},{"groupId":"76095115","addonId":"60999878"},{"groupId":"76095115","addonId":"60999879"},{"groupId":"76095115","addonId":"60999880"},{"groupId":"76095115","addonId":"60999881"},{"groupId":"76095115","addonId":"60999882"},{"groupId":"76095115","addonId":"60999883"},{"groupId":"76095115","addonId":"60999884"},{"groupId":"76095113","addonId":"60998441"},{"groupId":"76095113","addonId":"60998442"},{"groupId":"76095113","addonId":"60998443"},{"groupId":"76095113","addonId":"60998432"},{"groupId":"76095113","addonId":"60998433"},{"groupId":"76095113","addonId":"60998434"},{"groupId":"76095113","addonId":"60998435"},{"groupId":"76095116","addonId":"60999885"},{"groupId":"76095112","addonId":"60998438"},{"groupId":"76095112","addonId":"60998439"},{"groupId":"76095114","addonId":"60999875"}]},{"variations":[{"groupId":"23987174","variationId":"77571758"}],"price":38000,"addonCombinations":[{"groupId":"76095113","addonId":"60998441"},{"groupId":"76095113","addonId":"60998442"},{"groupId":"76095113","addonId":"60998443"},{"groupId":"76095113","addonId":"60998432"},{"groupId":"76095113","addonId":"60998433"},{"groupId":"76095113","addonId":"60998434"},{"groupId":"76095113","addonId":"60998435"},{"groupId":"76095117","addonId":"60999886"},{"groupId":"76095119","addonId":"60999896"},{"groupId":"76095112","addonId":"60998438"},{"groupId":"76095112","addonId":"60998439"},{"groupId":"76095118","addonId":"60999887"},{"groupId":"76095118","addonId":"60999888"},{"groupId":"76095118","addonId":"60999889"},{"groupId":"76095118","addonId":"60999890"},{"groupId":"76095118","addonId":"60999891"},{"groupId":"76095118","addonId":"60999892"},{"groupId":"76095118","addonId":"60999893"},{"groupId":"76095118","addonId":"60999894"},{"groupId":"76095118","addonId":"60999895"}]}]},"addons":[{"groupId":"76095109","groupName":"Extra Toppings [8 Inches]","choices":[{"id":"60999869","name":"Zucchini","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999865","name":"Paneer","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999866","name":"Broccoli","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999867","name":"Capsicum","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999868","name":"Red Paprika","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999872","name":"Olive","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999873","name":"Jalapeno","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999870","name":"Onion","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999871","name":"Corn","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095118","groupName":"Extra Toppings [12 Inches]","choices":[{"id":"60999887","name":"Paneer","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999888","name":"Broccoli","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999889","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999894","name":"Olive","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999895","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999890","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999891","name":"Zucchini","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999892","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999893","name":"Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095115","groupName":"Extra Toppings [10 Inches]","choices":[{"id":"60999876","name":"Paneer","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999877","name":"Broccoli","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999878","name":"Capsicum","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999879","name":"Red Paprika","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999883","name":"Olive","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999884","name":"Jalapeno","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999880","name":"Zucchini","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999881","name":"Onion","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999882","name":"Corn","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095113","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095108","groupName":"Extra Cheese brust [Reg]","choices":[{"id":"60999864","name":"Cheese Brust","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095114","groupName":"Extra Cheese brust [Med]","choices":[{"id":"60999875","name":"Cheese Brust","price":10000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095117","groupName":"Extra Cheese brust [Large]","choices":[{"id":"60999886","name":"Cheese Brust","price":13000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095111","groupName":"Extra Cheese [regular]","choices":[{"id":"60999874","name":"Extra Cheese","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095116","groupName":"Extra [medium]","choices":[{"id":"60999885","name":"Extra Cheese","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095119","groupName":"Extras [large]","choices":[{"id":"60999896","name":"Extra Cheese","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095112","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"defaultPrice":18000,"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"75106392","name":"Cheese Tomato Pizza","category":"Pizza","description":"Hot Cheese, Tomato Slices And Basil With Spices.","imageId":"e6399f9f9c4bc0f53f0616e54fc796cc","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"23987175","name":"Portion","variations":[{"name":"Regular [8 Inches]","price":148,"default":1,"id":"77571759","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Medium [10 Inches]","price":248,"id":"77571760","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Large [12 Inches]","price":348,"id":"77571761","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"23987175","variationId":"77571759"}],"price":14800,"addonCombinations":[{"groupId":"76095120","addonId":"60999865"},{"groupId":"76095120","addonId":"60999866"},{"groupId":"76095120","addonId":"60999867"},{"groupId":"76095120","addonId":"60999868"},{"groupId":"76095120","addonId":"60999869"},{"groupId":"76095120","addonId":"60999870"},{"groupId":"76095120","addonId":"60999871"},{"groupId":"76095120","addonId":"60999872"},{"groupId":"76095120","addonId":"60999873"},{"groupId":"76095121","addonId":"60999864"},{"groupId":"76095123","addonId":"60999874"},{"groupId":"76095124","addonId":"60998438"},{"groupId":"76095124","addonId":"60998439"},{"groupId":"76095125","addonId":"60998441"},{"groupId":"76095125","addonId":"60998442"},{"groupId":"76095125","addonId":"60998443"},{"groupId":"76095125","addonId":"60998432"},{"groupId":"76095125","addonId":"60998433"},{"groupId":"76095125","addonId":"60998434"},{"groupId":"76095125","addonId":"60998435"}]},{"variations":[{"groupId":"23987175","variationId":"77571760"}],"price":24800,"addonCombinations":[{"groupId":"76095126","addonId":"60999876"},{"groupId":"76095126","addonId":"60999877"},{"groupId":"76095126","addonId":"60999878"},{"groupId":"76095126","addonId":"60999879"},{"groupId":"76095126","addonId":"60999880"},{"groupId":"76095126","addonId":"60999881"},{"groupId":"76095126","addonId":"60999882"},{"groupId":"76095126","addonId":"60999883"},{"groupId":"76095126","addonId":"60999884"},{"groupId":"76095128","addonId":"60999885"},{"groupId":"76095124","addonId":"60998438"},{"groupId":"76095124","addonId":"60998439"},{"groupId":"76095125","addonId":"60998441"},{"groupId":"76095125","addonId":"60998442"},{"groupId":"76095125","addonId":"60998443"},{"groupId":"76095125","addonId":"60998432"},{"groupId":"76095125","addonId":"60998433"},{"groupId":"76095125","addonId":"60998434"},{"groupId":"76095125","addonId":"60998435"},{"groupId":"76095127","addonId":"60999875"}]},{"variations":[{"groupId":"23987175","variationId":"77571761"}],"price":34800,"addonCombinations":[{"groupId":"76095130","addonId":"60999886"},{"groupId":"76095131","addonId":"60999896"},{"groupId":"76095124","addonId":"60998438"},{"groupId":"76095124","addonId":"60998439"},{"groupId":"76095125","addonId":"60998441"},{"groupId":"76095125","addonId":"60998442"},{"groupId":"76095125","addonId":"60998443"},{"groupId":"76095125","addonId":"60998432"},{"groupId":"76095125","addonId":"60998433"},{"groupId":"76095125","addonId":"60998434"},{"groupId":"76095125","addonId":"60998435"},{"groupId":"76095129","addonId":"60999887"},{"groupId":"76095129","addonId":"60999888"},{"groupId":"76095129","addonId":"60999889"},{"groupId":"76095129","addonId":"60999890"},{"groupId":"76095129","addonId":"60999891"},{"groupId":"76095129","addonId":"60999892"},{"groupId":"76095129","addonId":"60999893"},{"groupId":"76095129","addonId":"60999894"},{"groupId":"76095129","addonId":"60999895"}]}]},"addons":[{"groupId":"76095120","groupName":"Extra Toppings [8 Inches]","choices":[{"id":"60999869","name":"Zucchini","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999865","name":"Paneer","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999866","name":"Broccoli","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999867","name":"Capsicum","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999868","name":"Red Paprika","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999872","name":"Olive","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999873","name":"Jalapeno","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999870","name":"Onion","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999871","name":"Corn","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095129","groupName":"Extra Toppings [12 Inches]","choices":[{"id":"60999887","name":"Paneer","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999888","name":"Broccoli","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999889","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999894","name":"Olive","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999895","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999890","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999891","name":"Zucchini","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999892","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999893","name":"Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095126","groupName":"Extra Toppings [10 Inches]","choices":[{"id":"60999876","name":"Paneer","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999877","name":"Broccoli","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999878","name":"Capsicum","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999879","name":"Red Paprika","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999883","name":"Olive","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999884","name":"Jalapeno","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999880","name":"Zucchini","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999881","name":"Onion","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999882","name":"Corn","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095125","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095121","groupName":"Extra Cheese brust [Reg]","choices":[{"id":"60999864","name":"Cheese Brust","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095127","groupName":"Extra Cheese brust [Med]","choices":[{"id":"60999875","name":"Cheese Brust","price":10000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095130","groupName":"Extra Cheese brust [Large]","choices":[{"id":"60999886","name":"Cheese Brust","price":13000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095123","groupName":"Extra Cheese [regular]","choices":[{"id":"60999874","name":"Extra Cheese","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095128","groupName":"Extra [medium]","choices":[{"id":"60999885","name":"Extra Cheese","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095131","groupName":"Extras [large]","choices":[{"id":"60999896","name":"Extra Cheese","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095124","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"defaultPrice":14800,"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"75106399","name":"Masala Paneer Makhani Pizza","category":"Pizza","description":"Marinated Paneer, Onion, Capsicum Red Paprika,Tomatoes, Coriander Cheese With Hot Cheese Topping.","imageId":"1f9dd9907f24daf44583e7b34673bef1","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"23987183","name":"Portion","variations":[{"name":"Regular [8 Inches]","price":280,"default":1,"id":"77571784","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Medium [10 Inches]","price":380,"id":"77571785","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Large [12 Inches]","price":480,"id":"77571786","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"23987183","variationId":"77571784"}],"price":28000,"addonCombinations":[{"groupId":"76095216","addonId":"60999865"},{"groupId":"76095216","addonId":"60999866"},{"groupId":"76095216","addonId":"60999867"},{"groupId":"76095216","addonId":"60999868"},{"groupId":"76095216","addonId":"60999869"},{"groupId":"76095216","addonId":"60999870"},{"groupId":"76095216","addonId":"60999871"},{"groupId":"76095216","addonId":"60999872"},{"groupId":"76095216","addonId":"60999873"},{"groupId":"76095217","addonId":"60999864"},{"groupId":"76095219","addonId":"60999874"},{"groupId":"76095220","addonId":"60998438"},{"groupId":"76095220","addonId":"60998439"},{"groupId":"76095221","addonId":"60998441"},{"groupId":"76095221","addonId":"60998442"},{"groupId":"76095221","addonId":"60998443"},{"groupId":"76095221","addonId":"60998432"},{"groupId":"76095221","addonId":"60998433"},{"groupId":"76095221","addonId":"60998434"},{"groupId":"76095221","addonId":"60998435"}]},{"variations":[{"groupId":"23987183","variationId":"77571785"}],"price":38000,"addonCombinations":[{"groupId":"76095222","addonId":"60999876"},{"groupId":"76095222","addonId":"60999877"},{"groupId":"76095222","addonId":"60999878"},{"groupId":"76095222","addonId":"60999879"},{"groupId":"76095222","addonId":"60999880"},{"groupId":"76095222","addonId":"60999881"},{"groupId":"76095222","addonId":"60999882"},{"groupId":"76095222","addonId":"60999883"},{"groupId":"76095222","addonId":"60999884"},{"groupId":"76095224","addonId":"60999885"},{"groupId":"76095220","addonId":"60998438"},{"groupId":"76095220","addonId":"60998439"},{"groupId":"76095221","addonId":"60998441"},{"groupId":"76095221","addonId":"60998442"},{"groupId":"76095221","addonId":"60998443"},{"groupId":"76095221","addonId":"60998432"},{"groupId":"76095221","addonId":"60998433"},{"groupId":"76095221","addonId":"60998434"},{"groupId":"76095221","addonId":"60998435"},{"groupId":"76095223","addonId":"60999875"}]},{"variations":[{"groupId":"23987183","variationId":"77571786"}],"price":48000,"addonCombinations":[{"groupId":"76095226","addonId":"60999886"},{"groupId":"76095227","addonId":"60999896"},{"groupId":"76095220","addonId":"60998438"},{"groupId":"76095220","addonId":"60998439"},{"groupId":"76095221","addonId":"60998441"},{"groupId":"76095221","addonId":"60998442"},{"groupId":"76095221","addonId":"60998443"},{"groupId":"76095221","addonId":"60998432"},{"groupId":"76095221","addonId":"60998433"},{"groupId":"76095221","addonId":"60998434"},{"groupId":"76095221","addonId":"60998435"},{"groupId":"76095225","addonId":"60999887"},{"groupId":"76095225","addonId":"60999888"},{"groupId":"76095225","addonId":"60999889"},{"groupId":"76095225","addonId":"60999890"},{"groupId":"76095225","addonId":"60999891"},{"groupId":"76095225","addonId":"60999892"},{"groupId":"76095225","addonId":"60999893"},{"groupId":"76095225","addonId":"60999894"},{"groupId":"76095225","addonId":"60999895"}]}]},"addons":[{"groupId":"76095216","groupName":"Extra Toppings [8 Inches]","choices":[{"id":"60999869","name":"Zucchini","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999865","name":"Paneer","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999866","name":"Broccoli","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999867","name":"Capsicum","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999868","name":"Red Paprika","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999872","name":"Olive","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999873","name":"Jalapeno","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999870","name":"Onion","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999871","name":"Corn","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095225","groupName":"Extra Toppings [12 Inches]","choices":[{"id":"60999887","name":"Paneer","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999888","name":"Broccoli","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999889","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999894","name":"Olive","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999895","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999890","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999891","name":"Zucchini","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999892","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999893","name":"Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095222","groupName":"Extra Toppings [10 Inches]","choices":[{"id":"60999876","name":"Paneer","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999877","name":"Broccoli","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999878","name":"Capsicum","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999879","name":"Red Paprika","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999883","name":"Olive","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999884","name":"Jalapeno","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999880","name":"Zucchini","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999881","name":"Onion","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999882","name":"Corn","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095221","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095217","groupName":"Extra Cheese brust [Reg]","choices":[{"id":"60999864","name":"Cheese Brust","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095223","groupName":"Extra Cheese brust [Med]","choices":[{"id":"60999875","name":"Cheese Brust","price":10000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095226","groupName":"Extra Cheese brust [Large]","choices":[{"id":"60999886","name":"Cheese Brust","price":13000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095219","groupName":"Extra Cheese [regular]","choices":[{"id":"60999874","name":"Extra Cheese","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095224","groupName":"Extra [medium]","choices":[{"id":"60999885","name":"Extra Cheese","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095227","groupName":"Extras [large]","choices":[{"id":"60999896","name":"Extra Cheese","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095220","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"defaultPrice":28000,"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.6","ratingCount":"6 ratings","ratingCountV2":"6"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"75106401","name":"Mexican Choice Pizza","category":"Pizza","description":"Onion, Capsicum, Sweet Corn, Jalapeno With Toppings Of Red Paprika.","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"23987184","name":"Portion","variations":[{"name":"Regular [8 Inches]","price":240,"default":1,"id":"77571787","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Medium [10 Inches]","price":340,"id":"77571788","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Large [12 Inches]","price":440,"id":"77571789","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"23987184","variationId":"77571787"}],"price":24000,"addonCombinations":[{"groupId":"76095228","addonId":"60999864"},{"groupId":"76095229","addonId":"60999865"},{"groupId":"76095229","addonId":"60999866"},{"groupId":"76095229","addonId":"60999867"},{"groupId":"76095229","addonId":"60999868"},{"groupId":"76095229","addonId":"60999869"},{"groupId":"76095229","addonId":"60999870"},{"groupId":"76095229","addonId":"60999871"},{"groupId":"76095229","addonId":"60999872"},{"groupId":"76095229","addonId":"60999873"},{"groupId":"76095231","addonId":"60999874"},{"groupId":"76095232","addonId":"60998438"},{"groupId":"76095232","addonId":"60998439"},{"groupId":"76095233","addonId":"60998441"},{"groupId":"76095233","addonId":"60998442"},{"groupId":"76095233","addonId":"60998443"},{"groupId":"76095233","addonId":"60998432"},{"groupId":"76095233","addonId":"60998433"},{"groupId":"76095233","addonId":"60998434"},{"groupId":"76095233","addonId":"60998435"}]},{"variations":[{"groupId":"23987184","variationId":"77571788"}],"price":34000,"addonCombinations":[{"groupId":"76095235","addonId":"60999876"},{"groupId":"76095235","addonId":"60999877"},{"groupId":"76095235","addonId":"60999878"},{"groupId":"76095235","addonId":"60999879"},{"groupId":"76095235","addonId":"60999880"},{"groupId":"76095235","addonId":"60999881"},{"groupId":"76095235","addonId":"60999882"},{"groupId":"76095235","addonId":"60999883"},{"groupId":"76095235","addonId":"60999884"},{"groupId":"76095236","addonId":"60999885"},{"groupId":"76095232","addonId":"60998438"},{"groupId":"76095232","addonId":"60998439"},{"groupId":"76095233","addonId":"60998441"},{"groupId":"76095233","addonId":"60998442"},{"groupId":"76095233","addonId":"60998443"},{"groupId":"76095233","addonId":"60998432"},{"groupId":"76095233","addonId":"60998433"},{"groupId":"76095233","addonId":"60998434"},{"groupId":"76095233","addonId":"60998435"},{"groupId":"76095234","addonId":"60999875"}]},{"variations":[{"groupId":"23987184","variationId":"77571789"}],"price":44000,"addonCombinations":[{"groupId":"76095237","addonId":"60999886"},{"groupId":"76095239","addonId":"60999896"},{"groupId":"76095232","addonId":"60998438"},{"groupId":"76095232","addonId":"60998439"},{"groupId":"76095233","addonId":"60998441"},{"groupId":"76095233","addonId":"60998442"},{"groupId":"76095233","addonId":"60998443"},{"groupId":"76095233","addonId":"60998432"},{"groupId":"76095233","addonId":"60998433"},{"groupId":"76095233","addonId":"60998434"},{"groupId":"76095233","addonId":"60998435"},{"groupId":"76095238","addonId":"60999887"},{"groupId":"76095238","addonId":"60999888"},{"groupId":"76095238","addonId":"60999889"},{"groupId":"76095238","addonId":"60999890"},{"groupId":"76095238","addonId":"60999891"},{"groupId":"76095238","addonId":"60999892"},{"groupId":"76095238","addonId":"60999893"},{"groupId":"76095238","addonId":"60999894"},{"groupId":"76095238","addonId":"60999895"}]}]},"addons":[{"groupId":"76095229","groupName":"Extra Toppings [8 Inches]","choices":[{"id":"60999869","name":"Zucchini","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999865","name":"Paneer","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999866","name":"Broccoli","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999867","name":"Capsicum","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999868","name":"Red Paprika","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999872","name":"Olive","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999873","name":"Jalapeno","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999870","name":"Onion","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999871","name":"Corn","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095238","groupName":"Extra Toppings [12 Inches]","choices":[{"id":"60999887","name":"Paneer","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999888","name":"Broccoli","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999889","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999894","name":"Olive","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999895","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999890","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999891","name":"Zucchini","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999892","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999893","name":"Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095235","groupName":"Extra Toppings [10 Inches]","choices":[{"id":"60999876","name":"Paneer","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999877","name":"Broccoli","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999878","name":"Capsicum","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999879","name":"Red Paprika","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999883","name":"Olive","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999884","name":"Jalapeno","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999880","name":"Zucchini","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999881","name":"Onion","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999882","name":"Corn","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095233","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095228","groupName":"Extra Cheese brust [Reg]","choices":[{"id":"60999864","name":"Cheese Brust","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095234","groupName":"Extra Cheese brust [Med]","choices":[{"id":"60999875","name":"Cheese Brust","price":10000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095237","groupName":"Extra Cheese brust [Large]","choices":[{"id":"60999886","name":"Cheese Brust","price":13000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095231","groupName":"Extra Cheese [regular]","choices":[{"id":"60999874","name":"Extra Cheese","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095236","groupName":"Extra [medium]","choices":[{"id":"60999885","name":"Extra Cheese","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095239","groupName":"Extras [large]","choices":[{"id":"60999896","name":"Extra Cheese","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095232","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"defaultPrice":24000,"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"5.0","ratingCount":"4 ratings","ratingCountV2":"4"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"75106404","name":"Ultimate Paneer Pizza","category":"Pizza","description":"Peppy Paneer, Onion Tomato, Green Chilies, Corn, Italian Sprinkle","imageId":"ocafwv6i9csobnarmj5d","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"23987195","name":"Portion","variations":[{"name":"Regular [8 Inches]","price":280,"default":1,"id":"77571820","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Medium [10 Inches]","price":380,"id":"77571821","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Large [12 Inches]","price":480,"id":"77571822","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"23987195","variationId":"77571820"}],"price":28000,"addonCombinations":[{"groupId":"76095358","addonId":"60999865"},{"groupId":"76095358","addonId":"60999866"},{"groupId":"76095358","addonId":"60999867"},{"groupId":"76095358","addonId":"60999868"},{"groupId":"76095358","addonId":"60999869"},{"groupId":"76095358","addonId":"60999870"},{"groupId":"76095358","addonId":"60999871"},{"groupId":"76095358","addonId":"60999872"},{"groupId":"76095358","addonId":"60999873"},{"groupId":"76095359","addonId":"60999864"},{"groupId":"76095361","addonId":"60999874"},{"groupId":"76095362","addonId":"60998438"},{"groupId":"76095362","addonId":"60998439"},{"groupId":"76095363","addonId":"60998441"},{"groupId":"76095363","addonId":"60998442"},{"groupId":"76095363","addonId":"60998443"},{"groupId":"76095363","addonId":"60998432"},{"groupId":"76095363","addonId":"60998433"},{"groupId":"76095363","addonId":"60998434"},{"groupId":"76095363","addonId":"60998435"}]},{"variations":[{"groupId":"23987195","variationId":"77571821"}],"price":38000,"addonCombinations":[{"groupId":"76095364","addonId":"60999876"},{"groupId":"76095364","addonId":"60999877"},{"groupId":"76095364","addonId":"60999878"},{"groupId":"76095364","addonId":"60999879"},{"groupId":"76095364","addonId":"60999880"},{"groupId":"76095364","addonId":"60999881"},{"groupId":"76095364","addonId":"60999882"},{"groupId":"76095364","addonId":"60999883"},{"groupId":"76095364","addonId":"60999884"},{"groupId":"76095362","addonId":"60998438"},{"groupId":"76095362","addonId":"60998439"},{"groupId":"76095363","addonId":"60998441"},{"groupId":"76095363","addonId":"60998442"},{"groupId":"76095363","addonId":"60998443"},{"groupId":"76095363","addonId":"60998432"},{"groupId":"76095363","addonId":"60998433"},{"groupId":"76095363","addonId":"60998434"},{"groupId":"76095363","addonId":"60998435"},{"groupId":"115661957","addonId":"60999885"},{"groupId":"76095365","addonId":"60999875"}]},{"variations":[{"groupId":"23987195","variationId":"77571822"}],"price":48000,"addonCombinations":[{"groupId":"76095367","addonId":"60999886"},{"groupId":"76095368","addonId":"60999896"},{"groupId":"76095362","addonId":"60998438"},{"groupId":"76095362","addonId":"60998439"},{"groupId":"76095363","addonId":"60998441"},{"groupId":"76095363","addonId":"60998442"},{"groupId":"76095363","addonId":"60998443"},{"groupId":"76095363","addonId":"60998432"},{"groupId":"76095363","addonId":"60998433"},{"groupId":"76095363","addonId":"60998434"},{"groupId":"76095363","addonId":"60998435"},{"groupId":"76095366","addonId":"60999887"},{"groupId":"76095366","addonId":"60999888"},{"groupId":"76095366","addonId":"60999889"},{"groupId":"76095366","addonId":"60999890"},{"groupId":"76095366","addonId":"60999891"},{"groupId":"76095366","addonId":"60999892"},{"groupId":"76095366","addonId":"60999893"},{"groupId":"76095366","addonId":"60999894"},{"groupId":"76095366","addonId":"60999895"}]}]},"addons":[{"groupId":"76095358","groupName":"Extra Toppings [8 Inches]","choices":[{"id":"60999869","name":"Zucchini","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999865","name":"Paneer","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999866","name":"Broccoli","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999867","name":"Capsicum","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999868","name":"Red Paprika","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999872","name":"Olive","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999873","name":"Jalapeno","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999870","name":"Onion","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999871","name":"Corn","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095366","groupName":"Extra Toppings [12 Inches]","choices":[{"id":"60999887","name":"Paneer","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999888","name":"Broccoli","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999889","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999894","name":"Olive","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999895","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999890","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999891","name":"Zucchini","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999892","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999893","name":"Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095364","groupName":"Extra Toppings [10 Inches]","choices":[{"id":"60999876","name":"Paneer","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999877","name":"Broccoli","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999878","name":"Capsicum","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999879","name":"Red Paprika","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999883","name":"Olive","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999884","name":"Jalapeno","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999880","name":"Zucchini","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999881","name":"Onion","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999882","name":"Corn","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095363","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095359","groupName":"Extra Cheese brust [Reg]","choices":[{"id":"60999864","name":"Cheese Brust","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095365","groupName":"Extra Cheese brust [Med]","choices":[{"id":"60999875","name":"Cheese Brust","price":10000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095367","groupName":"Extra Cheese brust [Large]","choices":[{"id":"60999886","name":"Cheese Brust","price":13000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095361","groupName":"Extra Cheese [regular]","choices":[{"id":"60999874","name":"Extra Cheese","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661957","groupName":"Extra [medium]","choices":[{"id":"60999885","name":"Extra Cheese","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095368","groupName":"Extras [large]","choices":[{"id":"60999896","name":"Extra Cheese","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095362","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"defaultPrice":28000,"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.7","ratingCount":"4 ratings","ratingCountV2":"4"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"100777642","name":"Double Cheese Pizza.","category":"Pizza","description":"Classic Italian pizza with double mozrella cheese topping","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"23987179","name":"Size","variations":[{"name":"Regular","price":200,"default":1,"id":"77571771","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Medium","price":300,"id":"77571772","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Large","price":400,"id":"77571773","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"23987179","variationId":"77571771"}],"price":20000,"addonCombinations":[{"groupId":"76095168","addonId":"60999865"},{"groupId":"76095168","addonId":"60999866"},{"groupId":"76095168","addonId":"60999867"},{"groupId":"76095168","addonId":"60999868"},{"groupId":"76095168","addonId":"60999869"},{"groupId":"76095168","addonId":"60999870"},{"groupId":"76095168","addonId":"60999871"},{"groupId":"76095168","addonId":"60999872"},{"groupId":"76095168","addonId":"60999873"},{"groupId":"76095169","addonId":"60999864"},{"groupId":"76095171","addonId":"60999874"},{"groupId":"76095172","addonId":"60998438"},{"groupId":"76095172","addonId":"60998439"},{"groupId":"76095173","addonId":"60998441"},{"groupId":"76095173","addonId":"60998442"},{"groupId":"76095173","addonId":"60998443"},{"groupId":"76095173","addonId":"60998432"},{"groupId":"76095173","addonId":"60998433"},{"groupId":"76095173","addonId":"60998434"},{"groupId":"76095173","addonId":"60998435"}]},{"variations":[{"groupId":"23987179","variationId":"77571772"}],"price":30000,"addonCombinations":[{"groupId":"76095174","addonId":"60999876"},{"groupId":"76095174","addonId":"60999877"},{"groupId":"76095174","addonId":"60999878"},{"groupId":"76095174","addonId":"60999879"},{"groupId":"76095174","addonId":"60999880"},{"groupId":"76095174","addonId":"60999881"},{"groupId":"76095174","addonId":"60999882"},{"groupId":"76095174","addonId":"60999883"},{"groupId":"76095174","addonId":"60999884"},{"groupId":"76095176","addonId":"60999885"},{"groupId":"76095172","addonId":"60998438"},{"groupId":"76095172","addonId":"60998439"},{"groupId":"76095173","addonId":"60998441"},{"groupId":"76095173","addonId":"60998442"},{"groupId":"76095173","addonId":"60998443"},{"groupId":"76095173","addonId":"60998432"},{"groupId":"76095173","addonId":"60998433"},{"groupId":"76095173","addonId":"60998434"},{"groupId":"76095173","addonId":"60998435"},{"groupId":"76095175","addonId":"60999875"}]},{"variations":[{"groupId":"23987179","variationId":"77571773"}],"price":40000,"addonCombinations":[{"groupId":"76095178","addonId":"60999886"},{"groupId":"76095179","addonId":"60999896"},{"groupId":"76095172","addonId":"60998438"},{"groupId":"76095172","addonId":"60998439"},{"groupId":"76095173","addonId":"60998441"},{"groupId":"76095173","addonId":"60998442"},{"groupId":"76095173","addonId":"60998443"},{"groupId":"76095173","addonId":"60998432"},{"groupId":"76095173","addonId":"60998433"},{"groupId":"76095173","addonId":"60998434"},{"groupId":"76095173","addonId":"60998435"},{"groupId":"76095177","addonId":"60999887"},{"groupId":"76095177","addonId":"60999888"},{"groupId":"76095177","addonId":"60999889"},{"groupId":"76095177","addonId":"60999890"},{"groupId":"76095177","addonId":"60999891"},{"groupId":"76095177","addonId":"60999892"},{"groupId":"76095177","addonId":"60999893"},{"groupId":"76095177","addonId":"60999894"},{"groupId":"76095177","addonId":"60999895"}]}]},"addons":[{"groupId":"76095168","groupName":"Extra Toppings [8 Inches]","choices":[{"id":"60999869","name":"Zucchini","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999865","name":"Paneer","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999866","name":"Broccoli","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999867","name":"Capsicum","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999868","name":"Red Paprika","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999872","name":"Olive","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999873","name":"Jalapeno","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999870","name":"Onion","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999871","name":"Corn","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095177","groupName":"Extra Toppings [12 Inches]","choices":[{"id":"60999887","name":"Paneer","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999888","name":"Broccoli","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999889","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999894","name":"Olive","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999895","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999890","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999891","name":"Zucchini","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999892","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999893","name":"Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095174","groupName":"Extra Toppings [10 Inches]","choices":[{"id":"60999876","name":"Paneer","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999877","name":"Broccoli","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999878","name":"Capsicum","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999879","name":"Red Paprika","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999883","name":"Olive","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999884","name":"Jalapeno","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999880","name":"Zucchini","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999881","name":"Onion","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999882","name":"Corn","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095173","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095169","groupName":"Extra Cheese brust [Reg]","choices":[{"id":"60999864","name":"Cheese Brust","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095175","groupName":"Extra Cheese brust [Med]","choices":[{"id":"60999875","name":"Cheese Brust","price":10000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095178","groupName":"Extra Cheese brust [Large]","choices":[{"id":"60999886","name":"Cheese Brust","price":13000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095171","groupName":"Extra Cheese [regular]","choices":[{"id":"60999874","name":"Extra Cheese","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095176","groupName":"Extra [medium]","choices":[{"id":"60999885","name":"Extra Cheese","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095179","groupName":"Extras [large]","choices":[{"id":"60999896","name":"Extra Cheese","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095172","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"defaultPrice":20000,"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"100777643","name":"Farm House.","category":"Pizza","description":"Onion, capsicum, tomato, sweet corn and mushroom","imageId":"4f090cb34a0767cc5ee780c34589c925","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"23987180","name":"Size","variations":[{"name":"Regular","price":210,"default":1,"id":"77571774","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Medium","price":310,"id":"77571775","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Large","price":410,"id":"77571776","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"23987180","variationId":"77571774"}],"price":21000,"addonCombinations":[{"groupId":"76095180","addonId":"60999865"},{"groupId":"76095180","addonId":"60999866"},{"groupId":"76095180","addonId":"60999867"},{"groupId":"76095180","addonId":"60999868"},{"groupId":"76095180","addonId":"60999869"},{"groupId":"76095180","addonId":"60999870"},{"groupId":"76095180","addonId":"60999871"},{"groupId":"76095180","addonId":"60999872"},{"groupId":"76095180","addonId":"60999873"},{"groupId":"76095181","addonId":"60999864"},{"groupId":"76095183","addonId":"60999874"},{"groupId":"76095184","addonId":"60998438"},{"groupId":"76095184","addonId":"60998439"},{"groupId":"76095185","addonId":"60998441"},{"groupId":"76095185","addonId":"60998442"},{"groupId":"76095185","addonId":"60998443"},{"groupId":"76095185","addonId":"60998432"},{"groupId":"76095185","addonId":"60998433"},{"groupId":"76095185","addonId":"60998434"},{"groupId":"76095185","addonId":"60998435"}]},{"variations":[{"groupId":"23987180","variationId":"77571775"}],"price":31000,"addonCombinations":[{"groupId":"76095186","addonId":"60999876"},{"groupId":"76095186","addonId":"60999877"},{"groupId":"76095186","addonId":"60999878"},{"groupId":"76095186","addonId":"60999879"},{"groupId":"76095186","addonId":"60999880"},{"groupId":"76095186","addonId":"60999881"},{"groupId":"76095186","addonId":"60999882"},{"groupId":"76095186","addonId":"60999883"},{"groupId":"76095186","addonId":"60999884"},{"groupId":"76095188","addonId":"60999885"},{"groupId":"76095184","addonId":"60998438"},{"groupId":"76095184","addonId":"60998439"},{"groupId":"76095185","addonId":"60998441"},{"groupId":"76095185","addonId":"60998442"},{"groupId":"76095185","addonId":"60998443"},{"groupId":"76095185","addonId":"60998432"},{"groupId":"76095185","addonId":"60998433"},{"groupId":"76095185","addonId":"60998434"},{"groupId":"76095185","addonId":"60998435"},{"groupId":"76095187","addonId":"60999875"}]},{"variations":[{"groupId":"23987180","variationId":"77571776"}],"price":41000,"addonCombinations":[{"groupId":"76095190","addonId":"60999886"},{"groupId":"76095191","addonId":"60999896"},{"groupId":"76095184","addonId":"60998438"},{"groupId":"76095184","addonId":"60998439"},{"groupId":"76095185","addonId":"60998441"},{"groupId":"76095185","addonId":"60998442"},{"groupId":"76095185","addonId":"60998443"},{"groupId":"76095185","addonId":"60998432"},{"groupId":"76095185","addonId":"60998433"},{"groupId":"76095185","addonId":"60998434"},{"groupId":"76095185","addonId":"60998435"},{"groupId":"76095189","addonId":"60999887"},{"groupId":"76095189","addonId":"60999888"},{"groupId":"76095189","addonId":"60999889"},{"groupId":"76095189","addonId":"60999890"},{"groupId":"76095189","addonId":"60999891"},{"groupId":"76095189","addonId":"60999892"},{"groupId":"76095189","addonId":"60999893"},{"groupId":"76095189","addonId":"60999894"},{"groupId":"76095189","addonId":"60999895"}]}]},"addons":[{"groupId":"76095180","groupName":"Extra Toppings [8 Inches]","choices":[{"id":"60999869","name":"Zucchini","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999865","name":"Paneer","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999866","name":"Broccoli","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999867","name":"Capsicum","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999868","name":"Red Paprika","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999872","name":"Olive","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999873","name":"Jalapeno","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999870","name":"Onion","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999871","name":"Corn","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095189","groupName":"Extra Toppings [12 Inches]","choices":[{"id":"60999887","name":"Paneer","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999888","name":"Broccoli","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999889","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999894","name":"Olive","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999895","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999890","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999891","name":"Zucchini","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999892","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999893","name":"Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095186","groupName":"Extra Toppings [10 Inches]","choices":[{"id":"60999876","name":"Paneer","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999877","name":"Broccoli","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999878","name":"Capsicum","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999879","name":"Red Paprika","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999883","name":"Olive","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999884","name":"Jalapeno","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999880","name":"Zucchini","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999881","name":"Onion","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999882","name":"Corn","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095185","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095181","groupName":"Extra Cheese brust [Reg]","choices":[{"id":"60999864","name":"Cheese Brust","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095187","groupName":"Extra Cheese brust [Med]","choices":[{"id":"60999875","name":"Cheese Brust","price":10000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095190","groupName":"Extra Cheese brust [Large]","choices":[{"id":"60999886","name":"Cheese Brust","price":13000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095183","groupName":"Extra Cheese [regular]","choices":[{"id":"60999874","name":"Extra Cheese","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095188","groupName":"Extra [medium]","choices":[{"id":"60999885","name":"Extra Cheese","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095191","groupName":"Extras [large]","choices":[{"id":"60999896","name":"Extra Cheese","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095184","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"defaultPrice":21000,"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"type":"ITEM","itemBadge":{},"badgesV2":{},"isBestseller":true,"ratings":{"aggregatedRating":{"rating":"3.5","ratingCount":"9 ratings","ratingCountV2":"9"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"100777644","name":"Hawaiian Pizza.","category":"Pizza","description":"A classic combination of pineapple, mix capsicum, red paprika and corn","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"23987181","name":"Size","variations":[{"name":"Regular","price":230,"default":1,"id":"77571777","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Medium","price":330,"id":"77571778","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Large","price":430,"id":"77571779","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"23987181","variationId":"77571777"}],"price":23000,"addonCombinations":[{"groupId":"76095192","addonId":"60999865"},{"groupId":"76095192","addonId":"60999866"},{"groupId":"76095192","addonId":"60999867"},{"groupId":"76095192","addonId":"60999868"},{"groupId":"76095192","addonId":"60999869"},{"groupId":"76095192","addonId":"60999870"},{"groupId":"76095192","addonId":"60999871"},{"groupId":"76095192","addonId":"60999872"},{"groupId":"76095192","addonId":"60999873"},{"groupId":"76095193","addonId":"60999864"},{"groupId":"76095195","addonId":"60999874"},{"groupId":"76095196","addonId":"60998438"},{"groupId":"76095196","addonId":"60998439"},{"groupId":"76095197","addonId":"60998441"},{"groupId":"76095197","addonId":"60998442"},{"groupId":"76095197","addonId":"60998443"},{"groupId":"76095197","addonId":"60998432"},{"groupId":"76095197","addonId":"60998433"},{"groupId":"76095197","addonId":"60998434"},{"groupId":"76095197","addonId":"60998435"}]},{"variations":[{"groupId":"23987181","variationId":"77571778"}],"price":33000,"addonCombinations":[{"groupId":"76095198","addonId":"60999876"},{"groupId":"76095198","addonId":"60999877"},{"groupId":"76095198","addonId":"60999878"},{"groupId":"76095198","addonId":"60999879"},{"groupId":"76095198","addonId":"60999880"},{"groupId":"76095198","addonId":"60999881"},{"groupId":"76095198","addonId":"60999882"},{"groupId":"76095198","addonId":"60999883"},{"groupId":"76095198","addonId":"60999884"},{"groupId":"76095200","addonId":"60999885"},{"groupId":"76095196","addonId":"60998438"},{"groupId":"76095196","addonId":"60998439"},{"groupId":"76095197","addonId":"60998441"},{"groupId":"76095197","addonId":"60998442"},{"groupId":"76095197","addonId":"60998443"},{"groupId":"76095197","addonId":"60998432"},{"groupId":"76095197","addonId":"60998433"},{"groupId":"76095197","addonId":"60998434"},{"groupId":"76095197","addonId":"60998435"},{"groupId":"76095199","addonId":"60999875"}]},{"variations":[{"groupId":"23987181","variationId":"77571779"}],"price":43000,"addonCombinations":[{"groupId":"76095202","addonId":"60999886"},{"groupId":"76095203","addonId":"60999896"},{"groupId":"76095196","addonId":"60998438"},{"groupId":"76095196","addonId":"60998439"},{"groupId":"76095197","addonId":"60998441"},{"groupId":"76095197","addonId":"60998442"},{"groupId":"76095197","addonId":"60998443"},{"groupId":"76095197","addonId":"60998432"},{"groupId":"76095197","addonId":"60998433"},{"groupId":"76095197","addonId":"60998434"},{"groupId":"76095197","addonId":"60998435"},{"groupId":"76095201","addonId":"60999887"},{"groupId":"76095201","addonId":"60999888"},{"groupId":"76095201","addonId":"60999889"},{"groupId":"76095201","addonId":"60999890"},{"groupId":"76095201","addonId":"60999891"},{"groupId":"76095201","addonId":"60999892"},{"groupId":"76095201","addonId":"60999893"},{"groupId":"76095201","addonId":"60999894"},{"groupId":"76095201","addonId":"60999895"}]}]},"addons":[{"groupId":"76095192","groupName":"Extra Toppings [8 Inches]","choices":[{"id":"60999869","name":"Zucchini","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999865","name":"Paneer","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999866","name":"Broccoli","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999867","name":"Capsicum","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999868","name":"Red Paprika","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999872","name":"Olive","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999873","name":"Jalapeno","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999870","name":"Onion","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999871","name":"Corn","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095201","groupName":"Extra Toppings [12 Inches]","choices":[{"id":"60999887","name":"Paneer","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999888","name":"Broccoli","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999889","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999894","name":"Olive","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999895","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999890","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999891","name":"Zucchini","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999892","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999893","name":"Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095198","groupName":"Extra Toppings [10 Inches]","choices":[{"id":"60999876","name":"Paneer","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999877","name":"Broccoli","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999878","name":"Capsicum","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999879","name":"Red Paprika","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999883","name":"Olive","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999884","name":"Jalapeno","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999880","name":"Zucchini","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999881","name":"Onion","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999882","name":"Corn","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095197","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095193","groupName":"Extra Cheese brust [Reg]","choices":[{"id":"60999864","name":"Cheese Brust","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095199","groupName":"Extra Cheese brust [Med]","choices":[{"id":"60999875","name":"Cheese Brust","price":10000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095202","groupName":"Extra Cheese brust [Large]","choices":[{"id":"60999886","name":"Cheese Brust","price":13000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095195","groupName":"Extra Cheese [regular]","choices":[{"id":"60999874","name":"Extra Cheese","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095200","groupName":"Extra [medium]","choices":[{"id":"60999885","name":"Extra Cheese","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095203","groupName":"Extras [large]","choices":[{"id":"60999896","name":"Extra Cheese","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095196","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"defaultPrice":23000,"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"100777646","name":"Onion & Paneer.","category":"Pizza","description":"Hot cheese, Sliced onion and paneer","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"23987185","name":"Size","variations":[{"name":"Regular","price":178,"default":1,"id":"77571790","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Medium","price":278,"id":"77571791","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Large","price":378,"id":"77571792","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"23987185","variationId":"77571790"}],"price":17800,"addonCombinations":[{"groupId":"76095240","addonId":"60999865"},{"groupId":"76095240","addonId":"60999866"},{"groupId":"76095240","addonId":"60999867"},{"groupId":"76095240","addonId":"60999868"},{"groupId":"76095240","addonId":"60999869"},{"groupId":"76095240","addonId":"60999870"},{"groupId":"76095240","addonId":"60999871"},{"groupId":"76095240","addonId":"60999872"},{"groupId":"76095240","addonId":"60999873"},{"groupId":"76095241","addonId":"60999864"},{"groupId":"76095243","addonId":"60999874"},{"groupId":"76095244","addonId":"60998438"},{"groupId":"76095244","addonId":"60998439"},{"groupId":"76095245","addonId":"60998441"},{"groupId":"76095245","addonId":"60998442"},{"groupId":"76095245","addonId":"60998443"},{"groupId":"76095245","addonId":"60998432"},{"groupId":"76095245","addonId":"60998433"},{"groupId":"76095245","addonId":"60998434"},{"groupId":"76095245","addonId":"60998435"}]},{"variations":[{"groupId":"23987185","variationId":"77571791"}],"price":27800,"addonCombinations":[{"groupId":"76095246","addonId":"60999876"},{"groupId":"76095246","addonId":"60999877"},{"groupId":"76095246","addonId":"60999878"},{"groupId":"76095246","addonId":"60999879"},{"groupId":"76095246","addonId":"60999880"},{"groupId":"76095246","addonId":"60999881"},{"groupId":"76095246","addonId":"60999882"},{"groupId":"76095246","addonId":"60999883"},{"groupId":"76095246","addonId":"60999884"},{"groupId":"76095248","addonId":"60999885"},{"groupId":"76095244","addonId":"60998438"},{"groupId":"76095244","addonId":"60998439"},{"groupId":"76095245","addonId":"60998441"},{"groupId":"76095245","addonId":"60998442"},{"groupId":"76095245","addonId":"60998443"},{"groupId":"76095245","addonId":"60998432"},{"groupId":"76095245","addonId":"60998433"},{"groupId":"76095245","addonId":"60998434"},{"groupId":"76095245","addonId":"60998435"},{"groupId":"76095247","addonId":"60999875"}]},{"variations":[{"groupId":"23987185","variationId":"77571792"}],"price":37800,"addonCombinations":[{"groupId":"76095250","addonId":"60999886"},{"groupId":"76095251","addonId":"60999896"},{"groupId":"76095244","addonId":"60998438"},{"groupId":"76095244","addonId":"60998439"},{"groupId":"76095245","addonId":"60998441"},{"groupId":"76095245","addonId":"60998442"},{"groupId":"76095245","addonId":"60998443"},{"groupId":"76095245","addonId":"60998432"},{"groupId":"76095245","addonId":"60998433"},{"groupId":"76095245","addonId":"60998434"},{"groupId":"76095245","addonId":"60998435"},{"groupId":"76095249","addonId":"60999887"},{"groupId":"76095249","addonId":"60999888"},{"groupId":"76095249","addonId":"60999889"},{"groupId":"76095249","addonId":"60999890"},{"groupId":"76095249","addonId":"60999891"},{"groupId":"76095249","addonId":"60999892"},{"groupId":"76095249","addonId":"60999893"},{"groupId":"76095249","addonId":"60999894"},{"groupId":"76095249","addonId":"60999895"}]}]},"addons":[{"groupId":"76095240","groupName":"Extra Toppings [8 Inches]","choices":[{"id":"60999869","name":"Zucchini","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999865","name":"Paneer","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999866","name":"Broccoli","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999867","name":"Capsicum","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999868","name":"Red Paprika","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999872","name":"Olive","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999873","name":"Jalapeno","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999870","name":"Onion","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999871","name":"Corn","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095249","groupName":"Extra Toppings [12 Inches]","choices":[{"id":"60999887","name":"Paneer","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999888","name":"Broccoli","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999889","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999894","name":"Olive","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999895","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999890","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999891","name":"Zucchini","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999892","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999893","name":"Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095246","groupName":"Extra Toppings [10 Inches]","choices":[{"id":"60999876","name":"Paneer","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999877","name":"Broccoli","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999878","name":"Capsicum","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999879","name":"Red Paprika","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999883","name":"Olive","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999884","name":"Jalapeno","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999880","name":"Zucchini","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999881","name":"Onion","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999882","name":"Corn","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095245","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095241","groupName":"Extra Cheese brust [Reg]","choices":[{"id":"60999864","name":"Cheese Brust","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095247","groupName":"Extra Cheese brust [Med]","choices":[{"id":"60999875","name":"Cheese Brust","price":10000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095250","groupName":"Extra Cheese brust [Large]","choices":[{"id":"60999886","name":"Cheese Brust","price":13000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095243","groupName":"Extra Cheese [regular]","choices":[{"id":"60999874","name":"Extra Cheese","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095248","groupName":"Extra [medium]","choices":[{"id":"60999885","name":"Extra Cheese","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095251","groupName":"Extras [large]","choices":[{"id":"60999896","name":"Extra Cheese","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095244","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"defaultPrice":17800,"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"100777684","name":"Veg Exotica.","category":"Pizza","description":"The garden fresh combination of onion, mushroom, sweet corn & green capsicum topped with red paprika","imageId":"0c5edf03e6fbc06cf30cb7d76fde3775","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"23987196","name":"Size","variations":[{"name":"Regular","price":250,"default":1,"id":"77571823","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Medium","price":350,"id":"77571824","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Large","price":450,"id":"77571825","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"23987196","variationId":"77571823"}],"price":25000,"addonCombinations":[{"groupId":"76095369","addonId":"60999865"},{"groupId":"76095369","addonId":"60999866"},{"groupId":"76095369","addonId":"60999867"},{"groupId":"76095369","addonId":"60999868"},{"groupId":"76095369","addonId":"60999869"},{"groupId":"76095369","addonId":"60999870"},{"groupId":"76095369","addonId":"60999871"},{"groupId":"76095369","addonId":"60999872"},{"groupId":"76095369","addonId":"60999873"},{"groupId":"76095370","addonId":"60999864"},{"groupId":"76095372","addonId":"60999874"},{"groupId":"76095373","addonId":"60998438"},{"groupId":"76095373","addonId":"60998439"},{"groupId":"76095374","addonId":"60998441"},{"groupId":"76095374","addonId":"60998442"},{"groupId":"76095374","addonId":"60998443"},{"groupId":"76095374","addonId":"60998432"},{"groupId":"76095374","addonId":"60998433"},{"groupId":"76095374","addonId":"60998434"},{"groupId":"76095374","addonId":"60998435"}]},{"variations":[{"groupId":"23987196","variationId":"77571824"}],"price":35000,"addonCombinations":[{"groupId":"76095375","addonId":"60999876"},{"groupId":"76095375","addonId":"60999877"},{"groupId":"76095375","addonId":"60999878"},{"groupId":"76095375","addonId":"60999879"},{"groupId":"76095375","addonId":"60999880"},{"groupId":"76095375","addonId":"60999881"},{"groupId":"76095375","addonId":"60999882"},{"groupId":"76095375","addonId":"60999883"},{"groupId":"76095375","addonId":"60999884"},{"groupId":"76095377","addonId":"60999885"},{"groupId":"76095373","addonId":"60998438"},{"groupId":"76095373","addonId":"60998439"},{"groupId":"76095374","addonId":"60998441"},{"groupId":"76095374","addonId":"60998442"},{"groupId":"76095374","addonId":"60998443"},{"groupId":"76095374","addonId":"60998432"},{"groupId":"76095374","addonId":"60998433"},{"groupId":"76095374","addonId":"60998434"},{"groupId":"76095374","addonId":"60998435"},{"groupId":"76095376","addonId":"60999875"}]},{"variations":[{"groupId":"23987196","variationId":"77571825"}],"price":45000,"addonCombinations":[{"groupId":"76095379","addonId":"60999886"},{"groupId":"76095380","addonId":"60999896"},{"groupId":"76095373","addonId":"60998438"},{"groupId":"76095373","addonId":"60998439"},{"groupId":"76095374","addonId":"60998441"},{"groupId":"76095374","addonId":"60998442"},{"groupId":"76095374","addonId":"60998443"},{"groupId":"76095374","addonId":"60998432"},{"groupId":"76095374","addonId":"60998433"},{"groupId":"76095374","addonId":"60998434"},{"groupId":"76095374","addonId":"60998435"},{"groupId":"76095378","addonId":"60999887"},{"groupId":"76095378","addonId":"60999888"},{"groupId":"76095378","addonId":"60999889"},{"groupId":"76095378","addonId":"60999890"},{"groupId":"76095378","addonId":"60999891"},{"groupId":"76095378","addonId":"60999892"},{"groupId":"76095378","addonId":"60999893"},{"groupId":"76095378","addonId":"60999894"},{"groupId":"76095378","addonId":"60999895"}]}]},"addons":[{"groupId":"76095369","groupName":"Extra Toppings [8 Inches]","choices":[{"id":"60999869","name":"Zucchini","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999865","name":"Paneer","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999866","name":"Broccoli","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999867","name":"Capsicum","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999868","name":"Red Paprika","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999872","name":"Olive","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999873","name":"Jalapeno","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999870","name":"Onion","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999871","name":"Corn","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095378","groupName":"Extra Toppings [12 Inches]","choices":[{"id":"60999887","name":"Paneer","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999888","name":"Broccoli","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999889","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999894","name":"Olive","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999895","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999890","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999891","name":"Zucchini","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999892","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999893","name":"Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095375","groupName":"Extra Toppings [10 Inches]","choices":[{"id":"60999876","name":"Paneer","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999877","name":"Broccoli","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999878","name":"Capsicum","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999879","name":"Red Paprika","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999883","name":"Olive","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999884","name":"Jalapeno","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999880","name":"Zucchini","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999881","name":"Onion","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999882","name":"Corn","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095374","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095370","groupName":"Extra Cheese brust [Reg]","choices":[{"id":"60999864","name":"Cheese Brust","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095376","groupName":"Extra Cheese brust [Med]","choices":[{"id":"60999875","name":"Cheese Brust","price":10000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095379","groupName":"Extra Cheese brust [Large]","choices":[{"id":"60999886","name":"Cheese Brust","price":13000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095372","groupName":"Extra Cheese [regular]","choices":[{"id":"60999874","name":"Extra Cheese","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095377","groupName":"Extra [medium]","choices":[{"id":"60999885","name":"Extra Cheese","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095380","groupName":"Extras [large]","choices":[{"id":"60999896","name":"Extra Cheese","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095373","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"defaultPrice":25000,"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"100777685","name":"Veg Loaded.","category":"Pizza","description":"A seven topping loaded pizza with onion, mushroom, corn, jalepenos, sliced black olive with red capsicum & zucchini","imageId":"fa325bb9147492fb5bfe44bd6d203499","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"23987198","name":"Size","variations":[{"name":"Regular","price":250,"default":1,"id":"77571829","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Medium","price":350,"id":"77571830","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Large","price":450,"id":"77571831","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"23987198","variationId":"77571829"}],"price":25000,"addonCombinations":[{"groupId":"76095393","addonId":"60999865"},{"groupId":"76095393","addonId":"60999866"},{"groupId":"76095393","addonId":"60999867"},{"groupId":"76095393","addonId":"60999868"},{"groupId":"76095393","addonId":"60999869"},{"groupId":"76095393","addonId":"60999870"},{"groupId":"76095393","addonId":"60999871"},{"groupId":"76095393","addonId":"60999872"},{"groupId":"76095393","addonId":"60999873"},{"groupId":"76095394","addonId":"60999864"},{"groupId":"76095396","addonId":"60999874"},{"groupId":"76095397","addonId":"60998438"},{"groupId":"76095397","addonId":"60998439"},{"groupId":"76095398","addonId":"60998441"},{"groupId":"76095398","addonId":"60998442"},{"groupId":"76095398","addonId":"60998443"},{"groupId":"76095398","addonId":"60998432"},{"groupId":"76095398","addonId":"60998433"},{"groupId":"76095398","addonId":"60998434"},{"groupId":"76095398","addonId":"60998435"}]},{"variations":[{"groupId":"23987198","variationId":"77571830"}],"price":35000,"addonCombinations":[{"groupId":"76095399","addonId":"60999876"},{"groupId":"76095399","addonId":"60999877"},{"groupId":"76095399","addonId":"60999878"},{"groupId":"76095399","addonId":"60999879"},{"groupId":"76095399","addonId":"60999880"},{"groupId":"76095399","addonId":"60999881"},{"groupId":"76095399","addonId":"60999882"},{"groupId":"76095399","addonId":"60999883"},{"groupId":"76095399","addonId":"60999884"},{"groupId":"76095401","addonId":"60999885"},{"groupId":"76095397","addonId":"60998438"},{"groupId":"76095397","addonId":"60998439"},{"groupId":"76095398","addonId":"60998441"},{"groupId":"76095398","addonId":"60998442"},{"groupId":"76095398","addonId":"60998443"},{"groupId":"76095398","addonId":"60998432"},{"groupId":"76095398","addonId":"60998433"},{"groupId":"76095398","addonId":"60998434"},{"groupId":"76095398","addonId":"60998435"},{"groupId":"76095400","addonId":"60999875"}]},{"variations":[{"groupId":"23987198","variationId":"77571831"}],"price":45000,"addonCombinations":[{"groupId":"76095403","addonId":"60999886"},{"groupId":"76095404","addonId":"60999896"},{"groupId":"76095397","addonId":"60998438"},{"groupId":"76095397","addonId":"60998439"},{"groupId":"76095398","addonId":"60998441"},{"groupId":"76095398","addonId":"60998442"},{"groupId":"76095398","addonId":"60998443"},{"groupId":"76095398","addonId":"60998432"},{"groupId":"76095398","addonId":"60998433"},{"groupId":"76095398","addonId":"60998434"},{"groupId":"76095398","addonId":"60998435"},{"groupId":"76095402","addonId":"60999887"},{"groupId":"76095402","addonId":"60999888"},{"groupId":"76095402","addonId":"60999889"},{"groupId":"76095402","addonId":"60999890"},{"groupId":"76095402","addonId":"60999891"},{"groupId":"76095402","addonId":"60999892"},{"groupId":"76095402","addonId":"60999893"},{"groupId":"76095402","addonId":"60999894"},{"groupId":"76095402","addonId":"60999895"}]}]},"addons":[{"groupId":"76095393","groupName":"Extra Toppings [8 Inches]","choices":[{"id":"60999869","name":"Zucchini","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999865","name":"Paneer","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999866","name":"Broccoli","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999867","name":"Capsicum","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999868","name":"Red Paprika","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999872","name":"Olive","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999873","name":"Jalapeno","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999870","name":"Onion","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999871","name":"Corn","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095402","groupName":"Extra Toppings [12 Inches]","choices":[{"id":"60999887","name":"Paneer","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999888","name":"Broccoli","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999889","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999894","name":"Olive","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999895","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999890","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999891","name":"Zucchini","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999892","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999893","name":"Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095399","groupName":"Extra Toppings [10 Inches]","choices":[{"id":"60999876","name":"Paneer","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999877","name":"Broccoli","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999878","name":"Capsicum","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999879","name":"Red Paprika","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999883","name":"Olive","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999884","name":"Jalapeno","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999880","name":"Zucchini","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999881","name":"Onion","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999882","name":"Corn","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095398","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095394","groupName":"Extra Cheese brust [Reg]","choices":[{"id":"60999864","name":"Cheese Brust","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095400","groupName":"Extra Cheese brust [Med]","choices":[{"id":"60999875","name":"Cheese Brust","price":10000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095403","groupName":"Extra Cheese brust [Large]","choices":[{"id":"60999886","name":"Cheese Brust","price":13000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095396","groupName":"Extra Cheese [regular]","choices":[{"id":"60999874","name":"Extra Cheese","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095401","groupName":"Extra [medium]","choices":[{"id":"60999885","name":"Extra Cheese","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095404","groupName":"Extras [large]","choices":[{"id":"60999896","name":"Extra Cheese","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095397","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"defaultPrice":25000,"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"100777686","name":"Veggie Lover.","category":"Pizza","description":"Mushroom, capsicum, onion, tomato, baby corn, olive and pineapple","imageId":"1c4a708238b6792765deab6aa7e111ab","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"23987200","name":"Size","variations":[{"name":"Regular","price":250,"default":1,"id":"77571835","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Medium","price":350,"id":"77571836","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Large","price":450,"id":"77571837","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"23987200","variationId":"77571835"}],"price":25000,"addonCombinations":[{"groupId":"76095417","addonId":"60999865"},{"groupId":"76095417","addonId":"60999866"},{"groupId":"76095417","addonId":"60999867"},{"groupId":"76095417","addonId":"60999868"},{"groupId":"76095417","addonId":"60999869"},{"groupId":"76095417","addonId":"60999870"},{"groupId":"76095417","addonId":"60999871"},{"groupId":"76095417","addonId":"60999872"},{"groupId":"76095417","addonId":"60999873"},{"groupId":"76095418","addonId":"60999864"},{"groupId":"76095420","addonId":"60999874"},{"groupId":"76095421","addonId":"60998438"},{"groupId":"76095421","addonId":"60998439"},{"groupId":"76095422","addonId":"60998441"},{"groupId":"76095422","addonId":"60998442"},{"groupId":"76095422","addonId":"60998443"},{"groupId":"76095422","addonId":"60998432"},{"groupId":"76095422","addonId":"60998433"},{"groupId":"76095422","addonId":"60998434"},{"groupId":"76095422","addonId":"60998435"}]},{"variations":[{"groupId":"23987200","variationId":"77571836"}],"price":35000,"addonCombinations":[{"groupId":"76095423","addonId":"60999876"},{"groupId":"76095423","addonId":"60999877"},{"groupId":"76095423","addonId":"60999878"},{"groupId":"76095423","addonId":"60999879"},{"groupId":"76095423","addonId":"60999880"},{"groupId":"76095423","addonId":"60999881"},{"groupId":"76095423","addonId":"60999882"},{"groupId":"76095423","addonId":"60999883"},{"groupId":"76095423","addonId":"60999884"},{"groupId":"76095425","addonId":"60999885"},{"groupId":"76095421","addonId":"60998438"},{"groupId":"76095421","addonId":"60998439"},{"groupId":"76095422","addonId":"60998441"},{"groupId":"76095422","addonId":"60998442"},{"groupId":"76095422","addonId":"60998443"},{"groupId":"76095422","addonId":"60998432"},{"groupId":"76095422","addonId":"60998433"},{"groupId":"76095422","addonId":"60998434"},{"groupId":"76095422","addonId":"60998435"},{"groupId":"76095424","addonId":"60999875"}]},{"variations":[{"groupId":"23987200","variationId":"77571837"}],"price":45000,"addonCombinations":[{"groupId":"76095427","addonId":"60999886"},{"groupId":"76095428","addonId":"60999896"},{"groupId":"76095421","addonId":"60998438"},{"groupId":"76095421","addonId":"60998439"},{"groupId":"76095422","addonId":"60998441"},{"groupId":"76095422","addonId":"60998442"},{"groupId":"76095422","addonId":"60998443"},{"groupId":"76095422","addonId":"60998432"},{"groupId":"76095422","addonId":"60998433"},{"groupId":"76095422","addonId":"60998434"},{"groupId":"76095422","addonId":"60998435"},{"groupId":"76095426","addonId":"60999887"},{"groupId":"76095426","addonId":"60999888"},{"groupId":"76095426","addonId":"60999889"},{"groupId":"76095426","addonId":"60999890"},{"groupId":"76095426","addonId":"60999891"},{"groupId":"76095426","addonId":"60999892"},{"groupId":"76095426","addonId":"60999893"},{"groupId":"76095426","addonId":"60999894"},{"groupId":"76095426","addonId":"60999895"}]}]},"addons":[{"groupId":"76095417","groupName":"Extra Toppings [8 Inches]","choices":[{"id":"60999869","name":"Zucchini","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999865","name":"Paneer","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999866","name":"Broccoli","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999867","name":"Capsicum","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999868","name":"Red Paprika","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999872","name":"Olive","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999873","name":"Jalapeno","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999870","name":"Onion","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999871","name":"Corn","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095426","groupName":"Extra Toppings [12 Inches]","choices":[{"id":"60999887","name":"Paneer","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999888","name":"Broccoli","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999889","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999894","name":"Olive","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999895","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999890","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999891","name":"Zucchini","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999892","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999893","name":"Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095423","groupName":"Extra Toppings [10 Inches]","choices":[{"id":"60999876","name":"Paneer","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999877","name":"Broccoli","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999878","name":"Capsicum","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999879","name":"Red Paprika","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999883","name":"Olive","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999884","name":"Jalapeno","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999880","name":"Zucchini","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999881","name":"Onion","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999882","name":"Corn","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095422","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095418","groupName":"Extra Cheese brust [Reg]","choices":[{"id":"60999864","name":"Cheese Brust","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095424","groupName":"Extra Cheese brust [Med]","choices":[{"id":"60999875","name":"Cheese Brust","price":10000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095427","groupName":"Extra Cheese brust [Large]","choices":[{"id":"60999886","name":"Cheese Brust","price":13000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095420","groupName":"Extra Cheese [regular]","choices":[{"id":"60999874","name":"Extra Cheese","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095425","groupName":"Extra [medium]","choices":[{"id":"60999885","name":"Extra Cheese","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095428","groupName":"Extras [large]","choices":[{"id":"60999896","name":"Extra Cheese","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095421","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"defaultPrice":25000,"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"106567954","name":"Veg Pizza","category":"Pizza","description":"Onion, capsicum, tomato with cheese blend and mozzarella cheese","imageId":"3055e6ca9b0945c92db4d31b5f706eea","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"23987199","name":"Portion","variations":[{"name":"Regular [8 Inches]","price":148,"default":1,"id":"77571832","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Medium [10 Inches]","price":248,"id":"77571833","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Large [12 Inches]","price":348,"id":"77571834","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"23987199","variationId":"77571832"}],"price":14800,"addonCombinations":[{"groupId":"76095405","addonId":"60999865"},{"groupId":"76095405","addonId":"60999866"},{"groupId":"76095405","addonId":"60999867"},{"groupId":"76095405","addonId":"60999868"},{"groupId":"76095405","addonId":"60999869"},{"groupId":"76095405","addonId":"60999870"},{"groupId":"76095405","addonId":"60999871"},{"groupId":"76095405","addonId":"60999872"},{"groupId":"76095405","addonId":"60999873"},{"groupId":"76095406","addonId":"60998441"},{"groupId":"76095406","addonId":"60998442"},{"groupId":"76095406","addonId":"60998443"},{"groupId":"76095406","addonId":"60998432"},{"groupId":"76095406","addonId":"60998433"},{"groupId":"76095406","addonId":"60998434"},{"groupId":"76095406","addonId":"60998435"},{"groupId":"76095407","addonId":"60999864"},{"groupId":"76095409","addonId":"60999874"},{"groupId":"76095410","addonId":"60998438"},{"groupId":"76095410","addonId":"60998439"}]},{"variations":[{"groupId":"23987199","variationId":"77571833"}],"price":24800,"addonCombinations":[{"groupId":"76095411","addonId":"60999876"},{"groupId":"76095411","addonId":"60999877"},{"groupId":"76095411","addonId":"60999878"},{"groupId":"76095411","addonId":"60999879"},{"groupId":"76095411","addonId":"60999880"},{"groupId":"76095411","addonId":"60999881"},{"groupId":"76095411","addonId":"60999882"},{"groupId":"76095411","addonId":"60999883"},{"groupId":"76095411","addonId":"60999884"},{"groupId":"76095406","addonId":"60998441"},{"groupId":"76095406","addonId":"60998442"},{"groupId":"76095406","addonId":"60998443"},{"groupId":"76095406","addonId":"60998432"},{"groupId":"76095406","addonId":"60998433"},{"groupId":"76095406","addonId":"60998434"},{"groupId":"76095406","addonId":"60998435"},{"groupId":"76095413","addonId":"60999885"},{"groupId":"76095410","addonId":"60998438"},{"groupId":"76095410","addonId":"60998439"},{"groupId":"76095412","addonId":"60999875"}]},{"variations":[{"groupId":"23987199","variationId":"77571834"}],"price":34800,"addonCombinations":[{"groupId":"76095406","addonId":"60998441"},{"groupId":"76095406","addonId":"60998442"},{"groupId":"76095406","addonId":"60998443"},{"groupId":"76095406","addonId":"60998432"},{"groupId":"76095406","addonId":"60998433"},{"groupId":"76095406","addonId":"60998434"},{"groupId":"76095406","addonId":"60998435"},{"groupId":"76095415","addonId":"60999886"},{"groupId":"76095416","addonId":"60999896"},{"groupId":"76095410","addonId":"60998438"},{"groupId":"76095410","addonId":"60998439"},{"groupId":"76095414","addonId":"60999887"},{"groupId":"76095414","addonId":"60999888"},{"groupId":"76095414","addonId":"60999889"},{"groupId":"76095414","addonId":"60999890"},{"groupId":"76095414","addonId":"60999891"},{"groupId":"76095414","addonId":"60999892"},{"groupId":"76095414","addonId":"60999893"},{"groupId":"76095414","addonId":"60999894"},{"groupId":"76095414","addonId":"60999895"}]}]},"addons":[{"groupId":"76095405","groupName":"Extra Toppings [8 Inches]","choices":[{"id":"60999869","name":"Zucchini","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999865","name":"Paneer","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999866","name":"Broccoli","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999867","name":"Capsicum","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999868","name":"Red Paprika","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999872","name":"Olive","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999873","name":"Jalapeno","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999870","name":"Onion","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999871","name":"Corn","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095414","groupName":"Extra Toppings [12 Inches]","choices":[{"id":"60999887","name":"Paneer","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999888","name":"Broccoli","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999889","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999894","name":"Olive","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999895","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999890","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999891","name":"Zucchini","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999892","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999893","name":"Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095411","groupName":"Extra Toppings [10 Inches]","choices":[{"id":"60999876","name":"Paneer","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999877","name":"Broccoli","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999878","name":"Capsicum","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999879","name":"Red Paprika","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999883","name":"Olive","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999884","name":"Jalapeno","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999880","name":"Zucchini","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999881","name":"Onion","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999882","name":"Corn","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095406","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095407","groupName":"Extra Cheese brust [Reg]","choices":[{"id":"60999864","name":"Cheese Brust","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095412","groupName":"Extra Cheese brust [Med]","choices":[{"id":"60999875","name":"Cheese Brust","price":10000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095415","groupName":"Extra Cheese brust [Large]","choices":[{"id":"60999886","name":"Cheese Brust","price":13000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095409","groupName":"Extra Cheese [regular]","choices":[{"id":"60999874","name":"Extra Cheese","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095413","groupName":"Extra [medium]","choices":[{"id":"60999885","name":"Extra Cheese","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095416","groupName":"Extras [large]","choices":[{"id":"60999896","name":"Extra Cheese","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095410","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"defaultPrice":14800,"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"type":"ITEM","itemBadge":{},"badgesV2":{},"isBestseller":true,"ratings":{"aggregatedRating":{"rating":"4.1","ratingCount":"67 ratings","ratingCountV2":"67"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"109225812","name":"Punjabi Pizza","category":"Pizza","description":"Onion, capcicum, tomato, paneer with cheese blend and mozrella cheese","imageId":"3cc56b8250110edff311cd94fc4ccbaf","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"23987188","name":"Portion","variations":[{"name":"Regular [8 Inches]","price":185,"default":1,"id":"77571799","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Medium [10 Inches]","price":285,"id":"77571800","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Large [12 Inches]","price":385,"id":"77571801","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"23987188","variationId":"77571799"}],"price":18500,"addonCombinations":[{"groupId":"76095276","addonId":"60999865"},{"groupId":"76095276","addonId":"60999866"},{"groupId":"76095276","addonId":"60999867"},{"groupId":"76095276","addonId":"60999868"},{"groupId":"76095276","addonId":"60999869"},{"groupId":"76095276","addonId":"60999870"},{"groupId":"76095276","addonId":"60999871"},{"groupId":"76095276","addonId":"60999872"},{"groupId":"76095276","addonId":"60999873"},{"groupId":"76095277","addonId":"60998441"},{"groupId":"76095277","addonId":"60998442"},{"groupId":"76095277","addonId":"60998443"},{"groupId":"76095277","addonId":"60998432"},{"groupId":"76095277","addonId":"60998433"},{"groupId":"76095277","addonId":"60998434"},{"groupId":"76095277","addonId":"60998435"},{"groupId":"115661956","addonId":"60999864"},{"groupId":"76095279","addonId":"60999874"},{"groupId":"76095280","addonId":"60998438"},{"groupId":"76095280","addonId":"60998439"}]},{"variations":[{"groupId":"23987188","variationId":"77571800"}],"price":28500,"addonCombinations":[{"groupId":"76095281","addonId":"60999876"},{"groupId":"76095281","addonId":"60999877"},{"groupId":"76095281","addonId":"60999878"},{"groupId":"76095281","addonId":"60999879"},{"groupId":"76095281","addonId":"60999880"},{"groupId":"76095281","addonId":"60999881"},{"groupId":"76095281","addonId":"60999882"},{"groupId":"76095281","addonId":"60999883"},{"groupId":"76095281","addonId":"60999884"},{"groupId":"76095277","addonId":"60998441"},{"groupId":"76095277","addonId":"60998442"},{"groupId":"76095277","addonId":"60998443"},{"groupId":"76095277","addonId":"60998432"},{"groupId":"76095277","addonId":"60998433"},{"groupId":"76095277","addonId":"60998434"},{"groupId":"76095277","addonId":"60998435"},{"groupId":"76095282","addonId":"60999885"},{"groupId":"76095280","addonId":"60998438"},{"groupId":"76095280","addonId":"60998439"},{"groupId":"115661955","addonId":"60999875"}]},{"variations":[{"groupId":"23987188","variationId":"77571801"}],"price":38500,"addonCombinations":[{"groupId":"76095277","addonId":"60998441"},{"groupId":"76095277","addonId":"60998442"},{"groupId":"76095277","addonId":"60998443"},{"groupId":"76095277","addonId":"60998432"},{"groupId":"76095277","addonId":"60998433"},{"groupId":"76095277","addonId":"60998434"},{"groupId":"76095277","addonId":"60998435"},{"groupId":"115661954","addonId":"60999886"},{"groupId":"76095284","addonId":"60999896"},{"groupId":"76095280","addonId":"60998438"},{"groupId":"76095280","addonId":"60998439"},{"groupId":"76095283","addonId":"60999887"},{"groupId":"76095283","addonId":"60999888"},{"groupId":"76095283","addonId":"60999889"},{"groupId":"76095283","addonId":"60999890"},{"groupId":"76095283","addonId":"60999891"},{"groupId":"76095283","addonId":"60999892"},{"groupId":"76095283","addonId":"60999893"},{"groupId":"76095283","addonId":"60999894"},{"groupId":"76095283","addonId":"60999895"}]}]},"addons":[{"groupId":"76095276","groupName":"Extra Toppings [8 Inches]","choices":[{"id":"60999869","name":"Zucchini","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999865","name":"Paneer","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999866","name":"Broccoli","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999867","name":"Capsicum","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999868","name":"Red Paprika","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999872","name":"Olive","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999873","name":"Jalapeno","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999870","name":"Onion","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999871","name":"Corn","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095283","groupName":"Extra Toppings [12 Inches]","choices":[{"id":"60999887","name":"Paneer","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999888","name":"Broccoli","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999889","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999894","name":"Olive","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999895","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999890","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999891","name":"Zucchini","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999892","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999893","name":"Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095281","groupName":"Extra Toppings [10 Inches]","choices":[{"id":"60999876","name":"Paneer","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999877","name":"Broccoli","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999878","name":"Capsicum","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999879","name":"Red Paprika","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999883","name":"Olive","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999884","name":"Jalapeno","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999880","name":"Zucchini","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999881","name":"Onion","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999882","name":"Corn","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"76095277","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661956","groupName":"Extra Cheese brust [Reg]","choices":[{"id":"60999864","name":"Cheese Brust","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661955","groupName":"Extra Cheese brust [Med]","choices":[{"id":"60999875","name":"Cheese Brust","price":10000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661954","groupName":"Extra Cheese brust [Large]","choices":[{"id":"60999886","name":"Cheese Brust","price":13000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095279","groupName":"Extra Cheese [regular]","choices":[{"id":"60999874","name":"Extra Cheese","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095282","groupName":"Extra [medium]","choices":[{"id":"60999885","name":"Extra Cheese","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095284","groupName":"Extras [large]","choices":[{"id":"60999896","name":"Extra Cheese","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"76095280","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"defaultPrice":18500,"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"type":"ITEM","itemBadge":{},"badgesV2":{},"isBestseller":true,"ratings":{"aggregatedRating":{"rating":"4.1","ratingCount":"68 ratings","ratingCountV2":"68"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"125911161","name":"Cappsicum & Paneer Pizza.","category":"Pizza","description":"Cappsicum, Paneer, mozzarella & processed cheese","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"33087254","name":"Size","variations":[{"name":"Regular","price":178,"default":1,"id":"102396772","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Medium","price":278,"id":"102396773","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Large","price":378,"id":"102396774","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"33087254","variationId":"102396772"}],"price":17800,"addonCombinations":[{"groupId":"115661836","addonId":"60999865"},{"groupId":"115661836","addonId":"60999866"},{"groupId":"115661836","addonId":"60999867"},{"groupId":"115661836","addonId":"60999868"},{"groupId":"115661836","addonId":"60999869"},{"groupId":"115661836","addonId":"60999870"},{"groupId":"115661836","addonId":"60999871"},{"groupId":"115661836","addonId":"60999872"},{"groupId":"115661836","addonId":"60999873"},{"groupId":"115661837","addonId":"60999864"},{"groupId":"115661838","addonId":"60999874"},{"groupId":"115661839","addonId":"60998438"},{"groupId":"115661839","addonId":"60998439"},{"groupId":"115661840","addonId":"60998441"},{"groupId":"115661840","addonId":"60998442"},{"groupId":"115661840","addonId":"60998443"},{"groupId":"115661840","addonId":"60998432"},{"groupId":"115661840","addonId":"60998433"},{"groupId":"115661840","addonId":"60998434"},{"groupId":"115661840","addonId":"60998435"}]},{"variations":[{"groupId":"33087254","variationId":"102396773"}],"price":27800,"addonCombinations":[{"groupId":"115661845","addonId":"60999876"},{"groupId":"115661845","addonId":"60999877"},{"groupId":"115661845","addonId":"60999878"},{"groupId":"115661845","addonId":"60999879"},{"groupId":"115661845","addonId":"60999880"},{"groupId":"115661845","addonId":"60999881"},{"groupId":"115661845","addonId":"60999882"},{"groupId":"115661845","addonId":"60999883"},{"groupId":"115661845","addonId":"60999884"},{"groupId":"115661842","addonId":"60999885"},{"groupId":"115661839","addonId":"60998438"},{"groupId":"115661839","addonId":"60998439"},{"groupId":"115661840","addonId":"60998441"},{"groupId":"115661840","addonId":"60998442"},{"groupId":"115661840","addonId":"60998443"},{"groupId":"115661840","addonId":"60998432"},{"groupId":"115661840","addonId":"60998433"},{"groupId":"115661840","addonId":"60998434"},{"groupId":"115661840","addonId":"60998435"},{"groupId":"115661844","addonId":"60999875"}]},{"variations":[{"groupId":"33087254","variationId":"102396774"}],"price":37800,"addonCombinations":[{"groupId":"115661843","addonId":"60999886"},{"groupId":"115661841","addonId":"60999896"},{"groupId":"115661839","addonId":"60998438"},{"groupId":"115661839","addonId":"60998439"},{"groupId":"115661840","addonId":"60998441"},{"groupId":"115661840","addonId":"60998442"},{"groupId":"115661840","addonId":"60998443"},{"groupId":"115661840","addonId":"60998432"},{"groupId":"115661840","addonId":"60998433"},{"groupId":"115661840","addonId":"60998434"},{"groupId":"115661840","addonId":"60998435"},{"groupId":"115661846","addonId":"60999887"},{"groupId":"115661846","addonId":"60999888"},{"groupId":"115661846","addonId":"60999889"},{"groupId":"115661846","addonId":"60999890"},{"groupId":"115661846","addonId":"60999891"},{"groupId":"115661846","addonId":"60999892"},{"groupId":"115661846","addonId":"60999893"},{"groupId":"115661846","addonId":"60999894"},{"groupId":"115661846","addonId":"60999895"}]}]},"addons":[{"groupId":"115661836","groupName":"Extra Toppings [8 Inches]","choices":[{"id":"60999869","name":"Zucchini","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999865","name":"Paneer","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999866","name":"Broccoli","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999867","name":"Capsicum","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999868","name":"Red Paprika","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999872","name":"Olive","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999873","name":"Jalapeno","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999870","name":"Onion","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999871","name":"Corn","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"115661846","groupName":"Extra Toppings [12 Inches]","choices":[{"id":"60999887","name":"Paneer","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999888","name":"Broccoli","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999889","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999894","name":"Olive","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999895","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999890","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999891","name":"Zucchini","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999892","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999893","name":"Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"115661845","groupName":"Extra Toppings [10 Inches]","choices":[{"id":"60999876","name":"Paneer","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999877","name":"Broccoli","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999878","name":"Capsicum","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999879","name":"Red Paprika","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999883","name":"Olive","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999884","name":"Jalapeno","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999880","name":"Zucchini","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999881","name":"Onion","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999882","name":"Corn","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"115661840","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661837","groupName":"Extra Cheese brust [Reg]","choices":[{"id":"60999864","name":"Cheese Brust","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661844","groupName":"Extra Cheese brust [Med]","choices":[{"id":"60999875","name":"Cheese Brust","price":10000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661843","groupName":"Extra Cheese brust [Large]","choices":[{"id":"60999886","name":"Cheese Brust","price":13000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661838","groupName":"Extra Cheese [regular]","choices":[{"id":"60999874","name":"Extra Cheese","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661842","groupName":"Extra [medium]","choices":[{"id":"60999885","name":"Extra Cheese","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661841","groupName":"Extras [large]","choices":[{"id":"60999896","name":"Extra Cheese","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661839","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"defaultPrice":17800,"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"125911162","name":"Corn & Cappsicum Pizza","category":"Pizza","description":"( hot cheese, sliced &corn with spices)","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"33087255","name":"Portion","variations":[{"name":"Regular [8 Inches]","price":178,"default":1,"id":"102396775","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Medium [10 Inches]","price":278,"id":"102396776","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Large [12 Inches]","price":378,"id":"102396777","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"33087255","variationId":"102396775"}],"price":17800,"addonCombinations":[{"groupId":"115661847","addonId":"60998438"},{"groupId":"115661847","addonId":"60998439"},{"groupId":"115661850","addonId":"60999874"},{"groupId":"115661853","addonId":"60999864"},{"groupId":"115661854","addonId":"60998441"},{"groupId":"115661854","addonId":"60998442"},{"groupId":"115661854","addonId":"60998443"},{"groupId":"115661854","addonId":"60998432"},{"groupId":"115661854","addonId":"60998433"},{"groupId":"115661854","addonId":"60998434"},{"groupId":"115661854","addonId":"60998435"},{"groupId":"115661857","addonId":"60999865"},{"groupId":"115661857","addonId":"60999866"},{"groupId":"115661857","addonId":"60999867"},{"groupId":"115661857","addonId":"60999868"},{"groupId":"115661857","addonId":"60999869"},{"groupId":"115661857","addonId":"60999870"},{"groupId":"115661857","addonId":"60999871"},{"groupId":"115661857","addonId":"60999872"},{"groupId":"115661857","addonId":"60999873"}]},{"variations":[{"groupId":"33087255","variationId":"102396776"}],"price":27800,"addonCombinations":[{"groupId":"115661847","addonId":"60998438"},{"groupId":"115661847","addonId":"60998439"},{"groupId":"115661849","addonId":"60999885"},{"groupId":"115661854","addonId":"60998441"},{"groupId":"115661854","addonId":"60998442"},{"groupId":"115661854","addonId":"60998443"},{"groupId":"115661854","addonId":"60998432"},{"groupId":"115661854","addonId":"60998433"},{"groupId":"115661854","addonId":"60998434"},{"groupId":"115661854","addonId":"60998435"},{"groupId":"115661855","addonId":"60999876"},{"groupId":"115661855","addonId":"60999877"},{"groupId":"115661855","addonId":"60999878"},{"groupId":"115661855","addonId":"60999879"},{"groupId":"115661855","addonId":"60999880"},{"groupId":"115661855","addonId":"60999881"},{"groupId":"115661855","addonId":"60999882"},{"groupId":"115661855","addonId":"60999883"},{"groupId":"115661855","addonId":"60999884"},{"groupId":"115661852","addonId":"60999875"}]},{"variations":[{"groupId":"33087255","variationId":"102396777"}],"price":37800,"addonCombinations":[{"groupId":"115661847","addonId":"60998438"},{"groupId":"115661847","addonId":"60998439"},{"groupId":"115661848","addonId":"60999896"},{"groupId":"115661851","addonId":"60999886"},{"groupId":"115661854","addonId":"60998441"},{"groupId":"115661854","addonId":"60998442"},{"groupId":"115661854","addonId":"60998443"},{"groupId":"115661854","addonId":"60998432"},{"groupId":"115661854","addonId":"60998433"},{"groupId":"115661854","addonId":"60998434"},{"groupId":"115661854","addonId":"60998435"},{"groupId":"115661856","addonId":"60999887"},{"groupId":"115661856","addonId":"60999888"},{"groupId":"115661856","addonId":"60999889"},{"groupId":"115661856","addonId":"60999890"},{"groupId":"115661856","addonId":"60999891"},{"groupId":"115661856","addonId":"60999892"},{"groupId":"115661856","addonId":"60999893"},{"groupId":"115661856","addonId":"60999894"},{"groupId":"115661856","addonId":"60999895"}]}]},"addons":[{"groupId":"115661857","groupName":"Extra Toppings [8 Inches]","choices":[{"id":"60999869","name":"Zucchini","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999865","name":"Paneer","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999866","name":"Broccoli","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999867","name":"Capsicum","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999868","name":"Red Paprika","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999872","name":"Olive","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999873","name":"Jalapeno","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999870","name":"Onion","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999871","name":"Corn","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"115661856","groupName":"Extra Toppings [12 Inches]","choices":[{"id":"60999887","name":"Paneer","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999888","name":"Broccoli","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999889","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999894","name":"Olive","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999895","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999890","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999891","name":"Zucchini","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999892","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999893","name":"Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"115661855","groupName":"Extra Toppings [10 Inches]","choices":[{"id":"60999876","name":"Paneer","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999877","name":"Broccoli","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999878","name":"Capsicum","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999879","name":"Red Paprika","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999883","name":"Olive","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999884","name":"Jalapeno","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999880","name":"Zucchini","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999881","name":"Onion","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999882","name":"Corn","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"115661854","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661853","groupName":"Extra Cheese brust [Reg]","choices":[{"id":"60999864","name":"Cheese Brust","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661852","groupName":"Extra Cheese brust [Med]","choices":[{"id":"60999875","name":"Cheese Brust","price":10000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661851","groupName":"Extra Cheese brust [Large]","choices":[{"id":"60999886","name":"Cheese Brust","price":13000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661850","groupName":"Extra Cheese [regular]","choices":[{"id":"60999874","name":"Extra Cheese","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661849","groupName":"Extra [medium]","choices":[{"id":"60999885","name":"Extra Cheese","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661848","groupName":"Extras [large]","choices":[{"id":"60999896","name":"Extra Cheese","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661847","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"defaultPrice":17800,"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"125911163","name":"Indian Veg Pizza","category":"Pizza","description":"( onion, cappsicum, tomato, garlic, green chili, jelphino )","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"33087256","name":"Portion","variations":[{"name":"Regular [8 Inches]","price":210,"default":1,"id":"102396778","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Medium [10 Inches]","price":330,"id":"102396779","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Large [12 Inches]","price":430,"id":"102396780","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"33087256","variationId":"102396778"}],"price":21000,"addonCombinations":[{"groupId":"115661858","addonId":"60998438"},{"groupId":"115661858","addonId":"60998439"},{"groupId":"115661861","addonId":"60999874"},{"groupId":"115661864","addonId":"60999864"},{"groupId":"115661865","addonId":"60998441"},{"groupId":"115661865","addonId":"60998442"},{"groupId":"115661865","addonId":"60998443"},{"groupId":"115661865","addonId":"60998432"},{"groupId":"115661865","addonId":"60998433"},{"groupId":"115661865","addonId":"60998434"},{"groupId":"115661865","addonId":"60998435"},{"groupId":"115661868","addonId":"60999865"},{"groupId":"115661868","addonId":"60999866"},{"groupId":"115661868","addonId":"60999867"},{"groupId":"115661868","addonId":"60999868"},{"groupId":"115661868","addonId":"60999869"},{"groupId":"115661868","addonId":"60999870"},{"groupId":"115661868","addonId":"60999871"},{"groupId":"115661868","addonId":"60999872"},{"groupId":"115661868","addonId":"60999873"}]},{"variations":[{"groupId":"33087256","variationId":"102396779"}],"price":33000,"addonCombinations":[{"groupId":"115661858","addonId":"60998438"},{"groupId":"115661858","addonId":"60998439"},{"groupId":"115661860","addonId":"60999885"},{"groupId":"115661865","addonId":"60998441"},{"groupId":"115661865","addonId":"60998442"},{"groupId":"115661865","addonId":"60998443"},{"groupId":"115661865","addonId":"60998432"},{"groupId":"115661865","addonId":"60998433"},{"groupId":"115661865","addonId":"60998434"},{"groupId":"115661865","addonId":"60998435"},{"groupId":"115661866","addonId":"60999876"},{"groupId":"115661866","addonId":"60999877"},{"groupId":"115661866","addonId":"60999878"},{"groupId":"115661866","addonId":"60999879"},{"groupId":"115661866","addonId":"60999880"},{"groupId":"115661866","addonId":"60999881"},{"groupId":"115661866","addonId":"60999882"},{"groupId":"115661866","addonId":"60999883"},{"groupId":"115661866","addonId":"60999884"},{"groupId":"115661863","addonId":"60999875"}]},{"variations":[{"groupId":"33087256","variationId":"102396780"}],"price":43000,"addonCombinations":[{"groupId":"115661858","addonId":"60998438"},{"groupId":"115661858","addonId":"60998439"},{"groupId":"115661859","addonId":"60999896"},{"groupId":"115661862","addonId":"60999886"},{"groupId":"115661865","addonId":"60998441"},{"groupId":"115661865","addonId":"60998442"},{"groupId":"115661865","addonId":"60998443"},{"groupId":"115661865","addonId":"60998432"},{"groupId":"115661865","addonId":"60998433"},{"groupId":"115661865","addonId":"60998434"},{"groupId":"115661865","addonId":"60998435"},{"groupId":"115661867","addonId":"60999887"},{"groupId":"115661867","addonId":"60999888"},{"groupId":"115661867","addonId":"60999889"},{"groupId":"115661867","addonId":"60999890"},{"groupId":"115661867","addonId":"60999891"},{"groupId":"115661867","addonId":"60999892"},{"groupId":"115661867","addonId":"60999893"},{"groupId":"115661867","addonId":"60999894"},{"groupId":"115661867","addonId":"60999895"}]}]},"addons":[{"groupId":"115661868","groupName":"Extra Toppings [8 Inches]","choices":[{"id":"60999869","name":"Zucchini","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999865","name":"Paneer","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999866","name":"Broccoli","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999867","name":"Capsicum","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999868","name":"Red Paprika","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999872","name":"Olive","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999873","name":"Jalapeno","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999870","name":"Onion","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999871","name":"Corn","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"115661867","groupName":"Extra Toppings [12 Inches]","choices":[{"id":"60999887","name":"Paneer","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999888","name":"Broccoli","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999889","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999894","name":"Olive","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999895","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999890","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999891","name":"Zucchini","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999892","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999893","name":"Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"115661866","groupName":"Extra Toppings [10 Inches]","choices":[{"id":"60999876","name":"Paneer","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999877","name":"Broccoli","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999878","name":"Capsicum","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999879","name":"Red Paprika","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999883","name":"Olive","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999884","name":"Jalapeno","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999880","name":"Zucchini","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999881","name":"Onion","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999882","name":"Corn","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"115661865","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661864","groupName":"Extra Cheese brust [Reg]","choices":[{"id":"60999864","name":"Cheese Brust","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661863","groupName":"Extra Cheese brust [Med]","choices":[{"id":"60999875","name":"Cheese Brust","price":10000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661862","groupName":"Extra Cheese brust [Large]","choices":[{"id":"60999886","name":"Cheese Brust","price":13000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661861","groupName":"Extra Cheese [regular]","choices":[{"id":"60999874","name":"Extra Cheese","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661860","groupName":"Extra [medium]","choices":[{"id":"60999885","name":"Extra Cheese","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661859","groupName":"Extras [large]","choices":[{"id":"60999896","name":"Extra Cheese","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661858","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"defaultPrice":21000,"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"125911164","name":"Onion & Corn Pizza","category":"Pizza","description":"( hot cheese, sliced onion and corn)","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"33087257","name":"Portion","variations":[{"name":"Regular [8 Inches]","price":178,"default":1,"id":"102396781","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Medium [10 Inches]","price":278,"id":"102396782","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Large [12 Inches]","price":378,"id":"102396783","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"33087257","variationId":"102396781"}],"price":17800,"addonCombinations":[{"groupId":"115661869","addonId":"60998438"},{"groupId":"115661869","addonId":"60998439"},{"groupId":"115661872","addonId":"60999874"},{"groupId":"115661875","addonId":"60999864"},{"groupId":"115661876","addonId":"60998441"},{"groupId":"115661876","addonId":"60998442"},{"groupId":"115661876","addonId":"60998443"},{"groupId":"115661876","addonId":"60998432"},{"groupId":"115661876","addonId":"60998433"},{"groupId":"115661876","addonId":"60998434"},{"groupId":"115661876","addonId":"60998435"},{"groupId":"115661879","addonId":"60999865"},{"groupId":"115661879","addonId":"60999866"},{"groupId":"115661879","addonId":"60999867"},{"groupId":"115661879","addonId":"60999868"},{"groupId":"115661879","addonId":"60999869"},{"groupId":"115661879","addonId":"60999870"},{"groupId":"115661879","addonId":"60999871"},{"groupId":"115661879","addonId":"60999872"},{"groupId":"115661879","addonId":"60999873"}]},{"variations":[{"groupId":"33087257","variationId":"102396782"}],"price":27800,"addonCombinations":[{"groupId":"115661869","addonId":"60998438"},{"groupId":"115661869","addonId":"60998439"},{"groupId":"115661871","addonId":"60999885"},{"groupId":"115661876","addonId":"60998441"},{"groupId":"115661876","addonId":"60998442"},{"groupId":"115661876","addonId":"60998443"},{"groupId":"115661876","addonId":"60998432"},{"groupId":"115661876","addonId":"60998433"},{"groupId":"115661876","addonId":"60998434"},{"groupId":"115661876","addonId":"60998435"},{"groupId":"115661877","addonId":"60999876"},{"groupId":"115661877","addonId":"60999877"},{"groupId":"115661877","addonId":"60999878"},{"groupId":"115661877","addonId":"60999879"},{"groupId":"115661877","addonId":"60999880"},{"groupId":"115661877","addonId":"60999881"},{"groupId":"115661877","addonId":"60999882"},{"groupId":"115661877","addonId":"60999883"},{"groupId":"115661877","addonId":"60999884"},{"groupId":"115661874","addonId":"60999875"}]},{"variations":[{"groupId":"33087257","variationId":"102396783"}],"price":37800,"addonCombinations":[{"groupId":"115661869","addonId":"60998438"},{"groupId":"115661869","addonId":"60998439"},{"groupId":"115661870","addonId":"60999896"},{"groupId":"115661873","addonId":"60999886"},{"groupId":"115661876","addonId":"60998441"},{"groupId":"115661876","addonId":"60998442"},{"groupId":"115661876","addonId":"60998443"},{"groupId":"115661876","addonId":"60998432"},{"groupId":"115661876","addonId":"60998433"},{"groupId":"115661876","addonId":"60998434"},{"groupId":"115661876","addonId":"60998435"},{"groupId":"115661878","addonId":"60999887"},{"groupId":"115661878","addonId":"60999888"},{"groupId":"115661878","addonId":"60999889"},{"groupId":"115661878","addonId":"60999890"},{"groupId":"115661878","addonId":"60999891"},{"groupId":"115661878","addonId":"60999892"},{"groupId":"115661878","addonId":"60999893"},{"groupId":"115661878","addonId":"60999894"},{"groupId":"115661878","addonId":"60999895"}]}]},"addons":[{"groupId":"115661879","groupName":"Extra Toppings [8 Inches]","choices":[{"id":"60999869","name":"Zucchini","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999865","name":"Paneer","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999866","name":"Broccoli","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999867","name":"Capsicum","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999868","name":"Red Paprika","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999872","name":"Olive","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999873","name":"Jalapeno","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999870","name":"Onion","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999871","name":"Corn","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"115661878","groupName":"Extra Toppings [12 Inches]","choices":[{"id":"60999887","name":"Paneer","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999888","name":"Broccoli","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999889","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999894","name":"Olive","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999895","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999890","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999891","name":"Zucchini","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999892","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999893","name":"Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"115661877","groupName":"Extra Toppings [10 Inches]","choices":[{"id":"60999876","name":"Paneer","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999877","name":"Broccoli","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999878","name":"Capsicum","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999879","name":"Red Paprika","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999883","name":"Olive","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999884","name":"Jalapeno","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999880","name":"Zucchini","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999881","name":"Onion","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999882","name":"Corn","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"115661876","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661875","groupName":"Extra Cheese brust [Reg]","choices":[{"id":"60999864","name":"Cheese Brust","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661874","groupName":"Extra Cheese brust [Med]","choices":[{"id":"60999875","name":"Cheese Brust","price":10000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661873","groupName":"Extra Cheese brust [Large]","choices":[{"id":"60999886","name":"Cheese Brust","price":13000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661872","groupName":"Extra Cheese [regular]","choices":[{"id":"60999874","name":"Extra Cheese","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661871","groupName":"Extra [medium]","choices":[{"id":"60999885","name":"Extra Cheese","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661870","groupName":"Extras [large]","choices":[{"id":"60999896","name":"Extra Cheese","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661869","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"defaultPrice":17800,"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"125911165","name":"Onion & Pineapple Pizza","category":"Pizza","description":"( hot cheese , sliced onion & pineapple cheese)","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"33087258","name":"Portion","variations":[{"name":"Regular [8 Inches]","price":178,"default":1,"id":"102396784","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Medium [10 Inches]","price":278,"id":"102396785","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Large [12 Inches]","price":378,"id":"102396786","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"33087258","variationId":"102396784"}],"price":17800,"addonCombinations":[{"groupId":"115661880","addonId":"60998438"},{"groupId":"115661880","addonId":"60998439"},{"groupId":"115661883","addonId":"60999874"},{"groupId":"115661886","addonId":"60999864"},{"groupId":"115661887","addonId":"60998441"},{"groupId":"115661887","addonId":"60998442"},{"groupId":"115661887","addonId":"60998443"},{"groupId":"115661887","addonId":"60998432"},{"groupId":"115661887","addonId":"60998433"},{"groupId":"115661887","addonId":"60998434"},{"groupId":"115661887","addonId":"60998435"},{"groupId":"115661890","addonId":"60999865"},{"groupId":"115661890","addonId":"60999866"},{"groupId":"115661890","addonId":"60999867"},{"groupId":"115661890","addonId":"60999868"},{"groupId":"115661890","addonId":"60999869"},{"groupId":"115661890","addonId":"60999870"},{"groupId":"115661890","addonId":"60999871"},{"groupId":"115661890","addonId":"60999872"},{"groupId":"115661890","addonId":"60999873"}]},{"variations":[{"groupId":"33087258","variationId":"102396785"}],"price":27800,"addonCombinations":[{"groupId":"115661880","addonId":"60998438"},{"groupId":"115661880","addonId":"60998439"},{"groupId":"115661882","addonId":"60999885"},{"groupId":"115661887","addonId":"60998441"},{"groupId":"115661887","addonId":"60998442"},{"groupId":"115661887","addonId":"60998443"},{"groupId":"115661887","addonId":"60998432"},{"groupId":"115661887","addonId":"60998433"},{"groupId":"115661887","addonId":"60998434"},{"groupId":"115661887","addonId":"60998435"},{"groupId":"115661888","addonId":"60999876"},{"groupId":"115661888","addonId":"60999877"},{"groupId":"115661888","addonId":"60999878"},{"groupId":"115661888","addonId":"60999879"},{"groupId":"115661888","addonId":"60999880"},{"groupId":"115661888","addonId":"60999881"},{"groupId":"115661888","addonId":"60999882"},{"groupId":"115661888","addonId":"60999883"},{"groupId":"115661888","addonId":"60999884"},{"groupId":"115661885","addonId":"60999875"}]},{"variations":[{"groupId":"33087258","variationId":"102396786"}],"price":37800,"addonCombinations":[{"groupId":"115661880","addonId":"60998438"},{"groupId":"115661880","addonId":"60998439"},{"groupId":"115661881","addonId":"60999896"},{"groupId":"115661884","addonId":"60999886"},{"groupId":"115661887","addonId":"60998441"},{"groupId":"115661887","addonId":"60998442"},{"groupId":"115661887","addonId":"60998443"},{"groupId":"115661887","addonId":"60998432"},{"groupId":"115661887","addonId":"60998433"},{"groupId":"115661887","addonId":"60998434"},{"groupId":"115661887","addonId":"60998435"},{"groupId":"115661889","addonId":"60999887"},{"groupId":"115661889","addonId":"60999888"},{"groupId":"115661889","addonId":"60999889"},{"groupId":"115661889","addonId":"60999890"},{"groupId":"115661889","addonId":"60999891"},{"groupId":"115661889","addonId":"60999892"},{"groupId":"115661889","addonId":"60999893"},{"groupId":"115661889","addonId":"60999894"},{"groupId":"115661889","addonId":"60999895"}]}]},"addons":[{"groupId":"115661890","groupName":"Extra Toppings [8 Inches]","choices":[{"id":"60999869","name":"Zucchini","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999865","name":"Paneer","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999866","name":"Broccoli","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999867","name":"Capsicum","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999868","name":"Red Paprika","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999872","name":"Olive","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999873","name":"Jalapeno","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999870","name":"Onion","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999871","name":"Corn","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"115661889","groupName":"Extra Toppings [12 Inches]","choices":[{"id":"60999887","name":"Paneer","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999888","name":"Broccoli","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999889","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999894","name":"Olive","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999895","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999890","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999891","name":"Zucchini","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999892","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999893","name":"Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"115661888","groupName":"Extra Toppings [10 Inches]","choices":[{"id":"60999876","name":"Paneer","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999877","name":"Broccoli","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999878","name":"Capsicum","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999879","name":"Red Paprika","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999883","name":"Olive","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999884","name":"Jalapeno","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999880","name":"Zucchini","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999881","name":"Onion","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999882","name":"Corn","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"115661887","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661886","groupName":"Extra Cheese brust [Reg]","choices":[{"id":"60999864","name":"Cheese Brust","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661885","groupName":"Extra Cheese brust [Med]","choices":[{"id":"60999875","name":"Cheese Brust","price":10000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661884","groupName":"Extra Cheese brust [Large]","choices":[{"id":"60999886","name":"Cheese Brust","price":13000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661883","groupName":"Extra Cheese [regular]","choices":[{"id":"60999874","name":"Extra Cheese","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661882","groupName":"Extra [medium]","choices":[{"id":"60999885","name":"Extra Cheese","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661881","groupName":"Extras [large]","choices":[{"id":"60999896","name":"Extra Cheese","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661880","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"defaultPrice":17800,"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"125911166","name":"Veg Corn Pizza","category":"Pizza","description":"( onion & cappsicum sweet corn serve with mozarella cheese)","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"33087259","name":"Portion","variations":[{"name":"Regular [8 Inches]","price":148,"default":1,"id":"102396787","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Medium [10 Inches]","price":248,"id":"102396788","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Large [12 Inches]","price":348,"id":"102396789","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"33087259","variationId":"102396787"}],"price":14800,"addonCombinations":[{"groupId":"115661891","addonId":"60998438"},{"groupId":"115661891","addonId":"60998439"},{"groupId":"115661894","addonId":"60999874"},{"groupId":"115661897","addonId":"60999864"},{"groupId":"115661898","addonId":"60998441"},{"groupId":"115661898","addonId":"60998442"},{"groupId":"115661898","addonId":"60998443"},{"groupId":"115661898","addonId":"60998432"},{"groupId":"115661898","addonId":"60998433"},{"groupId":"115661898","addonId":"60998434"},{"groupId":"115661898","addonId":"60998435"},{"groupId":"115661901","addonId":"60999865"},{"groupId":"115661901","addonId":"60999866"},{"groupId":"115661901","addonId":"60999867"},{"groupId":"115661901","addonId":"60999868"},{"groupId":"115661901","addonId":"60999869"},{"groupId":"115661901","addonId":"60999870"},{"groupId":"115661901","addonId":"60999871"},{"groupId":"115661901","addonId":"60999872"},{"groupId":"115661901","addonId":"60999873"}]},{"variations":[{"groupId":"33087259","variationId":"102396788"}],"price":24800,"addonCombinations":[{"groupId":"115661891","addonId":"60998438"},{"groupId":"115661891","addonId":"60998439"},{"groupId":"115661893","addonId":"60999885"},{"groupId":"115661898","addonId":"60998441"},{"groupId":"115661898","addonId":"60998442"},{"groupId":"115661898","addonId":"60998443"},{"groupId":"115661898","addonId":"60998432"},{"groupId":"115661898","addonId":"60998433"},{"groupId":"115661898","addonId":"60998434"},{"groupId":"115661898","addonId":"60998435"},{"groupId":"115661899","addonId":"60999876"},{"groupId":"115661899","addonId":"60999877"},{"groupId":"115661899","addonId":"60999878"},{"groupId":"115661899","addonId":"60999879"},{"groupId":"115661899","addonId":"60999880"},{"groupId":"115661899","addonId":"60999881"},{"groupId":"115661899","addonId":"60999882"},{"groupId":"115661899","addonId":"60999883"},{"groupId":"115661899","addonId":"60999884"},{"groupId":"115661896","addonId":"60999875"}]},{"variations":[{"groupId":"33087259","variationId":"102396789"}],"price":34800,"addonCombinations":[{"groupId":"115661891","addonId":"60998438"},{"groupId":"115661891","addonId":"60998439"},{"groupId":"115661892","addonId":"60999896"},{"groupId":"115661895","addonId":"60999886"},{"groupId":"115661898","addonId":"60998441"},{"groupId":"115661898","addonId":"60998442"},{"groupId":"115661898","addonId":"60998443"},{"groupId":"115661898","addonId":"60998432"},{"groupId":"115661898","addonId":"60998433"},{"groupId":"115661898","addonId":"60998434"},{"groupId":"115661898","addonId":"60998435"},{"groupId":"115661900","addonId":"60999887"},{"groupId":"115661900","addonId":"60999888"},{"groupId":"115661900","addonId":"60999889"},{"groupId":"115661900","addonId":"60999890"},{"groupId":"115661900","addonId":"60999891"},{"groupId":"115661900","addonId":"60999892"},{"groupId":"115661900","addonId":"60999893"},{"groupId":"115661900","addonId":"60999894"},{"groupId":"115661900","addonId":"60999895"}]}]},"addons":[{"groupId":"115661901","groupName":"Extra Toppings [8 Inches]","choices":[{"id":"60999869","name":"Zucchini","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999865","name":"Paneer","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999866","name":"Broccoli","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999867","name":"Capsicum","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999868","name":"Red Paprika","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999872","name":"Olive","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999873","name":"Jalapeno","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999870","name":"Onion","price":3000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999871","name":"Corn","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"115661900","groupName":"Extra Toppings [12 Inches]","choices":[{"id":"60999887","name":"Paneer","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999888","name":"Broccoli","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999889","name":"Capsicum","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999894","name":"Olive","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999895","name":"Jalapeno","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999890","name":"Red Paprika","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999891","name":"Zucchini","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999892","name":"Onion","price":7000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999893","name":"Corn","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"115661899","groupName":"Extra Toppings [10 Inches]","choices":[{"id":"60999876","name":"Paneer","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999877","name":"Broccoli","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999878","name":"Capsicum","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999879","name":"Red Paprika","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999883","name":"Olive","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999884","name":"Jalapeno","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999880","name":"Zucchini","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999881","name":"Onion","price":5000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60999882","name":"Corn","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1},{"groupId":"115661898","groupName":"Extra Dip","choices":[{"id":"60998441","name":"Mayonies Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998442","name":"Tandoori Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998443","name":"Chilly Garlic Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998432","name":"Sezwan Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998433","name":"Green Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998434","name":"Red Chilly Dip","price":1500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998435","name":"Chipolata Dip","price":2000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661897","groupName":"Extra Cheese brust [Reg]","choices":[{"id":"60999864","name":"Cheese Brust","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661896","groupName":"Extra Cheese brust [Med]","choices":[{"id":"60999875","name":"Cheese Brust","price":10000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661895","groupName":"Extra Cheese brust [Large]","choices":[{"id":"60999886","name":"Cheese Brust","price":13000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661894","groupName":"Extra Cheese [regular]","choices":[{"id":"60999874","name":"Extra Cheese","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661893","groupName":"Extra [medium]","choices":[{"id":"60999885","name":"Extra Cheese","price":5000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661892","groupName":"Extras [large]","choices":[{"id":"60999896","name":"Extra Cheese","price":7000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"115661891","groupName":"Add On [ketchup]","choices":[{"id":"60998438","name":"1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks","price":500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"60998439","name":"2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks","price":1000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"defaultPrice":14800,"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}}]}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"Chai ","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"104495485","name":"Lemon Green Tea","category":"Chai ","imageId":"d264b33fd32f3ff7ca21a8e0a920023e","inStock":1,"isVeg":1,"price":8000,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"104495486","name":"Kesar Chai","category":"Chai ","imageId":"c5a7038a543dfd7a4449cdaff53174bc","inStock":1,"isVeg":1,"price":9500,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"104495487","name":"Masala Chai","category":"Chai ","imageId":"b64f7527e2aa331c7a1b2c8296e155ac","inStock":1,"isVeg":1,"price":8000,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"104495488","name":"Honey Green Tea","category":"Chai ","imageId":"5d050ac78db1690e710a958daf8d7089","inStock":1,"isVeg":1,"price":8000,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"104495489","name":"Adrak Chai","category":"Chai ","imageId":"3f7c3335d22a6a35cbc310df10e32457","inStock":1,"isVeg":1,"price":8000,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"104495491","name":"Elachi Chai","category":"Chai ","imageId":"8e7c21deca9421ae7637684e870189ca","inStock":1,"isVeg":1,"price":8000,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}}]}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"Hot Coffee ","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"57814676","name":"Hot Coffee","category":"Hot Coffee ","imageId":"f3878586926949ad0a5f856f896fe2dc","inStock":1,"isVeg":1,"price":10500,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"104495460","name":"Black Coffee","category":"Hot Coffee ","inStock":1,"isVeg":1,"price":10500,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"104495462","name":"Irish Cream Coffee","category":"Hot Coffee ","imageId":"6fddef48d74fee4f8d90ebbe97c7cea7","inStock":1,"isVeg":1,"price":11500,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"104495463","name":"Hazelnut Coffee","category":"Hot Coffee ","inStock":1,"isVeg":1,"price":11500,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"104495466","name":"Chocolate Coffee","category":"Hot Coffee ","imageId":"6414973d0ce23655dc4feb3b106ce7f8","inStock":1,"isVeg":1,"price":11500,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"104495467","name":"Caramel Coffee","category":"Hot Coffee ","inStock":1,"isVeg":1,"price":11500,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}}]}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"Mojitos","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"75106466","name":"Mint Mojito","category":"Mojitos","imageId":"2ff92ddd6a14ad6ea99149579bc7ab73","inStock":1,"isVeg":1,"price":13000,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"100777357","name":"Blue Blush Mojito","category":"Mojitos","imageId":"aff39ff5bad9cdcaed337c4e6ab55c73","inStock":1,"isVeg":1,"price":12000,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"100777358","name":"Bubble Gum Mojito","category":"Mojitos","imageId":"e65591fc5006b7cafd4f0a3b1bad9b55","inStock":1,"isVeg":1,"price":12000,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"100777360","name":"Fresh Lemon Mojito","category":"Mojitos","imageId":"b25410adf8448b30f5e060005caf93a5","inStock":1,"isVeg":1,"price":12000,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"100777362","name":"Green Apple Mojito","category":"Mojitos","imageId":"8854196ed46f7fc873d93d15ddfc5008","inStock":1,"isVeg":1,"price":12000,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"100777363","name":"Kala Khata Mojito","category":"Mojitos","imageId":"d2bab1b767aad08cb7198a143af88cd5","inStock":1,"isVeg":1,"price":13000,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"100777365","name":"Malt Beer Flavour Mojito","category":"Mojitos","imageId":"9662796923ff4cfb1324f6aa3a0f55e0","inStock":1,"isVeg":1,"price":12000,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"100777366","name":"Masala Mango Mojito","category":"Mojitos","imageId":"adc7969c6c22a9b43c5d111102749223","inStock":1,"isVeg":1,"price":12000,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"100777367","name":"Peach Ice Tea","category":"Mojitos","imageId":"5944da60ef1e6ca7627f3b413d7b144e","inStock":1,"isVeg":1,"price":13000,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"100777368","name":"Pineapple Chilli Mojito","category":"Mojitos","imageId":"17eb82538583821f2c5ca5ab45e95556","inStock":1,"isVeg":1,"price":12000,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"100777369","name":"Virgin Mojito","category":"Mojitos","imageId":"d1e2f41dc26107c04bb596b868bdd6dd","inStock":1,"isVeg":1,"price":12000,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"100777370","name":"Watermelon Mojito","category":"Mojitos","imageId":"a9992a3410707cb7c6bd8c2863d0d42a","inStock":1,"isVeg":1,"price":12000,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}}]}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory","title":"Desserts And Beverages","categories":[{"title":"Slush\'s","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"57814617","name":"Mango Slush","category":"Desserts And Beverages","inStock":1,"isVeg":1,"price":11000,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"57814621","name":"Blackcurrent Slush","category":"Desserts And Beverages","inStock":1,"isVeg":1,"price":11000,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"57814623","name":"Orange Slush","category":"Desserts And Beverages","inStock":1,"isVeg":1,"price":11000,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"100777688","name":"Kala Khata Ice Slush","category":"Desserts And Beverages","inStock":1,"isVeg":1,"price":11000,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}}]},{"title":"Cold Coffee","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"57814604","name":"Cold Coffee","category":"Desserts And Beverages","imageId":"23c32257784c39309b939bd4cd31f6a4","inStock":1,"isVeg":1,"price":13000,"variants":{},"variantsV2":{},"addons":[{"groupId":"115661907","groupName":"Choose your Ice Cream","choices":[{"id":"60998573","name":"Vanilla Ice Cream","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"1.2","ratingCount":"3 ratings","ratingCountV2":"3"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"104495464","name":"Cold Coffee Frapee","category":"Desserts And Beverages","imageId":"60bfc6a0455cb75ca512d0693aae9631","inStock":1,"isVeg":1,"price":16000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76093558","groupName":"Choose your Ice Cream","choices":[{"id":"60998573","name":"Vanilla Ice Cream","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"1.2","ratingCount":"3 ratings","ratingCountV2":"3"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"104495748","name":"Cold Coffee Icecream","category":"Desserts And Beverages","imageId":"c7a56ba00a55d12e719bb6cbb289635b","inStock":1,"isVeg":1,"price":18000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76093556","groupName":"Choose your Ice Cream","choices":[{"id":"60998573","name":"Vanilla Ice Cream","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"104495749","name":"Hazelnut Coffee Frappe","category":"Desserts And Beverages","imageId":"2c17d3ccc6be87077e7871bc99f6b208","inStock":1,"isVeg":1,"price":17000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76093559","groupName":"Choose your Ice Cream","choices":[{"id":"60998573","name":"Vanilla Ice Cream","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"104495752","name":"Caramel Coffee Frappe","category":"Desserts And Beverages","imageId":"4d6badf78872c39cbe2074f2efa36c08","inStock":1,"isVeg":1,"price":17000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76093551","groupName":"Choose your Ice Cream","choices":[{"id":"60998573","name":"Vanilla Ice Cream","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"125911173","name":"Coffee Frappe Irish Cream","category":"Desserts And Beverages","imageId":"d95a51a476e134185406b5ccf1d5ece2","inStock":1,"isVeg":1,"price":18000,"variants":{},"variantsV2":{},"addons":[{"groupId":"115661906","groupName":"Choose your Ice Cream","choices":[{"id":"60998573","name":"Vanilla Ice Cream","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}}]},{"title":"Chocolate Shakes","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"75106489","name":"Brownie Shake","category":"Desserts And Beverages","imageId":"2758f434da6f91b5733b2278b8b82da8","inStock":1,"isVeg":1,"price":18000,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"75106495","name":"Ferrero Rocher Shake","category":"Desserts And Beverages","imageId":"2ec75c31a235e414a7f8ab3d679fa823","inStock":1,"isVeg":1,"price":18000,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"75106497","name":"Oreo Brownie Shake","category":"Desserts And Beverages","imageId":"861d58ea8f64c39b842116ff395450d3","inStock":1,"isVeg":1,"price":18000,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"75106500","name":"Oreo Shake","category":"Desserts And Beverages","imageId":"f890dc0d5fe88856ec115d1ecbeb5287","inStock":1,"isVeg":1,"price":18000,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"100777692","name":"Kit Kat Shake","category":"Desserts And Beverages","imageId":"f44ad1aa9f7347402ba323882c93b323","inStock":1,"isVeg":1,"price":18000,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"100777693","name":"Nutty Belgian Dark Chocolate Shake","category":"Desserts And Beverages","imageId":"d963b6a516f1855ddce3e64946e2ca71","inStock":1,"isVeg":1,"price":18000,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"125911174","name":"Chocollate Shake","category":"Desserts And Beverages","imageId":"4c651e8162556f93eb741c33ace3c578","inStock":1,"isVeg":1,"price":18000,"variants":{},"variantsV2":{},"addons":[{"groupId":"115668585","groupName":"Add On Vanila Ice","choices":[{"id":"102291573","name":"Vanilla Ice Cream","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"125911175","name":"Cookies & Cream Shake","category":"Desserts And Beverages","imageId":"cfa5048b6b63ef678c55e980bef1d81f","inStock":1,"isVeg":1,"price":18000,"variants":{},"variantsV2":{},"addons":[{"groupId":"115668586","groupName":"Add On Vanila Ice","choices":[{"id":"102291573","name":"Vanilla Ice Cream","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"125911176","name":"Mocha Browine Shake","category":"Desserts And Beverages","imageId":"4c1491a321223d58ab84c3762768455e","inStock":1,"isVeg":1,"price":18000,"variants":{},"variantsV2":{},"addons":[{"groupId":"115668587","groupName":"Add On Vanila Ice","choices":[{"id":"102291573","name":"Vanilla Ice Cream","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}}]}]}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"Thik Shakes (standard)","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"57814553","name":"Butterscotch","category":"Thik Shakes (standard)","imageId":"4078e845a69abb43b9d539fd69019a12","inStock":1,"isVeg":1,"price":15000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76093439","groupName":"Choose your Ice Cream","choices":[{"id":"60998573","name":"Vanilla Ice Cream","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"104495446","name":"Vanilla","category":"Thik Shakes (standard)","inStock":1,"isVeg":1,"price":15000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76093455","groupName":"Choose your Ice Cream","choices":[{"id":"60998573","name":"Vanilla Ice Cream","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"104495449","name":"Tutti Frutti","category":"Thik Shakes (standard)","imageId":"a1970822aa8f948fb847d22a20fb430b","inStock":1,"isVeg":1,"price":15000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76093454","groupName":"Choose your Ice Cream","choices":[{"id":"60998573","name":"Vanilla Ice Cream","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"104495494","name":"Strawderry","category":"Thik Shakes (standard)","imageId":"21a6c48e52ada35a77a9eeb4df9ac67d","inStock":1,"isVeg":1,"price":15000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76093449","groupName":"Choose your Ice Cream","choices":[{"id":"60998573","name":"Vanilla Ice Cream","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"104495495","name":"Fresh Pineapple","category":"Thik Shakes (standard)","imageId":"eeefe39e1a3b4158813236302f882d07","inStock":1,"isVeg":1,"price":15000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76093440","groupName":"Choose your Ice Cream","choices":[{"id":"60998573","name":"Vanilla Ice Cream","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"104495709","name":"Paan","category":"Thik Shakes (standard)","inStock":1,"isVeg":1,"price":15000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76093442","groupName":"Choose your Ice Cream","choices":[{"id":"60998573","name":"Vanilla Ice Cream","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"104495719","name":"Raj Bhog","category":"Thik Shakes (standard)","imageId":"824ad6e041a73604a7f8dbbcc018b1d3","inStock":1,"isVeg":1,"price":15000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76093443","groupName":"Choose your Ice Cream","choices":[{"id":"60998573","name":"Vanilla Ice Cream","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"104495729","name":"Kaju Draklsh","category":"Thik Shakes (standard)","imageId":"a7854c01380b900c8877cce800fdf754","inStock":1,"isVeg":1,"price":15000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76093447","groupName":"Choose your Ice Cream","choices":[{"id":"60998573","name":"Vanilla Ice Cream","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"104495741","name":"Kesar Pista","category":"Thik Shakes (standard)","imageId":"b7180695c64ec6c3ae7ebda639b25277","inStock":1,"isVeg":1,"price":15000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76093441","groupName":"Choose your Ice Cream","choices":[{"id":"60998573","name":"Vanilla Ice Cream","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"104495744","name":"Alphonso Mango","category":"Thik Shakes (standard)","imageId":"67064419eb4bfe6e27af8156252ab9d1","inStock":1,"isVeg":1,"price":15000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76093434","groupName":"Choose your Ice Cream","choices":[{"id":"60998573","name":"Vanilla Ice Cream","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"104495745","name":"American Nuts","category":"Thik Shakes (standard)","imageId":"922c2aa0b3eb257345247e1e6ac6a6d4","inStock":1,"isVeg":1,"price":15000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76093435","groupName":"Choose your Ice Cream","choices":[{"id":"60998573","name":"Vanilla Ice Cream","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"104509849","name":"Black Cvrrant","category":"Thik Shakes (standard)","imageId":"65bf03e09c35470ce639892158da41c7","inStock":1,"isVeg":1,"price":15000,"variants":{},"variantsV2":{},"addons":[{"groupId":"76093438","groupName":"Choose your Ice Cream","choices":[{"id":"60998573","name":"Vanilla Ice Cream","price":3000,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}}]}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"Waffle","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"100777408","name":"Hot Chocolate Waffle","category":"Waffle","imageId":"6d3f9332a46a6804aab9767309706727","inStock":1,"isVeg":1,"price":19000,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"100777409","name":"Nutella Waffle","category":"Waffle","imageId":"76298f9308870ed36fccc830f660feee","inStock":1,"isVeg":1,"price":19000,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"125911167","name":"Almond Browine Waffle","category":"Waffle","inStock":1,"isVeg":1,"price":21000,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"125911168","name":"Honey Butter Waffle","category":"Waffle","inStock":1,"isVeg":1,"price":18000,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"125925047","name":"Almond Nutella Browine","category":"Waffle","inStock":1,"isVeg":1,"price":20000,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}}]}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"Hot Waffle Desserts","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"100777402","name":"Chocolate Lovers Waffle","category":"Hot Waffle Desserts","imageId":"02f98deb324937a9138ede7489fb04a7","inStock":1,"isVeg":1,"price":24000,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"100777403","name":"Classic Waffle","category":"Hot Waffle Desserts","inStock":1,"isVeg":1,"price":23000,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"100777404","name":"Cookies & Cream Waffle","category":"Hot Waffle Desserts","inStock":1,"isVeg":1,"price":24000,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"100777406","name":"Nutty Belgain Waffle","category":"Hot Waffle Desserts","imageId":"f4708fc74a1e95b94fa555b1f8f7bcc4","inStock":1,"isVeg":1,"price":24000,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"100777407","name":"Strawberry Hot Waffle","category":"Hot Waffle Desserts","inStock":1,"isVeg":1,"price":22000,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}}]}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"Waffle Cake","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"125911169","name":"Almond Browine Waffle Cake ( Single Layer )","category":"Waffle Cake","inStock":1,"isVeg":1,"price":30000,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"125911170","name":"Nuttella Chocolate Waffle Cake ( Single Layer)","category":"Waffle Cake","inStock":1,"isVeg":1,"price":30000,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}}]}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"Brownie Sundaes","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"75106471","name":"Brownie Sundae","category":"Brownie Sundaes","imageId":"c828af9fba7499e4157b400898479ff3","inStock":1,"isVeg":1,"price":18000,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.8","ratingCount":"5 ratings","ratingCountV2":"5"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"100777412","name":"Brownie Choco Sundae","category":"Brownie Sundaes","imageId":"4f69c7da49f19c0a023bd22b6c245111","inStock":1,"isVeg":1,"price":18000,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"125911171","name":"Browine With Hot Chocolate","category":"Brownie Sundaes","inStock":1,"isVeg":1,"price":14000,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}}]}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"Classic Icecream","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"100777423","name":"American Nuts Icecream","category":"Classic Icecream","imageId":"3b5ef45110b69b42e041cbfa83b37da9","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"23987055","name":"Customisation","variations":[{"name":"Small Scoop (62gm)","price":96.25,"default":1,"id":"77571484","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Regular Scoop (95gm)","price":113.75,"id":"77571485","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Double Scoop (120gm)","price":131.25,"id":"77571486","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"23987055","variationId":"77571484"}],"price":9625},{"variations":[{"groupId":"23987055","variationId":"77571485"}],"price":11375},{"variations":[{"groupId":"23987055","variationId":"77571486"}],"price":13125}]},"itemAttribute":{"vegClassifier":"VEG"},"defaultPrice":9625,"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.5","ratingCount":"4 ratings","ratingCountV2":"4"}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"100777425","name":"Butter Scotch Icecream","category":"Classic Icecream","imageId":"9579b896d41a8cb969e78d5899591813","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"23987056","name":"Customisation","variations":[{"name":"Small Scoop (62gm)","price":78.75,"default":1,"id":"77571487","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Regular Scoop (95gm)","price":96.25,"id":"77571488","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Double Scoop (120gm)","price":122.5,"id":"77571489","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"23987056","variationId":"77571487"}],"price":7875},{"variations":[{"groupId":"23987056","variationId":"77571488"}],"price":9625},{"variations":[{"groupId":"23987056","variationId":"77571489"}],"price":12250}]},"itemAttribute":{"vegClassifier":"VEG"},"defaultPrice":7875,"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"100777427","name":"Kaju Draksh Icecream","category":"Classic Icecream","imageId":"996833a1a47c3520d028f8b570ddf2cd","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"23987058","name":"Customisation","variations":[{"name":"Small Scoop (62gm)","price":78.75,"default":1,"id":"77571493","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Regular Scoop (95gm)","price":96.25,"id":"77571494","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Double Scoop (120gm)","price":122.5,"id":"77571495","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"23987058","variationId":"77571493"}],"price":7875},{"variations":[{"groupId":"23987058","variationId":"77571494"}],"price":9625},{"variations":[{"groupId":"23987058","variationId":"77571495"}],"price":12250}]},"itemAttribute":{"vegClassifier":"VEG"},"defaultPrice":7875,"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"100777430","name":"Kesar Pista Icecream","category":"Classic Icecream","imageId":"3e87112caedcfa66c367dd28484d5507","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"23987060","name":"Customisation","variations":[{"name":"Small Scoop (62gm)","price":78.75,"default":1,"id":"77571499","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Regular Scoop (95gm)","price":96.25,"id":"77571500","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Double Scoop (120gm)","price":122.5,"id":"77571501","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"23987060","variationId":"77571499"}],"price":7875},{"variations":[{"groupId":"23987060","variationId":"77571500"}],"price":9625},{"variations":[{"groupId":"23987060","variationId":"77571501"}],"price":12250}]},"itemAttribute":{"vegClassifier":"VEG"},"defaultPrice":7875,"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"100777431","name":"Paan Icecream","category":"Classic Icecream","imageId":"fb4c35d25afb82cc7792a173a84ee4d7","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"23987061","name":"Customisation","variations":[{"name":"Small Scoop (62gm)","price":78.75,"default":1,"id":"77571502","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Regular Scoop (95gm)","price":96.25,"id":"77571503","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Double Scoop (120gm)","price":122.5,"id":"77571504","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"23987061","variationId":"77571502"}],"price":7875},{"variations":[{"groupId":"23987061","variationId":"77571503"}],"price":9625},{"variations":[{"groupId":"23987061","variationId":"77571504"}],"price":12250}]},"itemAttribute":{"vegClassifier":"VEG"},"defaultPrice":7875,"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"100777433","name":"Raj Bhog Icecream","category":"Classic Icecream","imageId":"1e6a9efa3104efd90a6ed78517ad54fd","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"23987062","name":"Customisation","variations":[{"name":"Small Scoop (62gm)","price":96.25,"default":1,"id":"77571505","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Regular Scoop (95gm)","price":113.75,"id":"77571506","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Double Scoop (120gm)","price":131.25,"id":"77571507","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"23987062","variationId":"77571505"}],"price":9625},{"variations":[{"groupId":"23987062","variationId":"77571506"}],"price":11375},{"variations":[{"groupId":"23987062","variationId":"77571507"}],"price":13125}]},"itemAttribute":{"vegClassifier":"VEG"},"defaultPrice":9625,"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"100777438","name":"Vanilla Icecream","category":"Classic Icecream","imageId":"c48efcbea121fabd2db30dbffe4752c7","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"23987066","name":"Customisation","variations":[{"name":"Small Scoop (62gm)","price":78.75,"default":1,"id":"77571517","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Regular Scoop (95gm)","price":96.25,"id":"77571518","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Double Scoop (120gm)","price":122.5,"id":"77571519","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"23987066","variationId":"77571517"}],"price":7875},{"variations":[{"groupId":"23987066","variationId":"77571518"}],"price":9625},{"variations":[{"groupId":"23987066","variationId":"77571519"}],"price":12250}]},"itemAttribute":{"vegClassifier":"VEG"},"defaultPrice":7875,"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}}]}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"Fruits Ice Cream","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"100777414","name":"Alphonso Mango Icecream","category":"Fruits Ice Cream","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"23987047","name":"Customisation","variations":[{"name":"Small Scoop (62gm)","price":78.75,"default":1,"id":"77571460","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Regular Scoop (95gm)","price":96.25,"id":"77571461","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Double Scoop (120gm)","price":122.5,"id":"77571462","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"23987047","variationId":"77571460"}],"price":7875},{"variations":[{"groupId":"23987047","variationId":"77571461"}],"price":9625},{"variations":[{"groupId":"23987047","variationId":"77571462"}],"price":12250}]},"itemAttribute":{"vegClassifier":"VEG"},"defaultPrice":7875,"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"100777415","name":"Black Currant Icecream","category":"Fruits Ice Cream","imageId":"7f16b31c74060f3f68facd6be6d1f383","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"23987048","name":"Customisation","variations":[{"name":"Small Scoop (62gm)","price":96.25,"default":1,"id":"77571463","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Regular Scoop (95gm)","price":113.75,"id":"77571464","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Double Scoop (120gm)","price":131.25,"id":"77571465","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"23987048","variationId":"77571463"}],"price":9625},{"variations":[{"groupId":"23987048","variationId":"77571464"}],"price":11375},{"variations":[{"groupId":"23987048","variationId":"77571465"}],"price":13125}]},"itemAttribute":{"vegClassifier":"VEG"},"defaultPrice":9625,"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"100777416","name":"Fresh Pineapple Icecream","category":"Fruits Ice Cream","imageId":"d907d47763526f49585ddf464f172b98","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"23987049","name":"Customisation","variations":[{"name":"Small Scoop (62gm)","price":78.75,"default":1,"id":"77571466","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Regular Scoop (95gm)","price":96.25,"id":"77571467","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Double Scoop (120gm)","price":122.5,"id":"77571468","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"23987049","variationId":"77571466"}],"price":7875},{"variations":[{"groupId":"23987049","variationId":"77571467"}],"price":9625},{"variations":[{"groupId":"23987049","variationId":"77571468"}],"price":12250}]},"itemAttribute":{"vegClassifier":"VEG"},"defaultPrice":7875,"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"100777418","name":"Strawberry Icecream","category":"Fruits Ice Cream","imageId":"c52f52e3e14c29fb41b8f3e7ef0d8811","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"23987051","name":"Customisation","variations":[{"name":"Small Scoop (62gm)","price":78.75,"default":1,"id":"77571472","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Regular Scoop (95gm)","price":96.25,"id":"77571473","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Double Scoop (120gm)","price":122.5,"id":"77571474","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"23987051","variationId":"77571472"}],"price":7875},{"variations":[{"groupId":"23987051","variationId":"77571473"}],"price":9625},{"variations":[{"groupId":"23987051","variationId":"77571474"}],"price":12250}]},"itemAttribute":{"vegClassifier":"VEG"},"defaultPrice":7875,"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"100777419","name":"Tutty Fruitty Icecream","category":"Fruits Ice Cream","imageId":"36723d9dc21e83e2ffdf2acd17d2e990","inStock":1,"isVeg":1,"variants":{},"variantsV2":{"variantGroups":[{"groupId":"23987052","name":"Customisation","variations":[{"name":"Small Scoop (62gm)","price":96.25,"default":1,"id":"77571475","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Regular Scoop (95gm)","price":113.75,"id":"77571476","inStock":1,"isVeg":1,"isEnabled":1},{"name":"Double Scoop (120gm)","price":131.25,"id":"77571477","inStock":1,"isVeg":1,"isEnabled":1}]}],"pricingModels":[{"variations":[{"groupId":"23987052","variationId":"77571475"}],"price":9625},{"variations":[{"groupId":"23987052","variationId":"77571476"}],"price":11375},{"variations":[{"groupId":"23987052","variationId":"77571477"}],"price":13125}]},"itemAttribute":{"vegClassifier":"VEG"},"defaultPrice":9625,"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}}},"analytics":{},"hideRestaurantDetails":true}}]}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo","type":"FSSAI","imageId":"fssai_final_edss9i","text":["License No. 22220091001886"]}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress","name":"Sip & Bite","area":"Saraswati Nagar","completeAddress":"180 G Block, Sri Ganganagar"}}}]}}}}]');


const $0191956a9ab83ad4$export$783d4f61868d3a32 = (resturantId, setMenuPageData)=>{
    (0, $acw62.useEffect)(()=>{
        fetchData();
    }, []);
    const fetchData = async ()=>{
        try {
            const menuListApi = await fetch((0, $6d4b57eddd9e5082$export$f8a1af105e1b4bba) + resturantId);
            const menuListResponse = await menuListApi.json();
            const menuListData = menuListResponse?.data?.data?.cards;
            setTimeout(()=>{
                setMenuPageData(menuListData);
            }, 500);
        } catch (error) {
            setTimeout(()=>{
                setMenuPageData($6ffdc4461e22ed7a$exports);
            }, 500);
        }
    };
};





parcelRequire("acw62");

parcelRequire("acw62");



// this component show the item list of a particular category in the menu list page using the redux state variable for it
const $67fa11740906ac82$var$CategoryItemList = (props)=>{
    const { categoryItemList: categoryItemList } = props;
    const cartItems = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.cartSlice.cartItems);
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "border-2 w-full h-fit bg-blue-300 rounded-xl flex justify-between px-2 my-3 items-center ",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col gap-1 w-8/12 py-1",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                        className: "text-xs font-bold md:text-lg lg:text-2xl text-blue-900",
                        children: categoryItemList?.info?.name
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "hidden md:block text-clip md:text-[12px] lg:text-[16px]",
                        children: categoryItemList?.info?.description
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-xs font-bold md:text-lg",
                        children: [
                            "\u20B9",
                            categoryItemList?.info?.price / 100 || categoryItemList?.info?.defaultPrice / 100
                        ]
                    })
                ]
            }),
            categoryItemList?.info?.imageId ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: " w-4/12 h-fit  lg:w-2/12 relative p-1 lg:p-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        className: "h-[40px] md:h-[70px] lg:h-[100px] w-full rounded-xl",
                        srcSet: (0, $6d4b57eddd9e5082$export$3c67ec6258c4a827) + categoryItemList?.info?.imageId
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        onClick: ()=>dispatch((0, $c764300c7515c1f3$export$fb9705de59d96855)(categoryItemList)),
                        className: "hidden md:block bg-white text-blue-900 transition duration-500 ease-linear  p-2 rounded-xl absolute top-0 lg:top-3 hover:bg-blue-900 hover:text-white",
                        children: "Add +"
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "w-4/12 h-full  lg:w-2/12 flex justify-center items-center",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    onClick: ()=>dispatch((0, $c764300c7515c1f3$export$fb9705de59d96855)(categoryItemList)),
                    className: "hidden md:block bg-white text-blue-900 transition duration-500 ease-linear hover:bg-blue-900 hover:text-white p-2 rounded-xl",
                    children: "Add +"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                onClick: ()=>dispatch((0, $c764300c7515c1f3$export$fb9705de59d96855)(categoryItemList)),
                className: "block md:hidden text-xs w-1/4 rounded-xl p-1 bg-white text-blue-900 transition duration-500 ease-linear hover:bg-blue-900 hover:text-white",
                children: "Add +"
            })
        ]
    });
};
var $67fa11740906ac82$export$2e2bcd8739ae039 = $67fa11740906ac82$var$CategoryItemList;


// this is show the category list in the menu list page with toggle item list of a particular category
const $345fe699a64c3f55$var$CategoryList = (props)=>{
    let { categoryList: categoryList, showItem: showItem, visibleCategoryIndex: visibleCategoryIndex, index: index, openCategoryIndex: openCategoryIndex } = props;
    const categoryItemList = categoryList?.itemCards;
    // this function is used to hide item list of a category which is visible
    function handleShowItems(index) {
        if (openCategoryIndex === index) visibleCategoryIndex(null);
        else visibleCategoryIndex(index);
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: " bg-blue-100 rounded-xl w-11/12 mx-auto  p-2 my-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                onClick: ()=>handleShowItems(index),
                className: "flex justify-between p-4 rounded-xl bg-blue-300 cursor-pointer",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                        className: " truncate font-bold text-blue-900 text-sm md:text-lg",
                        children: categoryList?.title
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                        className: "ri-triangle-fill text-blue-900 rotate-180"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "w-full h-full ",
                children: showItem && categoryItemList?.map((items)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67fa11740906ac82$export$2e2bcd8739ae039), {
                        categoryItemList: items?.card
                    }, items?.card?.info?.id))
            })
        ]
    });
};
var $345fe699a64c3f55$export$2e2bcd8739ae039 = $345fe699a64c3f55$var$CategoryList;




// Show Restaurant Menu List for Particular Restaurant Card using Restaurant Id from router
const $daa674ec85a8d0d2$var$RestaurantsMenuList = ()=>{
    const { resturantId: resturantId } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const [menuPageData, setMenuPageData] = (0, $acw62.useState)([]);
    (0, $0191956a9ab83ad4$export$783d4f61868d3a32)(resturantId, setMenuPageData);
    console.log(menuPageData[3]);
    const resturantInfo = menuPageData[2]?.card?.card?.info;
    const categoryList = menuPageData[4]?.groupedCard?.cardGroupMap?.REGULAR?.cards.filter((category)=>category.card.card[`@type`] === "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory");
    const [openCategoryIndex, setOpenCategoryIndex] = (0, $acw62.useState)(null);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: " h-[80vh] flex flex-col  py-2",
        children: [
            menuPageData.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0e2e610bf1b1dc33$export$2e2bcd8739ae039), {
                uiType: "RestaurantMenuList"
            }),
            menuPageData.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "h-full py-1",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "w-11/12 mx-auto my-1 h-1/4 flex justify-between px-4 py-2 items-center border-4 rounded-xl border-blue-200",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "hidden h-full md:block md:w-2/12 lg:w-1/12",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    src: (0, $6d4b57eddd9e5082$export$3c67ec6258c4a827) + resturantInfo?.cloudinaryImageId,
                                    className: "md:h-full w-full rounded-xl     ",
                                    alt: ""
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "w-9/12 h-full md:w-7/12 lg:w-8/12 flex flex-col justify-center ",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                        className: "font-bold text-md md:text-2xl",
                                        children: resturantInfo?.name
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "font-extralight text-xs md:text-sm",
                                        children: resturantInfo?.cuisines.join(", ")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "font-extralight text-xs md:text-sm",
                                        children: [
                                            resturantInfo?.locality,
                                            " ,",
                                            " ",
                                            resturantInfo?.sla?.lastMileTravelString
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "w-4/12 md:w-2/12 h-5/6 lg:w-1/12 border-2 border-blue-100 px-1 rounded-lg flex flex-col  justify-evenly items-center lg:py-3 ",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "md:w-full md:h-full flex gap-1 text-green-700 font-bold items-center justify-center text-lg md:text-xl",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                className: "ri-star-fill  text-lg  md:text-2xl"
                                            }),
                                            resturantInfo?.avgRatingString
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                                        className: " w-full h-1/6 "
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "flex",
                                        children: [
                                            resturantInfo?.totalRatingsString?.split(" ")[0],
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "hidden md:block",
                                                children: "Rating"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "h-3/4 md:pb-11 lg:pb-14 overflow-y-scroll scrollbar-hide",
                        children: [
                            categoryList?.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "w-full h-full flex flex-col item-center gap-4 pt-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                        className: "text-xl text-center md:text-3xl",
                                        children: "No Menu List Found"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                        to: "/",
                                        className: "text-lg text-center py-1 px-2  bg-blue-900 rounded-xl md:w-4/12 mx-auto text-white md:p-2 md:text-2xl",
                                        children: "Go To Restaurant List"
                                    })
                                ]
                            }),
                            categoryList?.map((category, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $345fe699a64c3f55$export$2e2bcd8739ae039), {
                                    visibleCategoryIndex: (index)=>setOpenCategoryIndex(index),
                                    index: index,
                                    openCategoryIndex: openCategoryIndex,
                                    showItem: openCategoryIndex === index ? true : false,
                                    categoryList: category?.card?.card
                                }, index))
                        ]
                    })
                ]
            })
        ]
    });
};
var $daa674ec85a8d0d2$export$2e2bcd8739ae039 = $daa674ec85a8d0d2$var$RestaurantsMenuList;




// store all cart slice inside reducer of mainStore
const $f56b4b104c63d234$var$mainStore = (0, $74cf642ba7fa99c2$export$7d8a5b498da695ac)({
    reducer: {
        cartSlice: $c764300c7515c1f3$export$2e2bcd8739ae039
    }
});
var $f56b4b104c63d234$export$2e2bcd8739ae039 = $f56b4b104c63d234$var$mainStore;




// This is main component which handle rendering the all compoenet of whole app with routing
function $bb7131de8fd96889$var$App() {
    const [userLoginName, setUserLoginName] = (0, $acw62.useState)("Guest");
    const [liveLoginStatus, setLiveLoginStatus] = (0, $acw62.useState)(false);
    const [noticationMessage, setNotificationMessage] = (0, $acw62.useState)("");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $31f4d8f6ffbbb628$export$2e2bcd8739ae039), {
            store: (0, $f56b4b104c63d234$export$2e2bcd8739ae039),
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c09882a49af06a79$export$38ee920e59704589).Provider, {
                value: {
                    noticationMessage: noticationMessage,
                    setNotificationMessage: setNotificationMessage,
                    userName: userLoginName,
                    loginStatus: liveLoginStatus,
                    setLiveLoginStatus: setLiveLoginStatus,
                    setUserLoginName: setUserLoginName
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "relative w-screen h-screen overflow-hidden",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a3478a115f13707d$exports.Toaster), {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3df07944bfa6aab3$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$910ae8079b2c2852), {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d5c7001fb908dd0e$export$2e2bcd8739ae039), {})
                    ]
                })
            })
        })
    });
}
// Creating a routing for the app for different pages and components
const $bb7131de8fd96889$var$routing = (0, $040dbb9c344a508d$export$1f3f55432a00e06d)([
    {
        path: "/",
        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($bb7131de8fd96889$var$App, {}),
        children: [
            {
                path: "/",
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00b513cc47574162$export$2e2bcd8739ae039), {})
            },
            {
                path: "/menu/:resturantId/:resturantName",
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $daa674ec85a8d0d2$export$2e2bcd8739ae039), {})
            },
            {
                path: "/about",
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $213e0fec855ce3bb$export$2e2bcd8739ae039), {})
            },
            {
                path: "/contact",
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0a02757af33993aa$export$2e2bcd8739ae039), {})
            },
            {
                path: "/cart",
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fa5cada1489effcc$export$2e2bcd8739ae039), {})
            },
            {
                path: "/user",
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $96335adcb8d4055b$export$2e2bcd8739ae039), {}),
                children: [
                    {
                        path: "/user/",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2521ba5eca4440dd$export$2e2bcd8739ae039), {})
                    },
                    {
                        path: "/user/logout",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $384020c1894d4253$export$2e2bcd8739ae039), {})
                    }
                ]
            }
        ]
    }
]);
// Rendering the app component in root id element of html
const $bb7131de8fd96889$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($7e96a608cb33bf79$exports))).createRoot(document.getElementById("root"));
$bb7131de8fd96889$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$323e4fc2fa4753fb), {
    router: $bb7131de8fd96889$var$routing
}));


//# sourceMappingURL=index.c50a19c3.js.map
